﻿/**
 * SELF-CONTAINED SHOPIFY OPTION WIDGET LOADER
 * Complete widget with embedded CSS and JavaScript
 * No external dependencies - everything is injected and controlled by this file
 */
(function() {
  'use strict';
  
  // Version tracking for cache busting and debugging
  const WIDGET_VERSION = '1.5.5-OOM-FIX';
  const WIDGET_BUILD_DATE = '2026-02-25';
  const OPTION_WIDGET_RUNTIME_MODE = ((window.OPTION_WIDGET_RUNTIME_MODE || 'legacy').toString().trim().toLowerCase() || 'legacy');
  const PHASE0_WIDGET_TELEMETRY_ENABLED = OPTION_WIDGET_RUNTIME_MODE !== 'legacy';
  const OPTION_SET_CONTRACT_SHADOW_MODE = (
    window.OPTION_SET_CONTRACT_SHADOW_MODE ||
    (window.__VICI_OPTION_FLAGS && window.__VICI_OPTION_FLAGS.OPTION_SET_CONTRACT_SHADOW_MODE) ||
    'warn'
  ).toString().trim().toLowerCase();
  const PHASE1_CONTRACT_SHADOW_ENABLED = OPTION_SET_CONTRACT_SHADOW_MODE !== 'off';
  const WIDGET_DATA_LOADER_MODE = resolveWidgetPhase3Mode('WIDGET_DATA_LOADER_MODE');
  const WIDGET_CONTRACT_ADAPTER_MODE = resolveWidgetPhase3Mode('WIDGET_CONTRACT_ADAPTER_MODE');
  const WIDGET_PRICING_ENGINE_MODE = resolveWidgetPhase3Mode('WIDGET_PRICING_ENGINE_MODE');
  const WIDGET_CART_GATEWAY_MODE = resolveWidgetPhase3Mode('WIDGET_CART_GATEWAY_MODE');
  const PHASE3_WIDGET_MODULES = {
    dataLoader: 'data_loader',
    contractAdapter: 'contract_adapter',
    pricingEngine: 'pricing_engine',
    cartGateway: 'cart_gateway'
  };
  const PHASE3_WIDGET_RUNTIME_ENABLED =
    WIDGET_DATA_LOADER_MODE !== 'legacy' ||
    WIDGET_CONTRACT_ADAPTER_MODE !== 'legacy' ||
    WIDGET_PRICING_ENGINE_MODE !== 'legacy' ||
    WIDGET_CART_GATEWAY_MODE !== 'legacy';
  // Production hardening: disable all debug logging paths permanently for go-live.
  const WIDGET_DEBUG_LOGGING = false;
  // Disabled by default to avoid storefront console noise and unnecessary data collection.
  // Can be enabled explicitly via window.__VICI_OPTION_FLAGS.WIDGET_ANALYTICS_ENDPOINT.
  const ANALYTICS_ENDPOINT_DEFAULT = null;
  const WIDGET_ANALYTICS_ENDPOINT = (function() {
    const source =
      (window.__VICI_OPTION_FLAGS && window.__VICI_OPTION_FLAGS.WIDGET_ANALYTICS_ENDPOINT) ||
      window.VICI_WIDGET_ANALYTICS_ENDPOINT ||
      ANALYTICS_ENDPOINT_DEFAULT;
    const endpoint = String(source || '').trim();
    return endpoint || null;
  })();
  const WIDGET_IMAGE_PROXY_ENDPOINT = (function() {
    const explicitProxy =
      (window.__VICI_OPTION_FLAGS && window.__VICI_OPTION_FLAGS.WIDGET_IMAGE_PROXY_ENDPOINT) ||
      window.VICI_WIDGET_IMAGE_PROXY_ENDPOINT ||
      (window.WIDGET_CONFIG && window.WIDGET_CONFIG.imageProxyEndpoint) ||
      null;
    const explicit = String(explicitProxy || '').trim();
    if (explicit) return explicit;

    const backendFromConfig =
      (window.WIDGET_CONFIG && window.WIDGET_CONFIG.backendUrl) ||
      (window.__VICI_OPTION_FLAGS && window.__VICI_OPTION_FLAGS.WIDGET_BACKEND_URL) ||
      null;
    const backend = String(backendFromConfig || '').trim().replace(/\/+$/, '');
    if (backend) return `${backend}/api/image-proxy`;

    return null;
  })();
  let widgetAnalyticsDisabled = !WIDGET_ANALYTICS_ENDPOINT;
  let widgetAnalyticsDisableReason = widgetAnalyticsDisabled ? 'missing_endpoint' : null;

  function debugLog() {}

  // ðŸš¨ EMERGENCY FIX: Disable console logging in production to prevent crashes with 8+ fields
  // This fixes the major performance issue where 450+ console.log statements per click
  // were causing browser freezes and page reloads
  const IS_PRODUCTION = window.location.hostname !== 'localhost' &&
                        window.location.hostname !== '127.0.0.1';

  if (IS_PRODUCTION) {
    // Save original console methods for errors
    const originalConsoleError = console.error;

    // Disable non-critical console methods in production
    console.log = function() {};
    console.warn = function() {};
    console.info = function() {};
    console.debug = function() {};

    // Keep console.error for critical issues
    console.error = originalConsoleError;

    // Intentionally avoid console banner noise in production.
  }

  // Check if already loaded to prevent duplicates
  if (window.CustomOptionWidgetLoaded) {
    debugLog(`Custom Option Widget v${WIDGET_VERSION} - Already loaded, skipping duplicate initialization`);
    return;
  }
  
  // Check for conflicting scripts that might be causing issues
  if (typeof DiscountCode !== 'undefined') {
    console.warn(`Custom Option Widget v${WIDGET_VERSION} - DiscountCode conflict detected, continuing with widget load`);
  }
  
  // Mark as loaded and log version
  window.CustomOptionWidgetLoaded = true;
  window.__VICI_OPTION_WIDGET_RUNTIME_MODE = OPTION_WIDGET_RUNTIME_MODE;
  window.__VICI_OPTION_WIDGET_MODULE_MODES = {
    dataLoader: WIDGET_DATA_LOADER_MODE,
    contractAdapter: WIDGET_CONTRACT_ADAPTER_MODE,
    pricingEngine: WIDGET_PRICING_ENGINE_MODE,
    cartGateway: WIDGET_CART_GATEWAY_MODE
  };
  debugLog(`ðŸ”§ CRITICAL FIXES Custom Option Widget v${WIDGET_VERSION} (${WIDGET_BUILD_DATE}) - PRICING & INTEGRATION FIXES APPLIED!`);
  debugLog(`✅ CRITICAL FIXES: Corrected pricing calculation, Order Summary integration, all buttons unified`);
  
  // Remove debug surface in production builds.
  try {
    delete window.debugPricing;
  } catch (e) {
    window.debugPricing = undefined;
  }

  function stableNormalize(value) {
    if (Array.isArray(value)) {
      return value.map(stableNormalize);
    }
    if (value && typeof value === 'object') {
      return Object.keys(value)
        .sort()
        .reduce((acc, key) => {
          acc[key] = stableNormalize(value[key]);
          return acc;
        }, {});
    }
    return value;
  }

  function stableStringify(value) {
    return JSON.stringify(stableNormalize(value));
  }

  function simpleHash(input) {
    let hash = 0;
    const source = input || '';
    for (let i = 0; i < source.length; i += 1) {
      hash = (hash << 5) - hash + source.charCodeAt(i);
      hash |= 0;
    }
    return `h${Math.abs(hash)}`;
  }

  function safeArray(value) {
    return Array.isArray(value) ? value : [];
  }

  function safeNumber(value, fallback) {
    const num = Number(value);
    return Number.isFinite(num) ? num : fallback;
  }

  function getConfiguredPriceValue(optionLike) {
    if (!optionLike || typeof optionLike !== 'object') return 0;
    const raw =
      optionLike.price_value !== undefined && optionLike.price_value !== null
        ? optionLike.price_value
        : optionLike.price;
    return safeNumber(raw, 0);
  }

  function getConfiguredPriceMode(optionLike) {
    if (!optionLike || typeof optionLike !== 'object') return 'flat_fee';
    const mode = String(optionLike.price_mode || 'flat_fee').toLowerCase();
    return mode === 'per_unit' ? 'per_unit' : 'flat_fee';
  }

  function normalizeForMatch(value) {
    return String(value || '')
      .replace(/[^a-zA-Z0-9]/g, '')
      .toLowerCase();
  }

  function extractNumericValue(value) {
    const parsed = parseInt(String(value || '').replace(/[^0-9]/g, ''), 10);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function isLikelyRenderableImageUrl(value) {
    const candidate = String(value || '').trim();
    if (!candidate) return false;
    const lower = candidate.toLowerCase();
    if (lower === 'null' || lower === 'undefined' || lower === '[object object]') return false;
    if (lower.startsWith('javascript:')) return false;
    if (/^[a-z0-9.-]+\.[a-z]{2,}(\/|$)/i.test(candidate)) return true;
    return (
      lower.startsWith('http://') ||
      lower.startsWith('https://') ||
      lower.startsWith('//') ||
      lower.startsWith('/') ||
      lower.startsWith('data:image/') ||
      lower.startsWith('blob:')
    );
  }

  function buildImageFallbackDataUrl(label, caption, width = 150, height = 150, fontSize = 12) {
    const safeLabel = String(label || 'Option').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const safeCaption = String(caption || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const labelY = Math.round(height * 0.66);
    const captionY = Math.round(height * 0.8);
    const svgContent = `<svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
      <rect width="${width}" height="${height}" fill="#f8f9fa" stroke="#e0e0e0" stroke-width="2" rx="8"/>
      <circle cx="${Math.round(width / 2)}" cy="${Math.round(height * 0.4)}" r="${Math.round(Math.min(width, height) * 0.12)}" fill="#e0e0e0"/>
      <text x="${Math.round(width / 2)}" y="${labelY}" text-anchor="middle" font-family="Arial, sans-serif" font-size="${fontSize}" fill="#666">${safeLabel}</text>
      ${safeCaption ? `<text x="${Math.round(width / 2)}" y="${captionY}" text-anchor="middle" font-family="Arial, sans-serif" font-size="${Math.max(10, fontSize - 2)}" fill="#999">${safeCaption}</text>` : ''}
    </svg>`;
    return `data:image/svg+xml;base64,${btoa(svgContent)}`;
  }

  function resolveWidgetImageUrl(rawValue, fallbackLabel, fallbackCaption, fallbackOptions = {}) {
    const candidate = String(rawValue || '').trim();
    if (!isLikelyRenderableImageUrl(candidate)) {
      return null;
    }

    if (/^[a-z0-9.-]+\.[a-z]{2,}(\/|$)/i.test(candidate)) {
      return `https://${candidate}`;
    }

    if (candidate.toLowerCase().startsWith('blob:')) {
      return buildImageFallbackDataUrl(
        fallbackLabel,
        fallbackCaption,
        fallbackOptions.width || 150,
        fallbackOptions.height || 150,
        fallbackOptions.fontSize || 12
      );
    }

    return candidate;
  }

  const WIDGET_TRANSPARENT_IMAGE_PLACEHOLDER =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

  function escapeHtmlAttribute(value) {
    return String(value === undefined || value === null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function buildWidgetDeferredImageTag({
    imageUrl,
    altText,
    className,
    loading = 'eager',
    decoding = 'async',
    fetchPriority = 'auto',
    style = ''
  }) {
    if (!imageUrl) return '';
    const normalizedLoading = loading === 'lazy' ? 'lazy' : 'eager';
    const normalizedDecoding = decoding === 'sync' || decoding === 'auto' ? decoding : 'async';
    const normalizedFetchPriority =
      fetchPriority === 'high' || fetchPriority === 'low' ? fetchPriority : 'auto';
    const normalizedClassName = [String(className || '').trim(), 'vici-img-loading']
      .filter(Boolean)
      .join(' ');
    const styleAttribute = style ? ` style="${style}"` : '';
    const escapedAltText = escapeHtmlAttribute(altText);
    const proxyUrl = buildWidgetImageProxyUrl(imageUrl);
    const proxyAttribute = proxyUrl ? ` data-vici-proxy-src="${escapeHtmlAttribute(proxyUrl)}"` : '';
    return `<img src="${WIDGET_TRANSPARENT_IMAGE_PLACEHOLDER}" data-vici-src="${escapeHtmlAttribute(imageUrl)}"${proxyAttribute} data-vici-alt="${escapedAltText}" alt="" aria-label="${escapedAltText}" class="${normalizedClassName}" loading="${normalizedLoading}" decoding="${normalizedDecoding}" fetchpriority="${normalizedFetchPriority}"${styleAttribute}>`;
  }

  function buildWidgetImageProxyUrl(sourceUrl) {
    const proxyBase = String(WIDGET_IMAGE_PROXY_ENDPOINT || '').trim();
    const targetUrl = String(sourceUrl || '').trim();
    if (!proxyBase || !targetUrl) return null;
    try {
      const normalizedTarget = new URL(targetUrl, window.location.origin).toString();
      if (proxyBase.includes('{url}')) {
        return proxyBase.replace('{url}', encodeURIComponent(normalizedTarget));
      }
      const joiner = proxyBase.includes('?') ? '&' : '?';
      return `${proxyBase}${joiner}url=${encodeURIComponent(normalizedTarget)}`;
    } catch (error) {
      return null;
    }
  }

  function collectOptionSetImageUrls(optionSetData) {
    if (!optionSetData || typeof optionSetData !== 'object') return [];
    const fields = safeArray(optionSetData.fields);
    const urls = [];

    fields.forEach((field) => {
      const options = safeArray(field && field.options);
      options.forEach((option) => {
        const url = resolveWidgetImageUrl(
          option && option.image,
          option && (option.value || option.name || option.label || 'Option'),
          'Image Option'
        );
        if (url && !url.startsWith('data:')) {
          urls.push(url);
        }
      });

      const designMethods = safeArray(field && field.designMethods);
      designMethods.forEach((method) => {
        const url = resolveWidgetImageUrl(
          method && method.image,
          method && (method.name || 'Design Method'),
          'Design Method',
          { width: 200, height: 150, fontSize: 14 }
        );
        if (url && !url.startsWith('data:')) {
          urls.push(url);
        }
      });
    });

    return urls;
  }

  const preloadedWidgetImages = new Set();
  function primeWidgetImageCache(optionSetData) {
    if (typeof Image === 'undefined') return;
    const imageUrls = collectOptionSetImageUrls(optionSetData);
    imageUrls.forEach((url) => {
      if (!url || preloadedWidgetImages.has(url)) return;
      const img = new Image();
      img.decoding = 'async';
      img.src = url;
      preloadedWidgetImages.add(url);
    });
  }

  function normalizePricingPayload(payload) {
    if (!payload || typeof payload !== 'object') {
      return null;
    }

    const schemaVersion = String(payload.schemaVersion || '');
    const isCompactPayload = schemaVersion === 'pricing-compact/v1';
    let expandedPayload = payload;

    if (isCompactPayload) {
      const keyMaps = payload.keyMaps && typeof payload.keyMaps === 'object' ? payload.keyMaps : {};
      const dimensionKeyMap =
        keyMaps.dimensions && typeof keyMaps.dimensions === 'object' ? keyMaps.dimensions : {};
      const valueKeyMap = keyMaps.values && typeof keyMaps.values === 'object' ? keyMaps.values : {};

      const expandedDimensions = safeArray(payload.pricingDimensions).map((dimension) => {
        const originalDimensionKey = dimensionKeyMap[dimension?.key] || dimension?.key;
        return {
          ...dimension,
          key: originalDimensionKey,
          pricingDimensionKey: originalDimensionKey,
          values: safeArray(dimension?.values).map((value) => {
            const originalValueKey = valueKeyMap[value?.key] || value?.key;
            return {
              ...value,
              key: originalValueKey,
              pricingValueKey: originalValueKey
            };
          })
        };
      });

      const expandedVariants = safeArray(payload.pricingVariants).map((variant) => {
        const sourceDimensionValues = variant?.dimensionValues || variant?.dimension_values || {};
        const expandedDimensionValues = {};

        if (sourceDimensionValues && typeof sourceDimensionValues === 'object') {
          Object.entries(sourceDimensionValues).forEach(([dimensionKey, valueKey]) => {
            const originalDimensionKey = dimensionKeyMap[dimensionKey] || dimensionKey;
            const originalValueKey = valueKeyMap[valueKey] || valueKey;
            expandedDimensionValues[originalDimensionKey] = originalValueKey;
          });
        }

        return {
          ...variant,
          dimensionValues: expandedDimensionValues
        };
      });

      expandedPayload = {
        ...payload,
        pricingDimensions: expandedDimensions,
        pricingVariants: expandedVariants
      };
    }

    const pricingDimensions = safeArray(expandedPayload.pricingDimensions || expandedPayload.pricing_dimensions);
    const pricingVariants = safeArray(expandedPayload.pricingVariants || expandedPayload.pricing_variants).map((variant) => {
      if (!variant || typeof variant !== 'object') {
        return variant;
      }

      const normalizedFinalPrice = safeNumber(
        variant.finalPrice !== undefined
          ? variant.finalPrice
          : variant.final_price !== undefined
            ? variant.final_price
            : variant.price !== undefined
              ? variant.price
              : variant.totalPrice !== undefined
                ? variant.totalPrice
                : variant.total_price !== undefined
                  ? variant.total_price
                  : variant.amount,
        0
      );

      return {
        ...variant,
        dimensionValues: variant.dimensionValues || variant.dimension_values || {},
        finalPrice: normalizedFinalPrice
      };
    });

    return {
      ...expandedPayload,
      pricingDimensions,
      pricingVariants,
      basePrice: safeNumber(
        expandedPayload.basePrice !== undefined ? expandedPayload.basePrice : expandedPayload.base_price,
        0
      ),
      designServiceFee: safeNumber(
        expandedPayload.designServiceFee !== undefined
          ? expandedPayload.designServiceFee
          : expandedPayload.design_service_fee,
        0
      )
    };
  }

  function getNormalizedPricingPayload() {
    const normalized = normalizePricingPayload(window.optionSetPricing);
    if (normalized) {
      window.optionSetPricing = normalized;
    }
    return normalized;
  }

  function buildPricingPayloadFromOptionSetData(optionSetData) {
    if (!optionSetData || typeof optionSetData !== 'object') {
      return null;
    }

    return normalizePricingPayload({
      pricingDimensions: optionSetData.pricingDimensions || optionSetData.pricing_dimensions,
      pricingVariants: optionSetData.pricingVariants || optionSetData.pricing_variants,
      basePrice: optionSetData.basePrice !== undefined ? optionSetData.basePrice : optionSetData.base_price,
      designServiceFee:
        optionSetData.designServiceFee !== undefined
          ? optionSetData.designServiceFee
          : optionSetData.design_service_fee !== undefined
            ? optionSetData.design_service_fee
            : optionSetData.designServicePrice !== undefined
              ? optionSetData.designServicePrice
              : optionSetData.design_service_price
    });
  }

  function hydratePricingFromOptionSetData(optionSetData, context = {}) {
    const normalized = buildPricingPayloadFromOptionSetData(optionSetData);
    if (!normalized || !normalized.pricingVariants?.length) {
      return null;
    }

    window.optionSetPricing = normalized;
    try {
      window.__vici_debug = window.__vici_debug || {};
      window.__vici_debug.last_pricing_source = {
        source: context.source || 'option_set_payload',
        productId: context.productId || null,
        containerId: context.containerId || null,
        dimensions: normalized.pricingDimensions?.length || 0,
        variants: normalized.pricingVariants?.length || 0,
        ts: new Date().toISOString()
      };
    } catch (e) {
      // Non-blocking debug capture
    }
    debugLog('ðŸ’° Hydrated pricing from option set payload:', {
      source: context.source || 'unknown',
      productId: context.productId || null,
      containerId: context.containerId || null,
      dimensions: normalized.pricingDimensions?.length || 0,
      variants: normalized.pricingVariants?.length || 0
    });

    return normalized;
  }

  function ensurePricingPayload(optionSetData, context = {}) {
    const existing = getNormalizedPricingPayload();
    if (existing && existing.pricingVariants?.length) {
      return existing;
    }

    return hydratePricingFromOptionSetData(optionSetData, context) || null;
  }

  function normalizePayloadForShadowContract(payload) {
    if (Array.isArray(payload)) {
      return {
        id: null,
        name: payload[0] && payload[0].name ? payload[0].name : 'Legacy Option Set',
        description: null,
        status: null,
        category: null,
        tags: [],
        fields: payload.flatMap((optionSet) => safeArray(optionSet && optionSet.fields)),
        groups: payload.map((optionSet, index) => ({
          id: optionSet && optionSet.id ? optionSet.id : `section_${index + 1}`,
          name: optionSet && optionSet.name ? optionSet.name : `Section ${index + 1}`,
          enabled: optionSet && optionSet.enabled !== undefined ? optionSet.enabled : true
        })),
        assignedProducts: [],
        pricingDimensions: [],
        pricingVariants: [],
        basePrice: 0,
        designServiceEnabled: false,
        designServicePrice: 0,
        designServiceDescription: null
      };
    }

    if (!payload || typeof payload !== 'object') {
      return {
        id: null,
        name: 'Untitled Option Set',
        description: null,
        status: null,
        category: null,
        tags: [],
        fields: [],
        groups: [],
        assignedProducts: [],
        pricingDimensions: [],
        pricingVariants: [],
        basePrice: 0,
        designServiceEnabled: false,
        designServicePrice: 0,
        designServiceDescription: null
      };
    }

    return {
      id: payload.id !== undefined ? payload.id : null,
      name: payload.name || payload.title || 'Untitled Option Set',
      description: payload.description !== undefined ? payload.description : null,
      status: payload.status !== undefined ? payload.status : null,
      category: payload.category !== undefined ? payload.category : null,
      tags: safeArray(payload.tags),
      fields: safeArray(payload.fields),
      groups: safeArray(payload.groups),
      assignedProducts: safeArray(payload.assignedProducts || payload.assigned_products),
      pricingDimensions: safeArray(payload.pricingDimensions || payload.pricing_dimensions),
      pricingVariants: safeArray(payload.pricingVariants || payload.pricing_variants),
      basePrice: safeNumber(payload.basePrice !== undefined ? payload.basePrice : payload.base_price, 0),
      designServiceEnabled: Boolean(
        payload.designServiceEnabled !== undefined
          ? payload.designServiceEnabled
          : payload.design_service_enabled
      ),
      designServicePrice: safeNumber(
        payload.designServicePrice !== undefined ? payload.designServicePrice : payload.design_service_price,
        0
      ),
      designServiceDescription:
        payload.designServiceDescription !== undefined
          ? payload.designServiceDescription
          : payload.design_service_description || null
    };
  }

  function runOptionSetContractReadShadow(payload, context) {
    if (!PHASE1_CONTRACT_SHADOW_ENABLED) {
      return;
    }

    try {
      const normalized = normalizePayloadForShadowContract(payload);
      const contractWithoutHash = {
        schemaVersion: 'option-set-contract/v1',
        ...normalized
      };
      const v1Payload = {
        ...contractWithoutHash,
        contractHash: simpleHash(stableStringify(contractWithoutHash))
      };

      const warnings = [];
      if (!v1Payload.name || typeof v1Payload.name !== 'string') {
        warnings.push('name missing or invalid');
      }
      if (!Array.isArray(v1Payload.fields)) {
        warnings.push('fields must be an array');
      }
      if (!v1Payload.contractHash || typeof v1Payload.contractHash !== 'string') {
        warnings.push('contractHash missing');
      }

      const compatPayload = Array.isArray(payload)
        ? payload.slice()
        : payload && typeof payload === 'object'
          ? { ...payload }
          : payload;
      const parityMatch = stableStringify(compatPayload) === stableStringify(payload);
      if (warnings.length > 0 || !parityMatch) {
        console.warn(
          '[OptionSetContractShadow]',
          JSON.stringify({
            source: 'shopify.widget.read',
            mode: OPTION_SET_CONTRACT_SHADOW_MODE,
            warningCount: warnings.length,
            warnings,
            parityMatch,
            contractHash: v1Payload.contractHash,
            schemaVersion: v1Payload.schemaVersion,
            ...context
          })
        );
      }
    } catch (error) {
      console.warn(
        '[OptionSetContractShadow]',
        JSON.stringify({
          source: 'shopify.widget.read',
          mode: OPTION_SET_CONTRACT_SHADOW_MODE,
          warning: 'shadow validation failed',
          error: error && error.message ? error.message : String(error),
          ...context
        })
      );
    }
  }

  function resolveWidgetPhase3Mode(flagName) {
    const rawValue = (
      window[flagName] ||
      (window.__VICI_OPTION_FLAGS && window.__VICI_OPTION_FLAGS[flagName]) ||
      'legacy'
    ).toString().trim().toLowerCase();
    return rawValue === 'shadow' || rawValue === 'v2' ? rawValue : 'legacy';
  }

  function resolveWidgetPhase3CanaryConfig() {
    return (
      window.__VICI_WIDGET_CANARY ||
      (window.__VICI_OPTION_FLAGS && window.__VICI_OPTION_FLAGS.WIDGET_CANARY) ||
      (window.__VICI_OPTION_FLAGS && window.__VICI_OPTION_FLAGS.widgetCanary) ||
      null
    );
  }

  function normalizeWidgetCanaryList(value) {
    if (!value) return [];
    if (Array.isArray(value)) {
      return value.map(item => String(item).trim().toLowerCase()).filter(Boolean);
    }
    return String(value)
      .split(',')
      .map(item => item.trim().toLowerCase())
      .filter(Boolean);
  }

  function resolveWidgetPhase3Context(moduleName, context) {
    const incoming = context || {};
    const shopDomain = (
      incoming.shopDomain ||
      (window.Shopify && window.Shopify.shop) ||
      window.location.hostname ||
      ''
    ).toString().trim().toLowerCase();
    const productId = incoming.productId || getCurrentProductId() || null;
    const correlationId =
      incoming.correlationId ||
      `widget-${moduleName}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

    return {
      ...incoming,
      shopDomain,
      productId: productId !== null && productId !== undefined ? String(productId) : null,
      correlationId
    };
  }

  function isWidgetModuleCanaryEnabled(moduleName, runtimeContext) {
    const canaryConfig = resolveWidgetPhase3CanaryConfig();
    if (!canaryConfig) {
      return true;
    }

    const moduleConfig =
      (canaryConfig.modules && canaryConfig.modules[moduleName]) ||
      canaryConfig[moduleName] ||
      {};
    const enabledValue =
      moduleConfig.enabled !== undefined
        ? moduleConfig.enabled
        : canaryConfig.enabled !== undefined
          ? canaryConfig.enabled
          : true;
    if (!enabledValue) {
      return false;
    }

    const allowedShops = normalizeWidgetCanaryList(
      moduleConfig.shops || moduleConfig.shopDomains || canaryConfig.shops || canaryConfig.shopDomains
    );
    const allowedProducts = normalizeWidgetCanaryList(
      moduleConfig.products ||
      moduleConfig.productIds ||
      canaryConfig.products ||
      canaryConfig.productIds
    );
    const shopMatch =
      allowedShops.length === 0 ||
      (runtimeContext.shopDomain && allowedShops.includes(runtimeContext.shopDomain));
    const productMatch =
      allowedProducts.length === 0 ||
      (runtimeContext.productId && allowedProducts.includes(String(runtimeContext.productId).toLowerCase()));
    return shopMatch && productMatch;
  }

  function emitWidgetPhase3Telemetry(moduleName, eventName, payload) {
    if (!PHASE3_WIDGET_RUNTIME_ENABLED && OPTION_WIDGET_RUNTIME_MODE === 'legacy') {
      return;
    }

    try {
      console.warn(
        '[OptionWidgetPhase3]',
        JSON.stringify({
          source: 'shopify.widget.phase3',
          module: moduleName,
          event: eventName,
          timestamp: new Date().toISOString(),
          ...payload
        })
      );
    } catch (error) {
      console.warn('[OptionWidgetPhase3]', moduleName, eventName, payload, error);
    }
  }

  function toParitySignature(value) {
    try {
      return stableStringify(value);
    } catch (error) {
      return `[[unserializable:${String(error && error.message ? error.message : error)}]]`;
    }
  }

  function hasParityMatch(moduleName, legacyResult, v2Result) {
    if (moduleName === PHASE3_WIDGET_MODULES.pricingEngine) {
      const legacyPrice = Number(legacyResult);
      const v2Price = Number(v2Result);
      return Number.isFinite(legacyPrice) && Number.isFinite(v2Price) && legacyPrice === v2Price;
    }
    return toParitySignature(legacyResult) === toParitySignature(v2Result);
  }

  function adaptOptionSetContractLegacy(payload) {
    return payload;
  }

  function adaptOptionSetContractV2(payload) {
    return payload;
  }

  function adaptOptionSetContract(payload, context) {
    return runWidgetModuleFlowSync(
      PHASE3_WIDGET_MODULES.contractAdapter,
      WIDGET_CONTRACT_ADAPTER_MODE,
      {
        legacy: () => adaptOptionSetContractLegacy(payload),
        v2: () => adaptOptionSetContractV2(payload),
        parity: (legacyResult, v2Result) =>
          toParitySignature(legacyResult) === toParitySignature(v2Result)
      },
      context
    );
  }

  function runWidgetModuleFlowSync(moduleName, mode, handlers, context) {
    const runtimeContext = resolveWidgetPhase3Context(moduleName, context);
    const normalizedMode = mode === 'shadow' || mode === 'v2' ? mode : 'legacy';
    const legacyExecutor = handlers.legacy;
    const v2Executor = handlers.v2 || handlers.legacy;
    const parityChecker = handlers.parity || ((legacyResult, v2Result) => hasParityMatch(moduleName, legacyResult, v2Result));

    if (normalizedMode === 'legacy') {
      return legacyExecutor();
    }

    if (!isWidgetModuleCanaryEnabled(moduleName, runtimeContext)) {
      emitWidgetPhase3Telemetry(moduleName, 'canary_skip', {
        mode: normalizedMode,
        correlationId: runtimeContext.correlationId,
        shopDomain: runtimeContext.shopDomain,
        productId: runtimeContext.productId
      });
      return legacyExecutor();
    }

    if (normalizedMode === 'shadow') {
      const legacyResult = legacyExecutor();
      let parityMatch = false;
      let parityError = null;
      try {
        const v2Result = v2Executor();
        parityMatch = Boolean(parityChecker(legacyResult, v2Result));
      } catch (error) {
        parityError = error && error.message ? error.message : String(error);
      }
      emitWidgetPhase3Telemetry(moduleName, 'shadow_parity', {
        mode: normalizedMode,
        parityMatch,
        parityError,
        correlationId: runtimeContext.correlationId,
        shopDomain: runtimeContext.shopDomain,
        productId: runtimeContext.productId
      });
      return legacyResult;
    }

    try {
      const v2Result = v2Executor();
      emitWidgetPhase3Telemetry(moduleName, 'v2_execute', {
        mode: normalizedMode,
        correlationId: runtimeContext.correlationId,
        shopDomain: runtimeContext.shopDomain,
        productId: runtimeContext.productId
      });
      return v2Result;
    } catch (error) {
      emitWidgetPhase3Telemetry(moduleName, 'v2_fallback', {
        mode: normalizedMode,
        correlationId: runtimeContext.correlationId,
        shopDomain: runtimeContext.shopDomain,
        productId: runtimeContext.productId,
        error: error && error.message ? error.message : String(error)
      });
      return legacyExecutor();
    }
  }

  async function runWidgetModuleFlowAsync(moduleName, mode, handlers, context) {
    const runtimeContext = resolveWidgetPhase3Context(moduleName, context);
    const normalizedMode = mode === 'shadow' || mode === 'v2' ? mode : 'legacy';
    const legacyExecutor = handlers.legacy;
    const v2Executor = handlers.v2 || handlers.legacy;
    const parityChecker = handlers.parity || ((legacyResult, v2Result) => hasParityMatch(moduleName, legacyResult, v2Result));

    if (normalizedMode === 'legacy') {
      return legacyExecutor();
    }

    if (!isWidgetModuleCanaryEnabled(moduleName, runtimeContext)) {
      emitWidgetPhase3Telemetry(moduleName, 'canary_skip', {
        mode: normalizedMode,
        correlationId: runtimeContext.correlationId,
        shopDomain: runtimeContext.shopDomain,
        productId: runtimeContext.productId
      });
      return legacyExecutor();
    }

    if (normalizedMode === 'shadow') {
      if (handlers.sideEffect) {
        emitWidgetPhase3Telemetry(moduleName, 'shadow_side_effect_skip', {
          mode: normalizedMode,
          correlationId: runtimeContext.correlationId,
          shopDomain: runtimeContext.shopDomain,
          productId: runtimeContext.productId
        });
        return legacyExecutor();
      }

      const legacyResult = await legacyExecutor();
      let parityMatch = false;
      let parityError = null;
      try {
        const v2Result = await v2Executor();
        parityMatch = Boolean(parityChecker(legacyResult, v2Result));
      } catch (error) {
        parityError = error && error.message ? error.message : String(error);
      }
      emitWidgetPhase3Telemetry(moduleName, 'shadow_parity', {
        mode: normalizedMode,
        parityMatch,
        parityError,
        correlationId: runtimeContext.correlationId,
        shopDomain: runtimeContext.shopDomain,
        productId: runtimeContext.productId
      });
      return legacyResult;
    }

    try {
      const v2Result = await v2Executor();
      emitWidgetPhase3Telemetry(moduleName, 'v2_execute', {
        mode: normalizedMode,
        correlationId: runtimeContext.correlationId,
        shopDomain: runtimeContext.shopDomain,
        productId: runtimeContext.productId
      });
      return v2Result;
    } catch (error) {
      emitWidgetPhase3Telemetry(moduleName, 'v2_fallback', {
        mode: normalizedMode,
        correlationId: runtimeContext.correlationId,
        shopDomain: runtimeContext.shopDomain,
        productId: runtimeContext.productId,
        error: error && error.message ? error.message : String(error)
      });
      return legacyExecutor();
    }
  }

  // PERFORMANCE: Global widget manager to track instances and prevent memory leaks
  window.OptionWidgetManager = {
    instances: new Map(),
    
    initialize(container, productId) {
      // Clean up any existing instance
      this.cleanup(productId);
      
      // Create new instance
      const instance = {
        container,
        productId,
        listeners: [],
        timers: [],
        observers: []
      };
      
      this.instances.set(productId, instance);
      debugLog(`Custom Option Widget v${WIDGET_VERSION} - Initialized managed instance for product:`, productId);
      return instance;
    },
    
    cleanup(productId) {
      const instance = this.instances.get(productId);
      if (!instance) return;
      
      // Remove all event listeners
      instance.listeners.forEach(({ element, event, handler }) => {
        if (element && typeof element.removeEventListener === 'function') {
          element.removeEventListener(event, handler);
        }
      });
      
      // Clear all timers
      instance.timers.forEach(timer => {
        clearTimeout(timer);
        clearInterval(timer);
      });
      
      // Disconnect observers
      instance.observers.forEach(observer => {
        if (observer && typeof observer.disconnect === 'function') {
          observer.disconnect();
        }
      });
      
      // Clear references
      this.instances.delete(productId);
      debugLog(`Custom Option Widget v${WIDGET_VERSION} - Cleaned up instance for product:`, productId);
    },
    
    addListener(productId, element, event, handler, options = {}) {
      const instance = this.instances.get(productId);
      if (!instance || !element) return;
      
      element.addEventListener(event, handler, options);
      instance.listeners.push({ element, event, handler });
    },
    
    addTimer(productId, timer) {
      const instance = this.instances.get(productId);
      if (!instance) return;
      
      // OOM FIX: Prune cleared timers to prevent unbounded array growth.
      // Previously, every scheduleRefresh / updateOptionData call pushed a new
      // timer ID without removing the old (already-cleared) one, causing the
      // array to grow by 1-3 entries per click indefinitely.
      if (instance.timers.length > 50) {
        instance.timers = instance.timers.slice(-20);
      }
      instance.timers.push(timer);
    },
    
    addObserver(productId, observer) {
      const instance = this.instances.get(productId);
      if (!instance) return;
      
      instance.observers.push(observer);
    }
  };

  // PERFORMANCE: Debounce and throttle utilities
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  function throttle(func, limit) {
    let inThrottle;
    return function(...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }

  // PERFORMANCE: Performance monitoring utility
  const PerformanceMonitor = {
    marks: new Map(),
    
    start(label) {
      if (window.performance && window.performance.mark) {
        performance.mark(`${label}-start`);
        this.marks.set(label, performance.now());
      }
    },
    
    end(label) {
      if (window.performance && window.performance.mark) {
        performance.mark(`${label}-end`);
        const start = this.marks.get(label);
        if (start) {
          const duration = performance.now() - start;
          if (duration > 100) { // Log slow operations
            console.warn(`Custom Option Widget v${WIDGET_VERSION} - Slow operation: ${label} took ${duration.toFixed(2)}ms`);
          }
          this.marks.delete(label);
        }
        // OOM FIX: Clear accumulated performance marks to prevent
        // unbounded PerformanceMark entry growth in the browser timeline.
        try {
          performance.clearMarks(`${label}-start`);
          performance.clearMarks(`${label}-end`);
        } catch (_) { /* older browsers */ }
      }
    }
  };

  // ULTRA-SAFE DOM HELPER FUNCTIONS - PREVENT ALL CRASHES
  const SafeDOM = {
    query(parent, selector) {
      try {
        if (!parent || typeof parent.querySelector !== 'function') return null;
        return parent.querySelector(selector);
      } catch (error) {
        console.warn(`Safe DOM Query Failed [${selector}]:`, error);
        return null;
      }
    },
    
    queryAll(parent, selector) {
      try {
        if (!parent || typeof parent.querySelectorAll !== 'function') return [];
        return Array.from(parent.querySelectorAll(selector));
      } catch (error) {
        console.warn(`Safe DOM QueryAll Failed [${selector}]:`, error);
        return [];
      }
    },
    
    addClass(element, className) {
      try {
        if (!element || !element.classList) return false;
        element.classList.add(className);
        return true;
      } catch (error) {
        console.warn(`Safe addClass Failed [${className}]:`, error);
        return false;
      }
    },
    
    removeClass(element, className) {
      try {
        if (!element || !element.classList) return false;
        element.classList.remove(className);
        return true;
      } catch (error) {
        console.warn(`Safe removeClass Failed [${className}]:`, error);
        return false;
      }
    },
    
    hasClass(element, className) {
      try {
        if (!element || !element.classList) return false;
        return element.classList.contains(className);
      } catch (error) {
        console.warn(`Safe hasClass Failed [${className}]:`, error);
        return false;
      }
    },
    
    setText(element, text) {
      try {
        if (!element) return false;
        element.textContent = text;
        return true;
      } catch (error) {
        console.warn('Safe setText Failed:', error);
        return false;
      }
    },
    
    getText(element) {
      try {
        if (!element) return '';
        return element.textContent || '';
      } catch (error) {
        console.warn('Safe getText Failed:', error);
        return '';
      }
    }
  };

  // GLOBAL ERROR HANDLER - PREVENT PAGE CRASHES
  window.addEventListener('error', function(e) {
    if (e.error && e.error.stack && e.error.stack.includes('Custom Option Widget')) {
      console.error('Custom Option Widget - Caught global error:', e.error);
      e.preventDefault(); // Prevent browser error popup
      return true;
    }
  });
  
  window.addEventListener('unhandledrejection', function(e) {
    if (e.reason && e.reason.stack && e.reason.stack.includes('Custom Option Widget')) {
      console.error('Custom Option Widget - Caught unhandled promise rejection:', e.reason);
      e.preventDefault(); // Prevent browser error popup
      return true;
    }
  });

  // Hide broken image glyphs immediately, even before widget-specific listeners bind.
  document.addEventListener('error', function(e) {
    const target = e && e.target;
    if (!target || target.tagName !== 'IMG') return;
    if (!target.closest('#custom-options-widget-container, #custom-options-widget-container-2')) return;
    target.classList.add('vici-img-failed');
    target.style.display = 'none';
  }, true);

  // 1. INJECT ALL CSS DIRECTLY - Complete unified-option-fields.css embedded
  function injectStyles(optionSetData) {
    const styleId = 'custom-option-widget-styles';
    
    // Prevent duplicate injection
    if (document.getElementById(styleId)) {
      debugLog(`Custom Option Widget v${WIDGET_VERSION} - Styles already injected, skipping`);
      return;
    }
    
    debugLog(`Custom Option Widget v${WIDGET_VERSION} - Injecting widget styles...`);
    
    // Get Style Studio CSS if available
    let styleStudioCSS = '';
    if (optionSetData && optionSetData.styleStudio && optionSetData.styleStudio.css) {
      debugLog(`Custom Option Widget v${WIDGET_VERSION} - Injecting Style Studio CSS from option set`);
      styleStudioCSS = optionSetData.styleStudio.css;
    }
    
    const styles = `
/* FINAL NUCLEAR APPROACH - CONTINUOUS OVERRIDE ANIMATION */
@keyframes kill-orange-border {
  0%, 100% {
    outline: 0 !important;
    outline-style: none !important;
    outline-width: 0px !important;
    outline-color: transparent !important;
    outline-offset: 0px !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    border: 1px solid #e0e0e0 !important;
    -webkit-tap-highlight-color: rgba(0,0,0,0) !important;
    -webkit-focus-ring-color: rgba(0,0,0,0) !important;
  }
}

@keyframes kill-orange-border-active {
  0%, 100% {
    outline: 0 !important;
    outline-style: none !important;
    outline-width: 0px !important;
    outline-color: transparent !important;
    outline-offset: 0px !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    border: 2px solid #103c70 !important;
    -webkit-tap-highlight-color: rgba(0,0,0,0) !important;
    -webkit-focus-ring-color: rgba(0,0,0,0) !important;
  }
}

/* ABSOLUTE NUCLEAR APPROACH - OVERRIDE EVERYTHING WITH ANIMATIONS */
body #custom-options-widget-container .custom-dropdown-trigger,
body #custom-options-widget-container-2 .custom-dropdown-trigger,
html body #custom-options-widget-container .custom-dropdown-trigger,
html body #custom-options-widget-container-2 .custom-dropdown-trigger {
  animation: kill-orange-border 0.01s infinite !important;
  outline: 0 !important;
  outline-style: none !important;
  outline-width: 0px !important;
  outline-color: transparent !important;
  outline-offset: 0px !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
  background: white !important;
  -webkit-tap-highlight-color: rgba(0,0,0,0) !important;
  -webkit-focus-ring-color: rgba(0,0,0,0) !important;
  -moz-outline: 0 !important;
  -moz-outline-style: none !important;
}

/* TARGET PSEUDO-ELEMENTS THAT MIGHT BE CREATING THE ORANGE BORDER */
body #custom-options-widget-container .custom-dropdown-trigger::before,
body #custom-options-widget-container-2 .custom-dropdown-trigger::before,
body #custom-options-widget-container .custom-dropdown-trigger::after,
body #custom-options-widget-container-2 .custom-dropdown-trigger::after,
html body #custom-options-widget-container .custom-dropdown-trigger::before,
html body #custom-options-widget-container-2 .custom-dropdown-trigger::before,
html body #custom-options-widget-container .custom-dropdown-trigger::after,
html body #custom-options-widget-container-2 .custom-dropdown-trigger::after {
  display: none !important;
  content: none !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
}

/* TARGET ANY CHILD ELEMENTS */
body #custom-options-widget-container .custom-dropdown-trigger *,
body #custom-options-widget-container-2 .custom-dropdown-trigger *,
html body #custom-options-widget-container .custom-dropdown-trigger *,
html body #custom-options-widget-container-2 .custom-dropdown-trigger * {
  outline: 0 !important;
  box-shadow: none !important;
  border: none !important;
  -webkit-tap-highlight-color: rgba(0,0,0,0) !important;
}

body #custom-options-widget-container .custom-dropdown-trigger:focus,
body #custom-options-widget-container-2 .custom-dropdown-trigger:focus,
body #custom-options-widget-container .custom-dropdown-trigger:active,
body #custom-options-widget-container-2 .custom-dropdown-trigger:active,
body #custom-options-widget-container .custom-dropdown-trigger:focus-visible,
body #custom-options-widget-container-2 .custom-dropdown-trigger:focus-visible,
body #custom-options-widget-container .custom-dropdown-trigger.active,
body #custom-options-widget-container-2 .custom-dropdown-trigger.active,
html body #custom-options-widget-container .custom-dropdown-trigger:focus,
html body #custom-options-widget-container-2 .custom-dropdown-trigger:focus,
html body #custom-options-widget-container .custom-dropdown-trigger:active,
html body #custom-options-widget-container-2 .custom-dropdown-trigger:active,
html body #custom-options-widget-container .custom-dropdown-trigger:focus-visible,
html body #custom-options-widget-container-2 .custom-dropdown-trigger:focus-visible,
html body #custom-options-widget-container .custom-dropdown-trigger.active,
html body #custom-options-widget-container-2 .custom-dropdown-trigger.active {
  animation: kill-orange-border-active 0.01s infinite !important;
  outline: 0 !important;
  outline-style: none !important;
  outline-width: 0px !important;
  outline-color: transparent !important;
  outline-offset: 0px !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  border: 2px solid #103c70 !important;
  background: white !important;
  -webkit-tap-highlight-color: rgba(0,0,0,0) !important;
  -webkit-focus-ring-color: rgba(0,0,0,0) !important;
  -moz-outline: 0 !important;
  -moz-outline-style: none !important;
}

/* STYLE STUDIO CUSTOM CSS - INJECTED FIRST */
${styleStudioCSS}

/* WIDGET CONTAINER BORDER RESET - HIGHEST PRIORITY */
#custom-options-widget-container,
#custom-options-widget-container-2,
#custom-options-widget-container *,
#custom-options-widget-container-2 * {
  border: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}

/* RESTORE BORDERS ONLY FOR OPTION ELEMENTS */
#custom-options-widget-container .option-swatch-item,
#custom-options-widget-container-2 .option-swatch-item,
#custom-options-widget-container .corner-option,
#custom-options-widget-container-2 .corner-option,
#custom-options-widget-container .option-button,
#custom-options-widget-container-2 .option-button,
#custom-options-widget-container .radio-option,
#custom-options-widget-container-2 .radio-option,
#custom-options-widget-container .quantity-tier,
#custom-options-widget-container-2 .quantity-tier,
#custom-options-widget-container .design-method,
#custom-options-widget-container-2 .design-method,
#custom-options-widget-container input.option-widget-input,
#custom-options-widget-container-2 input.option-widget-input,
#custom-options-widget-container textarea.option-widget-textarea,
#custom-options-widget-container-2 textarea.option-widget-textarea,
#custom-options-widget-container select.option-widget-select,
#custom-options-widget-container-2 select.option-widget-select,
#custom-options-widget-container .upload-wrapper,
#custom-options-widget-container-2 .upload-wrapper,
#custom-options-widget-container .quantity-slider-wrapper,
#custom-options-widget-container-2 .quantity-slider-wrapper {
  border: 1px solid #e0e0e0 !important;
}


/* EMBEDDED CSS - Complete unified-option-fields.css with container scoping */
/* @import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;600;700&family=Open+Sans:wght@400;600;700&display=swap'); */

/* PERFORMANCE OPTIMIZATIONS - SMOOTH INTERACTIONS */
#custom-options-widget-container,
#custom-options-widget-container-2 {
  contain: style !important;
  will-change: auto !important;
}

#custom-options-widget-container *,
#custom-options-widget-container-2 * {
  box-sizing: border-box !important;
}

/* GPU ACCELERATION FOR SMOOTH ANIMATIONS */
#custom-options-widget-container .option-button,
#custom-options-widget-container-2 .option-button,
#custom-options-widget-container .option-swatch-item,
#custom-options-widget-container-2 .option-swatch-item,
#custom-options-widget-container .corner-option,
#custom-options-widget-container-2 .corner-option,
#custom-options-widget-container .quantity-tier,
#custom-options-widget-container-2 .quantity-tier,
#custom-options-widget-container .quantity-option,
#custom-options-widget-container-2 .quantity-option,
#custom-options-widget-container .design-method,
#custom-options-widget-container-2 .design-method {
  will-change: transform, border-color, background-color !important;
  transform: translateZ(0) !important;
  backface-visibility: hidden !important;
  perspective: 1000px !important;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* OPTIMIZED HOVER STATES */
#custom-options-widget-container .option-button:hover,
#custom-options-widget-container-2 .option-button:hover,
#custom-options-widget-container .option-swatch-item:hover,
#custom-options-widget-container-2 .option-swatch-item:hover {
  transform: translateZ(0) scale(1.02) !important;
}

/* INSTANT SELECTION FEEDBACK */
#custom-options-widget-container .selected,
#custom-options-widget-container-2 .selected {
  transition: border-color 0.1s ease-out, background-color 0.1s ease-out !important;
}

/* PREVENT LAYOUT THRASHING */
#custom-options-widget-container .option-widget-fields,
#custom-options-widget-container-2 .option-widget-fields {
  contain: style !important;
}

/* SMOOTH SLIDER OPTIMIZATIONS */
#custom-options-widget-container input[type="range"],
#custom-options-widget-container-2 input[type="range"] {
  -webkit-appearance: none !important;
  background: transparent !important;
  cursor: pointer !important;
  transform: translateZ(0) !important;
}

#custom-options-widget-container input[type="range"]::-webkit-slider-thumb,
#custom-options-widget-container-2 input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none !important;
  transition: all 0.1s ease !important;
  transform: translateZ(0) !important;
}

/* CSS VARIABLES - ENHANCED STYLE STUDIO THEME */
:root {
  --wcr-text: #1f2937;
  --wcr-sub: #6b7280;
  --wcr-card: #fff;
  --wcr-border: #e5e7eb;
  --wcr-border-strong: #103c70;
  --wcr-primary: #103c70;
  --option-primary: #103c70;
  --option-primary-hover: #103c70;
  --option-primary-light: rgba(16, 60, 112, 0.1);
  --wcr-primary: #103c70;
  --g-main: #103c70;
  --header-linkhover: #103c70;
  --header-menuhover: #103c70;
  --option-success: #28a745;
  --option-error: #dc3545;
  --option-warning: #ffc107;
  --option-white: var(--wcr-card);
  --option-background: var(--wcr-card);
  --option-border: #e0e0e0;
  --option-border-hover: #d0d0d0;
  --option-border-selected: #103c70;
  --option-text: #1a1a1a;
  --option-text-secondary: #666666;
  --option-subtext: #888888;
  --option-selected: var(--wcr-border-strong);
  --option-price: var(--wcr-text);
  --option-font-family: 'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  --option-label-font: 'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  --option-font-size-xs: 11px;
  --option-font-size-sm: 14px;
  --option-font-size-base: 17px;
  --option-font-size-md: 18px;
  --option-font-size-lg: 18px;
  --option-font-size-xl: 20px;
  --option-spacing-xs: 6px;
  --option-spacing-sm: 10px;
  --option-spacing-md: 4px;
  --option-spacing-lg: 20px;
  --option-spacing-xl: 28px;
  --option-radius: 10px;
  --option-radius-sm: 6px;
  --option-radius-md: 10px;
  --option-radius-lg: 8px;
  --option-radius-round: 50%;
  --option-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.06);
  --option-shadow-md: 0 2px 6px rgba(0, 0, 0, 0.08);
  --option-shadow-hover: 0 3px 12px rgba(0, 0, 0, 0.1);
  --option-shadow-focus: none;
  --option-transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  --option-transition-fast: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  --option-padding: 20px;
  --option-margin: 20px;
  --option-gap: 4px;
}

/* CONTAINER ISOLATION AND GLOBAL STYLES - NO BORDER */
#custom-options-widget-container,
#custom-options-widget-container-2 {
  font-family: var(--option-font-family) !important;
  background: transparent !important;
  border-radius: 0 !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  margin: 0 !important;
  width: 100% !important;
  box-sizing: border-box !important;
}

/* PREVENT BORDER ON HOVER - NO SHIFTING - COMPREHENSIVE */
#custom-options-widget-container:hover,
#custom-options-widget-container-2:hover,
#custom-options-widget-container:focus,
#custom-options-widget-container-2:focus,
#custom-options-widget-container:active,
#custom-options-widget-container-2:active {
  border: 0px solid transparent !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}

/* UNIVERSAL FOCUS/OUTLINE OVERRIDE - NO ORANGE BORDERS */
#custom-options-widget-container *:focus,
#custom-options-widget-container-2 *:focus,
#custom-options-widget-container *:focus-visible,
#custom-options-widget-container-2 *:focus-visible,
#custom-options-widget-container *:active,
#custom-options-widget-container-2 *:active {
  outline: none !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  border: inherit !important;
}

/* MAXIMUM SPECIFICITY OVERRIDE FOR DROPDOWN TRIGGER */
div#custom-options-widget-container div.custom-dropdown-trigger,
div#custom-options-widget-container-2 div.custom-dropdown-trigger {
  outline: 0 !important;
  outline-style: none !important;
  outline-width: 0 !important;
  outline-color: transparent !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

div#custom-options-widget-container div.custom-dropdown-trigger:focus,
div#custom-options-widget-container-2 div.custom-dropdown-trigger:focus,
div#custom-options-widget-container div.custom-dropdown-trigger:focus-visible,
div#custom-options-widget-container-2 div.custom-dropdown-trigger:focus-visible,
div#custom-options-widget-container div.custom-dropdown-trigger:active,
div#custom-options-widget-container-2 div.custom-dropdown-trigger:active,
div#custom-options-widget-container div.custom-dropdown-trigger.active,
div#custom-options-widget-container-2 div.custom-dropdown-trigger.active {
  outline: 0 !important;
  outline-style: none !important;
  outline-width: 0 !important;
  outline-color: transparent !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  border-color: var(--option-primary, #000000) !important;
}

#custom-options-widget-container *,
#custom-options-widget-container-2 * {
  box-sizing: border-box !important;
}

/* FIELD WRAPPER - NO BORDERS OR SHADOWS LIKE STYLE STUDIO */
#custom-options-widget-container .option-field-wrapper,
#custom-options-widget-container-2 .option-field-wrapper,
#custom-options-widget-container .option-field,
#custom-options-widget-container-2 .option-field {
  background: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  padding: 0 !important;
  margin-bottom: 24px !important;
  transition: none !important;
}

/* REMOVE ALL FIELD CONTAINER BORDERS AND SHADOWS */
#custom-options-widget-container .option-field-wrapper *,
#custom-options-widget-container-2 .option-field-wrapper * {
  border: none !important;
  box-shadow: none !important;
}

#custom-options-widget-container .option-field-wrapper:hover,
#custom-options-widget-container-2 .option-field-wrapper:hover {
  box-shadow: none !important;
  border: none !important;
}

#custom-options-widget-container .option-field-wrapper:last-child,
#custom-options-widget-container-2 .option-field-wrapper:last-child,
#custom-options-widget-container .option-field:last-child,
#custom-options-widget-container-2 .option-field:last-child {
  margin-bottom: 0 !important;
}

/* Ensure Order Summary field has no bottom margin since it's typically the last field */
#custom-options-widget-container .option-field-wrapper[data-field-type="summary"],
#custom-options-widget-container-2 .option-field-wrapper[data-field-type="summary"] {
  margin-bottom: 24px !important;
}

/* FIELD LABELS - ENHANCED TYPOGRAPHY */
#custom-options-widget-container .option-widget-label,
#custom-options-widget-container-2 .option-widget-label,
#custom-options-widget-container .option-field-label,
#custom-options-widget-container-2 .option-field-label,
#custom-options-widget-container .field-label,
#custom-options-widget-container-2 .field-label {
  display: block !important;
  font-family: var(--option-label-font) !important;
  color: var(--option-text) !important;
  font-weight: 500 !important;
  font-size: 19px !important;
  margin-bottom: 10px !important;
  line-height: 1.4 !important;
  letter-spacing: -0.01em !important;
}

/* IMAGE SWATCH GRID - ENHANCED STYLE STUDIO DESIGN */
#custom-options-widget-container .option-swatch-grid,
#custom-options-widget-container-2 .option-swatch-grid {
  display: grid !important;
  gap: 4px !important;
}

/* FORCE IMAGE SWATCH GRID LAYOUT - HIGHEST PRIORITY */
/* Column count is set via inline style (2 or 3 cols based on option count) */
.option-field-wrapper[data-field-type="image-swatch"] .option-swatch-grid {
  display: grid !important;
  gap: 4px !important;
  width: 100% !important;
}

/* FORCE SIZE FIELD GRID LAYOUT - DYNAMIC COLUMNS (set via inline style) */
#custom-options-widget-container .option-field-wrapper[data-field-type="size"] .option-swatch-grid,
#custom-options-widget-container-2 .option-field-wrapper[data-field-type="size"] .option-swatch-grid {
  display: grid !important;
  gap: 4px !important;
  width: 100% !important;
}

/* COLOR SWATCH GRID - CIRCLE DESIGN */
#custom-options-widget-container .color-swatch-grid,
#custom-options-widget-container-2 .color-swatch-grid {
  display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(70px, 1fr)) !important;
  gap: 15px !important;
  max-width: calc(7 * 70px + 6 * 15px) !important; /* Limit to 7 items per row */
  margin: 0 auto !important;
}

#custom-options-widget-container .color-swatch-item,
#custom-options-widget-container-2 .color-swatch-item {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

#custom-options-widget-container .color-swatch-circle,
#custom-options-widget-container-2 .color-swatch-circle {
  width: 45px !important;
  height: 45px !important;
  border-radius: 50% !important;
  border: 2px solid #e5e7eb !important;
  transition: all 0.2s ease !important;
  cursor: pointer !important;
  margin-bottom: 8px !important;
}

#custom-options-widget-container .color-swatch-item:hover .color-swatch-circle,
#custom-options-widget-container-2 .color-swatch-item:hover .color-swatch-circle {
  transform: scale(1.05) !important;
}

#custom-options-widget-container .color-swatch-item.selected .color-swatch-circle,
#custom-options-widget-container-2 .color-swatch-item.selected .color-swatch-circle {
  border-color: #103c70 !important;
}

#custom-options-widget-container .color-swatch-label,
#custom-options-widget-container-2 .color-swatch-label {
  font-size: 17px !important;
  font-weight: 500 !important;
  color: var(--option-text) !important;
  text-align: center !important;
  line-height: 1.3 !important;
  width: auto !important;
  min-width: 60px !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
}

/* IMAGE SWATCH ITEMS (KEEP EXISTING DESIGN) */
#custom-options-widget-container .option-swatch-item,
#custom-options-widget-container-2 .option-swatch-item {
  border: 1px solid var(--option-border) !important;
  border-radius: var(--option-radius-md) !important;
  padding: 12px !important;
  background: var(--option-background) !important;
  transition: var(--option-transition) !important;
  cursor: pointer !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  text-align: center !important;
  min-height: auto !important;
  position: relative !important;
  width: 100% !important;
  gap: 0px !important;
}

#custom-options-widget-container .option-swatch-item:hover,
#custom-options-widget-container-2 .option-swatch-item:hover {
  border-color: var(--option-border-hover) !important;
  box-shadow: var(--option-shadow-hover) !important;
  transform: translateY(-1px) !important;
}

#custom-options-widget-container .option-swatch-item.selected,
#custom-options-widget-container-2 .option-swatch-item.selected {
  border-color: var(--option-border-selected) !important;
  background: var(--option-background) !important;
  box-shadow: inset 0 0 0 1px var(--option-border-selected), var(--option-shadow-md) !important;
}

#custom-options-widget-container .swatch-image,
#custom-options-widget-container-2 .swatch-image {
  width: 100% !important;
  height: auto !important;
  max-height: 150px !important;
  border-radius: 8px !important;
  object-fit: contain !important;
  margin-bottom: 8px !important;
  display: block !important;
  background: #ffffff !important;
  opacity: 0 !important;
  visibility: hidden !important;
  transition: opacity 0.15s ease !important;
}

#custom-options-widget-container .swatch-image.vici-img-ready,
#custom-options-widget-container-2 .swatch-image.vici-img-ready {
  opacity: 1 !important;
  visibility: visible !important;
}

#custom-options-widget-container .swatch-image.vici-img-failed,
#custom-options-widget-container-2 .swatch-image.vici-img-failed {
  display: none !important;
}

#custom-options-widget-container img.vici-img-failed,
#custom-options-widget-container-2 img.vici-img-failed {
  display: none !important;
}

#custom-options-widget-container .option-swatch-item img,
#custom-options-widget-container-2 .option-swatch-item img,
#custom-options-widget-container .design-method img,
#custom-options-widget-container-2 .design-method img,
#custom-options-widget-container .corner-option img,
#custom-options-widget-container-2 .corner-option img {
  opacity: 0 !important;
  visibility: hidden !important;
}

#custom-options-widget-container .option-swatch-item img.vici-img-ready,
#custom-options-widget-container-2 .option-swatch-item img.vici-img-ready,
#custom-options-widget-container .design-method img.vici-img-ready,
#custom-options-widget-container-2 .design-method img.vici-img-ready,
#custom-options-widget-container .corner-option img.vici-img-ready,
#custom-options-widget-container-2 .corner-option img.vici-img-ready {
  opacity: 1 !important;
  visibility: visible !important;
}

/* SIZE FIELD IMAGES - FIT INSTEAD OF CROP */
#custom-options-widget-container .option-field-wrapper[data-field-type="size"] .swatch-image,
#custom-options-widget-container-2 .option-field-wrapper[data-field-type="size"] .swatch-image {
  object-fit: contain !important;
  background: #ffffff !important;
}


#custom-options-widget-container .swatch-label,
#custom-options-widget-container-2 .swatch-label {
  font-size: var(--option-font-size-base) !important;
  font-weight: 500 !important;
  color: var(--option-text) !important;
  margin-top: auto !important;
  line-height: 1.3 !important;
}

#custom-options-widget-container .swatch-price,
#custom-options-widget-container-2 .swatch-price {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: var(--option-primary) !important;
  margin-top: 4px !important;
}

/* SUBLABEL STYLES FOR ALL OPTION TYPES */
#custom-options-widget-container .swatch-sublabel,
#custom-options-widget-container-2 .swatch-sublabel,
#custom-options-widget-container .color-swatch-sublabel,
#custom-options-widget-container-2 .color-swatch-sublabel,
#custom-options-widget-container .option-sublabel,
#custom-options-widget-container-2 .option-sublabel,
#custom-options-widget-container .radio-sublabel,
#custom-options-widget-container-2 .radio-sublabel,
#custom-options-widget-container .size-sublabel,
#custom-options-widget-container-2 .size-sublabel {
  font-size: var(--option-font-size-sm) !important;
  font-weight: 500 !important;
  color: var(--option-subtext) !important;
  margin-top: 0px !important;
  line-height: 1.3 !important;
  opacity: 0.8 !important;
}

/* FORCE ZERO SPACING FOR SUBLABELS WITH HIGHEST SPECIFICITY */
#custom-options-widget-container .option-swatch-item .swatch-sublabel,
#custom-options-widget-container-2 .option-swatch-item .swatch-sublabel,
#custom-options-widget-container .option-swatch-item .size-sublabel,
#custom-options-widget-container-2 .option-swatch-item .size-sublabel,
#custom-options-widget-container .color-swatch-item .color-swatch-sublabel,
#custom-options-widget-container-2 .color-swatch-item .color-swatch-sublabel {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

/* IMAGE SWATCH DYNAMIC LAYOUT - IMAGE VS NO-IMAGE */
/* When image swatch has no image, make it compact like a regular button */
#custom-options-widget-container .option-swatch-item.no-image,
#custom-options-widget-container-2 .option-swatch-item.no-image {
  min-height: 48px !important;
  justify-content: center !important;
  padding: 12px 16px !important;
}

/* When image swatch has an image, use the full layout */
#custom-options-widget-container .option-swatch-item.has-image,
#custom-options-widget-container-2 .option-swatch-item.has-image {
  min-height: auto !important;
}

/* Make sure text in no-image swatches is properly centered and styled */
#custom-options-widget-container .option-swatch-item.no-image .swatch-label,
#custom-options-widget-container-2 .option-swatch-item.no-image .swatch-label {
  margin-top: 0 !important;
  font-size: 16px !important;
  font-weight: 500 !important;
}

/* QUANTITY SLIDER STYLES - MINIMAL COMPACT DESIGN */
#custom-options-widget-container .quantity-slider-wrapper,
#custom-options-widget-container-2 .quantity-slider-wrapper {
  background: none !important;
  padding: 0 !important;
  border: none !important;
  margin: 0 !important;
  position: relative !important;
}

/* REMOVED: quantity-input and save-more-text CSS - no longer used */

#custom-options-widget-container .slider-container,
#custom-options-widget-container-2 .slider-container {
  position: relative !important;
}

#custom-options-widget-container .quantity-slider,
#custom-options-widget-container-2 .quantity-slider {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  width: 100% !important;
  height: 20px !important; /* Container height for clickable area */
  background: transparent !important; /* Make container transparent */
  outline: none !important;
  cursor: pointer !important;
  margin: 0 !important;
  position: relative !important;
}

#custom-options-widget-container .quantity-slider:hover,
#custom-options-widget-container-2 .quantity-slider:hover {
  background: transparent !important;
}

#custom-options-widget-container .quantity-slider:focus,
#custom-options-widget-container-2 .quantity-slider:focus {
  box-shadow: none !important;
  outline: none !important;
  border: none !important;
}

/* WebKit/Chrome - Create custom thin track */
#custom-options-widget-container .quantity-slider::-webkit-slider-runnable-track,
#custom-options-widget-container-2 .quantity-slider::-webkit-slider-runnable-track {
  width: 100% !important;
  height: 4px !important;
  background: #e5e7eb !important;
  border-radius: 2px !important;
  border: none !important;
  outline: none !important;
}

#custom-options-widget-container .quantity-slider:focus::-webkit-slider-runnable-track,
#custom-options-widget-container-2 .quantity-slider:focus::-webkit-slider-runnable-track {
  background: #e5e7eb !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

/* Webkit Slider Thumb - Center on thin track */
#custom-options-widget-container .quantity-slider::-webkit-slider-thumb,
#custom-options-widget-container-2 .quantity-slider::-webkit-slider-thumb {
  -webkit-appearance: none !important;
  appearance: none !important;
  width: 20px !important;
  height: 20px !important;
  border-radius: 50% !important;
  background: var(--option-primary) !important;
  cursor: pointer !important;
  border: none !important;
  outline: none !important;
  margin-top: -8px !important; /* Center thumb on thin track: (20px - 4px) / 2 */
  transition: all 0.15s ease !important;
}

#custom-options-widget-container .quantity-slider:focus::-webkit-slider-thumb,
#custom-options-widget-container-2 .quantity-slider:focus::-webkit-slider-thumb {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
  border: none !important;
  box-shadow: none !important;
  transition: all 0.15s ease !important;
  position: relative !important;
  z-index: 2 !important;
}

#custom-options-widget-container .quantity-slider::-webkit-slider-thumb:hover,
#custom-options-widget-container-2 .quantity-slider::-webkit-slider-thumb:hover {
  transform: scale(1.1) !important;
}

#custom-options-widget-container .quantity-slider::-webkit-slider-thumb:active,
#custom-options-widget-container-2 .quantity-slider::-webkit-slider-thumb:active {
  transform: scale(1.05) !important;
}

/* Firefox Slider Thumb - Minimal Design */
#custom-options-widget-container .quantity-slider::-moz-range-thumb,
#custom-options-widget-container-2 .quantity-slider::-moz-range-thumb {
  width: 20px !important;
  height: 20px !important;
  border-radius: 50% !important;
  background: var(--option-primary) !important;
  cursor: pointer !important;
  border: none !important;
  box-shadow: none !important;
  transition: all 0.15s ease !important;
}

#custom-options-widget-container .quantity-slider::-moz-range-track,
#custom-options-widget-container-2 .quantity-slider::-moz-range-track {
  width: 100% !important;
  height: 4px !important;
  cursor: pointer !important;
  background: #e5e7eb !important;
  border-radius: 2px !important;
  border: none !important;
  outline: none !important;
}

#custom-options-widget-container .quantity-slider:focus::-moz-range-track,
#custom-options-widget-container-2 .quantity-slider:focus::-moz-range-track {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

#custom-options-widget-container .quantity-slider:focus::-moz-range-thumb,
#custom-options-widget-container-2 .quantity-slider:focus::-moz-range-thumb {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

/* IE/Edge Support - Force thin track */
#custom-options-widget-container .quantity-slider::-ms-track,
#custom-options-widget-container-2 .quantity-slider::-ms-track {
  width: 100% !important;
  height: 4px !important;
  background: transparent !important;
  border-color: transparent !important;
  color: transparent !important;
}

#custom-options-widget-container .quantity-slider::-ms-fill-lower,
#custom-options-widget-container-2 .quantity-slider::-ms-fill-lower,
#custom-options-widget-container .quantity-slider::-ms-fill-upper,
#custom-options-widget-container-2 .quantity-slider::-ms-fill-upper {
  background: #e5e7eb !important;
  height: 4px !important;
  border-radius: 2px !important;
}

#custom-options-widget-container .quantity-slider::-ms-thumb,
#custom-options-widget-container-2 .quantity-slider::-ms-thumb {
  width: 20px !important;
  height: 20px !important;
  border-radius: 50% !important;
  background: var(--option-primary) !important;
  cursor: pointer !important;
  border: none !important;
  margin-top: 0 !important;
}

/* Slider Labels - Minimal */
#custom-options-widget-container .slider-labels,
#custom-options-widget-container-2 .slider-labels {
  display: flex !important;
  justify-content: space-between !important;
  margin-top: 5px !important;
  font-size: 12px !important;
  color: #6b7280 !important;
  font-weight: 500 !important;
}

#custom-options-widget-container .slider-current-quantity,
#custom-options-widget-container-2 .slider-current-quantity {
  font-weight: 500 !important;
  color: var(--option-text) !important;
  font-size: 14px !important;
}

#custom-options-widget-container .total-price,
#custom-options-widget-container-2 .total-price {
  font-weight: 500 !important;
  color: #6b7280 !important;
  font-size: 12px !important;
}

/* QUANTITY AND UNIT PRICE DISPLAY BELOW SLIDER */
#custom-options-widget-container .unit-price-below-slider,
#custom-options-widget-container-2 .unit-price-below-slider {
  text-align: center !important;
  margin-top: 8px !important;
  line-height: 1.2 !important;
}

#custom-options-widget-container .quantity-display-below,
#custom-options-widget-container-2 .quantity-display-below {
  margin-bottom: 4px !important;
}

#custom-options-widget-container .quantity-display-below .total-price-quantity,
#custom-options-widget-container-2 .quantity-display-below .total-price-quantity {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: var(--option-text) !important;
}

#custom-options-widget-container .unit-price-below-slider .original-price-crossed,
#custom-options-widget-container-2 .unit-price-below-slider .original-price-crossed {
  text-decoration: line-through !important;
  color: #9ca3af !important;
  font-size: 14px !important;
  margin-right: 8px !important;
}

#custom-options-widget-container .unit-price-below-slider .current-unit-price,
#custom-options-widget-container-2 .unit-price-below-slider .current-unit-price {
  font-size: 15px !important;
  font-weight: 500 !important;
  color: var(--option-text) !important;
}

#custom-options-widget-container .unit-price-below-slider .volume-discount,
#custom-options-widget-container-2 .unit-price-below-slider .volume-discount {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #10b981 !important;
  margin-top: 4px !important;
}

/* PRICE DISPLAY BELOW SLIDER */
#custom-options-widget-container .price-display-below,
#custom-options-widget-container-2 .price-display-below {
  text-align: center !important;
  margin-top: -8px !important;
}

#custom-options-widget-container .price-display-below .price-text,
#custom-options-widget-container-2 .price-display-below .price-text,
#custom-options-widget-container .price-display-below .total-price-text,
#custom-options-widget-container-2 .price-display-below .total-price-text {
  font-size: 24px !important;
  font-weight: 500 !important;
  color: var(--option-primary) !important;
  margin-bottom: 4px !important;
}

#custom-options-widget-container .unit-pricing-breakdown,
#custom-options-widget-container-2 .unit-pricing-breakdown {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #6b7280 !important;
  line-height: 1.4 !important;
}

#custom-options-widget-container .buy-more-text,
#custom-options-widget-container-2 .buy-more-text {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #6b7280 !important;
  font-style: italic !important;
}

/* CORNER GROUP - 2 COLUMN GRID LAYOUT */
#custom-options-widget-container .corner-group,
#custom-options-widget-container-2 .corner-group {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: var(--option-gap) !important;
  width: 100% !important;
}

/* BUTTON GROUP - CONFIGURABLE GRID LAYOUT */
#custom-options-widget-container .button-group,
#custom-options-widget-container-2 .button-group {
  width: 100% !important;
  box-sizing: border-box !important;
  /* Note: display and grid-template-columns are set via inline styles for configurability */
}

/* CORNER, BUTTON SELECTION STYLES - ENHANCED */
#custom-options-widget-container .corner-option,
#custom-options-widget-container-2 .corner-option {
  border: 1px solid var(--option-border) !important;
  border-radius: var(--option-radius-md) !important;
  padding: 6px 16px !important;
  background: var(--option-background) !important;
  color: var(--option-text) !important;
  font-weight: 500 !important;
  font-size: var(--option-font-size-base) !important;
  font-family: var(--option-font-family) !important;
  transition: var(--option-transition) !important;
  cursor: pointer !important;
  min-height: 44px !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  text-align: left !important;
  line-height: 1.3 !important;
  width: 100% !important;
  box-sizing: border-box !important;
}

#custom-options-widget-container .option-button,
#custom-options-widget-container-2 .option-button {
  border: 1px solid var(--option-border) !important;
  border-radius: var(--option-radius-md) !important;
  padding: 12px 16px !important;
  background: var(--option-background) !important;
  color: var(--option-text) !important;
  font-weight: 500 !important;
  font-size: var(--option-font-size-base) !important;
  font-family: var(--option-font-family) !important;
  transition: var(--option-transition) !important;
  cursor: pointer !important;
  min-height: 44px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  line-height: 1.3 !important;
  width: 100% !important;
  box-sizing: border-box !important;
}

#custom-options-widget-container .corner-option:hover,
#custom-options-widget-container-2 .corner-option:hover,
#custom-options-widget-container .option-button:hover,
#custom-options-widget-container-2 .option-button:hover {
  border-color: var(--option-border-hover) !important;
  box-shadow: var(--option-shadow-hover) !important;
  transform: translateY(-1px) !important;
}

#custom-options-widget-container .corner-option.selected,
#custom-options-widget-container-2 .corner-option.selected,
#custom-options-widget-container .option-button.selected,
#custom-options-widget-container-2 .option-button.selected {
  border-color: var(--option-border-selected) !important;
  background: var(--option-background) !important;
  box-shadow: inset 0 0 0 1px var(--option-border-selected), var(--option-shadow-md) !important;
  font-weight: 500 !important;
}

/* RADIO OPTION STYLES - ENHANCED */
#custom-options-widget-container .radio-option,
#custom-options-widget-container-2 .radio-option {
  border: 1px solid var(--option-border) !important;
  border-radius: var(--option-radius-md) !important;
  padding: 12px 16px !important;
  background: var(--option-background) !important;
  transition: var(--option-transition) !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  min-height: 44px !important;
}

#custom-options-widget-container .radio-option:hover,
#custom-options-widget-container-2 .radio-option:hover {
  border-color: var(--option-border-hover) !important;
  box-shadow: var(--option-shadow-hover) !important;
  transform: translateY(-1px) !important;
}

#custom-options-widget-container .radio-option.selected,
#custom-options-widget-container-2 .radio-option.selected {
  border-color: var(--option-border-selected) !important;
  background: var(--option-background) !important;
  box-shadow: inset 0 0 0 1px var(--option-border-selected), var(--option-shadow-md) !important;
}

#custom-options-widget-container .radio-option label,
#custom-options-widget-container-2 .radio-option label {
  font-weight: 500 !important;
  font-size: var(--option-font-size-base) !important;
  color: var(--option-text) !important;
  font-family: var(--option-font-family) !important;
  line-height: 1.4 !important;
  margin-left: 12px !important;
}

#custom-options-widget-container .radio-option input[type="radio"],
#custom-options-widget-container-2 .radio-option input[type="radio"] {
  width: 18px !important;
  height: 18px !important;
  accent-color: var(--option-primary) !important;
}

/* CUSTOM DROPDOWN STYLING - FULL DESIGN CONTROL */
.custom-dropdown-wrapper {
  position: relative !important;
  width: 100% !important;
}

#custom-options-widget-container .custom-dropdown-trigger,
#custom-options-widget-container-2 .custom-dropdown-trigger {
  border: 1px solid var(--option-border, #e0e0e0) !important;
  border-radius: var(--option-radius-md, 8px) !important;
  padding: 16px 18px !important;
  color: var(--option-text, #333333) !important;
  background: var(--option-background, #ffffff) !important;
  font-family: var(--option-font-family) !important;
  font-size: var(--option-font-size-base, 16px) !important;
  font-weight: 500 !important;
  width: 100% !important;
  min-height: 52px !important;
  transition: all 0.2s ease !important;
  cursor: pointer !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  box-sizing: border-box !important;
  line-height: 1.4 !important;
  outline: none !important;
  box-shadow: none !important;
}

#custom-options-widget-container .custom-dropdown-trigger *,
#custom-options-widget-container-2 .custom-dropdown-trigger * {
  outline: none !important;
  box-shadow: none !important;
}

#custom-options-widget-container .custom-dropdown-trigger:hover,
#custom-options-widget-container-2 .custom-dropdown-trigger:hover {
  border-color: var(--option-border-hover, #cccccc) !important;
}

#custom-options-widget-container .custom-dropdown-trigger.active,
#custom-options-widget-container-2 .custom-dropdown-trigger.active {
  border-color: var(--option-primary, #000000) !important;
  box-shadow: none !important;
  outline: none !important;
}

#custom-options-widget-container .custom-dropdown-trigger:focus,
#custom-options-widget-container-2 .custom-dropdown-trigger:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: var(--option-primary, #000000) !important;
}

#custom-options-widget-container .custom-dropdown-trigger:focus-visible,
#custom-options-widget-container-2 .custom-dropdown-trigger:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  border-color: var(--option-primary, #000000) !important;
}

#custom-options-widget-container .custom-dropdown-trigger,
#custom-options-widget-container-2 .custom-dropdown-trigger {
  outline: none !important;
}

#custom-options-widget-container .custom-dropdown-text,
#custom-options-widget-container-2 .custom-dropdown-text {
  flex: 1 !important;
  text-align: left !important;
}

#custom-options-widget-container .custom-dropdown-arrow,
#custom-options-widget-container-2 .custom-dropdown-arrow {
  margin-left: 12px !important;
  transition: transform 0.2s ease !important;
  font-size: 12px !important;
  color: var(--option-text, #333333) !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

#custom-options-widget-container .custom-dropdown-arrow svg,
#custom-options-widget-container-2 .custom-dropdown-arrow svg {
  width: 16px !important;
  height: 16px !important;
  display: block !important;
  stroke: currentColor !important;
  fill: none !important;
}

#custom-options-widget-container .custom-dropdown-trigger.active .custom-dropdown-arrow,
#custom-options-widget-container-2 .custom-dropdown-trigger.active .custom-dropdown-arrow {
  transform: rotate(180deg) !important;
}

#custom-options-widget-container .custom-dropdown-menu,
#custom-options-widget-container-2 .custom-dropdown-menu {
  position: absolute !important;
  top: 100% !important;
  left: 0 !important;
  right: 0 !important;
  background: var(--option-background, #ffffff) !important;
  border: 1px solid var(--option-border, #e0e0e0) !important;
  border-radius: var(--option-radius-md, 8px) !important;
  z-index: 1000 !important;
  max-height: 200px !important;
  overflow-y: auto !important;
  display: none !important;
  margin-top: 4px !important;
  padding: 8px !important;
}

#custom-options-widget-container .custom-dropdown-menu.active,
#custom-options-widget-container-2 .custom-dropdown-menu.active {
  display: block !important;
}

#custom-options-widget-container .custom-dropdown-option,
#custom-options-widget-container-2 .custom-dropdown-option {
  padding: 16px 18px !important;
  color: var(--option-text, #333333) !important;
  font-family: var(--option-font-family) !important;
  font-size: var(--option-font-size-base, 16px) !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  border-radius: var(--option-radius-md, 8px) !important;
  margin-bottom: 8px !important;
  line-height: 1.4 !important;
  background: #ffffff !important;
}

#custom-options-widget-container .custom-dropdown-option:hover,
#custom-options-widget-container-2 .custom-dropdown-option:hover {
  background: #f5f5f5 !important;
}

#custom-options-widget-container .custom-dropdown-option:last-child,
#custom-options-widget-container-2 .custom-dropdown-option:last-child {
  margin-bottom: 0 !important;
}

#custom-options-widget-container .custom-dropdown-option.selected,
#custom-options-widget-container-2 .custom-dropdown-option.selected {
  background: var(--option-background, #ffffff) !important;
  color: var(--option-text, #333333) !important;
  font-weight: 500 !important;
  border: 2px solid #103c70 !important;
}

.custom-dropdown-option.disabled {
  background: var(--option-background, #ffffff) !important;
  color: var(--option-text-muted, #999999) !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}

/* MODERN DROPDOWN STYLING - ENHANCED STYLE STUDIO */
#custom-options-widget-container .option-widget-select:hover,
#custom-options-widget-container-2 .option-widget-select:hover {
  border-color: var(--option-border-hover, #cccccc) !important;
  background: var(--option-background, #ffffff) !important;
}

#custom-options-widget-container .option-widget-select:focus,
#custom-options-widget-container-2 .option-widget-select:focus {
  border-color: var(--option-primary, #000000) !important;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1) !important;
  outline: none !important;
}

/* DROPDOWN OPTIONS STYLING - ENHANCED FOR DESIGN CONSISTENCY */
#custom-options-widget-container .option-widget-select option,
#custom-options-widget-container-2 .option-widget-select option {
  background: var(--option-background, #ffffff) !important;
  color: var(--option-text, #333333) !important;
  font-family: var(--option-font-family) !important;
  font-size: var(--option-font-size-base, 16px) !important;
  font-weight: 500 !important;
  padding: 16px 18px !important;
  border: none !important;
  border-radius: var(--option-radius-md, 8px) !important;
  line-height: 1.4 !important;
  margin: 2px 0 !important;
  transition: all 0.2s ease !important;
}

#custom-options-widget-container .option-widget-select option:hover,
#custom-options-widget-container-2 .option-widget-select option:hover {
  background: var(--option-border-hover, #f0f0f0) !important;
  color: var(--option-text, #333333) !important;
  border-radius: var(--option-radius-md, 8px) !important;
}

#custom-options-widget-container .option-widget-select option:checked,
#custom-options-widget-container-2 .option-widget-select option:checked,
#custom-options-widget-container .option-widget-select option:selected,
#custom-options-widget-container-2 .option-widget-select option:selected {
  background: var(--option-primary, #000000) !important;
  color: var(--option-background, #ffffff) !important;
  font-weight: 500 !important;
  border-radius: var(--option-radius-md, 8px) !important;
}

#custom-options-widget-container .option-widget-select option:disabled,
#custom-options-widget-container-2 .option-widget-select option:disabled {
  background: var(--option-background, #ffffff) !important;
  color: var(--option-text-muted, #999999) !important;
  font-style: italic !important;
  opacity: 0.6 !important;
  border-radius: var(--option-radius-md, 8px) !important;
}

/* ENHANCED DROPDOWN CONTAINER STYLING */
#custom-options-widget-container .option-widget-select,
#custom-options-widget-container-2 .option-widget-select {
  border: 1px solid var(--option-border, #e0e0e0) !important;
  border-radius: var(--option-radius-md, 8px) !important;
  padding: 16px 18px !important;
  color: var(--option-text, #333333) !important;
  background: var(--option-background, #ffffff) !important;
  font-family: var(--option-font-family) !important;
  font-size: var(--option-font-size-base, 16px) !important;
  font-weight: 500 !important;
  width: 100% !important;
  min-height: 52px !important;
  transition: all 0.2s ease !important;
  appearance: none !important;
  background-image: url('data:image/svg+xml;utf8,<svg fill="%23333" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>') !important;
  background-repeat: no-repeat !important;
  background-position: right 16px center !important;
  background-size: 20px !important;
  line-height: 1.4 !important;
  box-sizing: border-box !important;
}

/* QUANTITY GRID STYLES - STYLE STUDIO EXACT MATCH */
#custom-options-widget-container .quantity-grid,
#custom-options-widget-container-2 .quantity-grid {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr)) !important;
  gap: 12px !important;
  padding: 0 !important;
  margin: 16px 0 !important;
}

#custom-options-widget-container .quantity-option,
#custom-options-widget-container-2 .quantity-option {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 14px 20px !important;
  background: var(--option-background) !important;
  border: 1px solid var(--option-border) !important;
  border-radius: var(--option-radius-md) !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  font-weight: 500 !important;
  font-size: 17px !important;
  min-height: 48px !important;
  color: var(--option-text) !important;
}

#custom-options-widget-container .quantity-option:hover,
#custom-options-widget-container-2 .quantity-option:hover {
  border-color: var(--option-border-hover) !important;
  background: var(--option-background-hover) !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important;
}

#custom-options-widget-container .quantity-option.selected,
#custom-options-widget-container-2 .quantity-option.selected {
  border-color: var(--option-border-selected) !important;
  background: var(--option-background-selected) !important;
  box-shadow: inset 0 0 0 1px var(--option-border-selected) !important;
  color: var(--option-text-selected) !important;
  font-weight: 500 !important;
}

/* QUANTITY TIERS - ENHANCED STYLE STUDIO DESIGN */
#custom-options-widget-container .quantity-list,
#custom-options-widget-container-2 .quantity-list {
  display: flex !important;
  flex-direction: column !important;
  gap: 4px !important;
}

#custom-options-widget-container .quantity-tier,
#custom-options-widget-container-2 .quantity-tier {
  position: relative !important;
  border: 1px solid var(--option-border) !important;
  border-radius: var(--option-radius-lg) !important;
  padding: 4px 12px 4px 22px !important;
  background: var(--option-background) !important;
  transition: var(--option-transition) !important;
  cursor: pointer !important;
  display: grid !important;
  grid-template-columns: 1fr 1fr 1fr !important;
  grid-template-areas: "quantity pricing savings" !important;
  align-items: center !important;
  gap: 12px !important;
  min-height: 40px !important;
  height: auto !important;
}

#custom-options-widget-container .quantity-tier:hover,
#custom-options-widget-container-2 .quantity-tier:hover {
  border-color: var(--option-border-hover) !important;
  box-shadow: var(--option-shadow-hover) !important;
  transform: translateY(-1px) !important;
}

/* QUANTITY TIER UNAVAILABLE - MUST HIDE $0 TIERS */
#custom-options-widget-container .quantity-tier.quantity-tier-unavailable,
#custom-options-widget-container-2 .quantity-tier.quantity-tier-unavailable {
  display: none !important;
}

#custom-options-widget-container .quantity-tier.selected,
#custom-options-widget-container-2 .quantity-tier.selected {
  border-color: var(--option-border-selected) !important;
  background: var(--option-background) !important;
  box-shadow: inset 0 0 0 1px var(--option-border-selected), var(--option-shadow-md) !important;
}

#custom-options-widget-container .quantity-tier.recommended,
#custom-options-widget-container-2 .quantity-tier.recommended {
  position: relative !important;
}

#custom-options-widget-container .tier-badge-inline,
#custom-options-widget-container-2 .tier-badge-inline {
  background: #103c70 !important;
  color: white !important;
  padding: 4px 12px !important; /* Reduced from 6px 16px to make pill smaller */
  border-radius: 16px !important; /* Reduced from 20px to match smaller padding */
  font-size: var(--option-font-size-xs) !important;
  font-weight: 500 !important;
  margin-left: 18px !important;
  display: inline-block !important;
  vertical-align: middle !important;
}

#custom-options-widget-container .tier-info,
#custom-options-widget-container-2 .tier-info {
  grid-area: quantity !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  gap: 0 !important;
  height: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

#custom-options-widget-container .tier-quantity,
#custom-options-widget-container-2 .tier-quantity {
  grid-area: quantity !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: var(--option-text) !important;
  line-height: 1.4 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  margin: 0 !important;
  padding: 0 !important;
}




#custom-options-widget-container .tier-pricing,
#custom-options-widget-container-2 .tier-pricing {
  grid-area: pricing !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  gap: 8px !important;
  width: 100% !important;
  height: 100% !important;
}

#custom-options-widget-container .tier-price,
#custom-options-widget-container-2 .tier-price {
  font-size: 15px !important;
  font-weight: 500 !important;
  color: var(--option-text) !important;
  line-height: 1.1 !important;
  text-align: center !important;
}

#custom-options-widget-container .tier-unit-price,
#custom-options-widget-container-2 .tier-unit-price {
  font-size: 15px !important;
  font-weight: 500 !important;
  color: var(--option-text-muted, #666) !important;
  line-height: 1.1 !important;
  text-align: center !important;
}

#custom-options-widget-container .tier-savings,
#custom-options-widget-container-2 .tier-savings {
  grid-area: savings !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #29B829 !important;
  min-width: auto !important;
  white-space: nowrap !important;
  flex-shrink: 0 !important;
}

/* Force all quantity tier content to be vertically centered */
#custom-options-widget-container .quantity-tier > *,
#custom-options-widget-container-2 .quantity-tier > * {
  display: flex !important;
  align-items: center !important;
}

/* Savings with actual savings - green text (default above) */
#custom-options-widget-container .tier-savings.has-savings,
#custom-options-widget-container-2 .tier-savings.has-savings {
  color: #29B829 !important;
}

/* No savings options - neutral text (still visible) */
#custom-options-widget-container .tier-savings.no-savings,
#custom-options-widget-container-2 .tier-savings.no-savings {
  color: var(--option-text-muted, #8b8b8b) !important;
}

/* Removed ::before arrow – caused encoding garble */

#custom-options-widget-container .see-more-quantities,
#custom-options-widget-container-2 .see-more-quantities {
  background: none !important;
  border: none !important;
  color: #000 !important;
  font-family: var(--option-font-family) !important;
  font-size: var(--option-font-size-sm) !important;
  font-weight: 500 !important;
  text-decoration: underline !important;
  cursor: pointer !important;
  padding: 8px 0 !important;
  margin-top: 4px !important;
  transition: var(--option-transition) !important;
}

#custom-options-widget-container .see-more-quantities:hover,
#custom-options-widget-container-2 .see-more-quantities:hover {
  color: #333 !important;
}

#custom-options-widget-container .quantity-tier-hidden,
#custom-options-widget-container-2 .quantity-tier-hidden {
  display: none !important;
}
  font-size: var(--option-font-size-xl) !important;
  font-weight: 500 !important;
  color: var(--option-primary) !important;
  line-height: 1.1 !important;
}

/* FORM INPUTS - ENHANCED STYLE STUDIO DESIGN */
#custom-options-widget-container input.option-widget-input,
#custom-options-widget-container-2 input.option-widget-input,
#custom-options-widget-container textarea.option-widget-textarea,
#custom-options-widget-container-2 textarea.option-widget-textarea {
  border: 1px solid var(--option-border) !important;
  border-radius: var(--option-radius-md) !important;
  padding: 16px 18px !important;
  color: var(--option-text) !important;
  background: var(--option-background) !important;
  font-family: var(--option-font-family) !important;
  font-size: var(--option-font-size-base) !important;
  font-weight: 500 !important;
  width: 100% !important;
  max-width: none !important;
  box-sizing: border-box !important;
  transition: var(--option-transition) !important;
  line-height: 1.4 !important;
  min-height: 42px !important;
}

#custom-options-widget-container input.option-widget-input:hover,
#custom-options-widget-container-2 input.option-widget-input:hover,
#custom-options-widget-container textarea.option-widget-textarea:hover,
#custom-options-widget-container-2 textarea.option-widget-textarea:hover {
  border-color: var(--option-border-hover) !important;
}

#custom-options-widget-container input.option-widget-input:focus,
#custom-options-widget-container-2 input.option-widget-input:focus,
#custom-options-widget-container textarea.option-widget-textarea:focus,
#custom-options-widget-container-2 textarea.option-widget-textarea:focus {
  outline: none !important;
  border-color: var(--option-primary) !important;
  box-shadow: var(--option-shadow-focus) !important;
}

#custom-options-widget-container textarea.option-widget-textarea,
#custom-options-widget-container-2 textarea.option-widget-textarea {
  min-height: 60px !important;
  resize: vertical !important;
}

/* ENSURE TEXT INPUT FIELDS ARE FULL WIDTH */
#custom-options-widget-container input[type="text"].option-widget-input,
#custom-options-widget-container-2 input[type="text"].option-widget-input {
  width: 100% !important;
  max-width: none !important;
  min-width: 0 !important;
  box-sizing: border-box !important;
  display: block !important;
}

/* DATE PICKER STYLING */
#custom-options-widget-container input[type="date"],
#custom-options-widget-container-2 input[type="date"] {
  border: 1px solid var(--option-border) !important;
  border-radius: var(--option-radius-md) !important;
  padding: 16px 18px !important;
  color: var(--option-text) !important;
  background: var(--option-background) !important;
  font-family: var(--option-font-family) !important;
  width: 100% !important;
  font-size: var(--option-font-size-base) !important;
  transition: var(--option-transition) !important;
  min-height: 52px !important;
}

#custom-options-widget-container input[type="date"]:hover,
#custom-options-widget-container-2 input[type="date"]:hover {
  border-color: var(--option-border-hover) !important;
}

#custom-options-widget-container input[type="date"]:focus,
#custom-options-widget-container-2 input[type="date"]:focus {
  outline: none !important;
  border-color: var(--option-primary) !important;
  box-shadow: var(--option-shadow-focus) !important;
}

/* DESIGN METHOD GRID - STYLE STUDIO LAYOUT */
#custom-options-widget-container .design-method-group,
#custom-options-widget-container-2 .design-method-group {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)) !important;
  gap: var(--option-gap) !important;
}

#custom-options-widget-container .design-method,
#custom-options-widget-container-2 .design-method {
  border: 1px solid var(--option-border) !important;
  border-radius: var(--option-radius-md) !important;
  padding: 12px !important;
  background: var(--option-background) !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  cursor: pointer !important;
  transition: var(--option-transition) !important;
  text-align: center !important;
  position: relative !important;
  overflow: hidden !important;
  /* Prevent all transforms to avoid image glitch */
  transform: none !important;
  will-change: auto !important;
}

#custom-options-widget-container .design-method:hover,
#custom-options-widget-container-2 .design-method:hover {
  border-color: var(--option-border-hover) !important;
  box-shadow: var(--option-shadow-hover) !important;
  /* Completely disable transform on hover to prevent image glitch */
  transform: none !important;
}

/* Prevent layout shift for multi-line design method labels */
#custom-options-widget-container .design-method .swatch-label,
#custom-options-widget-container-2 .design-method .swatch-label {
  line-height: 1.3 !important;
  min-height: 2.6em !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-bottom: 2px !important;
}

/* Override all performance optimizations for design methods to prevent image glitch */
#custom-options-widget-container .design-method,
#custom-options-widget-container-2 .design-method {
  will-change: auto !important;
  transform: none !important;
  backface-visibility: visible !important;
  perspective: none !important;
}

/* Prevent scroll anchoring and layout shifts */
#custom-options-widget-container,
#custom-options-widget-container-2 {
  overflow-anchor: none !important;
}

/* Ensure stable button sizing to prevent reflow */
#custom-options-widget-container .start-making-button,
#custom-options-widget-container-2 .start-making-button {
  min-width: 140px !important;
  text-align: center !important;
}

#custom-options-widget-container .design-method.selected,
#custom-options-widget-container-2 .design-method.selected {
  border-color: var(--option-border-selected) !important;
  box-shadow: inset 0 0 0 1px var(--option-border-selected), var(--option-shadow-md) !important;
}

#custom-options-widget-container .method-image,
#custom-options-widget-container-2 .method-image {
  width: 100% !important;
  height: 85px !important;
  object-fit: cover !important;
  border-radius: 8px !important;
  margin-bottom: 4px !important;
  opacity: 0 !important;
  visibility: hidden !important;
  transition: opacity 0.15s ease !important;
}

#custom-options-widget-container .method-image.vici-img-ready,
#custom-options-widget-container-2 .method-image.vici-img-ready {
  opacity: 1 !important;
  visibility: visible !important;
}

#custom-options-widget-container .method-image.vici-img-failed,
#custom-options-widget-container-2 .method-image.vici-img-failed {
  display: none !important;
}

#custom-options-widget-container .corner-image,
#custom-options-widget-container-2 .corner-image {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
  transition: opacity 0.15s ease !important;
}

#custom-options-widget-container .corner-image.vici-img-ready,
#custom-options-widget-container-2 .corner-image.vici-img-ready {
  display: block !important;
  opacity: 1 !important;
  visibility: visible !important;
}

#custom-options-widget-container .corner-image.vici-img-loading,
#custom-options-widget-container-2 .corner-image.vici-img-loading,
#custom-options-widget-container .corner-image.vici-img-failed,
#custom-options-widget-container-2 .corner-image.vici-img-failed {
  display: none !important;
}

#custom-options-widget-container .method-name,
#custom-options-widget-container-2 .method-name {
  font-size: 17px !important;
  font-weight: 500 !important;
  color: var(--option-text) !important;
  margin-bottom: 4px !important;
  line-height: 1.3 !important;
  width: 100% !important;
  text-align: center !important;
}

#custom-options-widget-container .swatch-label,
#custom-options-widget-container-2 .swatch-label {
  font-size: 17px !important;
  font-weight: 500 !important;
  color: var(--option-text) !important;
  margin-bottom: 0px !important;
  line-height: 1.3 !important;
  width: 100% !important;
  text-align: center !important;
}

#custom-options-widget-container .method-subtext,
#custom-options-widget-container-2 .method-subtext {
  font-size: 14px !important;
  color: var(--option-subtext) !important;
  margin-bottom: 6px !important;
  line-height: 1.4 !important;
}

#custom-options-widget-container .swatch-price,
#custom-options-widget-container-2 .swatch-price {
  background: #F26F0A !important;
  color: white !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  padding: 2px 10px !important;
  border-radius: 0 0 0 8px !important;
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
  margin: 0 !important;
  z-index: 2 !important;
  line-height: 1.4 !important;
}

#custom-options-widget-container .method-subtext,
#custom-options-widget-container-2 .method-subtext {
  font-size: var(--option-font-size-sm) !important;
  color: var(--option-text-secondary) !important;
  line-height: 1.4 !important;
  margin-bottom: 6px !important;
  flex-grow: 1 !important;
}

#custom-options-widget-container .method-price,
#custom-options-widget-container-2 .method-price {
  font-size: var(--option-font-size-sm) !important;
  font-weight: 500 !important;
  color: var(--option-primary) !important;
  margin-top: auto !important;
}

/* UPLOAD FIELDS - MODERN STYLE STUDIO DESIGN */
#custom-options-widget-container .upload-wrapper,
#custom-options-widget-container-2 .upload-wrapper {
  border: 1px dashed #e0e0e0 !important;
  border-radius: 12px !important;
  padding: 32px 24px !important;
  text-align: center !important;
  transition: border-color 0.2s, background-color 0.2s !important;
  background: #fafafa !important;
  cursor: pointer !important;
}

#custom-options-widget-container .upload-wrapper:hover,
#custom-options-widget-container-2 .upload-wrapper:hover {
  border-color: var(--option-primary) !important;
  background: #f5f5f5 !important;
}

#custom-options-widget-container .upload-wrapper .upload-icon,
#custom-options-widget-container-2 .upload-wrapper .upload-icon {
  width: 48px !important;
  height: 48px !important;
  margin: 0 auto 16px !important;
  background: #e0e0e0 !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #666 !important;
}

/* ACTION BUTTONS */
#custom-options-widget-container .start-making-button,
#custom-options-widget-container-2 .start-making-button {
  background: #103c70 !important;
  color: #fff !important;
  border-radius: 50px !important;
  padding: 12px 24px !important;
  transition: none !important;
  border: none !important;
  cursor: pointer !important;
  font-family: var(--option-font-family) !important;
  width: 100% !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  position: relative !important;
  overflow: hidden !important;
  min-height: 48px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Cart button animated checkmark */
@keyframes vici-checkmark-draw {
  0% { stroke-dashoffset: 24; }
  100% { stroke-dashoffset: 0; }
}
@keyframes vici-checkmark-circle {
  0% { stroke-dashoffset: 126; }
  100% { stroke-dashoffset: 0; }
}
@keyframes vici-spinner {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
@keyframes vici-btn-success-bg {
  0% { background-color: #103c70; }
  100% { background-color: #103c70; }
}

.vici-btn-loading .vici-spinner {
  animation: vici-spinner 0.8s linear infinite;
}
.vici-btn-success {
  animation: vici-btn-success-bg 0.3s ease forwards !important;
}
.vici-btn-success .vici-checkmark-circle {
  stroke-dasharray: 126;
  stroke-dashoffset: 126;
  animation: vici-checkmark-circle 0.4s ease 0.1s forwards;
}
.vici-btn-success .vici-checkmark-check {
  stroke-dasharray: 24;
  stroke-dashoffset: 24;
  animation: vici-checkmark-draw 0.3s ease 0.4s forwards;
}

#custom-options-widget-container .start-making-button:hover,
#custom-options-widget-container-2 .start-making-button:hover {
  background: #103c70 !important;
}

/* START MAKING BUTTON MODES */
#custom-options-widget-container .start-making-button.design-mode,
#custom-options-widget-container-2 .start-making-button.design-mode {
  background: #103c70 !important;
}

#custom-options-widget-container .start-making-button.design-mode:hover,
#custom-options-widget-container-2 .start-making-button.design-mode:hover {
  background: #103c70 !important;
}

#custom-options-widget-container .start-making-button.upload-mode,
#custom-options-widget-container-2 .start-making-button.upload-mode {
  background: #103c70 !important;
}

#custom-options-widget-container .start-making-button.upload-mode:hover,
#custom-options-widget-container-2 .start-making-button.upload-mode:hover {
  background: #103c70 !important;
}

#custom-options-widget-container .start-making-button.cart-mode,
#custom-options-widget-container-2 .start-making-button.cart-mode {
  background: #103c70 !important;
}

#custom-options-widget-container .start-making-button.cart-mode:hover,
#custom-options-widget-container-2 .start-making-button.cart-mode:hover {
  background: #103c70 !important;
}

/* START MAKING WRAPPER AND LATER OPTIONS */
.start-making-wrapper {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 8px !important;
}

.later-options {
  display: flex !important;
  gap: 16px !important;
  justify-content: center !important;
  margin-top: 14px !important;
}

.later-link {
  background: none !important;
  border: none !important;
  padding: 4px 8px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #6b7280 !important;
  cursor: pointer !important;
  transition: color 0.2s ease !important;
  font-family: var(--option-font-family) !important;
}

.later-link:hover {
  color: #374151 !important;
}

.later-link u {
  text-decoration: underline !important;
  text-decoration-color: currentColor !important;
}

/* DESIGN STUDIO AND UPLOAD EDITOR MODALS */
.design-studio-modal,
.upload-editor-modal {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 10000 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 20px !important;
}

.design-studio-overlay,
.upload-editor-overlay {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background: rgba(0, 0, 0, 0.7) !important;
  backdrop-filter: blur(4px) !important;
}

.design-studio-container,
.upload-editor-container {
  position: relative !important;
  width: 100% !important;
  max-width: 1200px !important;
  max-height: 90vh !important;
  background: white !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  display: flex !important;
  flex-direction: column !important;
}

.design-studio-header,
.upload-editor-header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 20px 24px !important;
  border-bottom: 1px solid #e5e7eb !important;
  background: #f9fafb !important;
}

.design-studio-header h3,
.upload-editor-header h3 {
  margin: 0 !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  color: #111827 !important;
}

.close-button {
  width: 32px !important;
  height: 32px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: none !important;
  border: none !important;
  border-radius: 6px !important;
  font-size: 18px !important;
  color: #6b7280 !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

.close-button:hover {
  background: #e5e7eb !important;
  color: #374151 !important;
}

#design-studio-iframe,
#upload-editor-iframe {
  flex: 1 !important;
  border: none !important;
  min-height: 600px !important;
}

.design-studio-footer,
.upload-editor-footer {
  display: flex !important;
  gap: 12px !important;
  padding: 20px 24px !important;
  border-top: 1px solid #e5e7eb !important;
  background: #f9fafb !important;
  justify-content: flex-end !important;
}

.btn-secondary {
  padding: 10px 20px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #374151 !important;
  background: white !important;
  border: 1px solid #d1d5db !important;
  border-radius: 6px !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

.btn-secondary:hover {
  background: #f9fafb !important;
  border-color: #9ca3af !important;
}

.btn-primary {
  padding: 10px 20px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: white !important;
  background: #2563eb !important;
  border: 1px solid #2563eb !important;
  border-radius: 6px !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

.btn-primary:hover {
  background: #1d4ed8 !important;
  border-color: #1d4ed8 !important;
}

/* REQUEST QUOTE FORM */
#custom-options-widget-container .request-quote-form,
#custom-options-widget-container-2 .request-quote-form {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  margin-top: 8px !important;
}

#custom-options-widget-container .contact-info-section,
#custom-options-widget-container-2 .contact-info-section {
  margin-bottom: 20px !important;
}

#custom-options-widget-container .form-row,
#custom-options-widget-container-2 .form-row {
  display: flex !important;
  gap: 12px !important;
  margin-bottom: 16px !important;
}

#custom-options-widget-container .form-field-half,
#custom-options-widget-container-2 .form-field-half {
  flex: 1 !important;
  min-width: 0 !important;
}

#custom-options-widget-container .form-field-half .option-widget-input,
#custom-options-widget-container-2 .form-field-half .option-widget-input {
  width: 100% !important;
  max-width: none !important;
  box-sizing: border-box !important;
}

#custom-options-widget-container .form-field-full,
#custom-options-widget-container-2 .form-field-full {
  margin-bottom: 16px !important;
}

#custom-options-widget-container .option-widget-textarea,
#custom-options-widget-container-2 .option-widget-textarea {
  width: 100% !important;
  padding: var(--option-input-padding, 8px 12px) !important;
  border: var(--option-border-width, 1px) solid var(--option-border, #cccccc) !important;
  border-radius: var(--option-radius, 4px) !important;
  font-size: var(--option-font-size-base, 16px) !important;
  font-family: var(--option-font-family, inherit) !important;
  color: var(--option-text, #333333) !important;
  background: var(--option-background, #ffffff) !important;
  transition: border-color 0.2s ease !important;
  box-sizing: border-box !important;
  resize: vertical !important;
  min-height: 80px !important;
  line-height: 1.4 !important;
}

#custom-options-widget-container .option-widget-textarea:focus,
#custom-options-widget-container-2 .option-widget-textarea:focus {
  outline: none !important;
  border-color: var(--option-border-hover, #999999) !important;
}

#custom-options-widget-container .request-quote-submit-button,
#custom-options-widget-container-2 .request-quote-submit-button {
  background: #103c70 !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 50px !important;
  padding: 12px 24px !important;
  font-size: var(--option-font-size-base, 16px) !important;
  font-weight: 500 !important;
  font-family: var(--option-font-family, inherit) !important;
  cursor: pointer !important;
  transition: background-color 0.2s ease !important;
  width: 100% !important;
  text-align: center !important;
}

#custom-options-widget-container .request-quote-submit-button:hover,
#custom-options-widget-container-2 .request-quote-submit-button:hover {
  background: #e55a2b !important;
}

/* ORDER SUMMARY */
#custom-options-widget-container .order-summary,
#custom-options-widget-container-2 .order-summary {
  background: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  padding: 0 !important;
  margin-bottom: 16px !important;
  box-shadow: none !important;
}

/* Field Label for Order Summary - reduce spacing to label and remove padding */
#custom-options-widget-container .option-field-wrapper[data-field-type="summary"] .field-label,
#custom-options-widget-container-2 .option-field-wrapper[data-field-type="summary"] .field-label {
  margin-bottom: 1px !important;
}

#custom-options-widget-container .option-field-wrapper[data-field-type="summary"] .order-summary,
#custom-options-widget-container-2 .option-field-wrapper[data-field-type="summary"] .order-summary {
  padding: 15px 0 15px 0 !important;
  margin-left: 0 !important;
  margin-top: 0 !important;
}

#custom-options-widget-container .summary-title,
#custom-options-widget-container-2 .summary-title {
  display: block !important;
  font-family: var(--option-label-font) !important;
  font-weight: 500 !important;
  font-size: 19px !important;
  margin-bottom: 10px !important;
  color: var(--option-text) !important;
  line-height: 1.4 !important;
  letter-spacing: -0.01em !important;
  border-bottom: none !important;
  padding-bottom: 0 !important;
}

#custom-options-widget-container .summary-content,
#custom-options-widget-container-2 .summary-content {
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
}

#custom-options-widget-container .summary-items,
#custom-options-widget-container-2 .summary-items {
  display: flex !important;
  flex-direction: column !important;
  gap: 0px !important;
  margin: 0 !important;
  padding: 0 !important;
}

#custom-options-widget-container .summary-item,
#custom-options-widget-container-2 .summary-item {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding: 6px 0 !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

#custom-options-widget-container .summary-item:last-child,
#custom-options-widget-container-2 .summary-item:last-child {
  border-bottom: none !important;
}

#custom-options-widget-container .summary-item-label,
#custom-options-widget-container-2 .summary-item-label {
  font-weight: 500 !important;
  color: var(--option-text) !important;
  font-size: 14px !important;
}

#custom-options-widget-container .summary-item-value,
#custom-options-widget-container-2 .summary-item-value {
  color: #64748b !important;
  font-size: 14px !important;
}

#custom-options-widget-container .summary-item-price,
#custom-options-widget-container-2 .summary-item-price {
  color: var(--option-primary) !important;
  font-weight: 500 !important;
  font-size: 14px !important;
}

#custom-options-widget-container .summary-pricing,
#custom-options-widget-container-2 .summary-pricing {
  border-top: 2px solid #f1f5f9 !important;
  padding-top: 12px !important;
}

#custom-options-widget-container .summary-line,
#custom-options-widget-container-2 .summary-line {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  margin-bottom: 8px !important;
}

#custom-options-widget-container .summary-line:last-child,
#custom-options-widget-container-2 .summary-line:last-child {
  margin-bottom: 0 !important;
}

#custom-options-widget-container .summary-line.total-line,
#custom-options-widget-container-2 .summary-line.total-line {
  font-size: 16px !important;
  font-weight: 500 !important;
  padding-top: 8px !important;
  border-top: 1px solid #e2e8f0 !important;
}

#custom-options-widget-container .line-label,
#custom-options-widget-container-2 .line-label {
  color: var(--option-text) !important;
}

#custom-options-widget-container .line-value,
#custom-options-widget-container-2 .line-value {
  color: var(--option-primary) !important;
  font-weight: 500 !important;
}

#custom-options-widget-container .summary-placeholder,
#custom-options-widget-container-2 .summary-placeholder {
  text-align: center !important;
  color: #94a3b8 !important;
  font-style: italic !important;
  padding: 20px !important;
}

/* BUILDER-STYLE ORDER SUMMARY ROWS */
#custom-options-widget-container .option-field-wrapper[data-field-type="summary"],
#custom-options-widget-container-2 .option-field-wrapper[data-field-type="summary"],
#custom-options-widget-container .option-field-wrapper[data-field-type="summary"] *,
#custom-options-widget-container-2 .option-field-wrapper[data-field-type="summary"] *,
#custom-options-widget-container .order-summary,
#custom-options-widget-container-2 .order-summary,
#custom-options-widget-container .order-summary *,
#custom-options-widget-container-2 .order-summary * {
  border: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  outline: 0 !important;
  outline-width: 0 !important;
  outline-style: none !important;
  outline-color: transparent !important;
  border-radius: 0 !important;
}

/* Override with specific Order Summary styling */
#custom-options-widget-container .order-summary h2,
#custom-options-widget-container-2 .order-summary h2 {
  font-size: 18px !important;
  font-weight: 500 !important;
  color: #333 !important;
  margin: 0 0 4px 0 !important;
}

#custom-options-widget-container .order-summary p,
#custom-options-widget-container-2 .order-summary p {
  font-size: 14px !important;
  color: #666 !important;
  margin: 0 0 5px 0 !important;
}

#custom-options-widget-container .summary-section,
#custom-options-widget-container-2 .summary-section {
  margin-top: 5px !important;
}

#custom-options-widget-container .summary-row,
#custom-options-widget-container-2 .summary-row {
  display: flex !important;
  justify-content: space-between !important;
  padding: 10px 0 !important;
  border-bottom: 1px solid #e2e8f0 !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  background: transparent !important;
}

#custom-options-widget-container .summary-row:hover,
#custom-options-widget-container-2 .summary-row:hover,
#custom-options-widget-container .summary-row:focus,
#custom-options-widget-container-2 .summary-row:focus,
#custom-options-widget-container .summary-row:active,
#custom-options-widget-container-2 .summary-row:active,
#custom-options-widget-container .summary-row .label:hover,
#custom-options-widget-container-2 .summary-row .label:hover,
#custom-options-widget-container .summary-row .label:focus,
#custom-options-widget-container-2 .summary-row .label:focus,
#custom-options-widget-container .summary-row .label:active,
#custom-options-widget-container-2 .summary-row .label:active,
#custom-options-widget-container .summary-row .value:hover,
#custom-options-widget-container-2 .summary-row .value:hover,
#custom-options-widget-container .summary-row .value:focus,
#custom-options-widget-container-2 .summary-row .value:focus,
#custom-options-widget-container .summary-row .value:active,
#custom-options-widget-container-2 .summary-row .value:active {
  border: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
}

#custom-options-widget-container .price-row,
#custom-options-widget-container-2 .price-row {
  display: flex !important;
  justify-content: space-between !important;
  padding: 10px 0 !important;
  border-top: 2px solid #ddd !important;
  font-weight: bold !important;
}

#custom-options-widget-container .price-container,
#custom-options-widget-container-2 .price-container {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}

#custom-options-widget-container .summary-row .label,
#custom-options-widget-container-2 .summary-row .label,
#custom-options-widget-container .price-row .label,
#custom-options-widget-container-2 .price-row .label {
  color: #333 !important;
  font-size: 15px !important;
  font-weight: 500 !important;
}

/* Summary row values (right side text) - back to 500 weight */
#custom-options-widget-container .summary-row .value,
#custom-options-widget-container-2 .summary-row .value {
  color: #333 !important;
  font-size: 15px !important;
  font-weight: 500 !important;
}

/* Price row values (pricing row) - keep heavier weight */
#custom-options-widget-container .price-row .value,
#custom-options-widget-container-2 .price-row .value {
  color: #333 !important;
  font-size: 15px !important;
  font-weight: 500 !important;
}

/* Specific styling for crossed out price */
#custom-options-widget-container .full-price-crossed,
#custom-options-widget-container-2 .full-price-crossed {
  font-size: 16px !important;
}

#custom-options-widget-container .summary-empty,
#custom-options-widget-container-2 .summary-empty {
  text-align: center !important;
  padding: 24px 0 !important;
  color: #999 !important;
}

#custom-options-widget-container .summary-empty p,
#custom-options-widget-container-2 .summary-empty p {
  margin: 0 !important;
}

#custom-options-widget-container .summary-empty .main,
#custom-options-widget-container-2 .summary-empty .main {
  font-size: 14px !important;
}

/* DETAILS FIELD */
#custom-options-widget-container .details-field-wrapper,
#custom-options-widget-container-2 .details-field-wrapper {
  background: transparent !important;
  border-radius: 0 !important;
  padding: 0 !important;
  margin-bottom: 16px !important;
}

#custom-options-widget-container .details-header,
#custom-options-widget-container-2 .details-header {
  display: block !important;
  font-family: var(--option-label-font) !important;
  font-size: 19px !important;
  font-weight: 500 !important;
  margin: 0 0 10px 0 !important;
  color: var(--option-text) !important;
  line-height: 1.4 !important;
  letter-spacing: -0.01em !important;
  text-transform: none !important;
}

#custom-options-widget-container .details-pricing,
#custom-options-widget-container-2 .details-pricing {
  margin: 0 0 12px 0 !important;
  color: var(--option-text) !important;
  line-height: 1.4 !important;
}

#custom-options-widget-container .pricing-quantity,
#custom-options-widget-container-2 .pricing-quantity {
  font-weight: 500 !important;
}

#custom-options-widget-container .pricing-from,
#custom-options-widget-container-2 .pricing-from {
  font-weight: 500 !important;
}

#custom-options-widget-container .pricing-price,
#custom-options-widget-container-2 .pricing-price {
  font-weight: 500 !important;
  color: var(--option-primary-color) !important;
}

#custom-options-widget-container .details-content,
#custom-options-widget-container-2 .details-content {
  color: var(--option-text) !important;
  line-height: 1.5 !important;
  margin: 0 !important;
}

#custom-options-widget-container .details-content p,
#custom-options-widget-container-2 .details-content p {
  margin: 0 0 8px 0 !important;
}

#custom-options-widget-container .details-content ul,
#custom-options-widget-container-2 .details-content ul {
  margin: 8px 0 !important;
  padding-left: 20px !important;
}

#custom-options-widget-container .details-content li,
#custom-options-widget-container-2 .details-content li {
  margin: 4px 0 !important;
  color: var(--option-text) !important;
}

/* RESPONSIVE DESIGN */
@media (max-width: 768px) {
  #custom-options-widget-container .corner-group,
  #custom-options-widget-container-2 .corner-group {
    grid-template-columns: 1fr !important;
  }

  #custom-options-widget-container .design-method-group,
  #custom-options-widget-container-2 .design-method-group {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  
  #custom-options-widget-container .option-swatch-grid,
  #custom-options-widget-container-2 .option-swatch-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

@media (max-width: 480px) {
  #custom-options-widget-container,
  #custom-options-widget-container-2 {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100% !important;
  }
  
  #custom-options-widget-container .design-method-group,
  #custom-options-widget-container-2 .design-method-group {
    grid-template-columns: 1fr !important;
  }
  
  #custom-options-widget-container .option-swatch-grid,
  #custom-options-widget-container-2 .option-swatch-grid {
    grid-template-columns: 1fr !important;
  }
  
  /* Quantity list responsive optimization */
  #custom-options-widget-container .quantity-tier,
  #custom-options-widget-container-2 .quantity-tier {
    grid-template-columns: 1fr 1fr 1fr !important;
    gap: 10px !important;
    padding: 6px 8px 6px 12px !important;
    min-height: 30px !important;
    height: auto !important;
  }
  
  #custom-options-widget-container .tier-quantity,
  #custom-options-widget-container-2 .tier-quantity {
    font-size: 14px !important;
    line-height: 1.2 !important;
  }
  
  #custom-options-widget-container .tier-badge-inline,
  #custom-options-widget-container-2 .tier-badge-inline {
    padding: 2px 8px !important;
    font-size: 10px !important;
    margin-left: 6px !important;
  }
  
  #custom-options-widget-container .tier-pricing,
  #custom-options-widget-container-2 .tier-pricing {
    justify-content: center !important;
    text-align: center !important;
    gap: 4px !important;
  }
  
  #custom-options-widget-container .tier-price,
  #custom-options-widget-container-2 .tier-price {
    font-size: 16px !important;
  }
  
  #custom-options-widget-container .tier-unit-price,
  #custom-options-widget-container-2 .tier-unit-price {
    font-size: 11px !important;
  }
  
  #custom-options-widget-container .tier-savings,
  #custom-options-widget-container-2 .tier-savings {
    font-size: 11px !important;
  }
}

/* DESIGN STUDIO & UPLOAD EDITOR MODAL STYLES */
.design-studio-modal, .upload-editor-modal {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 9999 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.design-studio-overlay, .upload-editor-overlay {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  background: rgba(0, 0, 0, 0.7) !important;
  z-index: 1 !important;
}

.design-studio-container, .upload-editor-container {
  position: relative !important;
  z-index: 2 !important;
  background: white !important;
  border-radius: 12px !important;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3) !important;
  width: 90% !important;
  max-width: 1200px !important;
  max-height: 90vh !important;
  overflow: hidden !important;
}

.design-studio-header, .upload-editor-header {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding: 20px !important;
  border-bottom: 1px solid #eee !important;
  background: #f8f9fa !important;
}

.design-studio-header h3, .upload-editor-header h3 {
  margin: 0 !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  color: #333 !important;
}

.close-button {
  background: none !important;
  border: none !important;
  font-size: 24px !important;
  cursor: pointer !important;
  color: #666 !important;
  padding: 5px !important;
  line-height: 1 !important;
}

.close-button:hover {
  color: #333 !important;
}

.design-studio-footer, .upload-editor-footer {
  display: flex !important;
  justify-content: flex-end !important;
  gap: 10px !important;
  padding: 20px !important;
  border-top: 1px solid #eee !important;
  background: #f8f9fa !important;
}

.btn-secondary, .btn-primary {
  padding: 10px 20px !important;
  border-radius: 6px !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  border: none !important;
  font-size: 14px !important;
}

.btn-secondary {
  background: #6c757d !important;
  color: white !important;
}

.btn-secondary:hover {
  background: #5a6268 !important;
}

.btn-primary {
  background: #007bff !important;
  color: white !important;
}

.btn-primary:hover {
  background: #0056b3 !important;
}

#design-studio-iframe, #upload-editor-iframe {
  border: none !important;
  width: 100% !important;
  height: 600px !important;
}

/* LATER LINKS STYLES */
.later-options {
  margin-top: 10px !important;
  text-align: center !important;
}

.later-link {
  background: none !important;
  border: none !important;
  color: #666 !important;
  font-size: 12px !important;
  cursor: pointer !important;
  text-decoration: underline !important;
  padding: 5px 10px !important;
  margin: 0 5px !important;
}

.later-link:hover {
  color: #333 !important;
}

.later-link:disabled {
  color: #ccc !important;
  cursor: not-allowed !important;
}
    `;
    
    const styleSheet = document.createElement('style');
    styleSheet.id = styleId;
    styleSheet.setAttribute('data-widget-styles', 'true');
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);
    
    debugLog(`Custom Option Widget v${WIDGET_VERSION} - Widget styles injected successfully âœ“`);
  }

  // 2. FETCH PRODUCT OPTION SET DATA
  async function fetchProductOptionSetLegacy(productId) {
    debugLog(`Custom Option Widget v${WIDGET_VERSION} - Fetching option set data for product:`, productId);
    
    try {
      // Method 1: Check for global debug variable (most reliable after fixes)
      const debugData = window[`OPTION_SET_DEBUG_${productId}`];
      if (debugData) {
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Using global debug data:`, debugData);
        // Guard: ignore known invalid/test payloads
        if (debugData && typeof debugData === 'object') {
          if (debugData.test === true) {
            console.warn(`Custom Option Widget v${WIDGET_VERSION} - Ignoring test payload from debugData`);
          } else if (debugData.fields && Array.isArray(debugData.fields)) {
            return debugData;
          } else {
            console.warn(`Custom Option Widget v${WIDGET_VERSION} - Debug data missing fields[], continuing...`);
          }
        }
      }
      
      // Method 2: Check for pre-parsed window data
      const windowData = window[`OPTION_SET_DATA_${productId}`];
      if (windowData) {
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Found pre-parsed data in window:`, windowData);
        // Guard: ignore {test:true} or objects without fields[]
        if (windowData && typeof windowData === 'object') {
          if (windowData.test === true) {
            console.warn(`Custom Option Widget v${WIDGET_VERSION} - Ignoring test payload from window data`);
          } else if (windowData.fields && Array.isArray(windowData.fields)) {
            return windowData;
          } else {
            console.warn(`Custom Option Widget v${WIDGET_VERSION} - Window data missing fields[], continuing...`);
          }
        }
      }
      
      // Method 2.5: Check if there's a successful conversion from the theme's debug processing
      if (window.tempSuccessfulOptionData) {
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Using theme's successful conversion:`, window.tempSuccessfulOptionData);
        const data = window.tempSuccessfulOptionData;
        delete window.tempSuccessfulOptionData; // Clean up
        return data;
      }
      
      // Method 3: Try to get data from embedded JSON script tag
      const embeddedData = document.getElementById(`option-set-data-${productId}`) || 
                          document.getElementById(`option-set-data-${productId}-2`) ||
                          document.getElementById('option-set-data');
      
      if (embeddedData) {
        try {
          let rawData = embeddedData.textContent.trim();
          debugLog(`Custom Option Widget v${WIDGET_VERSION} - Raw embedded data:`, rawData.substring(0, 200) + '...');
          
          // Skip if it contains error messages
          if (rawData.includes('"error"') && rawData.includes('json not allowed')) {
            console.error(`Custom Option Widget v${WIDGET_VERSION} - Metafield access error detected:`, rawData);
            throw new Error('Metafield cannot be accessed via json filter');
          }
          
          // Check if it's Ruby hash format (contains =>)
          if (rawData.includes('=>')) {
            debugLog(`Custom Option Widget v${WIDGET_VERSION} - Detected Ruby hash format, converting to JSON...`);
            
            try {
              // Advanced Ruby hash to JSON conversion
              let jsonData = rawData;
              
              // Step 1: Replace Ruby hash arrows with colons
              jsonData = jsonData.replace(/=>/g, ':');
              
              // Step 2: Replace nil with null
              jsonData = jsonData.replace(/\bnil\b/g, 'null');
              
              // Step 3: Handle quoted strings - protect content inside quotes first
              const stringRegex = /"([^"\\]*(\\.[^"\\]*)*)"/g;
              const protectedStrings = [];
              let stringIndex = 0;
              
              // Extract and protect all quoted strings
              jsonData = jsonData.replace(stringRegex, (match) => {
                const placeholder = `__STRING_${stringIndex}__`;
                protectedStrings[stringIndex] = match;
                stringIndex++;
                return placeholder;
              });
              
              // Step 4: Convert unquoted keys to quoted keys
              jsonData = jsonData.replace(/(\w+):/g, '"$1":');
              
              // Step 5: Restore protected strings
              protectedStrings.forEach((str, index) => {
                jsonData = jsonData.replace(`__STRING_${index}__`, str);
              });
              
              // Step 6: Clean up trailing commas
              jsonData = jsonData.replace(/,(\s*[}\]])/g, '$1');
              
              debugLog(`Custom Option Widget v${WIDGET_VERSION} - Advanced conversion sample:`, jsonData.substring(0, 300) + '...');
              
              const data = JSON.parse(jsonData);
              debugLog(`Custom Option Widget v${WIDGET_VERSION} - Successfully parsed with advanced conversion`);
              return data;
              
            } catch (advancedError) {
              console.error(`Custom Option Widget v${WIDGET_VERSION} - Advanced conversion failed:`, advancedError);
              
              // Fallback: Try to use eval (with safety checks) as last resort
              try {
                debugLog(`Custom Option Widget v${WIDGET_VERSION} - Attempting eval-based conversion...`);
                
                // Convert Ruby syntax to JavaScript object syntax with unique variable name
                const uniqueVar = `tempOptionData_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
                let jsData = rawData
                  .replace(/=>/g, ':')
                  .replace(/\bnil\b/g, 'null');
                
                // Safely wrap in a variable assignment
                jsData = `window.${uniqueVar} = ${jsData};`;
                
                // Use Function constructor for safer eval
                const func = new Function(jsData);
                func();
                
                if (window[uniqueVar]) {
                  const data = window[uniqueVar];
                  delete window[uniqueVar]; // Clean up immediately
                  debugLog(`Custom Option Widget v${WIDGET_VERSION} - Successfully parsed with eval conversion`);
                  
                  // CRITICAL DEBUG: Log options immediately after parsing
                  debugLog('=== IMMEDIATELY AFTER EVAL PARSING ===');
                  debugLog('Complete parsed data:', JSON.stringify(data, null, 2));
                  if (data && data.fields) {
                    debugLog('Total fields found:', data.fields.length);
                    data.fields.forEach((field, index) => {
                      debugLog(`Field ${index} (${field.type} - ${field.label}):`, {
                        hasOptions: !!field.options,
                        optionsLength: field.options?.length || 0,
                        optionsArray: field.options,
                        firstOption: field.options?.[0] || null
                      });
                    });
                  }
                  
                  return data;
                }
              } catch (evalError) {
                console.error(`Custom Option Widget v${WIDGET_VERSION} - Eval conversion also failed:`, evalError);
              }
            }
            
            debugLog(`Custom Option Widget v${WIDGET_VERSION} - Converted Ruby hash to JSON format`);
            debugLog(`Custom Option Widget v${WIDGET_VERSION} - Sample converted data:`, rawData.substring(0, 300) + '...');
          }
          
          // Try to parse as JSON
          const data = JSON.parse(rawData);
          debugLog(`Custom Option Widget v${WIDGET_VERSION} - Successfully parsed option set data`);
          debugLog(`Custom Option Widget v${WIDGET_VERSION} - Data structure:`, {
            hasFields: !!data.fields,
            fieldsCount: data.fields ? data.fields.length : 0,
            name: data.name,
            id: data.id
          });
          
          return data;
          
        } catch (e) {
          console.error(`Custom Option Widget v${WIDGET_VERSION} - Error parsing embedded option set data:`, e);
          console.error('Raw data sample:', embeddedData.textContent.substring(0, 500));
          return null;
        }
      } else {
        console.warn(`Custom Option Widget v${WIDGET_VERSION} - No embedded option set data found`);
      }
      
      // Method 4: Fallback to product API
      debugLog(`Custom Option Widget v${WIDGET_VERSION} - Attempting to fetch from product API...`);
      const productHandle = window.location.pathname.split('/').pop();
      const response = await fetch(`/products/${productHandle}.js`);
      const productData = await response.json();
      
      debugLog(`Custom Option Widget v${WIDGET_VERSION} - Product API data:`, productData);
      
      // Check if product has option set metafield
      if (productData.metafields && productData.metafields.optionsets && productData.metafields.optionsets.assigned_option_set) {
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Found metafield in API response`);
        return productData.metafields.optionsets.assigned_option_set;
      }
      
      // Method 5: Last fallback - look for data in DOM meta tags
      const metaTag = document.querySelector(`meta[name="option-set-${productId}"]`);
      if (metaTag) {
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Found data in meta tag`);
        return JSON.parse(metaTag.content);
      }
      
      console.warn(`Custom Option Widget v${WIDGET_VERSION} - No option set data found anywhere`);
      return null;
    } catch (error) {
      console.error(`Custom Option Widget v${WIDGET_VERSION} - Error fetching option set data:`, error);
      return null;
    }
  }

  async function fetchProductOptionSetV2(productId) {
    return fetchProductOptionSetLegacy(productId);
  }

  async function fetchProductOptionSet(productId) {
    return runWidgetModuleFlowAsync(
      PHASE3_WIDGET_MODULES.dataLoader,
      WIDGET_DATA_LOADER_MODE,
      {
        legacy: () => fetchProductOptionSetLegacy(productId),
        v2: () => fetchProductOptionSetV2(productId),
        parity: (legacyResult, v2Result) =>
          toParitySignature(legacyResult) === toParitySignature(v2Result)
      },
      { productId }
    );
  }

  function sanitizeFieldLabel(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderFieldFailureHTML(field, index) {
    const fallbackLabel = sanitizeFieldLabel(field && field.label ? field.label : `Option ${index + 1}`);
    return `
      <div class="option-field-wrapper option-field-wrapper-error" data-field-type="error" data-field-id="field-error-${index}">
        <label class="field-label">${fallbackLabel}</label>
        <div class="no-options-message" style="padding: 12px; text-align: left; color: #999; font-style: italic;">
          This option is temporarily unavailable.
        </div>
      </div>`;
  }

  // 3. BUILD WIDGET HTML STRUCTURE - ENHANCED WITH DETAILED LOGGING
  function buildWidgetHTML(optionSetData, productId) {
    debugLog(`Custom Option Widget v${WIDGET_VERSION} - Building widget with ACTUAL data:`, optionSetData);
    debugLog(`Custom Option Widget v${WIDGET_VERSION} - Data type:`, typeof optionSetData);
    
    if (!optionSetData) {
      console.warn(`Custom Option Widget v${WIDGET_VERSION} - No option set data provided`);
      return '<p class="option-widget-error">No options available for this product.</p>';
    }
    
    // CRITICAL DEBUG: Log the exact data structure we receive
    debugLog('=== RAW OPTION SET DATA AT START OF buildWidgetHTML ===');
    debugLog('Raw data:', JSON.stringify(optionSetData, null, 2));
    
    // The data structure we're getting has a 'fields' array
    let fields;
    
    if (optionSetData.fields && Array.isArray(optionSetData.fields)) {
      fields = optionSetData.fields;
      const originalFieldCount = fields.length;
      fields = fields.filter((field) => field && typeof field === 'object');
      if (fields.length !== originalFieldCount) {
        console.warn(
          `Custom Option Widget v${WIDGET_VERSION} - Ignoring ${originalFieldCount - fields.length} invalid field entries`
        );
      }
      debugLog(`Custom Option Widget v${WIDGET_VERSION} - Found ${fields.length} fields in option set "${optionSetData.name}"`);
      
      // LOG COMPLETE OPTION SET STRUCTURE BEFORE ANY PROCESSING
      debugLog('=== FIELDS BEFORE ANY PROCESSING ===');
      debugLog('Option Set Name:', optionSetData.name);
      debugLog('Fields count:', fields.length);
      
      // Log each field's options in detail BEFORE any filtering
      fields.forEach((field, index) => {
        try {
          debugLog(`ORIGINAL Field ${index} - ${field.label}:`, {
            type: field.type,
            hasOptions: !!(field.options || field.quantities || field.designMethods),
            optionsLength: field.options ? field.options.length : 0,
            actualOptions: field.options,
            quantities: field.quantities,
            designMethods: field.designMethods
          });
          
          // FILTER OUT EMPTY OPTIONS - Critical fix for option syncing
          if (field.options && Array.isArray(field.options)) {
            const originalLength = field.options.length;
            
            debugLog(`=== BEFORE FILTERING FIELD "${field.label}" ===`);
            debugLog('Original options array:', JSON.stringify(field.options, null, 2));
            debugLog('Original length:', originalLength);
            
            // Log each option before filtering
            field.options.forEach((opt, idx) => {
              debugLog(`Option ${idx} before filter:`, {
                hasValue: !!(opt.value && opt.value.trim() !== ''),
                valueContent: opt.value,
                hasLabel: !!(opt.label && opt.label.trim() !== ''),
                labelContent: opt.label,
                hasName: !!(opt.name && opt.name.trim() !== ''),
                nameContent: opt.name,
                hasImage: !!(opt.image && opt.image.trim() !== ''),
                imageContent: opt.image,
                hasColor: !!(opt.color && opt.color.trim() !== ''),
                colorContent: opt.color,
                allKeys: Object.keys(opt),
                fullOption: opt
              });
            });
            
            // RELAXED FILTERING - Accept options with ANY meaningful content
            field.options = field.options.filter(opt => {
              if (!opt) {
                debugLog('❌ Rejecting null/undefined option');
                return false;
              }
              
              // Much more permissive - accept if ANY property has content
              const hasValue = opt.value && String(opt.value).trim() !== '';
              const hasLabel = opt.label && String(opt.label).trim() !== '';
              const hasName = opt.name && String(opt.name).trim() !== '';
              const hasImage = opt.image && String(opt.image).trim() !== '';
              const hasColor = opt.color !== null && opt.color !== undefined && String(opt.color).trim() !== '';
              const hasPrice = opt.price !== null && opt.price !== undefined;
              
              const isValid = hasValue || hasLabel || hasName || hasImage || hasColor || hasPrice;
              
              debugLog('Option validation:', {
                option: opt,
                hasValue, hasLabel, hasName, hasImage, hasColor, hasPrice,
                isValid,
                reason: isValid ? 'KEPT - has meaningful content' : 'REJECTED - no meaningful content'
              });
              
              return isValid;
            });
            
            debugLog(`=== AFTER FILTERING FIELD "${field.label}" ===`);
            debugLog('Filtered options array:', JSON.stringify(field.options, null, 2));
            debugLog('Filtered length:', field.options.length);
            
            if (originalLength !== field.options.length) {
              debugLog(`Filtered ${originalLength - field.options.length} empty options from field "${field.label}"`);
            }
          }
        } catch (fieldProcessingError) {
          console.error(
            `Custom Option Widget v${WIDGET_VERSION} - Field preprocessing failed (index ${index})`,
            fieldProcessingError
          );
        }
      });
    } else {
      console.error(`Custom Option Widget v${WIDGET_VERSION} - No fields array found in data:`, Object.keys(optionSetData || {}));
      return '<p class="option-widget-error">Invalid option set configuration - no fields found.</p>';
    }
    
    if (fields.length === 0) {
      console.warn(`Custom Option Widget v${WIDGET_VERSION} - Fields array is empty`);
      return '<p class="option-widget-error">No option fields configured.</p>';
    }
    
    debugLog(`Custom Option Widget v${WIDGET_VERSION} - Processing ${fields.length} fields:`, fields.map(f => `${f.type}:${f.label}`));

    let html = `<form class="product-option-form" id="option-set-form-${productId}">`;
    
    fields.forEach((field, index) => {
      try {
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Processing field ${index}: ${field.type} - "${field.label}"`);
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Field data:`, {
          type: field.type,
          label: field.label,
          optionsCount: field.options?.length || 0,
          quantitiesCount: field.quantities?.length || 0,
          designMethodsCount: field.designMethods?.length || 0,
          hasValidOptions: !!(field.options?.length || field.quantities?.length || field.designMethods?.length)
        });
        
        // Skip fields without type
        if (!field.type) {
          console.warn(`Custom Option Widget v${WIDGET_VERSION} - Skipping field without type:`, field);
          return;
        }
        
        html += buildFieldHTML(field, index);
      } catch (fieldRenderError) {
        console.error(
          `Custom Option Widget v${WIDGET_VERSION} - Field render failed (index ${index}, type ${field && field.type ? field.type : 'unknown'})`,
          fieldRenderError
        );
        html += renderFieldFailureHTML(field, index);
      }
    });
    
    html += `
      <input type="hidden" id="option-set-data-${productId}" name="properties[_option_set_data]" value="">
    </form>`;
    
    return html;
  }

  // 4. BUILD FIELD HTML BASED ON TYPE
  // Helper function to validate and filter options - OPTIMIZED FOR PERFORMANCE
  function validateOptions(options, fieldType) {
    if (!options || !Array.isArray(options)) return [];
    
    // Pre-compiled validation functions for better performance
    const validators = {
      'swatch': (opt) => opt?.color || opt?.value?.trim?.() || opt?.name?.trim?.() || opt?.label?.trim?.(),
      'color-swatch': (opt) => opt?.color || opt?.value?.trim?.() || opt?.name?.trim?.() || opt?.label?.trim?.(),
      'image-swatch': (opt) => opt?.image?.trim?.() || opt?.value?.trim?.() || opt?.name?.trim?.() || opt?.label?.trim?.(),
      'size': (opt) => opt?.value?.trim?.() || opt?.name?.trim?.() || opt?.label?.trim?.() || (opt?.price !== null && opt?.price !== undefined),
      'button': (opt) => opt?.value?.trim?.() || opt?.name?.trim?.() || opt?.label?.trim?.() || (opt?.price !== null && opt?.price !== undefined),
      'radio': (opt) => opt?.value?.trim?.() || opt?.name?.trim?.() || opt?.label?.trim?.() || (opt?.price !== null && opt?.price !== undefined),
      'default': (opt) => opt?.value?.trim?.() || opt?.label?.trim?.() || opt?.name?.trim?.() || opt?.color || opt?.image?.trim?.() || (opt?.price !== null && opt?.price !== undefined)
    };
    
    const validator = validators[fieldType] || validators.default;
    
    // Fast filter with minimal logging for performance
    const validOptions = options.filter(option => option && validator(option));
    
    // Only log in debug mode or when there's an issue
    if (validOptions.length !== options.length && console.debug) {
      debugLog(`Options filtered: ${options.length} â†’ ${validOptions.length} (${fieldType})`);
    }
    
    return validOptions;
  }

  // Helper function to calculate tier-based pricing for quantity sliders
  function calculateTierPrice(quantity, quantitiesTiers) {
    if (!quantitiesTiers || quantitiesTiers.length === 0) return 0;
    
    // Find the tier that contains this quantity (range-based)
    for (let i = 0; i < quantitiesTiers.length; i++) {
      const tier = quantitiesTiers[i];
      const from = tier.quantityFrom || 1;
      const to = tier.quantityTo || from;
      
      if (quantity >= from && quantity <= to) {
        // Return total price: quantity * per-unit price for this tier
        return quantity * (tier.price || 0);
      }
    }
    
    // If no tier found, use the last tier's pricing
    const lastTier = quantitiesTiers[quantitiesTiers.length - 1];
    return quantity * (lastTier.price || 0);
  }

  // Helper function to get pricing breakdown with original price and current unit price
  function getPricingBreakdown(quantity, quantitiesTiers) {
    if (!quantitiesTiers || quantitiesTiers.length === 0) {
      return { totalPrice: 0, unitPrice: 0, originalUnitPrice: 0, isDiscounted: false };
    }

    // Find current tier
    let currentTier = null;
    for (let i = 0; i < quantitiesTiers.length; i++) {
      const tier = quantitiesTiers[i];
      const from = tier.quantityFrom || 1;
      const to = tier.quantityTo || from;
      
      if (quantity >= from && quantity <= to) {
        currentTier = tier;
        break;
      }
    }

    // Fallback to last tier if not found
    if (!currentTier) {
      currentTier = quantitiesTiers[quantitiesTiers.length - 1];
    }

    const currentUnitPrice = currentTier.price || 0;
    const totalPrice = quantity * currentUnitPrice;
    
    // Original price is the first tier's unit price (highest price)
    const originalUnitPrice = quantitiesTiers[0] ? (quantitiesTiers[0].price || 0) : currentUnitPrice;
    const isDiscounted = currentUnitPrice < originalUnitPrice;

    return {
      totalPrice: totalPrice,
      unitPrice: currentUnitPrice,
      originalUnitPrice: originalUnitPrice,
      isDiscounted: isDiscounted
    };
  }

  function buildFieldHTML(field, index) {
    // CRITICAL DEBUG: Log what field type we're actually processing
    debugLog(`ðŸ”¥ BUILDING FIELD ${index}:`, {
      type: field.type,
      label: field.label,
      hasQuantities: !!field.quantities,
      quantitiesLength: field.quantities?.length || 0,
      firstQuantity: field.quantities?.[0] || null
    });
    
    let html = `<div class="option-field-wrapper" data-field-type="${field.type}" data-field-id="${field.id}">`;
    
    // Add label if present and not empty (skip for certain field types)
    if (field.label && field.label.trim() !== '' && field.type !== 'start-making' && field.type !== 'details' && field.type !== 'summary') {
      html += `<label class="field-label">${field.label}</label>`;
    }
    
    switch (field.type) {
      case 'text':
        html += `<input type="text" name="properties[${field.label || 'text_' + index}]" class="option-widget-input" ${field.placeholder ? `placeholder="${field.placeholder}"` : ''}>`;
        break;
        
      case 'textarea':
        html += `<textarea name="properties[${field.label || 'textarea_' + index}]" class="option-widget-textarea" rows="4" ${field.placeholder ? `placeholder="${field.placeholder}"` : ''}></textarea>`;
        break;
        
      case 'number':
        html += `<input type="number" name="properties[${field.label || 'number_' + index}]" class="option-widget-input" ${field.min ? `min="${field.min}"` : ''} ${field.max ? `max="${field.max}"` : ''}>`;
        break;
        
      case 'date':
        html += `<input type="date" name="properties[${field.label || 'date_' + index}]" class="option-widget-input">`;
        break;
        
      case 'dropdown':
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Building dropdown field:`, {
          label: field.label,
          optionsCount: field.options?.length || 0,
          options: field.options,
          fullField: field
        });
        
        // Create custom dropdown instead of native select
        const dropdownId = `custom-dropdown-${field.id || index}`;
        const inputName = `properties[${field.label || 'dropdown_' + index}]`;
        
        html += `<div class="custom-dropdown-wrapper" data-dropdown-id="${dropdownId}">`;
        html += `<input type="hidden" name="${inputName}" class="custom-dropdown-input" value="">`;
        html += `<div class="custom-dropdown-trigger" data-dropdown-id="${dropdownId}" tabindex="-1" style="outline: none !important; box-shadow: none !important; -webkit-tap-highlight-color: transparent !important; pointer-events: auto; user-select: none;">`;
        html += `<span class="custom-dropdown-text">Select an option...</span>`;
        html += `<span class="custom-dropdown-arrow"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>`;
        html += `</div>`;
        debugLog('SVG Arrow HTML generated:', html.includes('<svg'));
        html += `<div class="custom-dropdown-menu" id="${dropdownId}">`;
        
        // Validate and filter options
        const dropdownItems = validateOptions(field.options, 'dropdown');
        
        if (dropdownItems.length > 0) {
          dropdownItems.forEach((option, optIndex) => {
            const optionValue = option.value || option.name || `Option ${optIndex + 1}`;
            const optionLabel = option.label || optionValue;
            html += `<div class="custom-dropdown-option" onclick="selectCustomDropdownOption('${dropdownId}', '${optionValue}', '${optionLabel}')">${optionLabel}</div>`;
          });
        } else {
          // No dropdown options configured - show empty state
          console.warn(`Custom Option Widget v${WIDGET_VERSION} - No dropdown options configured for field:`, field.label);
          html += '<div class="custom-dropdown-option disabled">No options configured</div>';
        }
        html += '</div>'; // Close custom-dropdown-menu
        html += '</div>'; // Close custom-dropdown-wrapper
        break;
        
      case 'button':
        debugLog('=== BUTTON FIELD DEBUG ===');
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Building button field:`, {
          label: field.label,
          optionsCount: field.options?.length || 0,
          options: field.options,
          fullField: field
        });
        
        // Check showPrice setting for button fields
        const showButtonPrice = field.structure?.showPrice !== false;
        
        // Additional debug logging for button options
        if (field.options && field.options.length > 0) {
          field.options.forEach((opt, idx) => {
            debugLog(`Raw button option ${idx}:`, {
              value: opt.value,
              name: opt.name,
              label: opt.label,
              price: opt.price,
              sublabel: opt.sublabel,
              allProperties: Object.keys(opt),
              fullOption: opt
            });
          });
        }
        
        // Check if gridColumns is specified in structure
        const gridColumns = field.structure?.gridColumns;
        const gridStyle = gridColumns ? 
          `display: grid; grid-template-columns: repeat(${gridColumns}, 1fr); gap: var(--option-gap);` : 
          'display: flex; flex-wrap: wrap; gap: var(--option-gap);';
        
        html += `<div class="button-group" style="${gridStyle}" data-field-name="${field.label || 'button_' + index}">`;
        
        // Validate and filter options
        const buttonItems = validateOptions(field.options || field.buttons, 'button');
        
        debugLog('Button validation result:', {
          original: field.options?.length || 0,
          filtered: buttonItems.length,
          buttonItems
        });
        
        debugLog('ðŸ” BUTTON ITEMS DETAILED DEBUG:');
        debugLog('buttonItems type:', typeof buttonItems);
        debugLog('buttonItems is array:', Array.isArray(buttonItems));
        debugLog('buttonItems length:', buttonItems.length);
        debugLog('buttonItems content:', JSON.stringify(buttonItems, null, 2));
        debugLog('buttonItems[0]:', buttonItems[0]);
        
        if (buttonItems.length > 0) {
          buttonItems.forEach((option, optIndex) => {
            // Better fallback logic for button values
            let buttonValue = '';
            let buttonLabel = '';
            
            // Try to get a meaningful value in order of preference
            if (option.value && String(option.value).trim()) {
              buttonValue = String(option.value).trim();
              buttonLabel = option.label || buttonValue;
            } else if (option.name && String(option.name).trim()) {
              buttonValue = String(option.name).trim();
              buttonLabel = option.label || buttonValue;
            } else if (option.label && String(option.label).trim()) {
              buttonValue = String(option.label).trim();
              buttonLabel = buttonValue;
            } else {
              // Fallback to auto-generated value
              buttonValue = `Option ${optIndex + 1}`;
              buttonLabel = `Option ${optIndex + 1}`;
            }
            
            debugLog(`ðŸŽ¯ Button ${optIndex + 1}: value="${buttonValue}", label="${buttonLabel}", original:`, option);
            
            html += `<div class="option-button ${optIndex === 0 ? 'selected' : ''}" data-value="${escapeHtmlAttribute(buttonValue)}" data-price="${option.price || 0}">
              <div>${buttonLabel}</div>
              ${showButtonPrice && option.price && option.price > 0 ? `<div class="option-price">+$${option.price}</div>` : ''}
              ${(field.structure?.showSubtext !== false) && option.sublabel ? `<div class="option-sublabel">${option.sublabel}</div>` : ''}
            </div>`;
          });
        } else {
          // No button options configured - show empty state
          console.error('ðŸš¨ BUTTON FIELD ERROR: buttonItems.length is 0!');
          console.error('ðŸš¨ buttonItems:', buttonItems);
          console.error('ðŸš¨ field.options:', field.options);
          console.error('ðŸš¨ field.buttons:', field.buttons);
          console.warn(`Custom Option Widget v${WIDGET_VERSION} - No button options configured for field:`, field.label);
          html += '<div class="no-options-message" style="padding: 20px; text-align: center; color: #999; font-style: italic;">No button options configured</div>';
        }
        html += '</div>';
        break;
        
      case 'radio':
        debugLog('=== RADIO FIELD DEBUG ===');
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Building radio field:`, {
          label: field.label,
          optionsCount: field.options?.length || 0,
          options: field.options,
          fullField: field
        });
        
        // Additional debug logging for radio options
        if (field.options && field.options.length > 0) {
          field.options.forEach((opt, idx) => {
            debugLog(`Raw radio option ${idx}:`, {
              value: opt.value,
              name: opt.name,
              label: opt.label,
              price: opt.price,
              sublabel: opt.sublabel,
              allProperties: Object.keys(opt),
              fullOption: opt
            });
          });
        }
        
        html += '<div class="radio-group" style="display: flex; flex-direction: column; gap: var(--option-spacing-md);" data-field-name="' + (field.label || 'radio_' + index) + '">';
        
        // Validate and filter radio options using the same logic as buttons
        const radioItems = validateOptions(field.options || field.radios, 'radio');
        
        debugLog('Radio validation result:', {
          original: field.options?.length || 0,
          filtered: radioItems.length,
          radioItems
        });
        
        if (radioItems.length > 0) {
          radioItems.forEach((option, optIndex) => {
            // Better fallback logic for radio values (same as buttons)
            let radioValue = '';
            let radioLabel = '';
            
            // Try to get a meaningful value in order of preference
            if (option.value && String(option.value).trim()) {
              radioValue = String(option.value).trim();
              radioLabel = option.label || radioValue;
            } else if (option.name && String(option.name).trim()) {
              radioValue = String(option.name).trim();
              radioLabel = option.label || radioValue;
            } else if (option.label && String(option.label).trim()) {
              radioValue = String(option.label).trim();
              radioLabel = radioValue;
            } else {
              // Fallback to auto-generated value
              radioValue = `Option ${optIndex + 1}`;
              radioLabel = `Option ${optIndex + 1}`;
            }
            
            debugLog(`ðŸŽ¯ Radio ${optIndex + 1}: value="${radioValue}", label="${radioLabel}", original:`, option);
            
            const radioId = `${field.id || 'radio'}-${optIndex}`;
            html += `
              <div class="radio-option ${optIndex === 0 ? 'selected' : ''}" data-value="${escapeHtmlAttribute(radioValue)}" style="display: flex; align-items: center; padding: 12px; border: 1px solid #e0e0e0; border-radius: var(--option-radius); background: var(--option-background); cursor: pointer; transition: var(--option-transition);">
                <input type="radio" name="properties[${field.label || 'radio_' + index}]" value="${escapeHtmlAttribute(radioValue)}" id="${radioId}" ${optIndex === 0 ? 'checked' : ''} style="margin-right: 12px; accent-color: var(--option-primary);">
                <div style="flex: 1;">
                  <label for="${radioId}" style="cursor: pointer; font-weight: 500; color: var(--option-text); font-family: var(--option-font-family); display: block;">${radioLabel}</label>
                  ${(field.structure?.showSubtext !== false) && option.sublabel ? `<div class="radio-sublabel">${option.sublabel}</div>` : ''}
                </div>
              </div>`;
          });
        } else {
          // No radio options configured - show empty state
          console.warn(`Custom Option Widget v${WIDGET_VERSION} - No radio options configured for field:`, field.label);
          html += '<div class="no-options-message" style="padding: 20px; text-align: center; color: #999; font-style: italic;">No radio options configured</div>';
        }
        html += '</div>';
        break;
        
      case 'image-swatch':
        const imageOptionCount = (field.options || []).length;
        const imageGridCols = imageOptionCount === 3 ? 3 : 2; // 3 opts = 3 cols, everything else = 2 cols
        const imageGap = field.structure?.gap || '4px';
        const showPrice = field.structure?.showPrice !== false;
        
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Building image-swatch field:`, {
          label: field.label,
          optionsCount: field.options?.length || 0,
          options: field.options,
          fullField: field
        });
        
        // Enhanced debugging for image swatch fields
        debugLog('ðŸ–¼ï¸ IMAGE SWATCH DETAILED DEBUG:');
        debugLog('Field ID:', field.id);
        debugLog('Field Label:', field.label);
        debugLog('Raw options:', JSON.stringify(field.options, null, 2));
        debugLog('Options length:', field.options?.length || 0);
        if (field.options && field.options.length > 0) {
          field.options.forEach((opt, idx) => {
            debugLog(`Image option ${idx}:`, {
              hasValue: !!opt.value,
              value: opt.value,
              hasImage: !!opt.image,
              image: opt.image,
              hasName: !!opt.name,
              name: opt.name,
              hasLabel: !!opt.label,
              label: opt.label,
              price: opt.price,
              fullOption: opt
            });
          });
        }
        
        // Apply validation like other fields
        const imageSwatchItems = validateOptions(field.options || [], 'image-swatch');
        debugLog('ðŸ–¼ï¸ Image swatch validation result:', {
          original: field.options?.length || 0,
          filtered: imageSwatchItems.length,
          imageSwatchItems
        });
        
        html += `<div class="option-swatch-grid" style="grid-template-columns: repeat(${imageGridCols}, 1fr); gap: ${imageGap};" data-field-name="${field.label || 'image_swatch_' + index}">`;
        if (imageSwatchItems && imageSwatchItems.length > 0) {
          imageSwatchItems.forEach((option, optIndex) => {
            // Better fallback logic for image swatch values
            let optionValue = '';
            let optionLabel = '';
            
            if (option.value && String(option.value).trim()) {
              optionValue = String(option.value).trim();
              optionLabel = option.label || optionValue;
            } else if (option.name && String(option.name).trim()) {
              optionValue = String(option.name).trim();
              optionLabel = option.label || optionValue;
            } else if (option.label && String(option.label).trim()) {
              optionValue = String(option.label).trim();
              optionLabel = optionValue;
            } else {
              optionValue = `Option ${optIndex + 1}`;
              optionLabel = `Option ${optIndex + 1}`;
            }

            const imageUrl = resolveWidgetImageUrl(option.image, optionValue, 'Image Option', {
              width: 150,
              height: 150,
              fontSize: 12
            });
            
            debugLog(`ðŸŽ¯ Image Swatch ${optIndex + 1}: value="${optionValue}", label="${optionLabel}", image="${imageUrl}", original:`, option);
            
            // Add class to indicate if this option has an image or not
            const hasImageClass = imageUrl ? 'has-image' : 'no-image';
            html += `<div class="option-swatch-item ${hasImageClass} ${optIndex === 0 ? 'selected' : ''}" data-value="${escapeHtmlAttribute(optionValue)}" data-price="${option.price || 0}" data-pricing-value-key="${escapeHtmlAttribute(option.pricingValueKey || '')}">`;
            
            // Only show image if imageUrl exists - no placeholder
            if (imageUrl) {
              const fetchPriority = optIndex < 4 ? 'high' : 'auto';
              html += buildWidgetDeferredImageTag({
                imageUrl,
                altText: optionValue,
                className: 'swatch-image',
                loading: 'eager',
                decoding: 'async',
                fetchPriority,
                style: 'display:block !important;opacity:0 !important;visibility:hidden !important;pointer-events:none !important;'
              });
            }
            
            html += `<div class="image-swatch-label" style="font-size: 17px; font-weight: 500; margin-bottom: 0px;">${optionLabel}</div>`;
            if (showPrice && option.price && option.price > 0) {
              html += `<div class="swatch-price">+$${option.price}</div>`;
            }
            if ((field.structure?.showSubtext !== false) && option.sublabel) {
              html += `<div class="image-swatch-subtext" style="font-size: 14px; font-weight: 500; margin-top: 0px; margin-bottom: 0px; padding-top: 0px; padding-bottom: 0px; line-height: 1.4;">${option.sublabel}</div>`;
            }
            html += '</div>';
          });
        } else {
          // No image swatch options configured - show empty state
          console.warn(`Custom Option Widget v${WIDGET_VERSION} - No image swatch options configured for field:`, field.label);
          html += '<div class="no-options-message" style="padding: 20px; text-align: center; color: #999; font-style: italic;">No image options configured</div>';
        }
        html += '</div>';
        break;
        
      case 'swatch':
      case 'color-swatch':
        debugLog('=== SWATCH FIELD DEBUG ===');
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Building swatch field:`, {
          label: field.label,
          optionsCount: field.options?.length || 0,
          options: field.options,
          fullField: field
        });
        
        // Check showPrice setting for swatch fields
        const showSwatchPrice = field.structure?.showPrice !== false;
        
        // Additional debug logging
        if (field.options && field.options.length > 0) {
          field.options.forEach((opt, idx) => {
            debugLog(`Raw option ${idx}:`, {
              color: opt.color,
              value: opt.value,
              name: opt.name,
              label: opt.label,
              price: opt.price,
              sublabel: opt.sublabel,
              allProperties: Object.keys(opt),
              fullOption: opt
            });
          });
        }
        
        html += '<div class="color-swatch-grid" data-field-name="' + (field.label || 'swatch_' + index) + '">';
        
        // Validate and filter options for color swatches
        const swatchItems = validateOptions(field.options || field.colors, field.type);
        
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Filtered swatch options:`, {
          original: field.options?.length || 0,
          filtered: swatchItems.length,
          swatchItems
        });
        
        if (swatchItems.length > 0) {
          swatchItems.forEach((option, optIndex) => {
            const displayValue = option.value || option.name || 'Color ' + (optIndex + 1);
            html += `<div class="color-swatch-item ${optIndex === 0 ? 'selected' : ''}" data-value="${escapeHtmlAttribute(displayValue)}" data-price="${option.price || 0}">`;
            
            if (option.color) {
              html += `<div class="color-swatch-circle" style="background-color: ${option.color};"></div>`;
            } else if (option.image) {
              const imageUrl = resolveWidgetImageUrl(option.image, displayValue.charAt(0), '', {
                width: 45,
                height: 45,
                fontSize: 14
              });
              if (imageUrl) {
                html += `<div class="color-swatch-circle" style="background-image: url('${imageUrl}'); background-size: cover; background-position: center;"></div>`;
              } else {
                html += `<div class="color-swatch-circle" style="background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%); display: flex; align-items: center; justify-content: center; color: #666; font-weight: 500; font-size: 18px;">${displayValue.charAt(0)}</div>`;
              }
            } else {
              html += `<div class="color-swatch-circle" style="background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%); display: flex; align-items: center; justify-content: center; color: #666; font-weight: 500; font-size: 18px;">${displayValue.charAt(0)}</div>`;
            }
            
            html += `<span class="color-swatch-label">${displayValue}</span>`;
            if (showSwatchPrice && option.price && option.price > 0) {
              html += `<div class="swatch-price">+$${option.price}</div>`;
            }
            if ((field.structure?.showSubtext !== false) && option.sublabel) {
              html += `<div class="color-swatch-sublabel">${option.sublabel}</div>`;
            }
            html += '</div>';
          });
        } else {
          // No color options configured - show empty state
          console.warn(`Custom Option Widget v${WIDGET_VERSION} - No color options configured for field:`, field.label);
          html += '<div class="no-options-message" style="padding: 20px; text-align: center; color: #999; font-style: italic;">No color options configured</div>';
        }
        html += '</div>';
        break;
        
      case 'size':
        const sizeOptionCount = (field.options || []).length;
        const sizeGridCols = sizeOptionCount <= 2 ? 2 : 3; // 2 options = 2 cols, 3+ = 3 cols
        const sizeGap = field.structure?.gap || '16px';
        const showSizePrice = field.structure?.showPrice !== false;
        
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Building size field:`, {
          label: field.label,
          optionsCount: field.options?.length || 0,
          options: field.options,
          fullField: field
        });
        
        // Enhanced debugging for size fields
        debugLog('ðŸ“ SIZE FIELD DETAILED DEBUG:');
        debugLog('Field ID:', field.id);
        debugLog('Field Label:', field.label);
        debugLog('Raw options:', JSON.stringify(field.options, null, 2));
        debugLog('Options length:', field.options?.length || 0);
        if (field.options && field.options.length > 0) {
          field.options.forEach((opt, idx) => {
            debugLog(`Size option ${idx}:`, {
              hasValue: !!opt.value,
              value: opt.value,
              hasImage: !!opt.image,
              image: opt.image,
              hasName: !!opt.name,
              name: opt.name,
              hasLabel: !!opt.label,
              label: opt.label,
              price: opt.price,
              fullOption: opt
            });
          });
        }
        
        // Apply validation like other fields
        const sizeItems = validateOptions(field.options || [], 'size');
        debugLog('ðŸ“ Size validation result:', {
          original: field.options?.length || 0,
          filtered: sizeItems.length,
          sizeItems
        });
        
        html += `<div class="option-swatch-grid" style="grid-template-columns: repeat(${sizeGridCols}, 1fr); gap: ${sizeGap};" data-field-name="${field.label || 'size_' + index}">`;  
        if (sizeItems && sizeItems.length > 0) {
          sizeItems.forEach((option, optIndex) => {
            // Better fallback logic for size values
            let sizeValue = '';
            let sizeLabel = '';
            
            if (option.value && String(option.value).trim()) {
              sizeValue = String(option.value).trim();
              sizeLabel = option.label || sizeValue;
            } else if (option.name && String(option.name).trim()) {
              sizeValue = String(option.name).trim();
              sizeLabel = option.label || sizeValue;
            } else if (option.label && String(option.label).trim()) {
              sizeValue = String(option.label).trim();
              sizeLabel = sizeValue;
            } else {
              sizeValue = `Size ${optIndex + 1}`;
              sizeLabel = `Size ${optIndex + 1}`;
            }
            
            debugLog(`ðŸŽ¯ Size ${optIndex + 1}: value="${sizeValue}", label="${sizeLabel}", original:`, option);
            
            const imageUrl = resolveWidgetImageUrl(option.image, sizeValue, 'Size Option', {
              width: 150,
              height: 150,
              fontSize: 14
            });
            
            // Add class to indicate if this option has an image or not (same as image-swatch)
            const hasImageClass = imageUrl ? 'has-image' : 'no-image';
            html += `<div class="option-swatch-item size-swatch ${hasImageClass} ${optIndex === 0 ? 'selected' : ''}" data-value="${escapeHtmlAttribute(sizeValue)}" data-price="${option.price || 0}">`;
            
            // Only show image if imageUrl exists - no placeholder (same as image-swatch)
            if (imageUrl) {
              const fetchPriority = optIndex < 4 ? 'high' : 'auto';
              html += buildWidgetDeferredImageTag({
                imageUrl,
                altText: sizeValue,
                className: 'swatch-image',
                loading: 'eager',
                decoding: 'async',
                fetchPriority,
                style: 'display:block !important;opacity:0 !important;visibility:hidden !important;pointer-events:none !important;'
              });
            }
            
            html += `<div class="size-label" style="font-size: 17px; font-weight: 500; margin-bottom: 0px;">${sizeLabel}</div>`;
            if (showSizePrice && option.price && option.price > 0) {
              html += `<div class="swatch-price">+$${parseFloat(option.price).toFixed(2)}</div>`;
            }
            if ((field.structure?.showSubtext !== false) && option.sublabel) {
              html += `<div class="size-subtext" style="font-size: 14px; font-weight: 500; margin-top: 0px; margin-bottom: 0px; padding-top: 0px; padding-bottom: 0px;">${option.sublabel}</div>`;
            }
            html += '</div>';
          });
        } else {
          // No size options configured - show empty state
          console.warn(`Custom Option Widget v${WIDGET_VERSION} - No size options configured for field:`, field.label);
          html += '<div class="no-options-message" style="padding: 20px; text-align: center; color: #999; font-style: italic;">No size options configured</div>';
        }
        html += '</div>';
        break;
        
      case 'corner':
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Building corner field:`, {
          label: field.label,
          optionsCount: field.options?.length || 0,
          options: field.options,
          fullField: field
        });
        html += '<div class="corner-group" style="display: grid; grid-template-columns: 1fr 1fr; gap: var(--option-gap);" data-field-name="' + (field.label || 'corner_' + index) + '">';
        
        // Validate and filter options
        const cornerItems = validateOptions(field.options || field.corners, 'corner');
        
        if (cornerItems.length > 0) {
          cornerItems.forEach((option, optIndex) => {
            const cornerValue = option.value || option.name || `Corner ${optIndex + 1}`;
            
            // Show price for corner options if enabled
            const showCornerPrice = !!field.showCornerPrice;
            const priceAttr = showCornerPrice && option.price ? ` data-price="${option.price}"` : '';
            
            html += `<div class="corner-option ${optIndex === 0 ? 'selected' : ''}" data-value="${escapeHtmlAttribute(cornerValue)}"${priceAttr} style="padding: 13px 13px 13px 13px; border: 1px solid #e0e0e0; border-radius: var(--option-radius); background: var(--option-background); cursor: pointer; transition: var(--option-transition); display: flex; flex-direction: row; align-items: center; width: 100%; min-height: 80px;">`;
            
            // Text content on the left (left-aligned, not centered)
            html += `<div class="corner-text" style="flex: 1; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; text-align: left;">`;
            html += `<div class="corner-label" style="font-weight: 500; font-size: 17px; color: var(--option-text); margin-bottom: 4px;">${option.label || cornerValue}</div>`;
            
            // Show price if enabled and price exists
            if (showCornerPrice && option.price) {
              html += `<div class="corner-price" style="font-size: 12px; color: var(--option-price, #007bff); font-weight: 500;">$${option.price}</div>`;
            }
            // Check for multiple possible subtext field names
            debugLog(`Corner option ${optIndex} data:`, option);
            const subtextContent = option.subtext || option.sublabel || option.subtitle || option.sub_text || option.description || option.helpText || option.help || '';
            debugLog(`Subtext content for ${cornerValue}:`, subtextContent);
            if (subtextContent) {
              html += `<div class="corner-subtext" style="font-size: 14px; font-weight: 500; color: var(--option-subtext); line-height: 1.3;">${subtextContent}</div>`;
            }
            html += `</div>`;
            
            // Image/icon on the right (no container)
            if (option.image) {
              const imageUrl = resolveWidgetImageUrl(option.image, cornerValue, '', {
                width: 48,
                height: 48,
                fontSize: 12
              });
              if (imageUrl) {
                html += buildWidgetDeferredImageTag({
                  imageUrl,
                  altText: cornerValue,
                  className: 'corner-image',
                  loading: 'eager',
                  decoding: 'async',
                  fetchPriority: 'auto',
                  style: 'width:48px;height:48px;object-fit:cover;border-radius:4px;margin-left:12px;display:block !important;opacity:0 !important;visibility:hidden !important;pointer-events:none !important;'
                });
              } else {
                const borderRadius = optIndex === 0 ? '0' : optIndex === 1 ? '6px' : '16px';
                html += `<div style="width: 48px; height: 48px; border: 2px solid #ccc; border-radius: ${borderRadius}; background: #fff; margin-left: 12px;"></div>`;
              }
            } else {
              // Create a visual representation of corner style (icon-like)
              const borderRadius = optIndex === 0 ? '0' : optIndex === 1 ? '6px' : '16px';
              html += `<div style="width: 48px; height: 48px; border: 2px solid #ccc; border-radius: ${borderRadius}; background: #fff; margin-left: 12px;"></div>`;
            }
            html += '</div>';
          });
        } else {
          // Show only Rectangle and Round for Style Studio
          const defaultCorners = [
            { name: 'Rectangle', radius: '0', width: '60px', height: '40px' },
            { name: 'Round', radius: '20px', width: '60px', height: '60px' }
          ];
          defaultCorners.forEach((corner, cornerIndex) => {
            html += `<div class="corner-option ${cornerIndex === 0 ? 'selected' : ''}" data-value="${escapeHtmlAttribute(corner.name)}" style="padding: 13px 13px 13px 13px; border: 1px solid #e0e0e0; border-radius: var(--option-radius); background: var(--option-background); cursor: pointer; transition: var(--option-transition); display: flex; flex-direction: row; align-items: center; width: 100%; min-height: 80px;">`;
            
            // Text content on the left (left-aligned, not centered)
            html += `<div class="corner-text" style="flex: 1; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; text-align: left;">`;
            html += `<div class="corner-label" style="font-weight: 500; font-size: 14px; color: var(--option-text);">${corner.name}</div>`;
            html += `</div>`;
            
            // Icon on the right (no container)
            html += `<div style="width: 48px; height: 48px; border: 2px solid #ccc; border-radius: ${corner.radius}; background: #fff; margin-left: 12px;"></div>`;
            
            html += '</div>';
          });
        }
        html += '</div>';
        break;
        
      case 'quantity-list':
        debugLog(`ðŸš¨ QUANTITY LIST FIELD DETECTED:`, {
          fieldType: field.type,
          label: field.label,
          quantitiesCount: field.quantities?.length || 0,
          quantities: field.quantities,
          fullField: field
        });
        
        debugLog('ðŸš¨ PROCESSING QUANTITY-LIST CASE - THIS SHOULD APPEAR IN CONSOLE');
        
        // Check if we have detailed pricing tiers or simple quantity options
        const hasDetailedTiers = field.quantities && field.quantities.length > 0 && 
                                field.quantities.some(q => q.price !== undefined);
        
        if (hasDetailedTiers) {
          // Render detailed pricing tiers with new 3-column layout
          html += `<div class="quantity-list" data-field-name="${field.label || 'quantity_' + index}">`;
          
          // Get base price (first option) for savings calculation
          const basePrice = field.quantities[0]?.price || 0;
          const baseQuantity = field.quantities[0]?.quantity || 1;
          const basePricePerUnit = basePrice / baseQuantity;
          
          // Get unit name from field properties, default to 'units'
          const unitName = field.unitName || 'units';
          const singularUnit = unitName.endsWith('s') ? unitName.slice(0, -1) : unitName;
          
          // Show first 5 options initially
          const visibleQuantities = field.quantities.slice(0, 5);
          const hiddenQuantities = field.quantities.slice(5);
          
          // Find if any quantity has recommended flag to determine selection
          const recommendedIndex = field.quantities.findIndex(qty => qty.recommended);
          const defaultSelectedIndex = recommendedIndex !== -1 ? recommendedIndex : 0;
          
          visibleQuantities.forEach((qty, qtyIndex) => {
            const globalIndex = qtyIndex; // This is the actual index in the full array
            const pricePerUnit = qty.price / qty.quantity;
            const savingsPercent = qtyIndex === 0 ? 0 : Math.round(((basePricePerUnit - pricePerUnit) / basePricePerUnit) * 100);
            const isRecommended = qty.recommended ? ' recommended' : '';
            // Only select if this is the recommended item OR if no recommended and this is first item
            const isSelected = (globalIndex === defaultSelectedIndex) ? ' selected' : '';
            
            // Determine if this option has savings for styling
            const hasSavings = savingsPercent > 0;
            const savingsClass = hasSavings ? ' has-savings' : ' no-savings';
            
            const tierHtml = `
              <div class="quantity-tier${isRecommended}${isSelected}" data-value="${escapeHtmlAttribute(qty.quantity)}" data-price="${qty.price}" data-pricing-value-key="${escapeHtmlAttribute(qty.pricingValueKey || '')}">
                <div class="tier-info">
                  <div class="tier-quantity">${qty.quantity}${qty.recommended ? ' <span class="tier-badge-inline">Recommended</span>' : ''}</div>
                </div>
                <div class="tier-pricing">
                  <div class="tier-price">$${parseFloat(qty.price).toFixed(2)}</div>
                  <div class="tier-unit-price">$${pricePerUnit.toFixed(2)}/${singularUnit}</div>
                </div>
                <div class="tier-savings${savingsClass}">${qtyIndex === 0 ? '' : (savingsPercent > 0 ? savingsPercent + '% Savings' : '')}</div>
              </div>`;
            
            // DEBUG: Log first option details
            if (qtyIndex === 0) {
              debugLog('ðŸ” FIRST OPTION DEBUG:', {
                index: qtyIndex,
                globalIndex: globalIndex,
                quantity: qty.quantity,
                isRecommended: isRecommended,
                isSelected: isSelected,
                classes: `quantity-tier${isRecommended}${isSelected}`,
                html: tierHtml
              });
            } else if (qtyIndex === 1) {
              debugLog('ðŸ” SECOND OPTION DEBUG (for comparison):', {
                index: qtyIndex,
                quantity: qty.quantity,
                classes: `quantity-tier${isRecommended}${isSelected}`,
                html: tierHtml
              });
            }
            
            html += tierHtml;
          });
          
          // Add "See more quantities" button if there are hidden options
          if (hiddenQuantities.length > 0) {
            // Add hidden quantities
            hiddenQuantities.forEach((qty, qtyIndex) => {
              const globalIndex = 5 + qtyIndex; // This is the actual index in the full array
              const pricePerUnit = qty.price / qty.quantity;
              const savingsPercent = Math.round(((basePricePerUnit - pricePerUnit) / basePricePerUnit) * 100);
              const isRecommended = qty.recommended ? ' recommended' : '';
              // Only select if this item matches the defaultSelectedIndex (recommended OR first)
              const isSelected = (globalIndex === defaultSelectedIndex) ? ' selected' : '';
              
              html += `
                <div class="quantity-tier quantity-tier-hidden${isRecommended}${isSelected}" data-value="${escapeHtmlAttribute(qty.quantity)}" data-price="${qty.price}" data-pricing-value-key="${escapeHtmlAttribute(qty.pricingValueKey || '')}" style="display: none;">
                  <div class="tier-info">
                    <div class="tier-quantity">${qty.quantity}${qty.recommended ? ' <span class="tier-badge-inline">Recommended</span>' : ''}</div>
                  </div>
                  <div class="tier-pricing">
                    <div class="tier-price">$${parseFloat(qty.price).toFixed(2)}</div>
                    <div class="tier-unit-price">$${pricePerUnit.toFixed(2)}/${singularUnit}</div>
                  </div>
                  <div class="tier-savings">${savingsPercent > 0 ? savingsPercent + '% Savings' : ''}</div>
                </div>`;
            });
            
            html += `<button type="button" class="see-more-quantities" onclick="toggleQuantities(this); return false;">See more quantities</button>`;
          }
          
          html += '</div>';
        } else {
          // Render simple quantity grid (Style Studio style) with TRUE PER-UNIT PRICING
          const defaultQuantities = field.quantities && field.quantities.length > 0 
            ? field.quantities 
            : [
                { quantity: 50, price: 22, label: '50' },      // $0.44/unit
                { quantity: 100, price: 43, label: '100' },    // $0.43/unit (discount)
                { quantity: 200, price: 74, label: '200' },    // $0.37/unit (more discount)
                { quantity: 400, price: 129, label: '400' },   // $0.3225/unit
                { quantity: 600, price: 163, label: '600' }    // $0.2717/unit (best value)
              ];
          
          html += `<div class="quantity-grid" data-field-name="${field.label || 'quantity_' + index}">`;
          defaultQuantities.forEach((qty, qtyIndex) => {
            const isSelected = qtyIndex === 1 ? ' selected' : ''; // Default to 100 units
            const quantityValue = qty.quantity || qty.value || qty.label;
            const displayLabel = qty.label || qty.quantity || qty.value;
            const unitPrice = qty.price ? (qty.price / qty.quantity).toFixed(4) : '';
            const priceDisplay = qty.price ? `$${qty.price.toFixed(2)}` : '';
            const unitDisplay = unitPrice ? `$${unitPrice}/Piece` : '';
            
            html += `
              <div class="quantity-tier${isSelected}" data-value="${escapeHtmlAttribute(quantityValue)}" data-price="${qty.price || ''}">
                <div class="tier-info">
                  <div class="tier-quantity">${displayLabel} pieces${qtyIndex === 1 ? ' <span class="tier-badge-inline">Popular</span>' : qtyIndex === 4 ? ' <span class="tier-badge-inline">Best Value</span>' : ''}</div>
                </div>
                <div class="tier-pricing">
                  <div class="tier-price">${priceDisplay}</div>
                  <div class="tier-unit-price">${unitDisplay}</div>
                </div>
                <div class="tier-savings">${unitPrice && qtyIndex > 0 ? Math.round((0.44 - parseFloat(unitPrice)) / 0.44 * 100) + '% Savings' : ''}</div>
              </div>`;
          });
          html += '</div>';
        }
        break;
        
      case 'quantity-slider':
        const minQty = field.minQuantity || field.min || 1;
        const maxQty = field.maxQuantity || field.max || 500;
        const stepValue = field.stepValue || field.step || 1;
        const defaultQty = field.defaultQuantity || minQty; // Start at minimum quantity (leftmost position)
        
        // Use quantities array for tiered pricing (similar to quantity-list)
        const quantitiesTiers = field.quantities && field.quantities.length > 0 ? field.quantities : [
          { quantityFrom: 1, quantityTo: 10, price: 0.50 },
          { quantityFrom: 11, quantityTo: 25, price: 0.45 },
          { quantityFrom: 26, quantityTo: 50, price: 0.40 },
          { quantityFrom: 51, quantityTo: 100, price: 0.35 },
          { quantityFrom: 101, quantityTo: 500, price: 0.30 }
        ];
        
        // Get unit name from field properties, default to 'units'
        const unitName = field.unitName || 'units';
        const singularUnit = unitName.endsWith('s') ? unitName.slice(0, -1) : unitName;
        
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Building quantity slider:`, {
          min: minQty,
          max: maxQty,
          default: defaultQty,
          quantities: quantitiesTiers,
          unitName: unitName
        });
        
        // Store quantities data as JSON for the slider event handler
        const quantitiesData = JSON.stringify(quantitiesTiers);
        
        html += `
          <div class="quantity-slider-wrapper" data-field-name="${field.label || 'quantity_slider_' + index}">
            <!-- Slider Container -->
            <div class="slider-container">
              <input type="range" 
                     class="quantity-slider" 
                     min="${minQty}" 
                     max="${maxQty}" 
                     step="${stepValue}" 
                     value="${defaultQty}"
                     data-quantities='${quantitiesData}'>
              
              <!-- Range Labels -->
              <div class="slider-labels">
                <span>${minQty} ${minQty !== 1 ? unitName : singularUnit}</span>
                <span>${maxQty} ${unitName}</span>
              </div>
            </div>
            
            <!-- Quantity and Unit Price Display Below Slider -->
            <div class="unit-price-below-slider">
              <div class="quantity-display-below">
                <span class="total-price-quantity">$${getPricingBreakdown(defaultQty, quantitiesTiers).totalPrice.toFixed(2)} for ${defaultQty} ${defaultQty !== 1 ? unitName : singularUnit}</span>
              </div>
              ${(() => {
                const pricing = getPricingBreakdown(defaultQty, quantitiesTiers);
                if (pricing.isDiscounted) {
                  const discountPercent = Math.round(((pricing.originalUnitPrice - pricing.unitPrice) / pricing.originalUnitPrice) * 100);
                  return `<span class="current-unit-price">$${pricing.unitPrice.toFixed(2)} / unit</span> <span class="original-price-crossed">$${pricing.originalUnitPrice.toFixed(2)} / unit</span><div class="volume-discount">${discountPercent}% volume discount</div>`;
                } else {
                  return `<span class="current-unit-price">$${pricing.unitPrice.toFixed(2)} / unit</span>`;
                }
              })()}
            </div>
          </div>`;
        break;
        
      case 'design-method':
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Building design method field:`, {
          label: field.label,
          designMethodsCount: field.designMethods?.length || 0,
          designMethods: field.designMethods,
          fullField: field
        });
        html += '<div class="design-method-group" data-field-name="' + (field.label || 'design_method_' + index) + '">';
        if (field.designMethods && field.designMethods.length > 0) {
          field.designMethods.forEach((method, methodIndex) => {
            const methodPrice = getConfiguredPriceValue(method);
            const methodName = method.name || `Method ${methodIndex + 1}`;
            const imageUrl = resolveWidgetImageUrl(method.image, methodName, 'Design Method', {
              width: 200,
              height: 150,
              fontSize: 14
            });
            
            html += `
              <div class="design-method ${methodIndex === 0 ? 'selected' : ''}" 
                   data-value="${escapeHtmlAttribute(method.id || 'method_' + methodIndex)}" 
                   data-redirect="${escapeHtmlAttribute(method.redirectBehavior || '')}"
                   data-price="${methodPrice}">
                ${imageUrl ? buildWidgetDeferredImageTag({
                  imageUrl,
                  altText: method.name || 'Design Method',
                  className: 'method-image',
                  loading: 'eager',
                  decoding: 'async',
                  fetchPriority: methodIndex < 2 ? 'high' : 'auto',
                  style: 'display:block !important;opacity:0 !important;visibility:hidden !important;pointer-events:none !important;'
                }) : ''}
                <div class="swatch-label">${(method.name || 'Design Method').replace(/We Design It For You/i, 'We Design It<br>For You')}</div>
                ${method.subtext || method.description ? `<div class="method-subtext">${method.subtext || method.description || ''}</div>` : ''}
                ${methodPrice > 0 ? `<div class="swatch-price">$${methodPrice}</div>` : ''}
              </div>`;
          });
        } else {
          // No design methods configured - show empty state
          console.warn(`Custom Option Widget v${WIDGET_VERSION} - No design methods configured for field:`, field.label);
          html += '<div class="no-options-message" style="padding: 20px; text-align: center; color: #999; font-style: italic;">No design methods configured</div>';
        }
        html += '</div>';
        break;
        
      case 'upload':
        html += `
          <div class="upload-wrapper" data-field-name="${field.label || 'upload_' + index}">
            <input type="file" class="file-upload" multiple accept="image/*,.pdf" style="position: absolute; opacity: 0; pointer-events: none;">
            <div class="upload-area">
              <div class="upload-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                  <polyline points="7,10 12,15 17,10"/>
                  <line x1="12" y1="15" x2="12" y2="3"/>
                </svg>
              </div>
              <div class="upload-text" style="font-weight: 500; color: var(--option-text); margin-bottom: 8px; font-family: var(--option-font-family);">Click to upload files or drag and drop</div>
              <div class="upload-subtext" style="color: var(--option-subtext); font-size: 14px; font-family: var(--option-font-family);">Supports images and PDF files</div>
            </div>
          </div>`;
        break;
        
      case 'start-making': {
        const rawText = (field.settings && field.settings.default_text) || 'Add to Cart';
        const buttonText = rawText === 'Start Making' ? 'Add to Cart' : rawText;
        html += `
          <div class="start-making-wrapper">
            <button type="button" class="start-making-button">${buttonText}</button>
            <div class="later-options">
              <button type="button" class="later-link design-later" style="display: none;">
                <u>Design Later</u>
              </button>
              <button type="button" class="later-link upload-later" style="display: none;">
                <u>Upload Later</u>
              </button>
            </div>
          </div>`;
        break;
      }
        
      case 'summary':
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Building enhanced order summary field:`, field);
        
        // Enhanced order summary with builder structure
        const summaryId = `order-summary-${index}`;
        
        html += `
          <div class="option-field-wrapper" data-field-type="summary" style="margin: 0 !important; padding: 0 !important; margin-bottom: 0 !important; margin-top: 0 !important;">`;
        
        // Skip field label for Order Summary to avoid duplication
        // The summary content will show its own title
        
        html += `<div id="order-summary-${index}" class="order-summary" data-field-id="${field.id}" data-summary-index="${index}" style="margin: 0 !important; padding: 0 !important;">
              <div class="summary-title" style="font-size: 19px !important; font-weight: 500 !important; color: var(--option-text) !important; margin-bottom: 10px !important; font-family: var(--option-label-font) !important; letter-spacing: -0.01em !important; line-height: 1.4 !important;">${field.label || 'Order Summary'}</div>
              ${field.description ? `<p style="margin: 8px 0 !important;">${field.description}</p>` : ''}
              <div class="summary-section" style="margin-top: 0 !important; padding-top: 0 !important;">
                <div class="summary-items" id="summary-items-${index}" style="margin-top: 0 !important; padding-top: 0 !important;">
                  <div class="summary-empty">
                    <p class="main">Select options to see your order details...</p>
                  </div>
                </div>
                <div class="price-row">
                  <span class="label">Price</span>
                  <div class="price-container" id="price-container-${index}">
                    <span class="value" id="summary-total-${index}">$0.00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>`;
        break;
        
      case 'details':
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Building details field:`, {
          header: field.header,
          pricingQuantity: field.pricingQuantity,
          pricingPrice: field.pricingPrice,
          content: field.content
        });
        
        html += '<div class="details-field-wrapper">';
        
        // Header
        if (field.header) {
          html += `<label class="field-label">${field.header}</label>`;
        }
        
        // Pricing line (quantity and price)
        if (field.pricingQuantity || field.pricingPrice) {
          html += '<p class="details-pricing">';
          if (field.pricingQuantity) {
            html += `<span class="pricing-quantity">${field.pricingQuantity}</span>`;
          }
          if (field.pricingQuantity && field.pricingPrice) {
            html += ' <span class="pricing-from">from</span> ';
          }
          if (field.pricingPrice) {
            html += `<span class="pricing-price">${field.pricingPrice}</span>`;
          }
          html += '</p>';
        }
        
        // Rich text content
        if (field.content) {
          html += `<div class="details-content">${field.content}</div>`;
        }
        
        html += '</div>';
        break;
        
      case 'request-quote':
        const quoteButtonText = (field.settings && field.settings.buttonText) || 'Request Quote';
        html += `
          <div class="request-quote-form">
            <div class="contact-info-section">
              <div class="form-row">
                <div class="form-field-half">
                  <label class="field-label">Full Name *</label>
                  <input type="text" name="properties[Full Name]" class="option-widget-input" placeholder="Enter your full name" required>
                </div>
                <div class="form-field-half">
                  <label class="field-label">Company Name</label>
                  <input type="text" name="properties[Company Name]" class="option-widget-input" placeholder="Enter your company name (optional)">
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-field-half">
                  <label class="field-label">Email Address *</label>
                  <input type="email" name="properties[Email]" class="option-widget-input" placeholder="Enter your email address" required>
                </div>
                <div class="form-field-half">
                  <label class="field-label">Phone Number *</label>
                  <input type="tel" name="properties[Phone]" class="option-widget-input" placeholder="Enter your phone number" required>
                </div>
              </div>
              
              <div class="form-field-full">
                <label class="field-label">Additional Details</label>
                <textarea name="properties[Additional Details]" class="option-widget-textarea" rows="4" placeholder="Please provide any additional details about your quote request, timeline, specific requirements, etc."></textarea>
              </div>
            </div>
            
            <button type="button" class="request-quote-submit-button" onclick="handleQuoteFormSubmit(this)">
              ${quoteButtonText}
            </button>
          </div>`;
        break;
        
      default:
        console.warn(`Custom Option Widget v${WIDGET_VERSION} - Unknown field type: ${field.type}`);
        html += `<div class="unknown-field">Unknown field type: ${field.type}</div>`;
    }
    
    html += '</div>';
    return html;
  }

  // 5. ATTACH EVENT LISTENERS - OPTIMIZED FOR MAXIMUM PERFORMANCE
  function attachEventListeners(container, productId) {
    PerformanceMonitor.start('attachEventListeners');
    const debugEnabled = WIDGET_DEBUG_LOGGING;

    // MEMORY FIX: Track refresh timeout to prevent pile-up
    let refreshTimeoutId = null;

    const refreshSummaryAndPricing = () => {
      if (!container || !container.isConnected) return;
      const currentSelections = getCurrentSelectionsFromForm(container);
      updateOrderSummary(container, currentSelections);
      updateQuantityListPricing(container, currentSelections, getOptionSetData(container));
    };

    // MEMORY FIX: Debounced refresh that cancels previous pending refresh
    const scheduleRefresh = (delay = 50) => {
      if (refreshTimeoutId) {
        clearTimeout(refreshTimeoutId);
      }
      refreshTimeoutId = setTimeout(() => {
        refreshTimeoutId = null;
        if (debugEnabled) {
          debugLog('ðŸ”„ Executing debounced refresh');
        }
        refreshSummaryAndPricing();
      }, delay);
      // Register timeout for cleanup
      window.OptionWidgetManager.addTimer(productId, refreshTimeoutId);
    };

    const form = SafeDOM.query(container, `#option-set-form-${productId}`);
    const hiddenInput = SafeDOM.query(container, `#option-set-data-${productId}`);

    if (!form || !hiddenInput) {
      console.warn(`Custom Option Widget v${WIDGET_VERSION} - Required elements not found for product ${productId}`);
      return;
    }

    // Create debounced update functions to prevent excessive calculations
    const debouncedUpdateData = debounce(() => {
      PerformanceMonitor.start('updateOptionData');
      updateOptionData(form, hiddenInput, container);
      PerformanceMonitor.end('updateOptionData');

      // updateOptionData already calls updateOrderSummary + updateQuantityListPricing,
      // so no redundant scheduleRefresh here — avoids double execution.
    }, 50);

    const throttledSliderUpdate = throttle((target) => {
      PerformanceMonitor.start('handleQuantitySlider');
      handleQuantitySlider(target);
      PerformanceMonitor.end('handleQuantitySlider');

      // CRITICAL FIX: Also trigger Order Summary update after slider changes
      // MEMORY FIX: Use scheduleRefresh instead of raw setTimeout
      scheduleRefresh(10);
    }, 16); // ~60fps

    // OPTIMIZED: Single click handler using event delegation
    // Time-based throttle: ignore clicks within 80ms of the last processed click
    let _lastClickProcessedAt = 0;
    const CLICK_THROTTLE_MS = 80;
    const optimizedClickHandler = function(e) {
      try {
        // Fast path: check if target is relevant
        const target = e.target;
        let optionElement = null;
        
        // Quick checks for common option types
        if (SafeDOM.hasClass(target, 'option-button') || 
            SafeDOM.hasClass(target, 'color-swatch-item') || 
            SafeDOM.hasClass(target, 'option-swatch-item') || 
            SafeDOM.hasClass(target, 'corner-option') || 
            SafeDOM.hasClass(target, 'quantity-tier') || 
            SafeDOM.hasClass(target, 'quantity-option') || 
            SafeDOM.hasClass(target, 'design-method')) {
          optionElement = target;
        } else {
          // Check parent elements (for nested elements like images inside buttons)
          optionElement = target.closest('.option-button, .color-swatch-item, .option-swatch-item, .corner-option, .quantity-tier, .quantity-option, .design-method');
        }

        if (optionElement) {
          e.preventDefault();
          e.stopPropagation();
          
          // Skip clicks on unavailable quantity tiers
          if (optionElement.classList.contains('quantity-tier-unavailable')) return;

          // No-op fast path: repeated clicks on the already-selected option should
          // not trigger the full pricing/order-summary update pipeline.
          if (optionElement.classList.contains('selected')) return;
          
          // Time-based throttle: drop clicks that arrive too fast
          const now = performance.now();
          if (now - _lastClickProcessedAt < CLICK_THROTTLE_MS) return;
          _lastClickProcessedAt = now;
        
        // Use requestAnimationFrame for butter-smooth updates
        requestAnimationFrame(() => {
          handleFastOptionSelection(optionElement);
          debouncedUpdateData();
          // debouncedUpdateData already triggers scheduleRefresh(10) internally,
          // so no need for a second scheduleRefresh(100) here -- eliminates
          // redundant double-refresh that caused visible price update delay.
        });
        return;
      }

      // Handle upload wrapper clicks
      const uploadWrapper = target.closest('.upload-wrapper');
      if (uploadWrapper) {
        const fileInput = uploadWrapper.querySelector('.file-upload');
        if (fileInput) {
          fileInput.click();
        }
        return;
      }

      // Handle radio options
      const radioOption = target.closest('.radio-option');
      if (radioOption) {
        e.preventDefault();
        e.stopPropagation();

        if (radioOption.classList.contains('selected')) {
          return;
        }
        
        requestAnimationFrame(() => {
          handleRadioSelection(radioOption);
          debouncedUpdateData();
          // OOM FIX: Removed redundant scheduleRefresh(100) — debouncedUpdateData
          // already triggers updateOrderSummary + updateQuantityListPricing internally,
          // so the duplicate scheduleRefresh was causing double execution of the entire
          // pricing calculation chain on every radio click.
        });
        return;
      }

      // Handle start making button
      if (target.matches('.start-making-button')) {
        handleStartMaking(target, form, container);
      }
      
      // Handle "later" links - add to cart without design process
      if (target.matches('.later-link')) {
        handleLaterLink(target, form, container);
      }
      } catch (error) {
        console.error('Custom Option Widget - Click handler error:', error);
        // Prevent page crashes by gracefully handling errors
      }
    };

    // OPTIMIZED: Single input handler for sliders
    const optimizedInputHandler = function(e) {
      try {
        const target = e.target;
        
        if (target.matches('.quantity-slider')) {
          throttledSliderUpdate(target);
          return;
        }
        
        // REMOVED: quantity-input handling - field no longer exists
        
        // Debounce other input updates
        debouncedUpdateData();
        // OOM FIX: Removed redundant scheduleRefresh(150) — debouncedUpdateData
        // already triggers the full pricing update chain.
      } catch (error) {
        console.error('Custom Option Widget - Input handler error:', error);
      }
    };

    // OPTIMIZED: Change handler
    const optimizedChangeHandler = function(e) {
      try {
        debouncedUpdateData();
        // OOM FIX: Removed redundant scheduleRefresh(100) — debouncedUpdateData
        // already triggers the full pricing update chain.
      } catch (error) {
        console.error('Custom Option Widget - Change handler error:', error);
      }
    };

    // Add managed event listeners (for automatic cleanup)
    window.OptionWidgetManager.addListener(productId, container, 'click', optimizedClickHandler, { passive: false });
    window.OptionWidgetManager.addListener(productId, container, 'input', optimizedInputHandler, { passive: true });
    window.OptionWidgetManager.addListener(productId, container, 'change', optimizedChangeHandler, { passive: true });

    PerformanceMonitor.end('attachEventListeners');
  }

  // 6. ULTRA-FAST OPTION SELECTION HANDLER
  function handleFastOptionSelection(element) {
    try {
      const group = element.parentElement;
      if (!group) return false;
      
      // Lightning-fast sibling deselection using native DOM methods
      const siblings = group.children;
      for (let i = 0; i < siblings.length; i++) {
        const sibling = siblings[i];
        if (SafeDOM.hasClass(sibling, 'selected') && sibling !== element) {
          SafeDOM.removeClass(sibling, 'selected');
        }
      }
      
      // Instant selection
      if (!SafeDOM.hasClass(element, 'selected')) {
        SafeDOM.addClass(element, 'selected');
      }
      
      // Check if this is a design method selection and update start making button
      if (SafeDOM.hasClass(element, 'design-method')) {
        updateStartMakingButtonForDesignMethod(element);
      }
      
      return true;
    } catch (error) {
      console.warn('Fast option selection error:', error);
      return false;
    }
  }

  // 6.1. UPDATE START MAKING BUTTON BASED ON DESIGN METHOD SELECTION
  // SIMPLIFIED: Always shows "Add to Cart" - no dynamic text changes
  function updateStartMakingButtonForDesignMethod(designMethodElement) {
    try {
      const container = designMethodElement.closest('#custom-options-widget-container, #custom-options-widget-container-2');
      if (!container) return;

      const startMakingButton = SafeDOM.query(container, '.start-making-button');
      if (!startMakingButton) return;

      // Always set to "Add to Cart" - no dynamic button text
      SafeDOM.setText(startMakingButton, 'Add to Cart');
      startMakingButton.className = 'start-making-button cart-mode';

      // Hide all "later" links - not used anymore
      const designLaterLink = SafeDOM.query(container, '.design-later');
      const uploadLaterLink = SafeDOM.query(container, '.upload-later');
      if (designLaterLink) designLaterLink.style.display = 'none';
      if (uploadLaterLink) uploadLaterLink.style.display = 'none';

      debugLog(`ðŸ”„ Button set to "Add to Cart"`);
    } catch (error) {
      console.warn('Error updating button:', error);
    }
  }

  // 9. ULTRA-SMOOTH QUANTITY SLIDER HANDLER
  function handleQuantitySlider(slider) {
    try {
      const wrapper = slider.closest('.quantity-slider-wrapper');
      if (!wrapper) return;
      
      const quantityText = wrapper.querySelector('.quantity-display-below .total-price-quantity');
      const unitPriceDisplay = wrapper.querySelector('.unit-price-below-slider');
      const currentValue = parseInt(slider.value) || 1;
      const maxValue = parseInt(slider.max) || 500;
      const minValue = parseInt(slider.min) || 1;
      
      // Get quantities tiers from data attribute
      let quantitiesTiers = [];
      try {
        quantitiesTiers = JSON.parse(slider.dataset.quantities || '[]');
      } catch (e) {
        console.error('Error parsing quantities data:', e);
        // Fallback to default tiers (range-based structure)
        quantitiesTiers = [
          { quantityFrom: 1, quantityTo: 10, price: 0.50 },
          { quantityFrom: 11, quantityTo: 25, price: 0.45 },
          { quantityFrom: 26, quantityTo: 50, price: 0.40 },
          { quantityFrom: 51, quantityTo: 100, price: 0.35 },
          { quantityFrom: 101, quantityTo: 500, price: 0.30 }
        ];
      }
      
      // Calculate progress percentage for instant visual feedback
      const progress = (currentValue / maxValue) * 100;
      
      // PERFORMANCE: Cache DOM property reads
      const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--option-primary') || '#000000';
      
      // Instant visual feedback with GPU-accelerated background update
      slider.style.background = `linear-gradient(to right, ${primaryColor} 0%, ${primaryColor} ${progress}%, #e0e0e0 ${progress}%, #e0e0e0 100%)`;
      
      // Get pricing breakdown
      const pricingBreakdown = getPricingBreakdown(currentValue, quantitiesTiers);
      
      // Determine unit text (singular vs plural)
      const unitName = slider.closest('.quantity-slider-wrapper').dataset.fieldName?.includes('units') ? 'units' : 'units';
      const singularUnit = unitName.endsWith('s') ? unitName.slice(0, -1) : unitName;
      const displayUnit = currentValue === 1 ? singularUnit : unitName;
      
      // Batch DOM writes to prevent layout thrashing
      requestAnimationFrame(() => {
        // Update total price display at top
        if (quantityText) {
          quantityText.textContent = `$${pricingBreakdown.totalPrice.toFixed(2)} for ${currentValue} ${displayUnit}`;
        }
        
        // Update unit pricing display
        if (unitPriceDisplay) {
          if (pricingBreakdown.isDiscounted) {
            const discountPercent = Math.round(((pricingBreakdown.originalUnitPrice - pricingBreakdown.unitPrice) / pricingBreakdown.originalUnitPrice) * 100);
            unitPriceDisplay.innerHTML = `<span class="current-unit-price">$${pricingBreakdown.unitPrice.toFixed(2)} / unit</span> <span class="original-price-crossed">$${pricingBreakdown.originalUnitPrice.toFixed(2)} / unit</span><div class="volume-discount">${discountPercent}% volume discount</div>`;
          } else {
            unitPriceDisplay.innerHTML = `<span class="current-unit-price">$${pricingBreakdown.unitPrice.toFixed(2)} / unit</span>`;
          }
        }
      });
      
      // Store value for form submission
      slider.dataset.currentValue = currentValue;
      
    } catch (error) {
      console.warn('Quantity slider error:', error);
    }
  }

  // 10. HANDLE DESIGN METHOD SELECTION (with iframe support)
  function handleDesignMethodSelection(element) {
    const group = element.parentElement;
    const iframeUrl = element.dataset.iframeUrl;
    
    // Remove selected class from siblings
    const siblings = group.querySelectorAll('.design-method');
    siblings.forEach(function(sibling) {
      sibling.classList.remove('selected');
    });
    
    // Add selected class to clicked element
    element.classList.add('selected');
    
    // Update the start making button text based on selection
    updateStartMakingButtonForDesignMethod(element);
    
    // If this option has an iframe URL, open it
    if (iframeUrl) {
      openDesignIframe(iframeUrl, element.dataset.value);
    }
  }

  // 11. OPEN DESIGN IFRAME
  // 11. OPEN DESIGN IFRAME
  function openDesignIframe(url, designType) {
    // Create iframe modal
    const modal = document.createElement('div');
    modal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.8);
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
    `;
    
    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.style.cssText = `
      width: 90%;
      height: 90%;
      border: none;
      border-radius: 8px;
      background: white;
    `;
    
    const closeButton = document.createElement('button');
    closeButton.textContent = '\u00D7';
    closeButton.style.cssText = `
      position: absolute;
      top: 20px;
      right: 20px;
      background: white;
      border: none;
      font-size: 24px;
      padding: 10px 15px;
      border-radius: 50%;
      cursor: pointer;
      z-index: 10001;
    `;
    
    closeButton.addEventListener('click', function() {
      document.body.removeChild(modal);
    });
    
    modal.appendChild(iframe);
    modal.appendChild(closeButton);
    document.body.appendChild(modal);
    
    // Close on backdrop click
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        document.body.removeChild(modal);
      }
    });
  }

  // 12. HANDLE RADIO SELECTION
  function handleRadioSelection(element) {
    const group = element.parentElement;
    const radioInput = element.querySelector('input[type="radio"]');
    
    if (radioInput) {
      // Check the radio input
      radioInput.checked = true;
      
      // Remove selected class from all radio options in this group
      const radioOptions = group.querySelectorAll('.radio-option');
      radioOptions.forEach(function(option) {
        option.classList.remove('selected');
      });
      
      // Add selected class to clicked option
      element.classList.add('selected');
    }
  }

  // Get cart quantity (separate from pricing quantity)
  function getCartQuantity(container) {
    try {
      const productForm =
        container?.closest('form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]');
      const qtyInput = productForm?.querySelector('input[name="quantity"]');
      const qty = parseInt(qtyInput?.value);
      return !isNaN(qty) && qty > 0 ? qty : 1;
    } catch (error) {
      console.warn('Error getting cart quantity:', error);
      return 1;
    }
  }

  // CRITICAL FIX: Extract Order Summary Data with Correct Pricing & Validation
  function extractOrderSummaryData(container, formData) {
    if (!formData || typeof formData !== 'object') {
      console.error('❌ Invalid form data provided to extractOrderSummaryData');
      return null;
    }

    const optionSetData = resolveActiveOptionSetData(container);
    ensurePricingPayload(optionSetData, {
      source: 'extract_order_summary',
      containerId: container?.id || null,
      productId: container?.dataset?.productId || getCurrentProductId()
    });

    // Determine pricing quantity from quantity-like fields (NOT cart quantity).
    let pricingQuantity = parseInt(formData['properties[Quantity]'], 10) || 0;
    if (!pricingQuantity || isNaN(pricingQuantity)) {
      const qtyField = optionSetData?.fields?.find(f => f.type === 'quantity-list' || f.type === 'quantity-slider');
      if (qtyField?.label) {
        const qtyKey = `properties[${qtyField.label}]`;
        const qtyValue = parseInt(formData[qtyKey], 10);
        if (!isNaN(qtyValue)) pricingQuantity = qtyValue;
      }
    }
    if (!pricingQuantity || isNaN(pricingQuantity)) {
      for (const [key, value] of Object.entries(formData)) {
        if (/quantity/i.test(key)) {
          const qtyValue = parseInt(value, 10);
          if (!isNaN(qtyValue) && qtyValue > 0) {
            pricingQuantity = qtyValue;
            break;
          }
        }
      }
    }
    if (!pricingQuantity || isNaN(pricingQuantity)) pricingQuantity = 1;

    const cartQuantity = getCartQuantity(container);

    let totalPrice = calculateTotalPrice(formData, optionSetData);

    // Constrained UI failsafe: only scrape trusted total nodes.
    if (!totalPrice || totalPrice <= 0 || isNaN(totalPrice)) {
      console.warn('⚠️ Pricing engine returned invalid total; engaging constrained UI failsafe');
      const trustedTotalNode = (container || document).querySelector(
        '.price-row .value, [id^="summary-total-"], .price-display-below .price-text'
      );
      if (trustedTotalNode?.textContent) {
        const scrapedTotal = parseFloat(trustedTotalNode.textContent.replace(/[^0-9.]/g, ''));
        if (!isNaN(scrapedTotal) && scrapedTotal > 0) {
          totalPrice = scrapedTotal;
          console.warn('ðŸš‘ Recovered total from UI node:', scrapedTotal);
        }
      }
    }

    // Last resort: product base price fallback.
    if (!totalPrice || totalPrice <= 0 || isNaN(totalPrice)) {
      const base = safeNumber(
        optionSetData?.basePrice !== undefined ? optionSetData.basePrice : optionSetData?.base_price,
        0
      );
      if (base > 0) {
        totalPrice = base * Math.max(1, pricingQuantity);
        console.warn('ðŸš‘ Recovered total from base price fallback:', totalPrice);
      }
    }

    const safeQuantity = Math.min(Math.max(1, pricingQuantity), 100000);
    const safeTotal = safeNumber(totalPrice, 0);

    const orderSummary = {
      size: formData['properties[Size]'] || '',
      finish: formData['properties[Finish]'] || formData['properties[Product finish]'] || '',
      corners: formData['properties[Choose your corners]'] || formData['properties[Corners]'] || '',
      quantity: safeQuantity,
      cartQuantity: Math.max(1, cartQuantity),
      totalPrice: safeTotal > 0 ? safeTotal : 0,
      unitPrice: safeTotal > 0 ? (safeTotal / safeQuantity) : 0,
      ...formData
    };

    debugLog('ðŸ“Š VALIDATED Order Summary:', orderSummary);
    return orderSummary;
  }

  // Cart Transform helpers for _vici_* properties
  function getViciOptionsSummary(container, orderSummaryData) {
    try {
      if (window.getCustomOptionsSummary && container?.id) {
        const summary = window.getCustomOptionsSummary(container.id);
        if (summary?.formattedSummary) {
          return summary.formattedSummary;
        }
      }
    } catch (error) {
      console.warn('⚠️ Failed to read summary from DOM:', error);
    }

    const parts = [];
    if (orderSummaryData?.size) parts.push(`Size: ${orderSummaryData.size}`);
    if (orderSummaryData?.finish) parts.push(`Finish: ${orderSummaryData.finish}`);
    if (orderSummaryData?.corners) parts.push(`Corners: ${orderSummaryData.corners}`);
    if (orderSummaryData?.quantity) parts.push(`Quantity: ${orderSummaryData.quantity}`);
    return parts.length > 0 ? parts.join(', ') : 'Custom Configuration';
  }

  function isDesignServiceSelected(designMethodValue, container) {
    const normalized = (designMethodValue || '').toString().trim().toLowerCase();
    if (normalized === 'we-design' || normalized.includes('we design') || normalized.includes('design for you')) {
      return true;
    }

    const selectedMethod = container?.querySelector('.design-method.selected');
    const label = selectedMethod?.querySelector('.swatch-label')?.textContent?.toLowerCase() || '';
    if (label.includes('we design') || label.includes('design for you')) {
      return true;
    }

    const redirectBehavior = selectedMethod?.dataset?.redirect || '';
    if (redirectBehavior === 'design-service') return true;

    return false;
  }

  function getDesignServiceFee(container) {
    const selectedMethod = container?.querySelector('.design-method.selected');
    const feeFromSelected = parseFloat(selectedMethod?.dataset?.price || '');
    if (!isNaN(feeFromSelected) && feeFromSelected > 0) return feeFromSelected;

    try {
      const optionSetData = resolveActiveOptionSetData(container);
      const designMethodField = optionSetData?.fields?.find(f => f.type === 'design-method');
      if (designMethodField?.designMethods?.length) {
        const selectedMethodValue = selectedMethod?.dataset?.value || '';
        const selectedMethodLabel = (selectedMethod?.querySelector('.swatch-label')?.textContent || '')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();
        const configuredMethod = designMethodField.designMethods.find(method => {
          const methodId = String(method?.id || '').trim();
          const methodName = String(method?.name || '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase();
          return (
            (selectedMethodValue && methodId && methodId === selectedMethodValue) ||
            (selectedMethodLabel && methodName && selectedMethodLabel.includes(methodName))
          );
        });
        const configuredFee = getConfiguredPriceValue(configuredMethod);
        if (configuredFee > 0) return configuredFee;
      }
    } catch (error) {
      debugLog('Design fee fallback lookup failed:', error);
    }

    const pricingData = ensurePricingPayload(resolveActiveOptionSetData(container), {
      source: 'design_service_fee',
      containerId: container?.id || null
    });
    const feeFromPricing = parseFloat(pricingData?.designServiceFee || '');
    if (!isNaN(feeFromPricing) && feeFromPricing > 0) return feeFromPricing;

    const feeFromBreakdown = parseFloat(window.lastPricingBreakdown?.flatDesignFee || '');
    if (!isNaN(feeFromBreakdown) && feeFromBreakdown > 0) return feeFromBreakdown;

    return 0;
  }

  /**
   * Get the price to send to Cart Transform.
   * Since cart quantity is always 1 (we're adding 1 "pack" of N items),
   * we send the TOTAL price from the pricing table, not per-unit.
   * This amount must include any selected design-service fee.
   */
  function getViciCalculatedPrice(orderSummaryData, designServiceFee = 0) {
    if (!orderSummaryData) return 0;
    const total = orderSummaryData.totalPrice || 0;
    return total > 0 ? total : 0;
  }

  // CRITICAL FIX: HANDLE START MAKING BUTTON WITH CORRECTED ORDER SUMMARY INTEGRATION
  function handleStartMaking(button, form, container) {
    try {
      function normalizeDesignMethodValue(value) {
        if (!value) return null;
        const v = value.toString().trim().toLowerCase();
        if (
          v === 'upload-design' ||
          v === 'upload design' ||
          v === 'upload your design' ||
          v === 'upload my design' ||
          v === 'upload_design' ||
          v === 'upload'
        ) {
          return 'upload-design';
        }
        if (
          v.includes('design for me') ||
          v.includes('we design') ||
          v.includes('design it for you') ||
          v.includes('design service')
        ) {
          return 'we-design';
        }
        if (
          v.includes('design studio') ||
          v.includes('design yourself') ||
          v.includes('design your own') ||
          v.includes('start designing')
        ) {
          return 'design-studio';
        }
        if (v.includes('template')) return 'template';
        return value;
      }

      function addToCartDirect(orderSummaryData, data, container, button, workflowStage, designMethodValue) {
        const productId = container.dataset.productId || getCurrentProductId();
        const variantId = getCurrentVariantId(container);
        const quantity = orderSummaryData.cartQuantity || 1;

        const properties = {};
        // Detect design-method field names from DOM so we can prefix them with _ to hide from checkout
        const designMethodFieldNames = new Set();
        (container.querySelectorAll('.design-method-group[data-field-name]') || []).forEach(el => {
          if (el.dataset.fieldName) designMethodFieldNames.add(el.dataset.fieldName);
        });
        Object.keys(data).forEach(key => {
          if (key.startsWith('properties[')) {
            const propName = key.replace('properties[', '').replace(']', '');
            // Hide design-method selections from checkout (already captured in _design_method)
            if (designMethodFieldNames.has(propName)) {
              properties['_' + propName] = data[key];
            } else {
              properties[propName] = data[key];
            }
          }
        });

        properties['_unit_price'] = orderSummaryData.unitPrice.toFixed(2);
        properties['_total_price'] = orderSummaryData.totalPrice.toFixed(2);
        properties['_workflow_stage'] = workflowStage || 'add_to_cart';
        if (orderSummaryData.size) properties['Size'] = orderSummaryData.size;
        if (orderSummaryData.finish) properties['Finish'] = orderSummaryData.finish;
        properties['_Quantity'] = orderSummaryData.quantity.toString();
        if (orderSummaryData.corners) properties['Choose your corners'] = orderSummaryData.corners;
        properties['_option_set_data'] = JSON.stringify(data);
        if (designMethodValue) properties['_design_method'] = designMethodValue;

        // Clean customer-facing design method label
        if (designMethodValue) {
          const designLabels = { 'we-design': 'We Design It For You', 'upload-design': 'Upload Your Design', 'design-studio': 'Design Your Own', 'template': 'Use a Template' };
          properties['Design Method'] = designLabels[designMethodValue] || designMethodValue;
        }

        // Cart Transform properties (_vici_*) - required for custom pricing
        const viciSummary = getViciOptionsSummary(container, orderSummaryData);
        if (viciSummary) properties['_vici_options_summary'] = viciSummary;
        const designServiceSelected = isDesignServiceSelected(designMethodValue, container);
        const designServiceFee = designServiceSelected ? getDesignServiceFee(container) : 0;
        const viciCalculatedPrice = getViciCalculatedPrice(orderSummaryData, designServiceFee).toFixed(2);
        properties['_vici_calculated_price'] = viciCalculatedPrice;
        if (designServiceSelected && designServiceFee > 0) {
          properties['_vici_design_service'] = designServiceFee.toFixed(2);
          properties['_vici_design_service_selected'] = 'true';
        }
        debugLog('ðŸ·ï¸ Cart Transform properties:', { price: properties['_vici_calculated_price'], summary: properties['_vici_options_summary'], designFee: designServiceFee, designServiceSelected });

        // Store product URL for reorder extension in Customer Accounts
        properties['_product_url'] = window.location.pathname;
        properties['_variant_id'] = variantId;

        setButtonLoading(button);

        addToCartWithValidation(productId, variantId, quantity, properties, container)
          .then(() => {
            setButtonSuccess(button);
          })
          .catch((error) => {
            console.error('❌ Error adding to cart:', error);
            setButtonError(button);
          });
      }

      // CRITICAL: Get current selections and calculate CORRECT pricing
      const data = getCurrentSelectionsFromForm(container);
      const orderSummaryData = extractOrderSummaryData(container, data);
      
      // VALIDATION: Check if order summary data is valid
      if (!orderSummaryData) {
        console.error('❌ Failed to extract Order Summary data');
        setButtonError(button);
        return;
      }
      
      // VALIDATION: Check if price is reasonable
      if (orderSummaryData.totalPrice <= 0) {
        console.error('❌ Invalid pricing detected');
        setButtonError(button);
        return;
      }
    
    // Get design method from properties (the actual data structure)
    const designMethodValue = data['properties[Design Method]'];
    
    // Also get the design method element to access data attributes
    const designMethodContainer = container.querySelector('[data-field-label*="Design Method"], [data-field-type="design-method"]');
    const selectedMethodElement = designMethodContainer?.querySelector('.design-method.selected');
    
    debugLog('ðŸš€ FIXED: Start Making clicked with Order Summary integration!');
    debugLog('ðŸ“Š Current data:', data);
    debugLog('ðŸ“‹ Order Summary data:', orderSummaryData);
    debugLog('ðŸŽ¯ Design method value:', designMethodValue);
    debugLog('ðŸŽ¯ Selected method element:', selectedMethodElement);
    
    // If no design method from form data, try to get it from the selected element
    let finalDesignMethodValue = designMethodValue;
    if (!finalDesignMethodValue && selectedMethodElement) {
      finalDesignMethodValue = selectedMethodElement.dataset.value;
      debugLog('ðŸ”„ Using design method from DOM element:', finalDesignMethodValue);
    }
    const normalizedDesignMethod = normalizeDesignMethodValue(finalDesignMethodValue);
    
    // Handle different design method behaviors
    if (normalizedDesignMethod) {
      debugLog('ðŸŽ¯ Processing design method:', normalizedDesignMethod);
      
      // Determine action based on method value
      if (normalizedDesignMethod === 'upload-design') {
        // "Upload Your Design" - Add to cart directly
        debugLog('ðŸ“¤ Upload design selected - adding to cart...');
        addToCartDirect(orderSummaryData, data, container, button, 'add_to_cart', normalizedDesignMethod);
        return;
      } else if (normalizedDesignMethod === 'we-design') {
        // "We Design It For You" - Add to cart with design service
        debugLog('ðŸ’¼ Adding design service to cart...');
        handleDesignServiceCart(data, container);
        return;
      }
      
      // Fallback for redirect behaviors from data attributes
      if (selectedMethodElement) {
        const redirectBehavior = selectedMethodElement.dataset.redirect;
        debugLog('ðŸ”„ Fallback redirect behavior:', redirectBehavior);
        
        switch (redirectBehavior) {
          case 'design-tool':
            handleDesignStudioLaunch(data, container);
            return;
          case 'uploader':
            handleUploadEditorLaunch(data, container);
            return;
          case 'design-service':
            handleDesignServiceCart(data, container);
            return;
        }
      }
    }
    
    // Default to direct add-to-cart when no design method is present
    const isCartMode = button?.classList?.contains('cart-mode') || !normalizedDesignMethod;
    if (isCartMode) {
      addToCartDirect(orderSummaryData, data, container, button, 'add_to_cart', normalizedDesignMethod);
      return;
    }

    // Default behavior - trigger custom event for cart integration
    const event = new CustomEvent('optionSetStartMaking', {
      detail: { 
        data: data, 
        productId: container.dataset.productId,
        container: container,
        designMethod: finalDesignMethodValue
      }
    });
    document.dispatchEvent(event);
    
    debugLog('ðŸ”„ Start Making default behavior triggered with data:', data);
  } catch (error) {
    console.error('❌ Error in handleStartMaking:', error);
    setButtonError(button);
  }
}

  // 13.1. DESIGN STUDIO INTEGRATION
  function handleDesignStudioLaunch(data, container) {
    debugLog('ðŸŽ¨ Launching Design Studio with data:', data);
    
    // Show loading state
    const button = container.querySelector('.start-making-button');
    const originalText = button.textContent;
    button.textContent = 'Opening Design Studio...';
    button.disabled = true;
    
    // Create design studio popup/iframe
    const designStudioUrl = getDesignStudioUrl(data, container);
    
    // Create modal overlay
    const modal = document.createElement('div');
    modal.className = 'design-studio-modal';
    modal.innerHTML = `
      <div class="design-studio-container">
        <div class="design-studio-header">
          <h3>Design Studio</h3>
          <button onclick="closeDesignStudio()" class="close-button">\u00D7</button>
        </div>
        <iframe 
          id="design-studio-iframe" 
          src="${designStudioUrl}" 
          style="width: 100%; height: 100%; border: none;"
          frameborder="0">
        </iframe>
      </div>
    `;
    
    // Add full screen modal styles
    const modalStyles = document.createElement('style');
    modalStyles.textContent = `
      body.modal-open {
        overflow: hidden !important;
      }
      .design-studio-modal {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        z-index: 999999 !important;
        margin: 0 !important;
        padding: 0 !important;
        border: none !important;
        background: rgba(0, 0, 0, 0) !important;
        display: block !important;
        align-items: unset !important;
        justify-content: unset !important;
        max-width: unset !important;
        max-height: unset !important;
        opacity: 0 !important;
        transition: opacity 0.3s cubic-bezier(0.25, 0.8, 0.25, 1), background 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
      }
      .design-studio-modal.opening {
        opacity: 1 !important;
        background: rgba(0, 0, 0, 0.1) !important;
      }
      .design-studio-container {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        background: white !important;
        border-radius: 0 !important;
        border: none !important;
        margin: 0 !important;
        padding: 0 !important;
        display: flex !important;
        flex-direction: column !important;
        box-sizing: border-box !important;
        max-width: unset !important;
        max-height: unset !important;
        border-radius: 0 !important;
        overflow: visible !important;
        box-shadow: none !important;
        transform: scale(0.95) !important;
        transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
      }
      .design-studio-modal.opening .design-studio-container {
        transform: scale(1) !important;
      }
      .design-studio-header {
        padding: 15px 20px !important;
        border-bottom: 1px solid #e0e0e0 !important;
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
        background: white !important;
        flex-shrink: 0 !important;
        position: relative !important;
        z-index: 1000000 !important;
        height: 60px !important;
        box-sizing: border-box !important;
      }
      .design-studio-header h3 {
        margin: 0 !important;
        font-size: 20px !important;
        font-weight: 500 !important;
        color: #333 !important;
      }
      .design-studio-modal .close-button {
        background: none !important;
        border: none !important;
        font-size: 24px !important;
        cursor: pointer !important;
        padding: 8px !important;
        width: 40px !important;
        height: 40px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        border-radius: 50% !important;
        transition: background 0.2s !important;
        color: #666 !important;
      }
      .design-studio-modal .close-button:hover {
        background: #f0f0f0 !important;
        color: #333 !important;
      }
      #design-studio-iframe {
        flex: 1 !important;
        width: 100% !important;
        height: calc(100vh - 60px) !important;
        border: none !important;
        margin: 0 !important;
        padding: 0 !important;
        background: white !important;
        display: block !important;
      }
    `;
    document.head.appendChild(modalStyles);
    
    // Prevent body scroll
    document.body.classList.add('modal-open');
    document.body.appendChild(modal);
    
    // Trigger smooth entrance animation
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        modal.classList.add('opening');
      });
    });
    
    // Reset button state
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 1000);
    
    // Store data for later use
    window.designStudioData = { data, container };
  }

  // 13.2. UPLOAD EDITOR INTEGRATION  
  function handleUploadEditorLaunch(data, container) {
    debugLog('ðŸ“¤ Launching Upload Editor with data:', data);
    
    // Show loading state
    const button = container.querySelector('.start-making-button');
    const originalText = button.textContent;
    button.textContent = 'Opening Upload Editor...';
    button.disabled = true;
    
    // Create upload editor popup
    const uploadEditorUrl = getUploadEditorUrl(data, container);
    
    // Create drawer slider from right side
    const modal = document.createElement('div');
    modal.className = 'upload-editor-modal';
    modal.innerHTML = `
      <div class="upload-editor-drawer">
        <div class="upload-editor-header">
          <h3>Upload Your Design</h3>
          <button onclick="closeUploadEditor()" class="close-button">\u00D7</button>
        </div>
        <iframe 
          id="upload-editor-iframe" 
          src="${uploadEditorUrl}" 
          style="width: 100%; height: 100%; border: none;"
          frameborder="0">
        </iframe>
      </div>
    `;
    
    // Add drawer slider styles
    const drawerStyles = document.createElement('style');
    drawerStyles.textContent = `
      .upload-editor-modal {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        z-index: 10000 !important;
        pointer-events: none !important;
        background: rgba(0, 0, 0, 0) !important;
        transition: background 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
      }
      .upload-editor-modal.open {
        background: rgba(0, 0, 0, 0.2) !important;
      }
      .upload-editor-drawer {
        position: absolute !important;
        top: 0 !important;
        right: 0 !important;
        width: 500px !important;
        height: 100vh !important;
        background: white !important;
        box-shadow: -4px 0 20px rgba(0, 0, 0, 0.2) !important;
        transform: translateX(100%) !important;
        transition: transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
        display: flex !important;
        flex-direction: column !important;
        pointer-events: all !important;
      }
      .upload-editor-modal.open .upload-editor-drawer {
        transform: translateX(0) !important;
      }
      .upload-editor-header {
        padding: 20px !important;
        border-bottom: 1px solid #e0e0e0 !important;
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
        background: white !important;
        flex-shrink: 0 !important;
      }
      .upload-editor-header h3 {
        margin: 0 !important;
        font-size: 18px !important;
        font-weight: 500 !important;
      }
      .upload-editor-modal .close-button {
        background: none !important;
        border: none !important;
        font-size: 24px !important;
        cursor: pointer !important;
        padding: 8px !important;
        width: 32px !important;
        height: 32px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        border-radius: 50% !important;
        transition: background 0.2s !important;
      }
      .upload-editor-modal .close-button:hover {
        background: #f0f0f0 !important;
      }
      #upload-editor-iframe {
        flex: 1 !important;
        width: 100% !important;
        height: calc(100vh - 80px) !important;
        border: none !important;
      }
      @media (max-width: 600px) {
        .upload-editor-drawer {
          width: 90vw !important;
          max-width: 500px !important;
        }
      }
      @media (max-width: 400px) {
        .upload-editor-drawer {
          width: 95vw !important;
          max-width: 380px !important;
        }
      }
    `;
    document.head.appendChild(drawerStyles);
    
    document.body.appendChild(modal);
    
    // Trigger smooth slide-in animation
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        modal.classList.add('open');
      });
    });
    
    // Reset button state
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 1000);
    
    // Store data for later use
    window.uploadEditorData = { data, container };
  }

  // 13.3. DESIGN SERVICE CART INTEGRATION
  function handleDesignServiceCart(data, container) {
    debugLog('ðŸ‘¥ Adding design service to cart with data:', data);

    const orderSummaryData = extractOrderSummaryData(container, data);
    if (!orderSummaryData) {
      console.error('❌ Failed to extract Order Summary data for design service');
      return;
    }
    
    // Show loading state
    const button = container.querySelector('.start-making-button');
    setButtonLoading(button);
    
    // Add design service note to data
    data.designService = true;
    data.designServiceNote = 'Professional design service requested';
    
    // Get current product and variant info
    const productId = getCurrentProductId();
    const variantId = getCurrentVariantId(container);
    const quantity = orderSummaryData.cartQuantity || 1;
    
    // Create properties object for Shopify cart
    const properties = {};
    // Detect design-method field names from DOM so we can prefix them with _ to hide from checkout
    const designMethodFieldNames = new Set();
    (container.querySelectorAll('.design-method-group[data-field-name]') || []).forEach(el => {
      if (el.dataset.fieldName) designMethodFieldNames.add(el.dataset.fieldName);
    });
    Object.keys(data).forEach(key => {
      if (key.startsWith('properties[')) {
        const cleanKey = key.replace('properties[', '').replace(']', '');
        if (designMethodFieldNames.has(cleanKey)) {
          properties['_' + cleanKey] = data[key];
        } else {
          properties[cleanKey] = data[key];
        }
      }
    });
    
    // Add design service properties (prefixed with _ to hide from checkout)
    properties['_Design Service'] = 'Professional design service requested';
    properties['_design_method'] = 'we-design';
    // Clean customer-facing design method label
    properties['Design Method'] = 'We Design It For You';
    properties['_option_set_data'] = JSON.stringify(data);
    
    // CRITICAL FIX: Add Order Summary data to cart properties
    properties['_unit_price'] = orderSummaryData.unitPrice.toFixed(2);
    properties['_total_price'] = orderSummaryData.totalPrice.toFixed(2);
    properties['_workflow_stage'] = 'start_making';
    properties['Size'] = orderSummaryData.size;
    properties['Finish'] = orderSummaryData.finish;
    properties['_Quantity'] = orderSummaryData.quantity.toString();
    properties['Choose your corners'] = orderSummaryData.corners;

    // Cart Transform properties (_vici_*) - required for custom pricing
    const viciSummary = getViciOptionsSummary(container, orderSummaryData);
    if (viciSummary) properties['_vici_options_summary'] = viciSummary;
    const designServiceFee = getDesignServiceFee(container);
    const viciCalculatedPrice = getViciCalculatedPrice(orderSummaryData, designServiceFee).toFixed(2);
    properties['_vici_calculated_price'] = viciCalculatedPrice;
    if (designServiceFee > 0) {
      properties['_vici_design_service'] = designServiceFee.toFixed(2);
      properties['_vici_design_service_selected'] = 'true';
    }
    debugLog('ðŸ·ï¸ Cart Transform properties:', { price: properties['_vici_calculated_price'], summary: properties['_vici_options_summary'], designFee: designServiceFee, designServiceSelected: true });
    
    // Store product URL for reorder extension in Customer Accounts
    properties['_product_url'] = window.location.pathname;
        properties['_variant_id'] = variantId;

    debugLog('ðŸ›’ FIXED: Adding to cart with Order Summary properties:', properties);
    
    // Call the add to cart function directly
    addToCartWithValidation(productId, variantId, quantity, properties, container)
      .then(() => {
        debugLog('✅ Successfully added design service to cart');
        setButtonSuccess(button);
      })
      .catch((error) => {
        console.error('❌ Error adding to cart:', error);
        setButtonError(button);
      });
  }

  // CRITICAL FIX: HANDLE "LATER" LINKS WITH ORDER SUMMARY INTEGRATION
  function handleLaterLink(laterLink, form, container) {
    try {
      const data = getCurrentSelectionsFromForm(container);
      const orderSummaryData = extractOrderSummaryData(container, data);
      
      // VALIDATION: Check if order summary data is valid
      if (!orderSummaryData) {
        console.error('❌ Failed to extract Order Summary data for later link');
        laterLink.textContent = 'Error - Invalid Data';
        setTimeout(() => laterLink.textContent = 'Design Later', 2000);
        return;
      }
      
      // Show loading state
      setButtonLoading(laterLink);
    
    // Add "later" flag to data
    const isDesignLater = laterLink.classList.contains('design-later');
    const isUploadLater = laterLink.classList.contains('upload-later');
    
    if (isDesignLater) {
      data.designLater = true;
      data.designLaterNote = 'Customer will complete design process later';
    } else if (isUploadLater) {
      data.uploadLater = true;
      data.uploadLaterNote = 'Customer will upload design files later';
    }
    
    // CRITICAL FIX: Add Order Summary data to the cart integration
    data._unit_price = orderSummaryData.unitPrice.toFixed(2);
    data._total_price = orderSummaryData.totalPrice.toFixed(2);
    data._workflow_stage = isDesignLater ? 'design_later' : (isUploadLater ? 'upload_later' : 'add_to_cart');
    
    // CRITICAL: Use direct cart integration like other buttons
    const productId = container.dataset.productId || getCurrentProductId();
    const variantId = getCurrentVariantId(container);
    const quantity = orderSummaryData.cartQuantity || 1;
    
    // Prepare cart properties matching other buttons
    const properties = {};
    // Detect design-method field names from DOM so we can prefix them with _ to hide from checkout
    const designMethodFieldNames = new Set();
    (container.querySelectorAll('.design-method-group[data-field-name]') || []).forEach(el => {
      if (el.dataset.fieldName) designMethodFieldNames.add(el.dataset.fieldName);
    });
    Object.keys(data).forEach(key => {
      if (key.startsWith('properties[')) {
        const propName = key.replace('properties[', '').replace(']', '');
        if (designMethodFieldNames.has(propName)) {
          properties['_' + propName] = data[key];
        } else {
          properties[propName] = data[key];
        }
      }
    });
    
    // Add Order Summary fields to properties
    properties['_unit_price'] = orderSummaryData.unitPrice.toFixed(2);
    properties['_total_price'] = orderSummaryData.totalPrice.toFixed(2);
    properties['_workflow_stage'] = isDesignLater ? 'design_later' : (isUploadLater ? 'upload_later' : 'add_to_cart');
    properties['Size'] = orderSummaryData.size;
    properties['Finish'] = orderSummaryData.finish;
    properties['_Quantity'] = orderSummaryData.quantity.toString();
    properties['Choose your corners'] = orderSummaryData.corners;
    properties['_option_set_data'] = JSON.stringify(data);

    // Clean customer-facing design method label for 'later' links
    if (isDesignLater) {
      properties['_design_method'] = 'we-design';
      properties['Design Method'] = 'We Design It For You';
    } else if (isUploadLater) {
      properties['_design_method'] = 'upload-design';
      properties['Design Method'] = 'Upload Your Design';
    }

    // Cart Transform properties (_vici_*) - required for custom pricing
    const viciSummary = getViciOptionsSummary(container, orderSummaryData);
    if (viciSummary) properties['_vici_options_summary'] = viciSummary;
    const viciCalculatedPrice = getViciCalculatedPrice(orderSummaryData, 0).toFixed(2);
    properties['_vici_calculated_price'] = viciCalculatedPrice;
    debugLog('ðŸ·ï¸ Cart Transform properties:', { price: properties['_vici_calculated_price'], summary: properties['_vici_options_summary'], designFee: 0, designServiceSelected: false });
    
    // Store product URL for reorder extension in Customer Accounts
    properties['_product_url'] = window.location.pathname;
        properties['_variant_id'] = variantId;

    debugLog('ðŸ›’ FIXED: Later link adding to cart with Order Summary data:', properties);
    
    // Call the same add to cart function as other buttons
    addToCartWithValidation(productId, variantId, quantity, properties, container)
      .then(() => {
        debugLog('✅ Successfully added later item to cart');
        setButtonSuccess(laterLink);
      })
      .catch((error) => {
        console.error('❌ Error adding later item to cart:', error);
        setButtonError(laterLink);
      });
    
    // Keep the legacy event for compatibility
    const event = new CustomEvent('optionSetAddToCart', {
      detail: { 
        data: data, 
        productId: container.dataset.productId,
        container: container,
        designLater: isDesignLater,
        uploadLater: isUploadLater
      }
    });
    document.dispatchEvent(event);
    
    debugLog('✅ FIXED: Later link integration completed with Order Summary data');
    } catch (error) {
      console.error('❌ Critical error in handleLaterLink:', error);
      laterLink.textContent = 'System Error';
      setTimeout(() => {
        laterLink.textContent = 'Design Later';
        laterLink.disabled = false;
      }, 3000);
    }
  }

  // 13.4. HELPER FUNCTIONS FOR EDITOR INTEGRATIONS
  function getDesignStudioUrl(data, container) {
    // Build URL with product and option data for your design platform
    const productId = container.dataset.productId || '';
    const shopDomain = window.Shopify?.shop || window.location.hostname;
    const variantId = getCurrentVariantId(container);
    
    // Use your actual design platform URL
    const baseUrl = 'https://vici-print.vercel.app/designer';
    
    const params = new URLSearchParams({
      product_id: productId,
      shop: shopDomain,
      variant_id: variantId,
      option_set_data: JSON.stringify(data),
      source: 'widget',
      mode: 'shopify_iframe'
    });
    
    debugLog('ðŸŽ¨ Design Studio URL generated:', `${baseUrl}?${params.toString()}`);
    return `${baseUrl}?${params.toString()}`;
  }
  
  function getUploadEditorUrl(data, container) {
    // Build URL with product and option data for your upload platform
    const productId = container.dataset.productId || '';
    const shopDomain = window.Shopify?.shop || window.location.hostname;
    const variantId = getCurrentVariantId(container);
    
    // Use your actual upload platform URL  
    const baseUrl = 'https://vici-print.vercel.app/upload';
    
    const params = new URLSearchParams({
      product_id: productId,
      shop: shopDomain,
      variant_id: variantId,
      option_set_data: JSON.stringify(data),
      source: 'widget',
      mode: 'shopify_iframe'
    });
    
    debugLog('ðŸ“¤ Upload Editor URL generated:', `${baseUrl}?${params.toString()}`);
    return `${baseUrl}?${params.toString()}`;
  }
  
  // 13.5. ENHANCED MODAL CONTROL FUNCTIONS WITH IFRAME COMMUNICATION
  window.closeDesignStudio = function() {
    const modal = document.querySelector('.design-studio-modal');
    if (modal) {
      modal.remove();
    }
    // Restore body scroll
    document.body.classList.remove('modal-open');
    delete window.designStudioData;
    debugLog('ðŸ”„ Design Studio modal closed');
  };
  
  window.closeUploadEditor = function() {
    const modal = document.querySelector('.upload-editor-modal');
    if (modal) {
      modal.remove();
    }
    delete window.uploadEditorData;
    debugLog('ðŸ”„ Upload Editor modal closed');
  };
  
  window.saveDesignAndAddToCart = function() {
    if (window.designStudioData) {
      const { data, container } = window.designStudioData;
      
      // Add design studio completion flag
      data.designCompleted = true;
      data.designSource = 'studio';
      
      // Trigger add to cart
      const event = new CustomEvent('optionSetAddToCart', {
        detail: { 
          data: data, 
          productId: container.dataset.productId,
          container: container,
          designCompleted: true
        }
      });
      document.dispatchEvent(event);
      
      closeDesignStudio();
      debugLog('ðŸŽ¨ Design saved and added to cart');
    }
  };
  
  window.saveUploadAndAddToCart = function() {
    if (window.uploadEditorData) {
      const { data, container } = window.uploadEditorData;
      
      // Add upload completion flag
      data.uploadCompleted = true;
      data.designSource = 'upload';
      
      // Trigger add to cart
      const event = new CustomEvent('optionSetAddToCart', {
        detail: { 
          data: data, 
          productId: container.dataset.productId,
          container: container,
          uploadCompleted: true
        }
      });
      document.dispatchEvent(event);
      
      closeUploadEditor();
      debugLog('ðŸ“¤ Upload saved and added to cart');
    }
  };
  
  // 13.5.1. IFRAME COMMUNICATION HANDLER
  window.addEventListener('message', function(event) {
    // Ensure message is from your platform
    if (event.origin !== 'https://vici-print.vercel.app' && event.origin !== 'http://localhost:3002' && event.origin !== 'http://localhost:3000') {
      return;
    }
    
    debugLog('ðŸ“¨ Received message from design platform:', event.data);
    
    switch (event.data.action) {
      case 'designCompleted':
        // Design studio completed a design
        if (window.designStudioData) {
          const { data, container } = window.designStudioData;
          data.designFiles = event.data.designFiles;
          data.designData = event.data.designData;
          data.designId = event.data.designId;
          saveDesignAndAddToCart();
        }
        break;
        
      case 'uploadCompleted':
        // Upload editor completed an upload
        if (window.uploadEditorData) {
          const { data, container } = window.uploadEditorData;
          data.uploadFiles = event.data.uploadFiles;
          data.uploadData = event.data.uploadData;
          data.uploadId = event.data.uploadId;
          saveUploadAndAddToCart();
        }
        break;
        
      case 'closeEditor':
        // User requested to close the editor
        closeDesignStudio();
        closeUploadEditor();
        break;
        
      case 'addToCart':
        // Direct add to cart from iframe
        const { data, container } = window.designStudioData || window.uploadEditorData || {};
        if (data && container) {
          // Merge iframe data with option set data
          Object.assign(data, event.data.data);
          
          const addToCartEvent = new CustomEvent('optionSetAddToCart', {
            detail: { 
              data: data, 
              productId: container.dataset.productId,
              container: container,
              fromIframe: true
            }
          });
          document.dispatchEvent(addToCartEvent);
          
          // Close the modal
          closeDesignStudio();
          closeUploadEditor();
        }
        break;
    }
  });
  function getProductTitle() {
    // Try multiple selectors to get product title from the page
    const titleSelectors = [
      'h1.product-title',
      'h1[class*="product"]',
      '.product-title h1',
      '.product-title',
      'h1.title',
      'h1',
      '[data-product-title]'
    ];
    
    for (const selector of titleSelectors) {
      const element = document.querySelector(selector);
      if (element && element.textContent.trim()) {
        return element.textContent.trim();
      }
    }
    
    // Fallback to document title or URL
    const pageTitle = document.title;
    if (pageTitle && !pageTitle.toLowerCase().includes('shopify')) {
      return pageTitle.split(' - ')[0] || pageTitle.split(' | ')[0] || pageTitle;
    }
    
    return 'Product';
  }
  
  function getOptionSetName(productId) {
    // Try to get option set name from stored data
    try {
      // First, try to get from window debug data
      const debugData = window[`OPTION_SET_DEBUG_${productId}`];
      if (debugData && debugData.name) {
        return debugData.name;
      }
      
      // Try to get from embedded script data
      const embeddedData = document.getElementById(`option-set-data-${productId}`) || 
                          document.getElementById(`option-set-data-${productId}-2`) ||
                          document.getElementById('option-set-data');
      
      if (embeddedData && embeddedData.textContent && embeddedData.textContent.trim()) {
        try {
          const data = JSON.parse(embeddedData.textContent);
          if (data && data.name) {
            return data.name;
          }
        } catch (e) {
          console.warn('Error parsing embedded option set data:', e);
          // Try alternative parsing if available
          if (embeddedData.textContent.includes('"name"')) {
            try {
              const nameMatch = embeddedData.textContent.match(/"name":\s*"([^"]+)"/);
              if (nameMatch && nameMatch[1]) {
                return nameMatch[1];
              }
            } catch (regexError) {
              console.warn('Error with regex fallback:', regexError);
            }
          }
        }
      }
      
      // Fallback to checking if there's a global option set name
      if (window.currentOptionSetName) {
        return window.currentOptionSetName;
      }
      
    } catch (error) {
      console.warn('Error getting option set name:', error);
    }
    
    return 'Custom Options';
  }

  function showSuccessMessage(form, quoteNumber) {
    // Remove any existing messages
    const existingMessage = form.querySelector('.quote-message');
    if (existingMessage) {
      existingMessage.remove();
    }

    // Find the submit button to place message after it
    const submitButton = form.querySelector('.request-quote-submit-button');
    if (!submitButton) return;

    // Create success message element
    const messageDiv = document.createElement('div');
    messageDiv.className = 'quote-message quote-success';
    messageDiv.innerHTML = `
      <div style="
        margin-top: 16px;
        padding: 16px;
        background: #d4edda;
        border: 1px solid #c3e6cb;
        border-radius: 8px;
        color: #155724;
        font-family: var(--option-font-family, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif);
        font-size: 14px;
        line-height: 1.5;
      ">
        <div style="display: flex; align-items: center; margin-bottom: 8px;">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style="margin-right: 8px; flex-shrink: 0;">
            <circle cx="12" cy="12" r="10" fill="#28a745"/>
            <path d="M9 12l2 2 4-4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <strong>Thank you! Your quote request has been submitted successfully.</strong>
        </div>
        <div style="margin-left: 28px;">
          <div><strong>Quote Number:</strong> ${quoteNumber}</div>
          <div style="margin-top: 8px;">We'll review your request and contact you within 24 hours with a detailed quote.</div>
        </div>
      </div>
    `;

    // Insert after the button
    submitButton.parentNode.insertBefore(messageDiv, submitButton.nextSibling);

    // Auto-hide after 10 seconds
    setTimeout(() => {
      if (messageDiv && messageDiv.parentNode) {
        messageDiv.style.transition = 'opacity 0.5s ease-out';
        messageDiv.style.opacity = '0';
        setTimeout(() => {
          if (messageDiv && messageDiv.parentNode) {
            messageDiv.remove();
          }
        }, 500);
      }
    }, 10000);
  }

  function showValidationMessage(form, errors) {
    // Remove any existing messages
    const existingMessage = form.querySelector('.quote-message');
    if (existingMessage) {
      existingMessage.remove();
    }

    // Find the submit button to place message after it
    const submitButton = form.querySelector('.request-quote-submit-button');
    if (!submitButton) return;

    // Create validation error list
    const errorList = errors.map(error => `<li style="margin: 4px 0;">${error}</li>`).join('');

    // Create validation message element
    const messageDiv = document.createElement('div');
    messageDiv.className = 'quote-message quote-validation';
    messageDiv.innerHTML = `
      <div style="
        margin-top: 16px;
        padding: 16px;
        background: #fff3cd;
        border: 1px solid #ffeaa7;
        border-radius: 8px;
        color: #856404;
        font-family: var(--option-font-family, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif);
        font-size: 14px;
        line-height: 1.5;
      ">
        <div style="display: flex; align-items: flex-start;">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style="margin-right: 8px; flex-shrink: 0; margin-top: 2px;">
            <path d="M12 2L1 21h22L12 2z" fill="#ffc107"/>
            <path d="M12 8v4M12 16h.01" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <div>
            <div style="font-weight: 500; margin-bottom: 8px;">Please fill in the required fields:</div>
            <ul style="margin: 0; padding-left: 16px; list-style-type: disc;">
              ${errorList}
            </ul>
          </div>
        </div>
      </div>
    `;

    // Insert after the button
    submitButton.parentNode.insertBefore(messageDiv, submitButton.nextSibling);

    // Auto-hide after 6 seconds
    setTimeout(() => {
      if (messageDiv && messageDiv.parentNode) {
        messageDiv.style.transition = 'opacity 0.5s ease-out';
        messageDiv.style.opacity = '0';
        setTimeout(() => {
          if (messageDiv && messageDiv.parentNode) {
            messageDiv.remove();
          }
        }, 500);
      }
    }, 6000);
  }

  function showErrorMessage(form, errorText) {
    // Remove any existing messages
    const existingMessage = form.querySelector('.quote-message');
    if (existingMessage) {
      existingMessage.remove();
    }

    // Find the submit button to place message after it
    const submitButton = form.querySelector('.request-quote-submit-button');
    if (!submitButton) return;

    // Create error message element
    const messageDiv = document.createElement('div');
    messageDiv.className = 'quote-message quote-error';
    messageDiv.innerHTML = `
      <div style="
        margin-top: 16px;
        padding: 16px;
        background: #f8d7da;
        border: 1px solid #f5c6cb;
        border-radius: 8px;
        color: #721c24;
        font-family: var(--option-font-family, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif);
        font-size: 14px;
        line-height: 1.5;
      ">
        <div style="display: flex; align-items: center;">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style="margin-right: 8px; flex-shrink: 0;">
            <circle cx="12" cy="12" r="10" fill="#dc3545"/>
            <path d="M15 9l-6 6M9 9l6 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <div>${errorText}</div>
        </div>
      </div>
    `;

    // Insert after the button
    submitButton.parentNode.insertBefore(messageDiv, submitButton.nextSibling);

    // Auto-hide after 8 seconds
    setTimeout(() => {
      if (messageDiv && messageDiv.parentNode) {
        messageDiv.style.transition = 'opacity 0.5s ease-out';
        messageDiv.style.opacity = '0';
        setTimeout(() => {
          if (messageDiv && messageDiv.parentNode) {
            messageDiv.remove();
          }
        }, 500);
      }
    }, 8000);
  }

  async function submitQuoteToBackend(quoteData, form) {
    // Show loading state
    const submitButton = form.querySelector('.request-quote-submit-button');
    const originalText = submitButton ? submitButton.textContent : 'Request Quote';
    
    try {
      if (submitButton) {
        submitButton.textContent = 'Submitting...';
        submitButton.disabled = true;
      }

      // FIXED: Auto-detect backend URL based on environment
      let backendUrl;
      const hostname = window.location.hostname;
      
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        backendUrl = 'http://localhost:4000';
      } else if (hostname.includes('shopify')) {
        // FIXED: Use the correct Vercel backend URL with proper endpoint
        if (window.WIDGET_CONFIG && window.WIDGET_CONFIG.backendUrl) {
          backendUrl = window.WIDGET_CONFIG.backendUrl;
        } else {
          // FIXED: Updated to use the correct production URL
          backendUrl = 'https://inkredibull-backend.vercel.app';
        }
      } else {
        // For production, use the current domain
        backendUrl = `https://${hostname}:5000`;
      }

      // FIXED: Use the correct endpoint path
      const apiUrl = backendUrl + '/api/quotes/submit';
      
      debugLog('Submitting quote to backend:', apiUrl);
      debugLog('Quote data:', quoteData);

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // FIXED: Add proper CORS headers
          'Accept': 'application/json',
          'Origin': window.location.origin
        },
        mode: 'cors', // FIXED: Explicitly set CORS mode
        body: JSON.stringify(quoteData)
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const result = await response.json();
      debugLog('Quote submission successful:', result);

      // Show success message under the button
      showSuccessMessage(form, result.quoteNumber || 'N/A');
      
      // Clear form
      const formFields = [
        'input[name="properties[Full Name]"]',
        'input[name="properties[Company Name]"]', 
        'input[name="properties[Email]"]',
        'input[name="properties[Phone]"]',
        'textarea[name="properties[Additional Details]"]'
      ];
      
      formFields.forEach(selector => {
        const field = form.querySelector(selector);
        if (field) field.value = '';
      });

    } catch (error) {
      console.error('Error submitting quote request:', error);
      
      // IMPROVED: More specific error messages
      let errorMessage = 'There was an error submitting your quote request. Please try again or contact us directly.';
      
      if (error.message.includes('CORS')) {
        errorMessage = 'Unable to connect to our quote system. Please try again or contact us directly via email or phone.';
      } else if (error.message.includes('Failed to fetch')) {
        errorMessage = 'Network error - please check your internet connection and try again.';
      }
      
      // Show error message under the button
      showErrorMessage(form, errorMessage);
      
    } finally {
      // Reset button state
      const submitButton = form.querySelector('.request-quote-submit-button');
      if (submitButton) {
        submitButton.textContent = originalText;
        submitButton.disabled = false;
      }
    }
  }

  // 13.1. HANDLE QUOTE FORM SUBMISSION
  function handleQuoteFormSubmit(button) {
    debugLog('ðŸš€ Quote form submit clicked!', button);
    const form = button.closest('form') || button.closest('#custom-options-widget-container') || button.closest('#custom-options-widget-container-2');
    const container = button.closest('#custom-options-widget-container') || button.closest('#custom-options-widget-container-2');
    
    if (!form || !container) {
      console.error('Could not find form or container for quote submission');
      return;
    }

    // Collect form data
    const formData = {
      fullName: form.querySelector('input[name="properties[Full Name]"]')?.value || '',
      companyName: form.querySelector('input[name="properties[Company Name]"]')?.value || '',
      email: form.querySelector('input[name="properties[Email]"]')?.value || '',
      phone: form.querySelector('input[name="properties[Phone]"]')?.value || '',
      additionalDetails: form.querySelector('textarea[name="properties[Additional Details]"]')?.value || ''
    };

    // Validate required fields
    const errors = [];
    if (!formData.fullName.trim()) errors.push('Full Name is required');
    if (!formData.email.trim()) errors.push('Email is required');
    if (!formData.phone.trim()) errors.push('Phone Number is required');
    
    if (errors.length > 0) {
      showValidationMessage(form, errors);
      return;
    }

    // Collect selected options
    const selectedOptions = getCurrentSelections(container);
    
    // Get product and option set information
    const productId = container.dataset.productId;
    const productTitle = getProductTitle(); // Function to get product title from page
    const optionSetName = getOptionSetName(productId); // Function to get option set name
    
    // Prepare comprehensive quote data
    const quoteData = {
      customer: formData,
      selectedOptions: selectedOptions,
      productTitle: productTitle,
      optionSetName: optionSetName,
      productId: productId,
      timestamp: new Date().toISOString(),
      pageUrl: window.location.href
    };

    // Trigger custom event for quote submission
    const event = new CustomEvent('optionSetQuoteRequest', {
      detail: { 
        data: quoteData, 
        productId: container.dataset.productId,
        container: container
      }
    });
    document.dispatchEvent(event);
    
    // Submit to backend API
    submitQuoteToBackend(quoteData, form);
    
    debugLog('Quote request prepared with comprehensive data:', quoteData);
  }

  // Expose handleQuoteFormSubmit to global scope for onclick handlers
  window.handleQuoteFormSubmit = handleQuoteFormSubmit;
  debugLog('ðŸ”§ handleQuoteFormSubmit function exposed globally:', typeof window.handleQuoteFormSubmit);

  // 13.5. ORDER SUMMARY CALCULATION AND UPDATE FUNCTIONS
  
  /**
   * Get field mappings from summary field configuration
   */
  function getSummaryFieldMappings(container, summaryElement) {
    try {
      const productId = container.dataset.productId;
      const instance = window.OptionWidgetManager?.instances?.get(productId);
      const optionSetData = instance?.optionSetData;
      
      if (!optionSetData?.fields) return {};
      
      // Find the summary field configuration
      const summaryField = optionSetData.fields.find(f => f.type === 'summary');
      
      if (summaryField?.summarySettings?.fieldMappings) {
        return summaryField.summarySettings.fieldMappings;
      }
      
      // Default field mappings - convert field labels to display labels
      const defaultMappings = {};
      optionSetData.fields.forEach(field => {
        if (field.type !== 'summary' && field.type !== 'details') {
          let displayLabel = field.label || field.type;
          
          // Smart label conversion
          displayLabel = displayLabel
            .replace(/^Choose your\s+/i, '')
            .replace(/^Select\s+/i, '')
            .replace(/^Pick\s+/i, '')
            .trim();
            
          // Capitalize first letter
          displayLabel = displayLabel.charAt(0).toUpperCase() + displayLabel.slice(1);
          
          defaultMappings[field.id] = {
            displayLabel: displayLabel,
            showInSummary: true
          };
        }
      });
      
      return defaultMappings;
    } catch (error) {
      console.warn('Error getting summary field mappings:', error);
      return {};
    }
  }

  /**
   * Get the option set data for a container
   */
  function getOptionSetData(container) {
    try {
      if (!container) return null;
      const productId = container.dataset.productId;
      const instance = window.OptionWidgetManager?.instances?.get(productId);
      if (instance?.optionSetData) {
        return instance.optionSetData;
      }

      if (productId) {
        const windowScopedData = window[`OPTION_SET_DATA_${productId}`];
        if (windowScopedData?.fields?.length) {
          return windowScopedData;
        }

        const embeddedData = document.getElementById(`option-set-data-${productId}`);
        if (embeddedData?.textContent) {
          try {
            const parsedData = JSON.parse(embeddedData.textContent);
            if (parsedData?.fields?.length) {
              return parsedData;
            }
          } catch (error) {
            // Ignore invalid embedded payload and continue fallback flow.
          }
        }
      }

      return null;
    } catch (error) {
      console.warn('Error getting option set data:', error);
      return null;
    }
  }

  function optionSetDataMatchesScope(optionSetData, productId, productHandle) {
    if (!optionSetData || typeof optionSetData !== 'object') return false;

    const scopeProductId =
      optionSetData.__viciProductId ||
      optionSetData.productId ||
      optionSetData.product_id ||
      null;
    const scopeProductHandle =
      optionSetData.__viciProductHandle ||
      optionSetData.productHandle ||
      optionSetData.product_handle ||
      null;

    if (productId && scopeProductId) {
      return String(scopeProductId) === String(productId);
    }
    if (productHandle && scopeProductHandle) {
      return String(scopeProductHandle) === String(productHandle);
    }

    return !productId && !productHandle;
  }

  function resolveActiveOptionSetData(container) {
    const scopedProductId = container?.dataset?.productId || container?.getAttribute?.('data-product-id') || null;
    const scopedProductHandle =
      container?.dataset?.productHandle || container?.getAttribute?.('data-product-handle') || null;
    const scopedOptionSetData = container ? getOptionSetData(container) : null;
    if (scopedOptionSetData?.fields?.length) {
      return scopedOptionSetData;
    }

    if (container && scopedProductId) {
      const windowScopedData = window[`OPTION_SET_DATA_${scopedProductId}`];
      if (windowScopedData?.fields?.length) {
        return windowScopedData;
      }
    }

    // Scoped mode: if we have a concrete product scope, do not leak into other product data.
    if (container && (scopedProductId || scopedProductHandle)) {
      if (window.optionSetData?.fields?.length && optionSetDataMatchesScope(window.optionSetData, scopedProductId, scopedProductHandle)) {
        return window.optionSetData;
      }
      return null;
    }

    if (!container) {
      const candidateContainers = Array.from(
        document.querySelectorAll('#custom-options-widget-container, #custom-options-widget-container-2, .option-widget-container')
      );
      for (const candidateContainer of candidateContainers) {
        const candidateData = getOptionSetData(candidateContainer);
        if (candidateData?.fields?.length) {
          return candidateData;
        }
      }
    }

    if (window.optionSetData?.fields?.length) {
      return window.optionSetData;
    }

    try {
      const firstInstance = window.OptionWidgetManager?.instances?.values?.().next?.().value;
      if (firstInstance?.optionSetData?.fields?.length) {
        return firstInstance.optionSetData;
      }
    } catch (error) {
      console.warn('Error resolving active option set data:', error);
    }

    return scopedOptionSetData || window.optionSetData || null;
  }

  /**
   * Get current selections from form elements - reads real-time selections
   */
  function getCurrentSelectionsFromForm(container) {
    const selections = {};
    const debugEnabled = WIDGET_DEBUG_LOGGING;
    
    try {
      if (debugEnabled) {
        debugLog('ðŸ” Getting current selections from container:', container.id);
      }
      
      // Get all selected option elements - ENHANCED SELECTION DETECTION
      const selectedElements = container.querySelectorAll('.selected');
      if (debugEnabled) {
        debugLog('ðŸ” Found selected elements:', selectedElements.length);
      }
      
      selectedElements.forEach((element, index) => {
        const parent = element.parentElement;
        let fieldName = parent?.dataset.fieldName;
        
        // ENHANCED: Try multiple ways to get field name
        if (!fieldName) {
          const wrapper = element.closest('[data-field-name]');
          fieldName = wrapper?.dataset.fieldName;
        }
        
        // Also try data-field-type containers
        if (!fieldName) {
          const typeWrapper = element.closest('[data-field-type]');
          const fieldLabel = typeWrapper?.querySelector('.field-label, h3')?.textContent?.trim();
          if (fieldLabel) {
            fieldName = fieldLabel;
          }
        }
        
        const value = element.dataset.value || element.value || element.textContent?.trim();
        
        if (debugEnabled) {
          debugLog(`ðŸ” Selected element ${index}:`, {
            fieldName,
            value,
            parentElement: parent?.tagName,
            parentClass: parent?.className,
            datasetValue: element.dataset.value,
            elementValue: element.value
          });
        }
        
        if (fieldName && value) {
          selections[`properties[${fieldName}]`] = value;
        }
      });
      
      // Get form input values
      const formInputs = container.querySelectorAll('input, textarea, select');
      if (debugEnabled) {
        debugLog('ðŸ” Found form inputs:', formInputs.length);
      }
      
      formInputs.forEach(input => {
        if (input.name && input.name.startsWith('properties[') && input.value && input.value.trim() !== '') {
          selections[input.name] = input.value;
          if (debugEnabled) {
            debugLog('ðŸ” Form input value:', input.name, '=', input.value);
          }
        }
      });
      
      // Get quantity slider values
      const quantitySliders = container.querySelectorAll('.quantity-slider');
      if (debugEnabled) {
        debugLog('ðŸ” Found quantity sliders:', quantitySliders.length);
      }
      
      quantitySliders.forEach(slider => {
        const wrapper = slider.closest('.quantity-slider-wrapper');
        const fieldName = wrapper?.dataset.fieldName;
        if (fieldName && slider.value) {
          selections[`properties[${fieldName}]`] = slider.value;
          if (debugEnabled) {
            debugLog('ðŸ” Quantity slider value:', fieldName, '=', slider.value);
          }
        }
      });
      
      if (debugEnabled) {
        debugLog('ðŸ”„ Current selections from form:', selections);
      }
      
    } catch (error) {
      console.warn('Error getting current selections:', error);
    }
    
    return selections;
  }

  /**
   * TRUE PER-UNIT PRICING SYSTEM - COMPLETE BUSINESS MODEL IMPLEMENTATION
   * Base price comes from quantity tiers with volume discounts built-in
   * Options add per-unit modifiers, design methods are flat fees only
   */
  function calculateTotalPriceLegacy(selections, optionSetData, basePrice = 0) {
    const debugEnabled = WIDGET_DEBUG_LOGGING;
    if (debugEnabled) {
      debugLog('ðŸŽ¯ PRICING CALCULATION: Starting...');
      debugLog('ðŸ“Š Received selections:', selections);
    }

    // âš¡ ZERO-LATENCY: Try to use pricing variants from metafield first
    const pricingData = ensurePricingPayload(optionSetData, { source: 'calculate_total_price' });
    if (pricingData && pricingData.pricingVariants?.length) {
      if (debugEnabled) {
        debugLog('âš¡ Using ZERO-LATENCY pricing from metafield variants');
      }
      const price = calculatePriceFromVariants(selections, pricingData, optionSetData);
      if (price !== null) {
        if (debugEnabled) {
          debugLog(`✅ Zero-latency price calculated: $${price.toFixed(2)}`);
        }
        return price;
      } else {
        console.warn('⚠️ Metafield pricing failed, falling back to legacy calculation');
      }
    }

    // FALLBACK: Legacy hardcoded pricing (for backwards compatibility)
    if (debugEnabled) {
      debugLog('ðŸ”„ Using legacy hardcoded pricing calculation');
    }

    // Base quantity tier pricing (with volume discounts built-in)
    const quantityTiers = [
      { quantity: 50, basePrice: 22, unitPrice: 0.44 },      // $22 Ã· 50 = $0.44/unit
      { quantity: 100, basePrice: 43, unitPrice: 0.43 },    // $43 Ã· 100 = $0.43/unit (discount)
      { quantity: 200, basePrice: 74, unitPrice: 0.37 },    // $74 Ã· 200 = $0.37/unit (more discount)
      { quantity: 400, basePrice: 129, unitPrice: 0.3225 }, // Volume discount
      { quantity: 600, basePrice: 163, unitPrice: 0.2717 }  // Best volume discount
    ];

    // Option pricing (per-unit modifiers)
    const optionPricing = {
      'Standard': 0.00,      // Free option
      'Matte': 0.02,         // +$0.02 per unit
      'Square Corner': 0.10, // +$0.10 per unit
      'InkRediBull': 0.25,   // +$0.25 per unit
      'Gloss': 0.10,         // +$0.10 per unit
      'Round Corner': 0.00   // Free option
    };

    // Design method pricing (flat fees only)
    const designMethodPricing = {
  // design-yourself removed
      'we-design': 95,
      'upload-design': 25
    };

    try {
      if (!optionSetData?.fields) return 0;

      // Step 1: Get base unit price from quantity tier (includes volume discount)
      let selectedQuantity = 100; // default
      let baseUnitPrice = 0.43; // default for 100 units

      // Extract quantity from selections
      Object.entries(selections).forEach(([key, value]) => {
        const cleanKey = key.replace(/^properties\[|\]$/g, '');
        if (cleanKey.toLowerCase().includes('quantity') && value) {
          const qty = parseInt(value);
          if (!isNaN(qty)) {
            selectedQuantity = qty;
            
            // Find matching tier or closest one
            const exactTier = quantityTiers.find(tier => tier.quantity === qty);
            if (exactTier) {
              baseUnitPrice = exactTier.unitPrice;
              if (debugEnabled) {
                debugLog(`📦 Exact tier match: ${qty} units @ $${baseUnitPrice}/unit (volume discount applied)`);
              }
            } else {
              // Find closest tier for interpolation
              let closestTier = quantityTiers[quantityTiers.length - 1]; // Default to best discount
              for (let tier of quantityTiers) {
                if (qty <= tier.quantity) {
                  closestTier = tier;
                  break;
                }
              }
              baseUnitPrice = closestTier.unitPrice;
              if (debugEnabled) {
                debugLog(`📦 Closest tier: ${qty} units using $${baseUnitPrice}/unit pricing`);
              }
            }
          }
        }
      });

      // Step 2: Calculate option modifiers per unit
      let optionModifiersPerUnit = 0;
      let flatDesignFee = 0;

      Object.entries(selections).forEach(([key, value]) => {
        const cleanKey = key.replace(/^properties\[|\]$/g, '');
        
        // Skip quantity fields
        if (cleanKey.toLowerCase().includes('quantity')) return;
        
        // Check if this is a design method
        if (cleanKey.toLowerCase().includes('design') || designMethodPricing.hasOwnProperty(value)) {
          if (designMethodPricing.hasOwnProperty(value)) {
            flatDesignFee += designMethodPricing[value];
            if (debugEnabled) {
              debugLog(`ðŸŽ¨ Design method: ${value} = +$${designMethodPricing[value]} (flat fee)`);
            }
          }
        } else {
          // All other options are per-unit modifiers
          if (optionPricing.hasOwnProperty(value)) {
            optionModifiersPerUnit += optionPricing[value];
            if (debugEnabled) {
              debugLog(`ðŸ“ˆ Option: ${value} = +$${optionPricing[value]}/unit`);
            }
          } else if (value && value !== 'Standard' && value !== 'Round Corner') {
            // Try to find option pricing in optionSetData
            optionSetData.fields.forEach(field => {
              if (field.options) {
                const selectedOption = field.options.find(opt => 
                  opt.value === value || opt.name === value || opt.label === value
                );
                if (selectedOption) {
                  const priceValue = parseFloat(selectedOption.price_value || selectedOption.price || 0);
                  if (priceValue > 0) {
                    optionModifiersPerUnit += priceValue;
                    if (debugEnabled) {
                      debugLog(`ðŸ“ˆ Dynamic option: ${value} = +$${priceValue}/unit`);
                    }
                  }
                }
              }
            });
          }
        }
      });

      // Step 3: Calculate final pricing
      const finalUnitPrice = baseUnitPrice + optionModifiersPerUnit;
      const subtotal = finalUnitPrice * selectedQuantity;
      const grandTotal = subtotal + flatDesignFee;

      if (debugEnabled) {
        debugLog('ðŸŽ¯ TRUE PER-UNIT PRICING BREAKDOWN:');
        debugLog(`  Selected Quantity: ${selectedQuantity} units`);
        debugLog(`  Base Unit Price: $${baseUnitPrice.toFixed(4)}/unit (includes volume discount)`);
        debugLog(`  Option Modifiers: +$${optionModifiersPerUnit.toFixed(4)}/unit`);
        debugLog(`  Final Unit Price: $${finalUnitPrice.toFixed(4)}/unit`);
        debugLog(`  Subtotal: $${finalUnitPrice.toFixed(4)} Ã— ${selectedQuantity} = $${subtotal.toFixed(2)}`);
        debugLog(`  Design Fees: +$${flatDesignFee.toFixed(2)} (flat)`);
        debugLog(`  ðŸŽ¯ GRAND TOTAL: $${grandTotal.toFixed(2)}`);
      }

      // Validation
      if (grandTotal < 0 || isNaN(grandTotal) || grandTotal > 50000) {
        console.error('ðŸš¨ PRICING ERROR - Invalid calculation result');
        console.error('Debug:', { selectedQuantity, baseUnitPrice, optionModifiersPerUnit, flatDesignFee, grandTotal });
        return 0;
      }

      // Store pricing breakdown for external access
      window.lastPricingBreakdown = {
        selectedQuantity,
        baseUnitPrice,
        optionModifiersPerUnit,
        finalUnitPrice,
        subtotal,
        flatDesignFee,
        grandTotal,
        breakdown: {
          baseTotal: baseUnitPrice * selectedQuantity,
          optionsTotal: optionModifiersPerUnit * selectedQuantity,
          designFee: flatDesignFee,
          final: grandTotal
        }
      };

      return grandTotal;

    } catch (error) {
      console.error('ðŸš¨ TRUE PER-UNIT PRICING ERROR:', error);
      console.error('Stack:', error.stack);
      return 0;
    }
  }

  function calculateTotalPriceV2(selections, optionSetData, basePrice = 0) {
    return calculateTotalPriceLegacy(selections, optionSetData, basePrice);
  }

  function calculateTotalPrice(selections, optionSetData, basePrice = 0) {
    return runWidgetModuleFlowSync(
      PHASE3_WIDGET_MODULES.pricingEngine,
      WIDGET_PRICING_ENGINE_MODE,
      {
        legacy: () => calculateTotalPriceLegacy(selections, optionSetData, basePrice),
        v2: () => calculateTotalPriceV2(selections, optionSetData, basePrice),
        parity: (legacyResult, v2Result) => Number(legacyResult) === Number(v2Result)
      },
      {
        productId: getCurrentProductId(),
        selectionCount: selections && typeof selections === 'object' ? Object.keys(selections).length : 0
      }
    );
  }

  /**
   * Update the order summary display - matches builder structure
   */
  function updateOrderSummary(container, selections) {
    const timestamp = new Date().toISOString();
    const debugEnabled = WIDGET_DEBUG_LOGGING;
    if (debugEnabled) {
      debugLog(`ðŸ”„ updateOrderSummary called at ${timestamp}:`, {
        container: container.id,
        selectionsCount: Object.keys(selections || {}).length
        // ðŸš¨ REMOVED: stackTrace - Creating Error objects is expensive
      });
    }
    
    try {
      const summaryElements = container.querySelectorAll('.order-summary');
      
      if (debugEnabled) {
        debugLog('ðŸ” Order Summary Elements Debug:');
        debugLog('  Found summary elements:', summaryElements.length);
      }

      // ðŸš¨ REMOVED: Visual debugging code that created memory leaks
      // The code below was creating untracked setTimeout calls on every interaction
      // causing memory accumulation and performance degradation with 8+ fields
      //
      // summaryElements.forEach((element, index) => {
      //   // Visual debugging and style inspection code removed
      // });
      
      if (summaryElements.length === 0) return;
      
      const optionSetData = getOptionSetData(container);
      if (!optionSetData) return;
      
      // FIXED: If no selections passed, get current selections from the form
      if (!selections || Object.keys(selections).length === 0) {
        selections = getCurrentSelectionsFromForm(container);
      }
      
      summaryElements.forEach(summaryElement => {
        const summaryIndex = summaryElement.getAttribute('data-summary-index');
        const itemsContainer = summaryElement.querySelector(`#summary-items-${summaryIndex}`);
        const totalElement = summaryElement.querySelector(`#summary-total-${summaryIndex}`);
        
        if (debugEnabled) {
          debugLog('ðŸ” DOM Element Search Debug:', {
            summaryIndex,
            itemsContainer: !!itemsContainer,
            totalElement: !!totalElement,
            summaryElementHTML: summaryElement.innerHTML.substring(0, 200),
            priceContainer: !!summaryElement.querySelector(`#price-container-${summaryIndex}`),
            totalElementAlternate: !!summaryElement.querySelector('.value'),
            allSpansWithValue: summaryElement.querySelectorAll('.value').length
          });
        }
        
        if (!itemsContainer) {
          console.warn('⚠️ Order Summary itemsContainer not found!', {
            summaryIndex,
            itemsContainerQuery: `#summary-items-${summaryIndex}`,
            availableIds: Array.from(summaryElement.querySelectorAll('[id]')).map(el => el.id)
          });
          return;
        }
        
        // Find or create totalElement - be more flexible
        let finalTotalElement = totalElement;
        if (!finalTotalElement) {
          // Try alternative selectors
          finalTotalElement = summaryElement.querySelector(`#price-container-${summaryIndex} .value`) ||
                             summaryElement.querySelector('.price-container .value') ||
                             summaryElement.querySelector('.value');
          
          if (!finalTotalElement) {
            console.warn('⚠️ Order Summary totalElement still not found after alternatives!', {
              summaryIndex,
              availableIds: Array.from(summaryElement.querySelectorAll('[id]')).map(el => el.id),
              allValues: Array.from(summaryElement.querySelectorAll('.value')).map(el => ({id: el.id, class: el.className}))
            });
            return;
          } else {
            if (debugEnabled) {
              debugLog('✅ Found totalElement using alternative selector:', finalTotalElement);
            }
          }
        }
        
        // Get field mappings for display labels
        const fieldMappings = getSummaryFieldMappings(container, summaryElement);
        
        // Build summary items using actual current selections
        const summaryItems = [];
        let hasSelections = false;
        
        if (debugEnabled) {
          debugLog('ðŸ” Order Summary Update - Current selections:', selections);
          debugLog('ðŸ” Available fields:', optionSetData.fields.map(f => ({type: f.type, label: f.label})));
          debugLog('ðŸ” Order Summary Debug - Container ID:', container.id);
        }
        
        // Process each field to check for selections
        optionSetData.fields.forEach(field => {
          if (field.type === 'summary' || field.type === 'details') return;
          
          // Get current selection for this field
          let selectedValue = null;
          let selectedElement = null;
          
          // Find selected element based on field type - ENHANCED SEARCH
          const fieldContainer = container.querySelector(`[data-field-name="${field.label}"]`);
          if (debugEnabled) {
            debugLog(`ðŸ” Field "${field.label}" - Container found:`, !!fieldContainer);
          }
          
          if (fieldContainer) {
            selectedElement = fieldContainer.querySelector('.selected');
            if (debugEnabled) {
              debugLog(`ðŸ” Field "${field.label}" - Selected element:`, !!selectedElement, selectedElement?.dataset?.value);
            }
            if (selectedElement) {
              selectedValue = selectedElement.dataset.value || selectedElement.value;
            }
          } else {
            // ENHANCED: Try alternative field container searches
            const alternativeContainers = [
              container.querySelector(`[data-field-type="${field.type}"]`),
              container.querySelector(`#field-${field.label.replace(/\s+/g, '-').toLowerCase()}`),
              container.querySelector(`.field-${field.label.replace(/\s+/g, '-').toLowerCase()}`),
              container.querySelector(`[data-field-id="${field.id}"]`)
            ].filter(Boolean);
            
            for (const altContainer of alternativeContainers) {
              selectedElement = altContainer.querySelector('.selected');
              if (selectedElement) {
                selectedValue = selectedElement.dataset.value || selectedElement.value;
                if (debugEnabled) {
                  debugLog(`ðŸ” Field "${field.label}" - Found via alternative container:`, selectedValue);
                }
                break;
              }
            }
            
            // Debug: Show what containers are available
            if (!selectedElement) {
              const allFieldContainers = container.querySelectorAll('[data-field-name]');
              if (debugEnabled) {
                debugLog(`⚠️ Field "${field.label}" container not found. Available containers:`, 
                  Array.from(allFieldContainers).map(el => el.dataset.fieldName));
              }
            }
          }
          
          // Also check form inputs for text fields, etc.
          const fieldKey = `properties[${field.label}]`;
          if (!selectedValue && selections[fieldKey]) {
            selectedValue = selections[fieldKey];
            if (debugEnabled) {
              debugLog(`ðŸ” Field "${field.label}" - Got value from selections:`, selectedValue);
            }
          }
          
          if (!selectedValue) return; // Skip if no selection
          
          if (debugEnabled) {
            debugLog(`ðŸŽ¯ Processing field "${field.label}": ${selectedValue}`);
          }
          
          // Filter out fields that shouldn't show in Order Summary
          const excludedTypes = [
            'text',
            'date', 
            'product-details',
            'details',
            'file-upload',
            'start-making',
            'request-quote',
            'design-method'
          ];
          
          if (excludedTypes.includes(field.type)) return;
          
          // Get display label from mapping or field configuration  
          const mapping = fieldMappings[field.id];
          if (mapping && !mapping.showInSummary) return; // Skip if hidden
          
          const displayLabel = mapping?.displayLabel || field.label;
          let displayValue = selectedValue;
          let itemPrice = 0;
          
          // Format display value and get price based on field type
          switch (field.type) {
            case 'design-method':
              // Special handling for design methods - support new pricing structure
              if (field.designMethods) {
                const selectedMethod = field.designMethods.find(m => 
                  m.id === selectedValue || m.name === selectedValue
                );
                if (selectedMethod) {
                  displayValue = selectedMethod.name || selectedValue;
                  // Use new pricing structure
                  const price_mode = selectedMethod.price_mode || 'flat_fee';
                  const price_value = parseFloat(selectedMethod.price_value !== undefined ? selectedMethod.price_value : (selectedMethod.price || 0)) || 0;
                  
                  if (price_value > 0) {
                    if (price_mode === 'per_unit') {
                      if (debugEnabled) {
                        debugLog(`ðŸ’° Per-unit design method "${displayValue}": $${price_value} per unit`);
                      }
                      displayValue += ` (+$${price_value.toFixed(4)}/unit)`;
                    } else {
                      if (debugEnabled) {
                        debugLog(`ðŸ’° Flat-fee design method "${displayValue}": +$${price_value}`);
                      }
                    }
                  }
                  
                  itemPrice = price_value;
                }
              }
              break;
              
            case 'quantity-list':
              if (field.quantities) {
                const quantityOption = field.quantities.find(q => 
                  q.quantity?.toString() === selectedValue
                );
                if (quantityOption) {
                  displayValue = `${quantityOption.quantity} ${field.unitName || 'units'}`;
                  // For quantity lists, we don't use itemPrice since pricing is handled by base price + per-unit calculations
                  itemPrice = 0; // Quantity doesn't add to price in new per-unit system
                  if (debugEnabled) {
                    debugLog(`📦 Quantity selected: ${displayValue} (base price handled separately)`);
                  }
                }
              }
              break;
              
            case 'quantity-slider':
              displayValue = `${selectedValue} ${field.unitName || 'units'}`;
              // For quantity sliders, we don't use itemPrice since pricing is handled by base price + per-unit calculations  
              itemPrice = 0; // Quantity doesn't add to price in new per-unit system
              if (debugEnabled) {
                debugLog(`ðŸŽšï¸ Quantity slider: ${displayValue} (base price handled separately)`);
              }
              break;
              
            case 'size':
            case 'swatch':
            case 'color-swatch':
            case 'image-swatch':
            case 'button':
            case 'dropdown':
            case 'corner':
              if (field.options) {
                const selectedOption = field.options.find(opt => 
                  opt.value === selectedValue || opt.name === selectedValue || opt.label === selectedValue
                );
                if (selectedOption) {
                  displayValue = selectedOption.label || selectedOption.name || selectedValue;
                  // Use new pricing structure for display purposes
                  const price_mode = selectedOption.price_mode || 'flat_fee';
                  const price_value = parseFloat(selectedOption.price_value !== undefined ? selectedOption.price_value : (selectedOption.price || 0)) || 0;
                  
                  if (price_mode === 'per_unit' && price_value > 0) {
                    if (debugEnabled) {
                      debugLog(`ðŸ”˜ Per-unit option "${displayValue}": $${price_value} per unit`);
                    }
                    // For display, we'll show the per-unit price info in the summary
                    displayValue += ` (+$${price_value.toFixed(4)}/unit)`;
                  } else if (price_value > 0) {
                    if (debugEnabled) {
                      debugLog(`ðŸ”˜ Flat-fee option "${displayValue}": +$${price_value}`);
                    }
                  }
                  
                  // For backward compatibility, still show the price in summaryItems
                  itemPrice = price_value;
                }
              }
              break;
              
            default:
              // For text inputs, etc.
              displayValue = selectedValue;
              break;
          }
          
          summaryItems.push({
            label: displayLabel,
            value: displayValue,
            price: itemPrice,
            fieldType: field.type,
            isPrimary: field.type === 'quantity-list' || field.type === 'quantity-slider' || field.type === 'design-method'
          });
          
          hasSelections = true;
        });
        
        // Calculate pricing using new Quantity-Based Pricing Logic
        const finalPrice = calculateTotalPrice(selections, optionSetData);
        
        if (debugEnabled) {
          debugLog('ðŸ“‹ Summary items built:', summaryItems);
          debugLog(`ðŸ’° Using new Quantity-Based Pricing Logic - Final price: $${finalPrice}`);
        }
        
        // Update the display
        if (hasSelections && summaryItems.length > 0) {
          // Build summary items HTML
          let itemsHTML = '';
          
          summaryItems.forEach(item => {
            itemsHTML += `
              <div class="summary-row" style="display: flex !important; justify-content: space-between !important; padding: 10px 0 10px 0 !important; border-bottom: 1px solid #ccc !important; margin: 0 !important; line-height: 1 !important; align-items: center !important;">
                <span class="label" style="margin: 0 !important; padding: 0 !important; line-height: 1 !important; vertical-align: top !important; display: block !important;">${item.label}</span>
                <span class="value" style="margin: 0 !important; padding: 0 !important; line-height: 1 !important; vertical-align: top !important; display: block !important;">${item.value}</span>
              </div>
            `;
          });
          
          if (debugEnabled) {
            debugLog('ðŸ”„ About to update Order Summary HTML:');
            debugLog('  Items HTML length:', itemsHTML.length);
            debugLog('  Items container element:', itemsContainer);
            debugLog('  Items HTML preview:', itemsHTML.substring(0, 200));
          }
          
          // OOM FIX: Removed body class toggle + untracked setTimeout pair
          itemsContainer.innerHTML = itemsHTML;
          if (debugEnabled) {
            debugLog('ðŸ”„ Order Summary HTML updated. New content:', itemsContainer.innerHTML.substring(0, 200));
          }
          
          
          // Update price display
          const priceContainer = summaryElement.querySelector(`#price-container-${summaryIndex}`);
          
          if (priceContainer) {
            // For quantity-based pricing, show the final calculated price
            // The calculateTotalPrice function handles all quantity discounts and per-unit calculations
            const priceHTML = `
              <span class="discounted-price" style="color: #333; font-size: 18px; font-weight: bold;">
                $${finalPrice.toFixed(2)}
              </span>
            `;
            
            if (debugEnabled) {
              debugLog('ðŸ”„ About to update price HTML:');
              debugLog('  Price container element:', priceContainer);
              debugLog('  Price HTML:', priceHTML);
            }
            
            // OOM FIX: Removed body class toggle + untracked setTimeout pair
            priceContainer.innerHTML = priceHTML;
            if (debugEnabled) {
              debugLog('ðŸ”„ Price HTML updated. New content:', priceContainer.innerHTML);
            }
            
            if (debugEnabled) {
              // Add mutation observer to detect if something overwrites our changes
              const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                  // Only log if this wasn't caused by our own updates
                  if (mutation.type === 'childList' && !document.querySelector('.updating-order-summary')) {
                    debugLog('ðŸš¨ EXTERNAL ORDER SUMMARY CHANGE DETECTED:', {
                      target: mutation.target.tagName + '.' + mutation.target.className,
                      addedNodes: mutation.addedNodes.length,
                      removedNodes: mutation.removedNodes.length,
                      currentContent: mutation.target.innerHTML?.substring(0, 100)
                    });
                    console.trace('External change source');
                  }
                });
              });
              
              // Observe both containers for changes
              if (itemsContainer) {
                observer.observe(itemsContainer, { 
                  childList: true, 
                  subtree: true, 
                  characterData: true,
                  attributes: true,
                  attributeOldValue: true,
                  characterDataOldValue: true
                });
              }
              if (priceContainer) {
                observer.observe(priceContainer, { 
                  childList: true, 
                  subtree: true, 
                  characterData: true,
                  attributes: true,
                  attributeOldValue: true,
                  characterDataOldValue: true
                });
              }
              
              // Stop observing after 10 seconds
              setTimeout(() => {
                observer.disconnect();
                debugLog('ðŸ” Mutation observer disconnected after 10 seconds');
              }, 10000);
            }
          } else {
            // Fallback if price container not found
            if (debugEnabled) {
              debugLog('ðŸ”„ Using fallback total element:', finalTotalElement);
            }
            finalTotalElement.textContent = `$${finalPrice.toFixed(2)}`;
          }
          
        } else {
          // Show placeholder when no selections
          if (debugEnabled) {
            debugLog('ðŸ”„ Order Summary showing empty state because:');
            debugLog('  hasSelections:', hasSelections);
            debugLog('  summaryItems.length:', summaryItems.length);
            debugLog('  summaryItems:', summaryItems);
          }
          
          itemsContainer.innerHTML = `
            <div class="summary-empty">
              <p class="main">Select options to see your order details...</p>
            </div>
          `;
          
          const priceContainer = summaryElement.querySelector(`#price-container-${summaryIndex}`);
          if (priceContainer) {
            priceContainer.innerHTML = `<span class="value">$${basePrice.toFixed(2)}</span>`;
          } else {
            finalTotalElement.textContent = `$${basePrice.toFixed(2)}`;
          }
        }
      });
      
      if (debugEnabled) {
        // FINAL VERIFICATION: Check if our updates are still there
        setTimeout(() => {
          debugLog('ðŸ” FINAL VERIFICATION - Order Summary state after 500ms:');
          
          // Check ALL possible Order Summary elements on the page
          const allSummaryElements = document.querySelectorAll('[id*="summary"], .order-summary, .summary-container, .summary-items, .price-container, [class*="order-summary"], [class*="summary"]');
          debugLog(`ðŸ” TOTAL summary-related elements found: ${allSummaryElements.length}`);
          
          allSummaryElements.forEach((el, i) => {
            debugLog(`  Element ${i}: ${el.tagName}.${el.className} #${el.id} - HTML length: ${el.innerHTML.length}`);
            if (el.innerHTML.length > 0 && el.innerHTML.length < 500) {
              debugLog(`    Content preview: ${el.innerHTML.substring(0, 200)}`);
            }
            debugLog(`    Computed styles:`, {
              display: getComputedStyle(el).display,
              visibility: getComputedStyle(el).visibility,
              opacity: getComputedStyle(el).opacity,
              position: getComputedStyle(el).position,
              zIndex: getComputedStyle(el).zIndex
            });
          });
          
          debugLog('ðŸ” Original target elements verification:');
          summaryElements.forEach((summaryElement, index) => {
            const summaryIndex = summaryElement.getAttribute('data-summary-index');
            const itemsContainer = summaryElement.querySelector(`#summary-items-${summaryIndex}`);
            const priceContainer = summaryElement.querySelector(`#price-container-${summaryIndex}`);
            
            debugLog(`  Summary ${index} (${summaryIndex}) final state:`);
            debugLog(`    Element visible: ${summaryElement.offsetHeight > 0 && summaryElement.offsetWidth > 0}`);
            debugLog(`    Items HTML length: ${itemsContainer?.innerHTML.length || 0}`);
            debugLog(`    Price HTML length: ${priceContainer?.innerHTML.length || 0}`);
            debugLog(`    Items HTML preview: ${itemsContainer?.innerHTML?.substring(0, 200) || 'None'}`);
            debugLog(`    Price HTML: ${priceContainer?.innerHTML || 'None'}`);
          });
        }, 500);
      }
      
    } catch (error) {
      console.warn('Error updating order summary:', error);
    }
  }

  /**
   * TRUE PER-UNIT PRICING: Real-time quantity list updates using METAFIELD PRICING
   * Updates all quantity tiers when ANY option changes using actual pricing variants
   */
  function updateQuantityListPricing(container, selections, optionSetData) {
    // Prevent recursive calls when we programmatically click a tier
    if (container.__updatingQuantityPricing) return;
    
    try {
      const pricingData = ensurePricingPayload(optionSetData, {
        source: 'update_quantity_list',
        containerId: container?.id || null
      });
      // Removed signature check to ensure quantity list always updates correctly when options change

      // Only log in debug mode to avoid per-click console overhead
      if (WIDGET_DEBUG_LOGGING) {
        debugLog('[QtyPricing] updateQuantityListPricing CALLED | pricingData:', pricingData ? `${pricingData.pricingVariants?.length} variants, ${pricingData.pricingDimensions?.length} dims` : 'NULL');
      }

      if (WIDGET_DEBUG_LOGGING) {
        debugLog('ðŸŽ¯ METAFIELD PRICING: updateQuantityListPricing called');
      }
      
      // Check if we have metafield pricing data
      if (!pricingData || !pricingData.pricingVariants?.length) {
        console.warn('[QtyPricing] EARLY EXIT: No pricing data/variants');
        if (WIDGET_DEBUG_LOGGING) {
          debugLog('⚠️ No metafield pricing data available for quantity list update');
        }
        return;
      }

      // Skip identical recalculations on rapid repeated clicks of the same
      // selection state. Include a lightweight pricing fingerprint so a real
      // pricing payload change still forces a recompute.
      const quantityPricingSignature = stableStringify({
        selections: selections || {},
        containerId: container?.id || null,
        pricingFingerprint: {
          dimensions: pricingData.pricingDimensions?.length || 0,
          variants: pricingData.pricingVariants?.length || 0,
          basePrice: safeNumber(pricingData.basePrice, 0),
          designServiceFee: safeNumber(pricingData.designServiceFee, 0)
        }
      });
      if (container.__lastQuantityPricingSignature === quantityPricingSignature) {
        return;
      }

      const { pricingDimensions, pricingVariants, basePrice } = pricingData;
      if (WIDGET_DEBUG_LOGGING) {
        debugLog('ðŸ“Š Pricing data:', {
          dimensions: pricingDimensions?.length,
          variants: pricingVariants?.length
        });
      }
      
      debugLog('ðŸ” Current selections for quantity pricing:', selections || {});

      // â”€â”€ Identify the quantity FIELD from option set data (by field type) â”€â”€
      const quantityField = optionSetData?.fields?.find(f =>
        f.type === 'quantity-list' || f.type === 'quantity-slider'
      );
      const quantityFieldLabel = quantityField?.label || null;
      const quantityFieldDimKey = quantityField?.pricingDimensionKey || null;

      // â”€â”€ Identify the quantity DIMENSION from pricing data â”€â”€
      // Priority: 1) isQuantity flag  2) field pricingDimensionKey linkage
      //           3) label/key contains "quantity"  4) all-numeric values
      const quantityDimension =
        pricingDimensions.find(dim => dim.isQuantity === true) ||
        (quantityFieldDimKey
          ? pricingDimensions.find(dim => dim.key === quantityFieldDimKey)
          : null) ||
        pricingDimensions.find(dim =>
          dim.label?.toLowerCase().includes('quantity') ||
          dim.key?.toLowerCase().includes('quantity')
        ) ||
        pricingDimensions.find(dim =>
          dim.values?.length > 0 &&
          dim.values.every(v => !isNaN(parseInt(v.label)))
        );

      // Need at least one of: quantity field label OR quantity dimension
      if (!quantityDimension && !quantityFieldLabel) {
        console.warn('[QtyPricing] EARLY EXIT: Cannot identify quantity dimension or field.',
          'Dims:', pricingDimensions.map(d => `${d.label}(isQuantity=${d.isQuantity})`).join(', '),
          'Fields:', (optionSetData?.fields || []).map(f => `${f.label}(${f.type})`).join(', '));
        return;
      }

      // Build the selections key for injecting tier quantities
      // Prefer the field label (matches how getCurrentSelectionsFromForm keys selections)
      const qtySelectionsKey = quantityFieldLabel
        ? `properties[${quantityFieldLabel}]`
        : `properties[${quantityDimension.label}]`;

      if (WIDGET_DEBUG_LOGGING) {
        console.log('[QtyPricing] quantityField:', quantityFieldLabel || '(none)',
          '| dimension:', quantityDimension?.label || '(none)',
          '| isQuantity:', quantityDimension?.isQuantity,
          '| dimKey:', quantityDimension?.key,
          '| fieldDimKey:', quantityFieldDimKey,
          '| selectionsKey:', qtySelectionsKey);
      }

      // â”€â”€ PERFORMANCE: Resolve base selection keys ONCE, reuse for every tier â”€â”€
      // We inject one dummy quantity value so the resolution runs the same path
      // as order summary, then overwrite the quantity key per-tier below.
      // IMPORTANT: Pass `container` so getFieldScopedSelection can do DOM lookups
      // for items where field labels don't match dimension labels.
      const baseSelections = { ...(selections || {}) };
      baseSelections[qtySelectionsKey] = '__placeholder__';
      const { selectionKeys: baseSelectionKeys } = buildVariantSelectionKeys(
        baseSelections, pricingData, optionSetData, container
      );
      // Identify which key in baseSelectionKeys belongs to the quantity dimension
      const qtyDimKey = quantityDimension?.key ||
        Object.keys(baseSelectionKeys).find(k => {
          const dim = pricingDimensions.find(d => d.key === k);
          return dim && (dim.isQuantity || (quantityFieldDimKey && dim.key === quantityFieldDimKey));
        });
      if (WIDGET_DEBUG_LOGGING) {
        console.log('[QtyPricing] Base keys (excl. qty):', JSON.stringify(baseSelectionKeys), '| qtyDimKey:', qtyDimKey);
      }

      // Find quantity lists in the container (can be .quantity-list or .quantity-grid)
      const quantityLists = container.querySelectorAll('.quantity-list, .quantity-grid, [data-field-type="quantity-list"]');
      if (WIDGET_DEBUG_LOGGING) {
        debugLog(`ðŸ” Found ${quantityLists.length} quantity lists to update`);
      }
      
      // If no quantity lists found, try finding quantity-tier elements directly
      let tiersToProcess = [];
      if (quantityLists.length === 0) {
        tiersToProcess = container.querySelectorAll('.quantity-tier');
        if (WIDGET_DEBUG_LOGGING) {
          debugLog(`ðŸ” Direct tier search found ${tiersToProcess.length} tiers`);
        }
      } else {
        // Collect all tiers from all quantity lists
        quantityLists.forEach(list => {
          const tiers = list.querySelectorAll('.quantity-tier');
          tiersToProcess = [...tiersToProcess, ...tiers];
        });
        if (WIDGET_DEBUG_LOGGING) {
          debugLog(`ðŸ” Collected ${tiersToProcess.length} tiers from lists`);
        }
      }
      
      if (tiersToProcess.length === 0) {
        console.warn('[QtyPricing] EARLY EXIT: No quantity tiers found in DOM');
        if (WIDGET_DEBUG_LOGGING) {
          debugLog('⚠️ No quantity tiers found to update');
        }
        return;
      }

      if (WIDGET_DEBUG_LOGGING) {
        console.log(`[QtyPricing] Processing ${tiersToProcess.length} tiers...`);
      }
      
      // First pass: calculate base unit price (first tier) for savings calculation
      let baseUnitPrice = null;
      let updatedCount = 0;
      
      // Group tiers by their index for position-based matching
      tiersToProcess.forEach((tier, tierIndex) => {
        const tierQuantityLabel = tier.dataset.value;
        if (!tierQuantityLabel) {
          if (WIDGET_DEBUG_LOGGING) {
            debugLog(`⚠️ Tier missing data-value:`, tier.outerHTML.substring(0, 100));
          }
          return;
        }
        
        // â”€â”€ PER-TIER RESOLUTION: reuse base keys, swap quantity only â”€â”€
        // baseSelectionKeys already has all non-quantity dimensions resolved
        // identically to the order summary path.  We just resolve this tier's
        // quantity value key and plug it in.
        const tierSelectionKeys = { ...baseSelectionKeys };
        if (qtyDimKey) {
          // Prefer DOM data-pricing-value-key (set from metafield during render)
          // BUT validate it actually exists in the pricing dimension values first.
          // Auto-save timing can cause the option set field keys and pricing variant
          // keys to diverge (different random suffixes). When that happens, fall
          // through to resolveDimensionValueKey which matches by numeric value.
          const domKey = tier.getAttribute('data-pricing-value-key') || null;
          const domKeyValid = domKey && quantityDimension?.values?.some(v => v.key === domKey);
          tierSelectionKeys[qtyDimKey] = (domKeyValid ? domKey : null)
            || resolveDimensionValueKey(quantityDimension, tierQuantityLabel, true)
            || null;
          if (domKey && !domKeyValid && WIDGET_DEBUG_LOGGING) {
            debugLog(`⚠️ DOM pricingValueKey "${domKey}" not found in pricing dimensions — using numeric fallback for tier ${tierQuantityLabel}`);
          }
        }

        // Skip tier if quantity key could not be resolved
        if (qtyDimKey && !tierSelectionKeys[qtyDimKey]) {
          if (WIDGET_DEBUG_LOGGING) {
            console.log(`[QtyPricing] Tier ${tierQuantityLabel}: SKIP (cannot resolve qty key)`);
          }
          return;
        }

        const matchingVariant = findMatchingVariantBySelectionKeys(
          pricingDimensions,
          pricingVariants,
          tierSelectionKeys
        );

        if (WIDGET_DEBUG_LOGGING) {
          console.log(`[QtyPricing] Tier ${tierQuantityLabel}: keys=${JSON.stringify(tierSelectionKeys)}, match=${matchingVariant ? '$' + matchingVariant.finalPrice + ' (SKU: ' + (matchingVariant.sku || 'N/A') + ')' : 'NONE'}`);
        }

        // Update UI with variant price
        const priceElement = tier.querySelector('.tier-price');
        const unitPriceElement = tier.querySelector('.tier-unit-price');
        const savingsElement = tier.querySelector('.tier-savings');
        
        if (matchingVariant) {
          const totalPrice = parseFloat(matchingVariant.finalPrice || 0);
          const tierQty = parseInt(tierQuantityLabel);
          const unitPrice = tierQty > 0 ? totalPrice / tierQty : 0;
          
          // Treat $0 as unavailable, but keep row visible so the list structure remains stable.
          if (totalPrice <= 0) {
            tier.classList.add('quantity-tier-unavailable');
            if (!tier.classList.contains('quantity-tier-hidden')) {
              tier.style.display = '';
            }
            if (WIDGET_DEBUG_LOGGING) {
              debugLog(`ðŸš« Tier ${tierQuantityLabel} unavailable: $0 price for current combo`);
            }
            return; // Skip further updates for this tier
          }
          
          // Variant is valid â€” ensure tier is visible (restore if previously hidden)
          if (tier.classList.contains('quantity-tier-unavailable')) {
            tier.classList.remove('quantity-tier-unavailable');
            // Only restore display if not part of the overflow-hidden set
            if (!tier.classList.contains('quantity-tier-hidden')) {
              tier.style.display = '';
            }
          }
          
          // Store base unit price for savings calculations (skip $0 tiers)
          if (baseUnitPrice === null) {
            baseUnitPrice = unitPrice;
          }
          
          if (priceElement) {
            priceElement.textContent = `$${totalPrice.toFixed(2)}`;
          }
          
          if (unitPriceElement) {
            unitPriceElement.textContent = `$${unitPrice.toFixed(2)}/unit`;
          }
          
          // Update savings percentage
          if (savingsElement && baseUnitPrice > 0) {
            const savingsPercent = Math.round(((baseUnitPrice - unitPrice) / baseUnitPrice) * 100);
            if (savingsPercent > 0) {
              savingsElement.textContent = `${savingsPercent}% Savings`;
              savingsElement.classList.add('has-savings');
              savingsElement.classList.remove('no-savings');
            } else {
              savingsElement.textContent = '';
              savingsElement.classList.add('no-savings');
              savingsElement.classList.remove('has-savings');
            }
          }
          
          // Update data attributes for selection
          tier.setAttribute('data-price', totalPrice.toFixed(2));
          tier.setAttribute('data-unit-price', unitPrice.toFixed(4));
          
          updatedCount++;
          if (WIDGET_DEBUG_LOGGING) {
            debugLog(`✅ Updated tier ${tierQuantityLabel}: $${totalPrice.toFixed(2)} from ${matchingVariant.sku}`);
          }
        } else {
          // No variant found â€” mark unavailable but keep visible (unless overflow-hidden)
          tier.classList.add('quantity-tier-unavailable');
          if (!tier.classList.contains('quantity-tier-hidden')) {
            tier.style.display = '';
          }
          if (WIDGET_DEBUG_LOGGING) {
            debugLog(`ðŸš« Tier ${tierQuantityLabel} unavailable: no variant for current combo`);
          }
        }
      });
      
      if (WIDGET_DEBUG_LOGGING) {
        console.log(`[QtyPricing] DONE: Updated ${updatedCount} of ${tiersToProcess.length} tiers`);
      }
      if (WIDGET_DEBUG_LOGGING) {
        debugLog(`ðŸŽ¯ Updated ${updatedCount} of ${tiersToProcess.length} tiers`);
      }

      // AUTO-EXPAND & AUTO-SELECT: Ensure at least 5 tiers are visible, and fix selection/button state
      const TARGET_VISIBLE = 5;

      quantityLists.forEach(list => {
        // RESPECT user's expand/collapse state â€” only the button toggles it.
        // If user expanded the list, keep it expanded after pricing updates.
        const isExpanded = list.dataset.expanded === 'true';

        // STEP 2: Get all available tiers (not $0/unavailable) and reset their visibility classes
        const allAvailableTiers = Array.from(list.querySelectorAll('.quantity-tier:not(.quantity-tier-unavailable)'));

        if (WIDGET_DEBUG_LOGGING) {
          debugLog(`ðŸ“Š Total available tiers (not $0): ${allAvailableTiers.length}, expanded: ${isExpanded}`);
        }

        // STEP 3: If collapsed, show first 5 and hide the rest. If expanded, show all.
        allAvailableTiers.forEach((tier, index) => {
          if (isExpanded || index < TARGET_VISIBLE) {
            // Show this tier
            tier.classList.remove('quantity-tier-hidden');
            tier.style.display = '';
            tier.style.visibility = '';
            tier.style.opacity = '1';
            tier.style.transform = '';
          } else {
            // Hide this tier (overflow)
            tier.classList.add('quantity-tier-hidden');
            tier.style.display = 'none';
            tier.style.visibility = 'hidden';
          }
        });

        if (WIDGET_DEBUG_LOGGING) {
          const visibleCount = Math.min(allAvailableTiers.length, TARGET_VISIBLE);
          const hiddenCount = Math.max(0, allAvailableTiers.length - TARGET_VISIBLE);
          debugLog(`ðŸ“Š After reset: ${visibleCount} visible, ${hiddenCount} hidden-but-available`);
        }

        // STEP 3.5: RECALCULATE SAVINGS based on FIRST VISIBLE tier
        // This ensures savings are always calculated correctly after visibility changes
        const visibleTiers = list.querySelectorAll('.quantity-tier:not(.quantity-tier-unavailable):not(.quantity-tier-hidden)');
        if (visibleTiers.length > 0) {
          // Get base unit price from FIRST visible tier
          const firstVisibleTier = visibleTiers[0];
          const firstUnitPrice = parseFloat(firstVisibleTier.dataset.unitPrice) || 0;

          if (WIDGET_DEBUG_LOGGING) {
            debugLog(`ðŸ’° Recalculating savings with base unit price: $${firstUnitPrice.toFixed(4)} from tier ${firstVisibleTier.dataset.value}`);
          }

          // Update savings for all visible tiers
          visibleTiers.forEach((tier, index) => {
            const savingsElement = tier.querySelector('.tier-savings');
            if (!savingsElement) return;

            if (index === 0) {
              // First visible tier = base price, no savings to show
              savingsElement.textContent = '';
              savingsElement.classList.add('no-savings');
              savingsElement.classList.remove('has-savings');
            } else {
              // Calculate savings compared to first visible tier
              const tierUnitPrice = parseFloat(tier.dataset.unitPrice) || 0;
              if (firstUnitPrice > 0 && tierUnitPrice > 0 && tierUnitPrice < firstUnitPrice) {
                const savingsPercent = Math.round(((firstUnitPrice - tierUnitPrice) / firstUnitPrice) * 100);
                savingsElement.textContent = `${savingsPercent}% Savings`;
                savingsElement.classList.add('has-savings');
                savingsElement.classList.remove('no-savings');
              } else {
                savingsElement.textContent = '0% Savings';
                savingsElement.classList.add('no-savings');
                savingsElement.classList.remove('has-savings');
              }
            }
          });

          // Also update savings for hidden-but-available tiers (for when user expands)
          const hiddenAvailableTiers = list.querySelectorAll('.quantity-tier.quantity-tier-hidden:not(.quantity-tier-unavailable)');
          hiddenAvailableTiers.forEach(tier => {
            const savingsElement = tier.querySelector('.tier-savings');
            if (!savingsElement) return;

            const tierUnitPrice = parseFloat(tier.dataset.unitPrice) || 0;
            if (firstUnitPrice > 0 && tierUnitPrice > 0 && tierUnitPrice < firstUnitPrice) {
              const savingsPercent = Math.round(((firstUnitPrice - tierUnitPrice) / firstUnitPrice) * 100);
              savingsElement.textContent = `${savingsPercent}% Savings`;
              savingsElement.classList.add('has-savings');
              savingsElement.classList.remove('no-savings');
            } else {
              savingsElement.textContent = '';
              savingsElement.classList.add('no-savings');
              savingsElement.classList.remove('has-savings');
            }
          });
        }

        // STEP 4: AUTO-SELECT - If the currently selected tier was hidden/unavailable, select first available
        const selectedTier = list.querySelector('.quantity-tier.selected.quantity-tier-unavailable');
        if (selectedTier) {
          selectedTier.classList.remove('selected');
          const firstAvailable = list.querySelector('.quantity-tier:not(.quantity-tier-unavailable):not(.quantity-tier-hidden)');
          if (firstAvailable) {
            firstAvailable.classList.add('selected');
            if (WIDGET_DEBUG_LOGGING) {
              debugLog(`ðŸ”„ Auto-selected tier ${firstAvailable.dataset.value} (previous selection was unavailable)`);
            }
            // Trigger option data update so price recalculates
            container.__updatingQuantityPricing = true;
            try {
              firstAvailable.click();
            } finally {
              container.__updatingQuantityPricing = false;
            }
          }
        }

        // STEP 5: UPDATE BUTTON STATE
        const seeMoreBtn = list.querySelector('.see-more-quantities');
        if (seeMoreBtn) {
          const remainingHidden = list.querySelectorAll('.quantity-tier.quantity-tier-hidden:not(.quantity-tier-unavailable)');
          if (isExpanded) {
            // Already expanded â€” show "See fewer quantities" toggle
            seeMoreBtn.style.display = '';
            seeMoreBtn.textContent = 'See fewer quantities';
          } else if (remainingHidden.length > 0) {
            seeMoreBtn.style.display = '';
            seeMoreBtn.textContent = 'See more quantities';
          } else {
            seeMoreBtn.style.display = 'none';
          }
        }
      });

      container.__lastQuantityPricingSignature = quantityPricingSignature;
      
    } catch (error) {
      console.warn('ðŸš¨ Error updating quantity list pricing:', error);
    }
  }

  // 14. ULTRA-OPTIMIZED OPTION DATA UPDATE
  function updateOptionData(form, hiddenInput, container) {
    try {
      const debugEnabled = WIDGET_DEBUG_LOGGING;
      const data = {};
      let dataChanged = false;
      
      // PERFORMANCE: Use faster native methods instead of querySelectorAll
      const selectedElements = [];
      const allElements = container.getElementsByTagName('*');
      
      // Single pass through DOM to find selected elements
      for (let i = 0; i < allElements.length; i++) {
        const element = allElements[i];
        if (element.classList && element.classList.contains('selected')) {
          const classList = element.classList;
          if (classList.contains('option-button') || 
              classList.contains('color-swatch-item') || 
              classList.contains('option-swatch-item') || 
              classList.contains('corner-option') || 
              classList.contains('quantity-tier') || 
              classList.contains('quantity-option') || 
              classList.contains('design-method') || 
              classList.contains('radio-option')) {
            selectedElements.push(element);
          }
        }
      }
      
      // Fast collection of selected options
      for (let i = 0; i < selectedElements.length; i++) {
        const selected = selectedElements[i];
        const group = selected.parentElement;
        const fieldName = group?.getAttribute('data-field-name');
        const value = selected.getAttribute('data-value');
        
        if (fieldName && value) {
          data['properties[' + fieldName + ']'] = value;
        }
      }
      
      // Optimized form input collection
      const formElements = form.elements;
      for (let i = 0; i < formElements.length; i++) {
        const input = formElements[i];
        if (input.name && input.name.startsWith('properties[') && input.value && input.value.trim() !== '') {
          const key = input.name;
          if (!data[key]) {
            data[key] = input.value;
          }
        }
      }
      
      // Fast quantity slider collection
      const quantitySliders = container.getElementsByClassName('quantity-slider');
      for (let i = 0; i < quantitySliders.length; i++) {
        const slider = quantitySliders[i];
        const wrapper = slider.closest('.quantity-slider-wrapper');
        const fieldName = wrapper?.getAttribute('data-field-name');
        if (fieldName && slider.value) {
          data['properties[' + fieldName + ']'] = slider.value;
        }
      }
      
      // CRITICAL: Only update if data actually changed to prevent excessive operations
      const newDataString = JSON.stringify(data);
      if (hiddenInput.value !== newDataString) {
        hiddenInput.value = newDataString;
        dataChanged = true;
        
        // FIXED: Update order summary with current data immediately
        if (debugEnabled) {
          debugLog('ðŸ“Š Updating order summary with new data:', data);
        }
        
        if (debugEnabled) {
          // Dev-only visual debug: highlight summary updates.
          const summaryElements = container.querySelectorAll('.order-summary');
          summaryElements.forEach(summary => {
            summary.style.border = '3px solid lime';
            summary.style.backgroundColor = 'rgba(0, 255, 0, 0.1)';
            setTimeout(() => {
              summary.style.border = '';
              summary.style.backgroundColor = '';
            }, 1000);
          });
        }
        
        updateOrderSummary(container, data);
        
        // Debounced event dispatch to prevent flooding
        if (!window.optionEventPending) {
          window.optionEventPending = true;
          
          const timer = setTimeout(() => {
            const event = new CustomEvent('optionSetUpdated', {
              detail: { 
                data: data, 
                productId: container.dataset.productId,
                container: container 
              }
            });
            document.dispatchEvent(event);
            window.optionEventPending = false;
          }, 100);
          
          // Track timer for cleanup
          const productId = container.dataset.productId;
          if (productId) {
            window.OptionWidgetManager.addTimer(productId, timer);
          }
        }
      }
      
      // ALWAYS update quantity list pricing to ensure it stays in sync with selections
      // even if the data string didn't change (e.g., initial load or race conditions)
      updateQuantityListPricing(container, data, getOptionSetData(container));
      
      return dataChanged;
      
    } catch (error) {
      console.warn('Update option data error:', error);
      return false;
    }
  }

  // 15. GET CURRENT SELECTIONS
  function setWidgetImageState(img, state) {
    if (!img || !img.classList) return;
    let normalizedState = state === 'ready' || state === 'failed' ? state : 'loading';
    if (normalizedState === 'ready' && img.complete && img.naturalWidth <= 0) {
      normalizedState = 'failed';
    }
    const isCornerImage = img.classList.contains('corner-image');

    img.classList.remove('vici-img-loading', 'vici-img-ready', 'vici-img-failed');
    img.classList.add(`vici-img-${normalizedState}`);
    img.dataset.viciImageState = normalizedState;

    const forceStyle = (prop, value) => {
      if (!img || !img.style || typeof img.style.setProperty !== 'function') return;
      img.style.setProperty(prop, value, 'important');
    };

    // Enforce visibility at the element level to prevent theme CSS overrides
    // from exposing broken-image placeholders/alt text during load/error states.
    if (normalizedState === 'ready') {
      forceStyle('display', 'block');
      forceStyle('opacity', '1');
      forceStyle('visibility', 'visible');
      forceStyle('pointer-events', 'auto');
    } else if (normalizedState === 'failed') {
      forceStyle('display', 'none');
      forceStyle('opacity', '0');
      forceStyle('visibility', 'hidden');
      forceStyle('pointer-events', 'none');
    } else {
      forceStyle('display', isCornerImage ? 'none' : 'block');
      forceStyle('opacity', '0');
      forceStyle('visibility', 'hidden');
      forceStyle('pointer-events', 'none');
    }

    const optionItem = img.closest('.option-swatch-item, .design-method, .corner-option');
    if (!optionItem || !optionItem.classList) return;
    if (normalizedState === 'failed' && optionItem.classList.contains('has-image')) {
      optionItem.classList.remove('has-image');
      optionItem.classList.add('no-image');
    }
    if (normalizedState === 'ready' && optionItem.classList.contains('no-image')) {
      optionItem.classList.remove('no-image');
      optionItem.classList.add('has-image');
    }
  }

  function buildWidgetImageRuntimeFallback(img) {
    const defaultLabel = String(
      (img && (img.dataset.viciAlt || img.getAttribute('aria-label') || img.getAttribute('alt'))) || 'Option'
    ).trim() || 'Option';
    const isCorner = img && img.classList && img.classList.contains('corner-image');
    const isMethod = img && img.classList && img.classList.contains('method-image');
    const width = isCorner ? 48 : isMethod ? 200 : 150;
    const height = isCorner ? 48 : isMethod ? 85 : 150;
    const fontSize = isCorner ? 11 : 12;
    return buildImageFallbackDataUrl(defaultLabel, '', width, height, fontSize);
  }

  function initializeWidgetImageStates(container) {
    if (!container || typeof container.querySelectorAll !== 'function') return;
    const images = container.querySelectorAll(
      'img.swatch-image, img.method-image, img.corner-image, .option-swatch-item img, .design-method img, .corner-option img'
    );
    images.forEach((img) => {
      const pendingSrc = String(img.dataset.viciSrc || '').trim();
      let appliedNewSource = false;

      if (img.dataset.viciImageBound !== 'true') {
        setWidgetImageState(img, 'loading');
        img.dataset.viciImageBound = 'true';
        img.dataset.viciImageSettled = 'false';
        img.dataset.viciImageErrorCount = img.dataset.viciImageErrorCount || '0';
        img.dataset.viciProxyTried = img.dataset.viciProxyTried || 'false';

        img.addEventListener('load', () => {
          img.dataset.viciImageSettled = 'true';
          setWidgetImageState(img, img.naturalWidth > 0 ? 'ready' : 'failed');
        });
        img.addEventListener('error', () => {
          const errorCount = Number(img.dataset.viciImageErrorCount || '0') + 1;
          img.dataset.viciImageErrorCount = String(errorCount);
          img.dataset.viciImageSettled = 'false';

          const proxySrc = String(img.dataset.viciProxySrc || '').trim();
          if (
            proxySrc &&
            img.dataset.viciProxyTried !== 'true' &&
            img.getAttribute('src') !== proxySrc
          ) {
            img.dataset.viciProxyTried = 'true';
            setWidgetImageState(img, 'loading');
            img.setAttribute('src', proxySrc);
            return;
          }

          // Guarantee a non-broken visual even when remote image hosts fail.
          if (img.dataset.viciFallbackApplied !== 'true') {
            img.dataset.viciFallbackApplied = 'true';
            const fallbackSrc = buildWidgetImageRuntimeFallback(img);
            if (fallbackSrc) {
              setWidgetImageState(img, 'loading');
              img.setAttribute('src', fallbackSrc);
              return;
            }
          }

          img.dataset.viciImageSettled = 'true';
          setWidgetImageState(img, 'failed');
        });
      }

      // Apply real image URL only after listeners are attached to prevent
      // broken-image icon flashes during initial paint.
      if (pendingSrc && img.dataset.viciSrcApplied !== 'true') {
        img.dataset.viciSrcApplied = 'true';
        img.dataset.viciImageSettled = 'false';
        setWidgetImageState(img, 'loading');
        appliedNewSource = true;
        img.setAttribute('src', pendingSrc);
      }

      // Do not evaluate completion in the same cycle where we just applied a new
      // source URL, otherwise the browser may report completion for the previous
      // placeholder and incorrectly mark the image as ready.
      if (!appliedNewSource && img.complete && img.dataset.viciImageSettled !== 'true') {
        img.dataset.viciImageSettled = 'true';
        setWidgetImageState(img, img.naturalWidth > 0 ? 'ready' : 'failed');
      }
    });
  }

  function lockWidgetFirstPaint(container) {
    if (!container || !container.style) return;
    container.dataset.viciPaintLocked = 'true';
    container.style.setProperty('visibility', 'hidden', 'important');
    container.style.setProperty('opacity', '0', 'important');
    container.style.setProperty('pointer-events', 'none', 'important');
  }

  function unlockWidgetFirstPaint(container) {
    if (!container || !container.style) return;
    container.style.setProperty('visibility', 'visible', 'important');
    container.style.setProperty('opacity', '1', 'important');
    container.style.setProperty('pointer-events', 'auto', 'important');
    container.dataset.viciPaintLocked = 'false';
  }

  function revealWidgetAfterImageSettle(container) {
    if (!container || typeof container.querySelectorAll !== 'function') return;
    const images = Array.from(
      container.querySelectorAll(
        'img.swatch-image, img.method-image, img.corner-image, .option-swatch-item img, .design-method img, .corner-option img'
      )
    );

    if (images.length === 0) {
      requestAnimationFrame(() => unlockWidgetFirstPaint(container));
      return;
    }

    let settledCount = 0;
    let isRevealed = false;
    const revealOnce = () => {
      if (isRevealed) return;
      isRevealed = true;
      unlockWidgetFirstPaint(container);
    };
    const markSettled = () => {
      settledCount += 1;
      if (settledCount >= images.length) {
        revealOnce();
      }
    };

    images.forEach((img) => {
      const state = img.dataset.viciImageState;
      if (
        state === 'ready' ||
        state === 'failed' ||
        (img.complete && (img.naturalWidth > 0 || img.naturalWidth === 0))
      ) {
        markSettled();
        return;
      }
      img.addEventListener('load', markSettled, { once: true });
      img.addEventListener('error', markSettled, { once: true });
    });

    // Failsafe to avoid keeping the widget hidden if a browser drops events.
    setTimeout(revealOnce, 220);
  }

  // 16. LAZY LOADING FOR PERFORMANCE
  function initializeLazyLoading(container, productId) {
    initializeWidgetImageStates(container);
    const images = container.querySelectorAll('img[data-src]');
    
    if ('IntersectionObserver' in window && images.length > 0) {
      const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            
            // Use requestAnimationFrame for smooth loading
            requestAnimationFrame(() => {
              setWidgetImageState(img, 'loading');
              img.addEventListener('load', () => {
                setWidgetImageState(img, img.naturalWidth > 0 ? 'ready' : 'failed');
              }, { once: true });
              img.addEventListener('error', () => {
                setWidgetImageState(img, 'failed');
              }, { once: true });
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
              img.classList.add('loaded');
            });
            
            imageObserver.unobserve(img);
          }
        });
      }, {
        rootMargin: '50px 0px',
        threshold: 0.1
      });
      
      images.forEach(img => imageObserver.observe(img));
      
      // Track observer for cleanup
      window.OptionWidgetManager.addObserver(productId, imageObserver);
      
      debugLog(`Custom Option Widget v${WIDGET_VERSION} - Lazy loading initialized for ${images.length} images`);
    } else {
      // Fallback for older browsers or no images
      images.forEach(img => {
        setWidgetImageState(img, 'loading');
        img.addEventListener('load', () => {
          setWidgetImageState(img, img.naturalWidth > 0 ? 'ready' : 'failed');
        }, { once: true });
        img.addEventListener('error', () => {
          setWidgetImageState(img, 'failed');
        }, { once: true });
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      });
    }
  }

  // 17. GET CURRENT SELECTIONS
  function getCurrentSelections(container) {
    const hiddenInput = container.querySelector('input[name="properties[_option_set_data]"]');
    if (!hiddenInput || !hiddenInput.value) return {};
    
    try {
      return JSON.parse(hiddenInput.value);
    } catch (e) {
      console.error('Error parsing option data:', e);
      return {};
    }
  }

  // 19. OPTIMIZED WIDGET INITIALIZATION WITH MEMORY MANAGEMENT
  async function initializeWidget() {
    PerformanceMonitor.start('initializeWidget');
    
    // Look for all widget containers (might be multiple on page)
    const containers = [
      document.getElementById('custom-options-widget-container'),
      document.getElementById('custom-options-widget-container-2')
    ].filter(container => container !== null);
    
    if (containers.length === 0) {
      throw new Error('No option widget containers found');
    }

    containers.forEach(lockWidgetFirstPaint);
    
    debugLog(`Custom Option Widget v${WIDGET_VERSION} - Found ${containers.length} container(s)`);
    
    // Get option set data first to inject styles with Style Studio CSS
    let optionSetData = null;
    let firstContainerProductId = null;
    if (containers.length > 0) {
      const firstContainer = containers[0];
      const productId = firstContainer.dataset.productId;
      if (productId) {
        firstContainerProductId = productId;
        optionSetData = await fetchProductOptionSet(productId);
        optionSetData = adaptOptionSetContract(optionSetData, {
          productId,
          containerId: firstContainer.id
        });
        primeWidgetImageCache(optionSetData);
      }
    }
    
    // Inject styles with Style Studio CSS
    debugLog(`Custom Option Widget v${WIDGET_VERSION} - Injecting styles with option set data...`);
    injectStyles(optionSetData);

    // âš¡ LOAD PRICING FROM METAFIELD FOR ZERO-LATENCY CALCULATIONS
    debugLog(`Custom Option Widget v${WIDGET_VERSION} - Loading pricing from metafields...`);
    const pricingLoaded = await loadPricingFromMetafield();
    if (pricingLoaded) {
      debugLog('✅ Zero-latency pricing enabled via metafields');
    } else {
      debugLog('⚠️ Pricing metafield not found - using legacy calculation');
      if (optionSetData) {
        ensurePricingPayload(optionSetData, {
          source: 'initialize_widget_prefetch',
          productId: firstContainerProductId,
          containerId: containers[0]?.id || null
        });
      }
    }

    // Initialize each container with memory management
    for (const container of containers) {
      const productId = container.dataset.productId;
      if (!productId) {
        console.error(`Custom Option Widget v${WIDGET_VERSION} - No product ID found for container:`, container.id);
        continue;
      }
      
      debugLog(`Custom Option Widget v${WIDGET_VERSION} - Initializing container ${container.id} for product ${productId}`);
      
      // Initialize managed instance for memory tracking
      const instance = window.OptionWidgetManager.initialize(container, productId);
      
      // Use preloaded data only when it belongs to this same product.
      let containerOptionSetData =
        optionSetData && firstContainerProductId && String(firstContainerProductId) === String(productId)
          ? optionSetData
          : null;
      if (!containerOptionSetData) {
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Fetching option set data for ${container.id}...`);
        containerOptionSetData = await fetchProductOptionSet(productId);
        containerOptionSetData = adaptOptionSetContract(containerOptionSetData, {
          productId,
          containerId: container.id
        });
        primeWidgetImageCache(containerOptionSetData);
      } else if (container.id !== containers[0].id) {
        containerOptionSetData = adaptOptionSetContract(containerOptionSetData, {
          productId,
          containerId: container.id
        });
        primeWidgetImageCache(containerOptionSetData);
      }
      
      if (!containerOptionSetData) {
        console.warn(`Custom Option Widget v${WIDGET_VERSION} - No option set data found for product ${productId}`);
        container.innerHTML = '<div style="padding: 20px; text-align: center; color: #999;">No options available for this product.</div>';
        unlockWidgetFirstPaint(container);
        continue;
      }
      ensurePricingPayload(containerOptionSetData, {
        source: 'initialize_widget_container',
        productId,
        containerId: container.id
      });
      runOptionSetContractReadShadow(containerOptionSetData, {
        productId,
        containerId: container.id,
        widgetRuntimeMode: OPTION_WIDGET_RUNTIME_MODE
      });
      
      debugLog(`Custom Option Widget v${WIDGET_VERSION} - Option set data loaded for ${container.id}:`, {
        name: containerOptionSetData.name,
        fieldsCount: containerOptionSetData.fields ? containerOptionSetData.fields.length : 0
      });
      
      // Build and inject widget HTML
      debugLog(`Custom Option Widget v${WIDGET_VERSION} - Building widget HTML for ${container.id}...`);
      const widgetHTML = buildWidgetHTML(containerOptionSetData, productId);
      container.innerHTML = widgetHTML;
      initializeWidgetImageStates(container);
      revealWidgetAfterImageSettle(container);
      
      // Store option set data in the instance for Order Summary access
      if (containerOptionSetData && typeof containerOptionSetData === 'object') {
        containerOptionSetData.__viciProductId = String(productId);
        const containerHandle = container.dataset?.productHandle || container.getAttribute('data-product-handle');
        if (containerHandle) {
          containerOptionSetData.__viciProductHandle = String(containerHandle);
        }
      }
      instance.optionSetData = containerOptionSetData;
      if (!window.optionSetData || !window.optionSetData.fields?.length) {
        window.optionSetData = containerOptionSetData;
      }
      
      // NOTE: OptionEventDelegator removed — it registered an undebounced
      // capture-phase click handler that duplicated (and raced with) the
      // debounced optimizedClickHandler in attachEventListeners, causing
      // page freezes/crashes on rapid clicking.
      
      // Attach event listeners
      debugLog(`Custom Option Widget v${WIDGET_VERSION} - Attaching event listeners for ${container.id}...`);
      attachEventListeners(container, productId);
      
      // Initialize lazy loading for performance
      initializeLazyLoading(container, productId);
      
      // ✅ AUTO-SELECT FIRST OPTIONS AND INITIALIZE PRICING
      const timer = setTimeout(() => {
        autoSelectFirstOptions(container, containerOptionSetData);
        
        // Update order summary with initial selections
        const form = container.querySelector(`#option-set-form-${productId}`);
        const hiddenInput = container.querySelector(`#option-set-data-${productId}`);
        if (form && hiddenInput) {
          updateOptionData(form, hiddenInput, container);
        }
        
        // Force update order summary with current selections
        const currentSelections = getCurrentSelectionsFromForm(container);
        debugLog('ðŸš€ Initial selections after auto-select:', currentSelections);
        updateOrderSummary(container, currentSelections);
        
        // ✅ CRITICAL: Initialize quantity list pricing from metafield data
        updateQuantityListPricing(container, currentSelections, containerOptionSetData);
      }, 150);
      
      // Track timer for cleanup
      window.OptionWidgetManager.addTimer(productId, timer);
    }
    
    // Add page cleanup handlers
    window.OptionWidgetManager.addListener('global', window, 'beforeunload', () => {
      window.OptionWidgetManager.instances.forEach((instance, productId) => {
        window.OptionWidgetManager.cleanup(productId);
      });
    });
    
    PerformanceMonitor.end('initializeWidget');
    debugLog(`Custom Option Widget v${WIDGET_VERSION} - Initialization complete with performance monitoring`);
  }

  function normalizeSelectionText(value) {
    return String(value || '').trim().toLowerCase();
  }

  function normalizeFieldType(type) {
    return String(type || '').trim().toLowerCase().replace(/_/g, '-');
  }

  function findPreferredOptionElement(elements, preferredValue) {
    const all = Array.from(elements || []);
    if (!all.length) return null;

    if (preferredValue !== undefined && preferredValue !== null && String(preferredValue).trim() !== '') {
      const preferred = normalizeSelectionText(preferredValue);
      const matched = all.find((element) => {
        const dataValue = normalizeSelectionText(element?.dataset?.value);
        const textValue = normalizeSelectionText(element?.textContent);
        return dataValue === preferred || textValue === preferred;
      });
      if (matched) return matched;
    }

    return all[0];
  }

  function selectChoiceElement(groupElement, elementToSelect) {
    if (!groupElement || !elementToSelect) return;
    const current = groupElement.querySelectorAll('.selected');
    current.forEach((node) => node.classList.remove('selected'));
    elementToSelect.classList.add('selected');
  }

  function buildFirstVariantDefaultMap() {
    const pricing = window.optionSetPricing;
    const defaults = {};

    if (!pricing || !Array.isArray(pricing.pricingDimensions) || !Array.isArray(pricing.pricingVariants) || !pricing.pricingVariants.length) {
      return defaults;
    }

    const firstVariant = pricing.pricingVariants[0] || {};
    const dimensionValues = firstVariant.dimensionValues || {};

    pricing.pricingDimensions.forEach((dimension) => {
      if (!dimension || typeof dimension !== 'object') return;
      const variantValueKey = dimensionValues[dimension.key];
      let selectedLabel = null;

      if (Array.isArray(dimension.values) && dimension.values.length) {
        const matchedValue = dimension.values.find((entry) => entry && (entry.key === variantValueKey || entry.label === variantValueKey));
        if (matchedValue) {
          selectedLabel = matchedValue.label || matchedValue.value || matchedValue.key || null;
        }
      }

      if (!selectedLabel && variantValueKey !== undefined && variantValueKey !== null) {
        selectedLabel = String(variantValueKey);
      }

      if (!selectedLabel) return;
      defaults[normalizeSelectionText(dimension.label)] = selectedLabel;
      defaults[normalizeSelectionText(dimension.key)] = selectedLabel;
    });

    return defaults;
  }

  // ✅ AUTO-SELECT DEFAULT OPTION COMBINATION
  // Prefers first pricing-variant combination (SKU -01 row), then falls back to first field option.
  function autoSelectFirstOptions(container, optionSetData) {
    if (!optionSetData?.fields) return;

    const defaultMap = buildFirstVariantDefaultMap();
    const hasPricingDefaults = Object.keys(defaultMap).length > 0;
    const debugEnabled = WIDGET_DEBUG_LOGGING;

    if (debugEnabled) {
      debugLog('ðŸ”„ Auto-selecting defaults for all fields...', { hasPricingDefaults, defaultMap });
    }

    optionSetData.fields.forEach((field) => {
      if (!field || typeof field !== 'object') return;
      const fieldLabel = field.label;
      if (!fieldLabel) return;

      let fieldContainer = container.querySelector(`[data-field-name="${fieldLabel}"]`);
      if (!fieldContainer) {
        const expectedName = `properties[${fieldLabel}]`;
        const namedInput = Array.from(
          container.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]')
        ).find((node) => node && node.name === expectedName);
        if (namedInput && typeof namedInput.closest === 'function') {
          fieldContainer =
            namedInput.closest('.custom-dropdown-wrapper') ||
            namedInput.closest('.quantity-slider-wrapper') ||
            namedInput.closest('.option-field-wrapper') ||
            namedInput.parentElement;
        }
      }
      if (!fieldContainer) return;

      const preferredValue = defaultMap[normalizeSelectionText(field.label)] ?? defaultMap[normalizeSelectionText(field.key)] ?? null;
      const fieldType = normalizeFieldType(field.type);

      try {
        if (fieldType === 'dropdown' || fieldType === 'custom-dropdown') {
          const wrapper = fieldContainer.closest('.custom-dropdown-wrapper') || fieldContainer;
          const hiddenInput = wrapper.querySelector('.custom-dropdown-input');
          const textEl = wrapper.querySelector('.custom-dropdown-text');
          const menuOptions = wrapper.querySelectorAll('.custom-dropdown-option:not(.disabled)');

          let preferredLabel = null;
          let preferredStoredValue = null;
          if (Array.isArray(field.options) && field.options.length) {
            const matched = field.options.find((opt) => {
              const candidateValues = [opt?.value, opt?.label, opt?.name].map(normalizeSelectionText);
              const preferred = normalizeSelectionText(preferredValue);
              return preferred && candidateValues.includes(preferred);
            }) || field.options[0];
            preferredStoredValue = matched?.value || matched?.name || matched?.label || '';
            preferredLabel = matched?.label || matched?.value || matched?.name || '';
          }

          if (!preferredLabel && menuOptions.length) {
            const preferredOptionEl = findPreferredOptionElement(menuOptions, preferredValue);
            preferredLabel = preferredOptionEl ? preferredOptionEl.textContent.trim() : menuOptions[0].textContent.trim();
            preferredStoredValue = preferredLabel;
          }

          if (hiddenInput && preferredStoredValue) hiddenInput.value = preferredStoredValue;
          if (textEl && preferredLabel) textEl.textContent = preferredLabel;

          if (menuOptions.length) {
            menuOptions.forEach((node) => node.classList.remove('selected'));
            const preferredOptionEl = findPreferredOptionElement(menuOptions, preferredLabel || preferredValue);
            if (preferredOptionEl) preferredOptionEl.classList.add('selected');
          }
          return;
        }

        if (fieldType === 'quantity-slider') {
          const slider = fieldContainer.querySelector('.quantity-slider');
          if (!slider) return;
          const numericPreferred = parseInt(preferredValue, 10);
          if (!Number.isNaN(numericPreferred)) {
            const min = parseInt(slider.min || '0', 10);
            const max = parseInt(slider.max || String(numericPreferred), 10);
            slider.value = String(Math.min(Math.max(numericPreferred, min), max));
            handleQuantitySlider(slider);
          }
          return;
        }

        if (fieldType === 'radio') {
          const options = fieldContainer.querySelectorAll('.radio-option');
          const target = findPreferredOptionElement(options, preferredValue);
          if (target) {
            selectChoiceElement(fieldContainer, target);
            const radio = target.querySelector('input[type="radio"]');
            if (radio) radio.checked = true;
          }
          return;
        }

        const selectableSelectorMap = {
          button: '.option-button',
          'button-group': '.option-button',
          'option-buttons': '.option-button',
          swatch: '.color-swatch-item, .option-swatch-item',
          'color-swatch': '.color-swatch-item, .option-swatch-item',
          'image-swatch': '.option-swatch-item',
          size: '.option-swatch-item, .size-swatch',
          corner: '.corner-option',
          'quantity-list': '.quantity-tier, .quantity-option',
          quantity: '.quantity-tier, .quantity-option',
          'design-method': '.design-method'
        };

        const selector = selectableSelectorMap[fieldType];
        if (!selector) return;

        const options = fieldContainer.querySelectorAll(selector);
        const target = findPreferredOptionElement(options, preferredValue);
        if (target) selectChoiceElement(fieldContainer, target);
      } catch (fieldDefaultError) {
        console.warn(`Custom Option Widget v${WIDGET_VERSION} - Failed default selection for field "${field.label}"`, fieldDefaultError);
      }
    });

    if (debugEnabled) {
      debugLog('✅ Default selections applied');
    }
  }

  // QUANTITY LIST TOGGLE FUNCTION - WITH SMOOTH SLIDE ANIMATION
  window.toggleQuantities = function(button) {
    try {
      // Find the quantity list container with fallback selectors
      const quantityList = button.closest('.quantity-list') || 
                          button.parentElement.querySelector('.quantity-list') ||
                          button.closest('.field-container').querySelector('.quantity-list');
      
      if (!quantityList) {
        console.error('No quantity list found');
        return;
      }
      
      // Find hidden tiers using multiple strategies (exclude unavailable tiers - those stay hidden)
      let hiddenTiers = quantityList.querySelectorAll('.quantity-tier-hidden:not(.quantity-tier-unavailable)');
      
      // If no hidden tiers found, try other selectors (excluding unavailable)
      if (hiddenTiers.length === 0) {
        hiddenTiers = quantityList.querySelectorAll('.quantity-tier[style*="display: none"]:not(.quantity-tier-unavailable)');
      }
      
      // If still none found, select tiers beyond the first 5 (excluding unavailable)
      if (hiddenTiers.length === 0) {
        const allTiers = quantityList.querySelectorAll('.quantity-tier:not(.quantity-tier-unavailable)');
        hiddenTiers = Array.from(allTiers).slice(5);
      }
      
      if (hiddenTiers.length === 0) {
        debugLog('No hidden tiers to toggle');
        return;
      }
      
      // Check current state by looking at first hidden tier
      const isCurrentlyExpanded = hiddenTiers[0].style.display !== 'none' && 
                                 hiddenTiers[0].style.visibility !== 'hidden';
      
      if (isCurrentlyExpanded) {
        // Collapse with slide up animation
        quantityList.dataset.expanded = 'false';
        hiddenTiers.forEach((tier, index) => {
          // Add slide up animation
          tier.style.transition = 'all 0.3s ease-out';
          tier.style.transform = 'translateY(-10px)';
          tier.style.opacity = '0';

          setTimeout(() => {
            tier.style.display = 'none';
            tier.style.visibility = 'hidden';
            tier.classList.add('quantity-tier-hidden');
            tier.style.transform = '';
            tier.style.opacity = '';
          }, 200 + (index * 50)); // Stagger the animation
        });
        button.textContent = 'See more quantities';
      } else {
        // Expand with slide down animation
        quantityList.dataset.expanded = 'true';
        hiddenTiers.forEach((tier, index) => {
          tier.style.display = 'grid';
          tier.style.visibility = 'visible';
          tier.classList.remove('quantity-tier-hidden');

          // Initial hidden state for animation
          tier.style.opacity = '0';
          tier.style.transform = 'translateY(-10px)';
          tier.style.transition = 'all 0.3s ease-out';

          setTimeout(() => {
            tier.style.opacity = '1';
            tier.style.transform = 'translateY(0)';
          }, 100 + (index * 50)); // Stagger the animation
        });
        button.textContent = 'Show less quantities';
      }
      
    } catch (error) {
      console.error('Toggle quantities error:', error);
    }
  };

  // 17. MEMORY MANAGEMENT AND CLEANUP
  function cleanupWidget(container) {
    try {
      // Clear any timeouts
      if (window.optionEventTimeout) {
        clearTimeout(window.optionEventTimeout);
        window.optionEventTimeout = null;
      }
      
      // Remove event listeners by cloning
      if (container && container.parentNode) {
        const clonedContainer = container.cloneNode(true);
        container.parentNode.replaceChild(clonedContainer, container);
      }
      
      debugLog(`Custom Option Widget v${WIDGET_VERSION} - Cleaned up widget for container:`, container?.id);
    } catch (error) {
      console.warn('Widget cleanup error:', error);
    }
  }

  // NOTE: Removed beforeunload cleanup - the DOM manipulation in cleanupWidget
  // (cloneNode/replaceChild) was causing broken image icons to flash during page refresh.
  // The page is unloading anyway, so cleanup is unnecessary and counterproductive.

  // 18. WAIT FOR DOM AND SHOPIFY TO BE READY
  function domReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // 18. EXPOSE GLOBAL API - ENHANCED WITH CSS SYNC
  window.CustomOptionWidget = {
    version: WIDGET_VERSION,
    buildDate: WIDGET_BUILD_DATE,
    getCurrentSelections: function(productId) {
      const container = document.getElementById('custom-options-widget-container');
      if (container && container.dataset.productId === productId) {
        return getCurrentSelections(container);
      }
      return {};
    },
    updateWidget: function(productId) {
      const container = document.getElementById('custom-options-widget-container');
      if (container && container.dataset.productId === productId) {
        const form = container.querySelector(`#option-set-form-${productId}`);
        const hiddenInput = container.querySelector(`#option-set-data-${productId}`);
        if (form && hiddenInput) {
          updateOptionData(form, hiddenInput, container);
        }
      }
    },
    // NEW: Extract CSS styles for builder preview sync
    getWidgetStyles: function() {
      // Return the complete CSS used by the widget
      return styles;
    },
    // NEW: Get widget CSS as string for external use
    extractStyles: function() {
      const styleElements = document.querySelectorAll('style[data-widget-styles]');
      let cssContent = '';
      styleElements.forEach(style => {
        cssContent += style.textContent + '\n';
      });
      return cssContent || styles;
    },
    getInfo: function() {
      return {
        version: WIDGET_VERSION,
        buildDate: WIDGET_BUILD_DATE,
        loaded: window.CustomOptionWidgetLoaded,
        container: document.getElementById('custom-options-widget-container')
      };
    }
  };

  // PERFORMANCE OPTIMIZATIONS FOR INSTANT DISPLAY
  
  // Batched DOM Updates System — keyed to prevent duplicate work per container
  window.PerformanceBatch = {
    pendingUpdates: new Map(), // Map<key, callback> to deduplicate per container
    rafId: null,
    
    schedule(callback, key) {
      // Use a key so rapid-fire calls for the same container replace rather than accumulate.
      // Falls back to the callback reference for backward-compat (Set-like behavior).
      const mapKey = key || callback;
      this.pendingUpdates.set(mapKey, callback);
      
      if (!this.rafId) {
        this.rafId = requestAnimationFrame(() => {
          // Execute all pending updates in a single frame
          this.pendingUpdates.forEach(cb => {
            try {
              cb();
            } catch (error) {
              console.warn('Batch update error:', error);
            }
          });
          this.pendingUpdates.clear();
          this.rafId = null;
        });
      }
    },
    
    immediate(callback) {
      // For critical updates that need immediate execution
      try {
        callback();
      } catch (error) {
        console.warn('Immediate update error:', error);
      }
    }
  };

  // Enhanced Event Delegation System
  window.OptionEventDelegator = {
    containers: new Set(),
    
    init(container) {
      if (this.containers.has(container)) return;
      
      const delegatedHandler = (e) => {
        if (WIDGET_DEBUG_LOGGING) {
          debugLog(`ðŸ–±ï¸ Click detected in ${container.id}:`, e.target);
        }
        
        // Find the target option element
        const target = e.target.closest([
          '.option-button',
          '.option-swatch-item', 
          '.color-swatch-item',
          '.corner-option',
          '.quantity-tier',
          '.design-method',
          '.radio-option'
        ].join(','));
        
        if (target && !target.classList.contains('disabled')) {
          if (WIDGET_DEBUG_LOGGING) {
            debugLog(`ðŸŽ¯ Valid option target found:`, target, `value: ${target.dataset.value}`);
          }
          e.preventDefault();
          e.stopPropagation();
          
          // Batch the selection update for performance
          window.PerformanceBatch.schedule(() => {
            this.handleSelection(target, container);
          });
        } else if (target) {
          if (WIDGET_DEBUG_LOGGING) {
            debugLog(`⚠️ Disabled target clicked:`, target);
          }
        } else {
          if (WIDGET_DEBUG_LOGGING) {
            debugLog(`❌ No valid option target found for:`, e.target);
          }
        }
      };
      
      // Single event listener handles all option interactions
      container.addEventListener('click', delegatedHandler, { 
        passive: false,
        capture: true
      });
      
      this.containers.add(container);
    },
    
    handleSelection(element, container) {
      const group = element.parentElement;
      const fieldName = group?.dataset.fieldName;
      const value = element.dataset.value;
      
      if (!fieldName || !value) return;
      
      if (WIDGET_DEBUG_LOGGING) {
        debugLog(`ðŸŽ¯ SELECTION CHANGE: ${fieldName} = ${value} in container ${container.id}`);
      }
      
      // Batch DOM updates
      const updates = [];
      
      // Remove selection from siblings
      const siblings = group.querySelectorAll('.selected');
      siblings.forEach(sibling => {
        updates.push(() => sibling.classList.remove('selected'));
      });
      
      // Add selection to clicked element  
      updates.push(() => element.classList.add('selected'));
      
      // Execute DOM updates immediately for instant feedback
      updates.forEach(update => update());
      
      if (WIDGET_DEBUG_LOGGING) {
        debugLog(`ðŸ”„ DOM updated for ${fieldName}, now triggering data update...`);
      }
      
      // Immediately trigger data update and order summary
      const form = container.querySelector('form');
      const productId = container.dataset.productId;
      const hiddenInput = document.getElementById(`option-set-data-${productId}`);
      
      if (WIDGET_DEBUG_LOGGING) {
        debugLog(`ðŸ” Verifying form and hidden input for data update...`);
      }
      if (!form) {
        console.error(`CRITICAL: Could not find form in container ${container.id}.`);
      }
      if (!hiddenInput) {
        console.error(`CRITICAL: Could not find hidden input in container ${container.id}. This is a fatal error for the update process.`);
        // Attempt to find it with the old, incorrect selector for debugging comparison
        if (WIDGET_DEBUG_LOGGING) {
          const oldWay = container.querySelector('[name="properties[option_set_data]"]');
          debugLog('Old selector result:', oldWay);
        }
      }

      if (form && hiddenInput) {
        if (WIDGET_DEBUG_LOGGING) {
          debugLog(`✅ Form and hidden input found. Calling updateOptionData.`);
        }
        updateOptionData(form, hiddenInput, container);
      } else {
        console.error(`❌ Update process halted due to missing form or hidden input.`);
      }
      
      // Batch price and summary updates
      window.PerformanceBatch.schedule(() => {
        if (typeof window.updatePricingDisplay === 'function') {
          window.updatePricingDisplay(container);
        }
        if (typeof window.updateOrderSummary === 'function') {
          if (WIDGET_DEBUG_LOGGING) {
            debugLog(`ðŸ”„ Calling updateOrderSummary from handleSelection for ${container.id}`);
          }
          window.updateOrderSummary(container);
        }
      }, `handleSelection-${container.id}`);
    }
  };

  // Memory-Efficient State Management
  window.OptionStateManager = {
    states: new Map(),
    
    setState(containerId, fieldName, value) {
      if (!this.states.has(containerId)) {
        this.states.set(containerId, new Map());
      }
      
      const containerState = this.states.get(containerId);
      const oldValue = containerState.get(fieldName);
      
      if (oldValue !== value) {
        containerState.set(fieldName, value);
        return true; // State changed
      }
      return false; // No change
    },
    
    getState(containerId, fieldName) {
      const containerState = this.states.get(containerId);
      return containerState?.get(fieldName);
    },
    
    getAllStates(containerId) {
      return this.states.get(containerId) || new Map();
    },
    
    cleanup(containerId) {
      this.states.delete(containerId);
    }
  };

  // 19. INITIALIZE EVERYTHING
  domReady(function() {
    debugLog(`Custom Option Widget v${WIDGET_VERSION} - DOM ready, initializing with performance optimizations...`);
    
    // Wait for Shopify theme to be ready
    if (window.Shopify && window.Shopify.theme) {
      debugLog(`Custom Option Widget v${WIDGET_VERSION} - Shopify theme detected, initializing widget...`);
      initializeWidget().then(() => {
        debugLog(`Custom Option Widget v${WIDGET_VERSION} - Initialization complete âœ“`);
      }).catch((error) => {
        console.error(`Custom Option Widget v${WIDGET_VERSION} - Initialization failed:`, error);
      });
    } else {
      // Fallback for themes that don't expose Shopify.theme
      debugLog(`Custom Option Widget v${WIDGET_VERSION} - Shopify theme not detected, using fallback initialization...`);
      setTimeout(() => {
        initializeWidget().then(() => {
          debugLog(`Custom Option Widget v${WIDGET_VERSION} - Initialization complete âœ“`);
        }).catch((error) => {
          console.error(`Custom Option Widget v${WIDGET_VERSION} - Initialization failed:`, error);
        });
      }, 100);
    }
  });

  // Custom Dropdown Functions
  window.toggleCustomDropdown = function(dropdownId) {
    const menu = document.getElementById(dropdownId);
    const trigger = menu?.previousElementSibling;
    const allMenus = document.querySelectorAll('.custom-dropdown-menu');
    const allTriggers = document.querySelectorAll('.custom-dropdown-trigger');
    
    // Close all other dropdowns
    allMenus.forEach(m => {
      if (m.id !== dropdownId) {
        m.classList.remove('active');
      }
    });
    allTriggers.forEach(t => {
      if (t !== trigger) {
        t.classList.remove('active');
      }
    });
    
    // Toggle current dropdown
    if (menu) {
      menu.classList.toggle('active');
      if (trigger) {
        trigger.classList.toggle('active');
      }
    }
  };

  window.selectCustomDropdownOption = function(dropdownId, value, label) {
    const menu = document.getElementById(dropdownId);
    const wrapper = menu?.closest('.custom-dropdown-wrapper');
    const trigger = wrapper?.querySelector('.custom-dropdown-trigger');
    const textSpan = trigger?.querySelector('.custom-dropdown-text');
    const hiddenInput = wrapper?.querySelector('.custom-dropdown-input');
    
    if (textSpan && hiddenInput) {
      // Update display text and hidden input value
      textSpan.textContent = label;
      hiddenInput.value = value;
      
      // Update selected state
      const options = menu.querySelectorAll('.custom-dropdown-option');
      options.forEach(opt => opt.classList.remove('selected'));
      // Find the clicked option by matching label text instead of relying on
      // the deprecated implicit `event` global (which can throw in strict mode
      // or certain browsers, crashing the page).
      const clickedOption = Array.from(options).find(opt => opt.textContent.trim() === label);
      if (clickedOption) clickedOption.classList.add('selected');
      
      // Close dropdown
      menu.classList.remove('active');
      trigger.classList.remove('active');
      
      // Trigger change event for form handling
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  // Close dropdowns when clicking outside
  document.addEventListener('click', function(event) {
    if (!event.target.closest('.custom-dropdown-wrapper')) {
      const allMenus = document.querySelectorAll('.custom-dropdown-menu');
      const allTriggers = document.querySelectorAll('.custom-dropdown-trigger');
      
      allMenus.forEach(menu => menu.classList.remove('active'));
      allTriggers.forEach(trigger => trigger.classList.remove('active'));
    }
  });

  // Add event listeners for dropdown triggers (replacing onclick)
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('.custom-dropdown-trigger');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      const dropdownId = trigger.getAttribute('data-dropdown-id');
      if (dropdownId) {
        toggleCustomDropdown(dropdownId);
      }
    }
  });

  // Prevent any focus events on dropdown triggers
  document.addEventListener('focusin', function(event) {
    const trigger = event.target.closest('.custom-dropdown-trigger');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      trigger.blur();
    }
  });

  // Removed diagnostic click handler for go-live hardening.

  // Export functions globally for Shopify cart integration
  window.CustomOptionWidget = window.CustomOptionWidget || {};
  window.CustomOptionWidget.updateOrderSummary = updateOrderSummary;
  window.CustomOptionWidget.calculateTotalPrice = calculateTotalPrice;
  window.CustomOptionWidget.getSummaryFieldMappings = getSummaryFieldMappings;
  
  // Export for external cart integration
  window.getCustomOptionsSummary = function(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return null;
    
    const summaryElement = container.querySelector('.order-summary');
    if (!summaryElement) return null;
    
    const items = [];
    const summaryItems = summaryElement.querySelectorAll('.summary-item');
    
    summaryItems.forEach(item => {
      const label = item.querySelector('.summary-item-label')?.textContent?.replace(':', '') || '';
      const value = item.querySelector('.summary-item-value')?.textContent || '';
      const price = item.querySelector('.summary-item-price')?.textContent || '';
      
      if (label && value) {
        items.push({ label, value, price });
      }
    });
    
    const totalElement = summaryElement.querySelector('.line-value');
    const total = totalElement?.textContent || '$0.00';
    
    return {
      items: items,
      total: total,
      formattedSummary: items.map(item => `${item.label}: ${item.value}`).join(', '),
      totalPrice: total
    };
  };

  // ==============================================================================
  // ðŸš€ ENTERPRISE-LEVEL ENHANCEMENTS FOR 100% BULLETPROOF RELIABILITY
  // ==============================================================================

  // Global variables for enhanced functionality
  let currentVariantId = null;
  let sessionId = generateSessionId();
  let widgetSessionId = generateWidgetSessionId();
  let retryHandler = null;

  // ✅ FIX 1: FIELD VALIDATION SYSTEM
  function validateOptionField(field, value) {
    const validation = {
      isValid: true,
      errors: []
    };

    // Required field validation
    if (field.required && (!value || String(value).trim() === '')) {
      validation.isValid = false;
      validation.errors.push(`${field.label} is required`);
    }

    if (!value || String(value).trim() === '') return validation;

    // Type-specific validation
    switch (field.type) {
      case 'email':
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          validation.isValid = false;
          validation.errors.push(`${field.label} must be a valid email address`);
        }
        break;
      
      case 'number':
        if (isNaN(Number(value))) {
          validation.isValid = false;
          validation.errors.push(`${field.label} must be a number`);
        } else {
          const numValue = Number(value);
          if (field.min !== undefined && numValue < field.min) {
            validation.isValid = false;
            validation.errors.push(`${field.label} must be at least ${field.min}`);
          }
          if (field.max !== undefined && numValue > field.max) {
            validation.isValid = false;
            validation.errors.push(`${field.label} must be no more than ${field.max}`);
          }
        }
        break;
      
      case 'text':
      case 'textarea':
        if (field.minLength && value.length < field.minLength) {
          validation.isValid = false;
          validation.errors.push(`${field.label} must be at least ${field.minLength} characters`);
        }
        if (field.maxLength && value.length > field.maxLength) {
          validation.isValid = false;
          validation.errors.push(`${field.label} must be no more than ${field.maxLength} characters`);
        }
        break;

      case 'phone':
        if (!/^\+?[\d\s\-\(\)]{10,}$/.test(value)) {
          validation.isValid = false;
          validation.errors.push(`${field.label} must be a valid phone number`);
        }
        break;

      case 'url':
        try {
          new URL(value.startsWith('http') ? value : 'https://' + value);
        } catch (e) {
          validation.isValid = false;
          validation.errors.push(`${field.label} must be a valid URL`);
        }
        break;
    }

    return validation;
  }

  function validateAllFields(optionSetData, formData) {
    const allErrors = [];
    
    if (!optionSetData || !optionSetData.fields) {
      return { isValid: false, errors: ['Invalid option set configuration'] };
    }
    
    optionSetData.fields.forEach(field => {
      const value = formData[field.id] || formData[field.label];
      const validation = validateOptionField(field, value);
      
      if (!validation.isValid) {
        allErrors.push(...validation.errors);
      }
    });
    
    return {
      isValid: allErrors.length === 0,
      errors: allErrors
    };
  }

  function showValidationErrors(errors) {
    // Remove existing error messages
    const existingErrors = document.querySelectorAll('.option-validation-error');
    existingErrors.forEach(error => error.remove());

    // Create error container
    const errorContainer = document.createElement('div');
    errorContainer.className = 'option-validation-error';
    errorContainer.style.cssText = `
      background: #fee2e2;
      border: 1px solid #fca5a5;
      border-radius: 6px;
      padding: 12px 16px;
      margin: 16px 0;
      color: #dc2626;
      font-size: 14px;
      line-height: 1.4;
    `;

    const errorList = errors.map(error => `\u2022 ${error}`).join('<br>');
    errorContainer.innerHTML = `
      <strong>Please correct the following errors:</strong><br>
      ${errorList}
    `;

    // Insert at top of widget
    const widget = document.querySelector('.option-widget-container');
    if (widget) {
      widget.insertBefore(errorContainer, widget.firstChild);
      
      // Scroll to errors
      errorContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function showSuccessMessage() {
    const successDiv = document.createElement('div');
    successDiv.className = 'option-success-message';
    successDiv.style.cssText = `
      background: #dcfce7;
      border: 1px solid #86efac;
      border-radius: 6px;
      padding: 12px 16px;
      margin: 16px 0;
      color: #166534;
      font-size: 14px;
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 10000;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    `;
    successDiv.innerHTML = '✅ Added to cart successfully!';
    document.body.appendChild(successDiv);

    setTimeout(() => {
      if (successDiv.parentNode) {
        successDiv.parentNode.removeChild(successDiv);
      }
    }, 3000);
  }

  function showErrorMessage(message) {
    // Parse error for user-friendly messaging
    const rawMessage = String(message || '');
    let userMessage = rawMessage;
    let icon = '❌';
    
    // Handle specific Shopify errors
    if (rawMessage.toLowerCase().includes('sold out') || rawMessage.toLowerCase().includes('out of stock')) {
      // Keep the specific sold-out message if we have one, otherwise fall back to a generic message
      userMessage = rawMessage.replace(/^failed to add item to cart:\s*/i, '').trim() ||
        'Sorry, this product is currently out of stock. Please check back later or contact us for availability.';
      icon = '📦';
    } else if (rawMessage.includes('422')) {
      // Extract the actual message from 422 errors
      const match = rawMessage.match(/"message":"([^"]+)"/);
      if (match) {
        userMessage = match[1];
      }
    } else if (rawMessage.toLowerCase().includes('inventory')) {
      userMessage = 'This product has limited availability. Please try a smaller quantity.';
      icon = '⚠️';
    } else if (rawMessage.toLowerCase().includes('variant')) {
      userMessage = 'Please select all required options before adding to cart.';
      icon = '⚠️';
    }
    
    const errorDiv = document.createElement('div');
    errorDiv.className = 'option-error-message';
    errorDiv.style.cssText = `
      background: #fee2e2;
      border: 1px solid #fca5a5;
      border-radius: 8px;
      padding: 16px 20px;
      margin: 16px 0;
      color: #dc2626;
      font-size: 14px;
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 10000;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      max-width: 400px;
      line-height: 1.5;
    `;
    errorDiv.innerHTML = `${icon} ${userMessage}`;
    document.body.appendChild(errorDiv);

    setTimeout(() => {
      if (errorDiv.parentNode) {
        errorDiv.style.transition = 'opacity 0.3s ease-out';
        errorDiv.style.opacity = '0';
        setTimeout(() => {
          if (errorDiv.parentNode) {
            errorDiv.parentNode.removeChild(errorDiv);
          }
        }, 300);
      }
    }, 6000);
  }

  function showLoadingState() {
    const addToCartButtons = document.querySelectorAll('.add-to-cart-button, [name="add"], .btn-cart');
    addToCartButtons.forEach(button => {
      button.disabled = true;
      button.style.opacity = '0.6';
      const originalText = button.textContent;
      button.setAttribute('data-original-text', originalText);
      button.innerHTML = '⏳ Adding to Cart...';
    });
  }

  function hideLoadingState() {
    const addToCartButtons = document.querySelectorAll('.add-to-cart-button, [name="add"], .btn-cart');
    addToCartButtons.forEach(button => {
      button.disabled = false;
      button.style.opacity = '1';
      const originalText = button.getAttribute('data-original-text');
      if (originalText) {
        button.innerHTML = originalText;
        button.removeAttribute('data-original-text');
      }
    });
  }

  // Animated button states (spinner â†’ checkmark like Ridge)
  const VICI_SPINNER_SVG = '<svg class="vici-spinner" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="9" stroke="rgba(255,255,255,0.3)" stroke-width="2.5"/><path d="M20 11a9 9 0 0 0-9-9" stroke="#fff" stroke-width="2.5" stroke-linecap="round"/></svg>';
  const VICI_CHECK_SVG = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><circle class="vici-checkmark-circle" cx="14" cy="14" r="12" stroke="#fff" stroke-width="2" fill="none"/><path class="vici-checkmark-check" d="M8.5 14.5l3.5 3.5 7.5-7.5" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';

  function setButtonLoading(button) {
    if (!button) return;
    if (!button.getAttribute('data-original-text')) {
      button.setAttribute('data-original-text', button.textContent);
    }
    button.disabled = true;
    button.innerHTML = VICI_SPINNER_SVG;
    button.classList.add('vici-btn-loading');
    button.classList.remove('vici-btn-success');
  }

  function setButtonSuccess(button, resetDelay) {
    if (!button) return;
    button.classList.remove('vici-btn-loading');
    button.classList.add('vici-btn-success');
    button.innerHTML = VICI_CHECK_SVG;
    const delay = resetDelay || 2000;
    setTimeout(() => {
      button.classList.remove('vici-btn-success');
      const originalText = button.getAttribute('data-original-text') || 'Add to Cart';
      button.textContent = originalText;
      button.removeAttribute('data-original-text');
      button.disabled = false;
      button.style.background = '';
    }, delay);
  }

  function setButtonError(button, resetDelay) {
    if (!button) return;
    button.classList.remove('vici-btn-loading', 'vici-btn-success');
    button.textContent = 'Error - Try Again';
    const delay = resetDelay || 2000;
    setTimeout(() => {
      const originalText = button.getAttribute('data-original-text') || 'Add to Cart';
      button.textContent = originalText;
      button.removeAttribute('data-original-text');
      button.disabled = false;
    }, delay);
  }

  // ✅ FIX 2: RETRY HANDLER CLASS - OPTIMIZED FOR SPEED
  class RetryHandler {
    constructor(maxRetries = 2, baseDelay = 200) {
      this.maxRetries = maxRetries;
      this.baseDelay = baseDelay;
    }

    async executeWithRetry(asyncFn, context = 'operation') {
      let lastError;

      for (let attempt = 0; attempt <= this.maxRetries; attempt++) {
        try {
          return await asyncFn();
        } catch (error) {
          lastError = error;

          if (error && error.nonRetryable) {
            console.warn(`${context} failed with non-retryable error:`, error.message);
            throw error;
          }

          if (attempt === this.maxRetries) {
            console.error(`${context} failed after ${this.maxRetries + 1} attempts:`, error);
            throw error;
          }

          // Fast retry with minimal delay (200ms, 400ms)
          const delay = this.baseDelay * Math.pow(2, attempt);
          console.warn(`${context} failed (attempt ${attempt + 1}), retrying in ${delay}ms:`, error.message);

          await new Promise(resolve => setTimeout(resolve, delay));
        }
      }
    }
  }

  retryHandler = new RetryHandler();

  // ✅ ZERO-LATENCY PRICING: Load pricing variants from Shopify metafields
  // DON'T overwrite if Liquid already injected the data
  if (!window.optionSetPricing) {
    window.optionSetPricing = null; // Will be loaded from API if not already set
  } else {
    getNormalizedPricingPayload();
    debugLog('✅ Pricing data already loaded from Liquid injection:', {
      dimensions: window.optionSetPricing.pricingDimensions?.length || 0,
      variants: window.optionSetPricing.pricingVariants?.length || 0
    });
  }

  async function loadPricingFromMetafield() {
    // 1) Fast path: already injected via Liquid.
    const preloadedPricing = getNormalizedPricingPayload();
    if (preloadedPricing && preloadedPricing.pricingVariants?.length) {
      debugLog('ðŸ’° Using pricing from Liquid injection');
      return true;
    }

    // 2) Scoped window payload by product id.
    try {
      const scopedContainer = document.querySelector('#custom-options-widget-container, #custom-options-widget-container-2, .option-widget-container');
      const scopedProductId = scopedContainer?.dataset?.productId || null;
      if (scopedProductId) {
        const scopedOptionSetData = window[`OPTION_SET_DATA_${scopedProductId}`];
        const scopedPricing = buildPricingPayloadFromOptionSetData(scopedOptionSetData);
        if (scopedPricing?.pricingVariants?.length) {
          window.optionSetPricing = scopedPricing;
          debugLog('✅ Pricing recovered from scoped option-set window payload');
          return true;
        }
      }
    } catch (error) {
      console.warn('⚠️ Scoped window pricing recovery failed:', error);
    }

    // 3) Scan embedded JSON scripts for pricing payloads.
    try {
      const jsonScripts = document.querySelectorAll('script[type="application/json"], script[type="application/ld+json"]');
      for (const script of jsonScripts) {
        const content = script?.textContent?.trim();
        if (!content || content.length < 10) continue;
        if (!/pricingVariants|pricing_variants|designServiceFee|design_service_fee/.test(content)) continue;

        let parsed;
        try {
          parsed = JSON.parse(content);
        } catch (parseError) {
          continue;
        }

        const candidateNodes = [
          parsed,
          parsed?.pricing_variants,
          parsed?.pricingVariants,
          parsed?.product?.metafields?.optionsets?.pricing_variants?.value,
          parsed?.product?.metafields?.optionsets?.pricingVariants?.value
        ];

        for (const node of candidateNodes) {
          if (!node) continue;
          let normalizedNode = node;
          if (typeof normalizedNode === 'string') {
            try {
              normalizedNode = JSON.parse(normalizedNode);
            } catch (error) {
              continue;
            }
          }
          const normalizedPricing = normalizePricingPayload(normalizedNode);
          if (normalizedPricing?.pricingVariants?.length) {
            window.optionSetPricing = normalizedPricing;
            debugLog('✅ Pricing recovered from embedded DOM JSON script');
            return true;
          }
        }
      }
    } catch (error) {
      console.warn('⚠️ DOM pricing script scan failed:', error);
    }

    // 4) Last fallback: product JSON API (metafields may be stripped).
    try {
      const productHandle = window.location.pathname.split('/products/')[1]?.split('/')[0];
      if (!productHandle) {
        return false;
      }

      const response = await fetch(`/products/${productHandle}.json`);
      if (!response.ok) {
        console.warn('⚠️ Failed product JSON pricing fallback:', response.status);
        return false;
      }

      const productData = await response.json();
      const pricingMetafield = productData?.product?.metafields?.find?.(
        (m) => m.namespace === 'optionsets' && m.key === 'pricing_variants'
      );

      if (!pricingMetafield?.value) {
        console.warn('⚠️ Product JSON returned without pricing_variants metafield');
        return false;
      }

      const pricingData = typeof pricingMetafield.value === 'string'
        ? JSON.parse(pricingMetafield.value)
        : pricingMetafield.value;
      const normalizedPricing = normalizePricingPayload(pricingData);
      if (!normalizedPricing?.pricingVariants?.length) {
        return false;
      }

      window.optionSetPricing = normalizedPricing;
      debugLog('✅ Pricing loaded from product JSON fallback');
      return true;
    } catch (error) {
      console.error('❌ Pricing fallback failed:', error);
      return false;
    }
  }

  // Calculate price from pricing variants (zero-latency)
  function findMatchingVariantBySelectionKeys(pricingDimensions = [], pricingVariants = [], selectionKeys = {}) {
    for (const variant of pricingVariants || []) {
      let matches = true;

      for (const dim of pricingDimensions || []) {
        const selectedKey = selectionKeys?.[dim.key];
        const variantValueKey = variant.dimensionValues?.[dim.key];

        if (!selectedKey) {
          continue;
        }

        if (!variantValueKey) {
          matches = false;
          break;
        }

        const isQuantityDimension =
          dim.isQuantity ||
          dim.type === 'quantity' ||
          normalizeForMatch(dim.label).includes('quantity');

        if (isQuantityDimension) {
          const selectedOption = dim.values?.find(v => v.key === selectedKey);
          const variantOption = dim.values?.find(v => v.key === variantValueKey);

          // Resolve numeric values: prefer explicit numericValue, then label,
          // then extractNumericValue on the label (NOT the raw key, which is
          // a compound string like "option-group-4-...-cpumx-50-kc7wy" and
          // would produce garbage when all digits are concatenated).
          const selectedNumeric =
            selectedOption?.numericValue !== undefined && selectedOption?.numericValue !== null
              ? Number(selectedOption.numericValue)
              : selectedOption?.label ? extractNumericValue(selectedOption.label)
              : extractNumericValue(selectedKey);
          const variantNumeric =
            variantOption?.numericValue !== undefined && variantOption?.numericValue !== null
              ? Number(variantOption.numericValue)
              : variantOption?.label ? extractNumericValue(variantOption.label)
              : extractNumericValue(variantValueKey);

          if (Number.isFinite(selectedNumeric) && Number.isFinite(variantNumeric)) {
            if (selectedNumeric !== variantNumeric) {
              matches = false;
              break;
            }
          } else if (selectedKey !== variantValueKey) {
            matches = false;
            break;
          }
        } else if (selectedKey !== variantValueKey) {
          matches = false;
          break;
        }
      }

      if (matches) {
        return variant;
      }
    }

    return null;
  }

  function resolveDimensionValueKey(dim, valueLabel, forceNumeric = false) {
    if (!dim || !valueLabel || !Array.isArray(dim.values)) return null;
    const normalizedLabel = normalizeForMatch(valueLabel);

    if (forceNumeric || dim.isQuantity || dim.type === 'quantity' || normalizeForMatch(dim.label).includes('quantity')) {
      const numericTarget = extractNumericValue(valueLabel);
      if (numericTarget !== null) {
        const numericMatch = dim.values.find(v =>
          Number(v.numericValue) === numericTarget ||
          extractNumericValue(v.label) === numericTarget ||
          extractNumericValue(v.key) === numericTarget
        );
        if (numericMatch) return numericMatch.key;
      }
    }

    const directMatch = dim.values.find(v =>
      normalizeForMatch(v.label) === normalizedLabel ||
      normalizeForMatch(v.key) === normalizedLabel ||
      normalizeForMatch(v.value) === normalizedLabel
    );
    return directMatch?.key || null;
  }

  function getFieldScopedSelection(container, field) {
    if (!container || !field) return null;

    let fieldWrapper = null;
    if (field.id) {
      fieldWrapper = container.querySelector(`.option-field-wrapper[data-field-id="${field.id}"]`);
    }

    if (!fieldWrapper && field.label) {
      const wrappersByName = container.querySelectorAll(`[data-field-name="${field.label}"]`);
      if (wrappersByName.length > 0) {
        fieldWrapper = wrappersByName[0];
      }
    }

    if (!fieldWrapper) return null;

    const selectedElement = fieldWrapper.querySelector('.selected');
    if (!selectedElement) return null;

    return {
      value: selectedElement.dataset.value || selectedElement.value || selectedElement.textContent?.trim() || null,
      pricingValueKey: selectedElement.getAttribute('data-pricing-value-key') || null
    };
  }

  function buildVariantSelectionKeys(selections, pricingData, optionSetDataForPricing, containerOverride = null) {
    const pricingDimensions = pricingData?.pricingDimensions || [];
    const cleanedSelections = {};
    const normalizedSelections = {};

    Object.entries(selections || {}).forEach(([key, value]) => {
      const cleanKey = key.replace(/^properties\[|\]$/g, '');
      cleanedSelections[cleanKey] = value;
      normalizedSelections[normalizeForMatch(cleanKey)] = value;
    });

    const selectionKeys = {};

    for (const dim of pricingDimensions) {
      const linkedFields = optionSetDataForPricing?.fields?.filter?.((field) => field?.pricingDimensionKey === dim.key) || [];
      let selectedLabel = null;
      let selectedKey = null;

      // Prefer field-scoped selected element (handles duplicate labels safely)
      if (containerOverride && linkedFields.length > 0) {
        for (const linkedField of linkedFields) {
          const scopedSelection = getFieldScopedSelection(containerOverride, linkedField);
          if (!scopedSelection) continue;

          selectedLabel = scopedSelection.value;
          const scopedKey = scopedSelection.pricingValueKey;
          if (scopedKey && dim.values?.some(v => v.key === scopedKey)) {
            selectedKey = scopedKey;
            break;
          }
        }
      }

      // Fallback to selection-map lookup using linked field labels
      if (!selectedKey && linkedFields.length > 0) {
        for (const linkedField of linkedFields) {
          const label = linkedField?.label;
          if (!label) continue;

          const linkedDirect = cleanedSelections[label];
          if (linkedDirect !== undefined && linkedDirect !== null && linkedDirect !== '') {
            selectedLabel = linkedDirect;
            break;
          }

          const linkedNormalized = normalizedSelections[normalizeForMatch(label)];
          if (linkedNormalized !== undefined && linkedNormalized !== null && linkedNormalized !== '') {
            selectedLabel = linkedNormalized;
            break;
          }
        }
      }

      // Try by dimension label/key
      if (!selectedLabel) {
        selectedLabel = cleanedSelections[dim.label] || cleanedSelections[dim.key];
      }
      if (!selectedLabel) {
        selectedLabel =
          normalizedSelections[normalizeForMatch(dim.label)] ||
          normalizedSelections[normalizeForMatch(dim.key)];
      }

      // Restricted fuzzy fallback
      if (!selectedLabel) {
        const dimLabelNorm = normalizeForMatch(dim.label);
        const dimKeyNorm = normalizeForMatch(dim.key);
        for (const [candidateKey, candidateValue] of Object.entries(normalizedSelections)) {
          if (!candidateValue) continue;
          if (candidateKey === dimLabelNorm || candidateKey === dimKeyNorm) {
            selectedLabel = candidateValue;
            break;
          }
        }
      }

      // Default to first value when unresolved
      if (!selectedLabel && dim.values && dim.values.length > 0) {
        selectedLabel = dim.values[0].label;
      }

      if (!selectedKey) {
        selectedKey = resolveDimensionValueKey(dim, selectedLabel);
      }

      selectionKeys[dim.key] = selectedKey;
    }

    return {
      selectionKeys,
      cleanedSelections,
      normalizedSelections
    };
  }

  function calculatePriceFromVariants(selections, pricingDataOverride = null, optionSetDataOverride = null, containerOverride = null) {
    const pricingData = normalizePricingPayload(pricingDataOverride) || getNormalizedPricingPayload();
    if (!pricingData || !pricingData.pricingVariants?.length) {
      console.warn('⚠️ No pricing variants available');
      return null;
    }
    const optionSetDataForPricing = optionSetDataOverride || resolveActiveOptionSetData(null);

    const { pricingDimensions, pricingVariants, basePrice } = pricingData;

    const {
      selectionKeys,
      cleanedSelections,
      normalizedSelections
    } = buildVariantSelectionKeys(selections, pricingData, optionSetDataForPricing, containerOverride);

    debugLog('ðŸ” Pricing lookup - Cleaned selections:', cleanedSelections);
    debugLog('ðŸ” Pricing lookup - Available dimensions:', pricingDimensions?.map(d => d.label));

    if (WIDGET_DEBUG_LOGGING) {
      (pricingDimensions || []).forEach((dim) => {
        debugLog(`ðŸ” Dimension "${dim.label}": key="${selectionKeys[dim.key]}"`);
      });
    }

    // Find matching variant using shared matcher (same logic as quantity list)
    const matchingVariant = findMatchingVariantBySelectionKeys(pricingDimensions, pricingVariants, selectionKeys);

    // Helper: Get design service fee from selected design method
    function getDesignFeeFromSelections() {
      // Get optionSetData to find design-method fields
      if (!optionSetDataForPricing?.fields) return 0;

      // Find design-method field
      const designMethodField = optionSetDataForPricing.fields.find(f => f.type === 'design-method');
      if (!designMethodField || !designMethodField.designMethods) return 0;

      // Find the selected design method value from selections
      const fieldLabel = designMethodField.label || 'Design Method';
      const selectedValue = cleanedSelections[fieldLabel] || normalizedSelections[normalizeForMatch(fieldLabel)];

      if (!selectedValue) {
        // Default to first method if none selected
        const firstMethod = designMethodField.designMethods[0];
        const defaultFee = getConfiguredPriceValue(firstMethod);
        if (defaultFee <= 0) return 0;
        if (getConfiguredPriceMode(firstMethod) === 'per_unit') {
          const quantityField = optionSetDataForPricing.fields.find(f => f.type === 'quantity-list' || f.type === 'quantity-slider');
          const quantityLabel = quantityField?.label || 'Quantity';
          const qtyRaw =
            cleanedSelections[quantityLabel] ||
            normalizedSelections[normalizeForMatch(quantityLabel)] ||
            cleanedSelections.Quantity ||
            normalizedSelections.quantity;
          const qty = Math.max(1, parseInt(qtyRaw, 10) || 1);
          return defaultFee * qty;
        }
        return defaultFee;
      }

      // Find the matching design method and get its price
      const selectedValueNormalized = String(selectedValue).toLowerCase();
      const selectedMethod = designMethodField.designMethods.find(m =>
        m.name === selectedValue ||
        m.id === selectedValue ||
        m.name?.toLowerCase().includes(selectedValueNormalized) ||
        selectedValueNormalized.includes(m.name?.toLowerCase())
      );

      const fee = getConfiguredPriceValue(selectedMethod);
      if (fee <= 0) return 0;
      if (getConfiguredPriceMode(selectedMethod) === 'per_unit') {
        const quantityField = optionSetDataForPricing.fields.find(f => f.type === 'quantity-list' || f.type === 'quantity-slider');
        const quantityLabel = quantityField?.label || 'Quantity';
        const qtyRaw =
          cleanedSelections[quantityLabel] ||
          normalizedSelections[normalizeForMatch(quantityLabel)] ||
          cleanedSelections.Quantity ||
          normalizedSelections.quantity;
        const qty = Math.max(1, parseInt(qtyRaw, 10) || 1);
        return fee * qty;
      }
      if (fee > 0) {
        debugLog(`ðŸŽ¨ Design service fee from "${selectedMethod?.name}": $${fee.toFixed(2)}`);
      }
      return fee;
    }

    // Calculate design fee to add to variant price
    const designFee = getDesignFeeFromSelections();

    if (matchingVariant) {
      const variantPrice = safeNumber(matchingVariant.finalPrice, safeNumber(basePrice, 0));
      const finalPrice = variantPrice + designFee;
      debugLog('ðŸ’° Price from variant:', matchingVariant.sku, '$' + variantPrice.toFixed(2));
      if (designFee > 0) {
        debugLog('ðŸ’° + Design fee: $' + designFee.toFixed(2) + ' = Total: $' + finalPrice.toFixed(2));
      }
      return finalPrice;
    }

    // Safety: returning null lets callers use legacy/dynamic fallback;
    // this avoids silently using the wrong first variant price.
    console.warn('⚠️ No exact variant match for current selections; returning null for fallback pricing path.');
    return null;
  }

  // ✅ FIX 3: REAL-TIME PRICE SYNC (now with metafield support)
  async function syncPriceWithShopify(variantId, optionSelections) {
    try {
      const activeOptionSetData = resolveActiveOptionSetData(null);
      const ensuredPricingData = ensurePricingPayload(activeOptionSetData, {
        source: 'sync_price',
        productId: getCurrentProductId()
      });
      const productHandle = window.location.pathname.split('/products/')[1]?.split('/')[0];
      if (!productHandle) {
        console.warn('Could not determine product handle for price sync');
        return calculateTotalPrice(optionSelections, activeOptionSetData, 0);
      }

      // Try to use pricing from metafield first (zero-latency)
      if (ensuredPricingData && ensuredPricingData.pricingVariants?.length) {
        const price = calculatePriceFromVariants(optionSelections, ensuredPricingData, activeOptionSetData);
        if (price !== null) {
          try {
            window.__vici_debug = window.__vici_debug || {};
            window.__vici_debug.last_price_resolution = {
              source: 'option_set_pricing_variants',
              price,
              variants: ensuredPricingData.pricingVariants?.length || 0,
              ts: new Date().toISOString()
            };
          } catch (e) {
            // Non-blocking debug capture
          }
          debugLog('âš¡ Using zero-latency pricing from metafield: $' + price.toFixed(2));
          updatePriceDisplay(price);
          return price;
        }
      }

      // Fallback to legacy calculation
      debugLog('⚠️ Falling back to legacy price calculation');
      const response = await fetch(`/products/${productHandle}.json`);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const productData = await response.json();
      const variant = productData.product.variants.find(v => v.id == variantId);
      const optionSetBasePrice = safeNumber(
        activeOptionSetData?.basePrice !== undefined ? activeOptionSetData.basePrice : activeOptionSetData?.base_price,
        0
      );

      if (!variant) {
        console.warn('Variant not found for price sync');
        return calculateTotalPrice(optionSelections, activeOptionSetData, optionSetBasePrice);
      }

      const shopifyPrice = safeNumber(variant.price, 0);
      const fallbackBasePrice = shopifyPrice > 0 ? shopifyPrice : optionSetBasePrice;
      const calculatedPrice = calculateTotalPrice(optionSelections, activeOptionSetData, fallbackBasePrice);
      try {
        window.__vici_debug = window.__vici_debug || {};
        window.__vici_debug.last_price_resolution = {
          source: 'legacy_fallback',
          shopifyPrice,
          optionSetBasePrice,
          fallbackBasePrice,
          calculatedPrice,
          ts: new Date().toISOString()
        };
      } catch (e) {
        // Non-blocking debug capture
      }

      updatePriceDisplay(calculatedPrice);
      return calculatedPrice;

    } catch (error) {
      console.error('Price sync failed:', error);
      return calculateTotalPrice(optionSelections, resolveActiveOptionSetData(null), 0);
    }
  }

  function updatePriceDisplay(price) {
    const priceElements = document.querySelectorAll('.price, .product-price, .current-price, .money');
    const formattedPrice = `$${price.toFixed(2)}`;
    
    priceElements.forEach(element => {
      if (element.closest('.option-widget-container')) {
        element.textContent = formattedPrice;
      }
    });

    // Trigger custom event for external integrations
    window.dispatchEvent(new CustomEvent('optionPriceUpdated', {
      detail: { price, formattedPrice }
    }));
  }

  // ✅ FIX 4: SESSION PERSISTENCE
  function generateSessionId() {
    return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  function generateTelemetryId(prefix) {
    return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
  }

  function generateWidgetSessionId() {
    return generateTelemetryId('widget');
  }

  function generateCartAttemptId() {
    return generateTelemetryId('cart');
  }

  function saveSelectionsToSession(selections) {
    const productId = getCurrentProductId();
    const sessionKey = `option_selections_${productId}`;
    
    try {
      const sessionData = {
        selections,
        timestamp: Date.now(),
        productId,
        variantId: getCurrentVariantId(),
        sessionId: sessionId
      };
      
      sessionStorage.setItem(sessionKey, JSON.stringify(sessionData));
      debugLog('Selections saved to session:', sessionKey);
    } catch (error) {
      console.warn('Failed to save selections to session:', error);
    }
  }

  function loadSelectionsFromSession() {
    const productId = getCurrentProductId();
    const sessionKey = `option_selections_${productId}`;
    
    try {
      const saved = sessionStorage.getItem(sessionKey);
      if (!saved) return null;
      
      const data = JSON.parse(saved);
      const fiveMinutesAgo = Date.now() - (5 * 60 * 1000);
      
      if (data.timestamp < fiveMinutesAgo) {
        sessionStorage.removeItem(sessionKey);
        return null;
      }
      
      debugLog('Selections loaded from session:', sessionKey);
      return data.selections;
    } catch (error) {
      console.warn('Failed to load selections from session:', error);
      return null;
    }
  }

  function getCurrentProductId() {
    // Try multiple methods to get product ID
    const productMeta = document.querySelector('meta[name="product-id"]');
    if (productMeta) return productMeta.getAttribute('content');
    
    const productScript = document.querySelector('script[data-product-id]');
    if (productScript) return productScript.getAttribute('data-product-id');
    
    // Extract from URL path
    const pathMatch = window.location.pathname.match(/\/products\/(.+)/);
    if (pathMatch) return pathMatch[1];
    
    return 'unknown';
  }

  function getUrlVariantId() {
    try {
      const params = new URLSearchParams(window.location.search || '');
      const variant = params.get('variant');
      return variant ? String(variant) : null;
    } catch (error) {
      return null;
    }
  }

  function getCurrentProductVariantIdSet(container) {
    const variantIds = new Set();
    const containerEl =
      container ||
      document.querySelector('#custom-options-widget-container, #custom-options-widget-container-2, .option-widget-container');
    const scopedProductId =
      containerEl?.dataset?.productId || containerEl?.getAttribute?.('data-product-id') || null;
    const scopedProductHandle =
      containerEl?.dataset?.productHandle || containerEl?.getAttribute?.('data-product-handle') || null;

    function collectVariantsFromProduct(product) {
      if (!product || !Array.isArray(product.variants)) return;
      product.variants.forEach((variant) => {
        if (variant && variant.id !== undefined && variant.id !== null) {
          variantIds.add(String(variant.id));
        }
      });
    }

    function productMatchesScope(product) {
      if (!product) return false;
      if (!scopedProductId && !scopedProductHandle) return true;

      const productId = product.id !== undefined && product.id !== null ? String(product.id) : null;
      const productHandle = product.handle ? String(product.handle) : null;

      if (scopedProductId && productId && scopedProductId === productId) return true;
      if (scopedProductHandle && productHandle && scopedProductHandle === productHandle) return true;
      return false;
    }

    const productRoot =
      (containerEl && typeof containerEl.closest === 'function'
        ? (containerEl.closest('[data-section-type="product"]') ||
           containerEl.closest('[data-product-id]') ||
           containerEl.closest('[data-product-handle]') ||
           containerEl.closest('.product-single') ||
           containerEl.closest('.product'))
        : null) ||
      containerEl ||
      null;

    // Primary source: variants from the scoped product form/root.
    if (productRoot?.querySelectorAll) {
      const scopedVariantInputs = productRoot.querySelectorAll(
        'form[action*="/cart/add"] select[name="id"], ' +
        'form[action*="/cart/add"] input[name="id"]:checked, ' +
        'form[action*="/cart/add"] input[name="id"][type="hidden"], ' +
        'select[name="id"], input[name="id"]:checked, input[name="id"][type="hidden"]'
      );
      scopedVariantInputs.forEach((input) => {
        if (input?.value) {
          variantIds.add(String(input.value));
        }
      });
    }

    function collectVariantsFromJsonScripts(scopeNode) {
      if (!scopeNode?.querySelectorAll) return;
      const scripts = scopeNode.querySelectorAll('script[type="application/json"]');
      for (const scriptEl of scripts) {
        const text = scriptEl?.textContent?.trim();
        if (!text || text.length < 20 || text.length > 200000) continue;
        try {
          const parsed = JSON.parse(text);
          const productPayload = parsed?.product || parsed;
          if (productPayload && Array.isArray(productPayload.variants) && productMatchesScope(productPayload)) {
            collectVariantsFromProduct(productPayload);
          }
        } catch (error) {
          // Ignore non-product JSON scripts.
        }
      }
    }

    // Secondary source: scoped JSON payloads in the product root.
    collectVariantsFromJsonScripts(productRoot);

    if (typeof meta !== 'undefined' && meta?.product && productMatchesScope(meta.product)) {
      collectVariantsFromProduct(meta.product);
    }
    if (window.product && productMatchesScope(window.product)) {
      collectVariantsFromProduct(window.product);
    }
    if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics?.meta?.product && productMatchesScope(ShopifyAnalytics.meta.product)) {
      collectVariantsFromProduct(ShopifyAnalytics.meta.product);
    }

    // Unscoped fallback only when no scoped product identity is available.
    if (variantIds.size === 0 && !scopedProductId && !scopedProductHandle) {
      collectVariantsFromJsonScripts(document);
    }

    return variantIds;
  }

  function isVariantIdAllowed(variantId, allowedVariantIds) {
    if (!variantId) return false;
    if (!allowedVariantIds || allowedVariantIds.size === 0) return true;
    return allowedVariantIds.has(String(variantId));
  }

  function pickAllowedVariantId(variantId, allowedVariantIds) {
    return isVariantIdAllowed(variantId, allowedVariantIds) ? String(variantId) : null;
  }

  function getCurrentVariantId(container) {
    const containerEl =
      container ||
      document.querySelector('#custom-options-widget-container, #custom-options-widget-container-2, .option-widget-container');
    const allowedVariantIds = getCurrentProductVariantIdSet(containerEl);
    const productIdAttr = containerEl && (containerEl.dataset?.productId || containerEl.getAttribute('data-product-id'));
    const productHandleAttr = containerEl && (containerEl.dataset?.productHandle || containerEl.getAttribute('data-product-handle'));
    const isScopedContainer = Boolean(containerEl && (productIdAttr || productHandleAttr));

    // 1) Resolve product root from container scope FIRST
    let productRoot = document;
    if (containerEl && typeof containerEl.closest === 'function') {
      productRoot =
        containerEl.closest('[data-section-type="product"]') ||
        containerEl.closest('[data-product-id]') ||
        containerEl.closest('[data-product-handle]') ||
        containerEl.closest('.product-single') ||
        containerEl.closest('.product') ||
        document;
    }

    // 2) If we have a product id/handle on the container, try to scope to that root explicitly
    if (productRoot === document && (productIdAttr || productHandleAttr)) {
      const explicitRoot =
        (productIdAttr && document.querySelector(`[data-product-id="${productIdAttr}"]`)) ||
        (productHandleAttr && document.querySelector(`[data-product-handle="${productHandleAttr}"]`));
      if (explicitRoot) productRoot = explicitRoot;
    }

    // 3) PRIORITY: Check theme's product form variant selector (excludes widget's own form)
    // This ensures we get the customer-selected variant, not a stale default
    const themeFormVariant = productRoot.querySelector(
      'form[action*="/cart/add"]:not(.option-widget-form) select[name="id"], ' +
      'form[action*="/cart/add"]:not(.option-widget-form) input[name="id"]:checked, ' +
      'form[action*="/cart/add"]:not(.option-widget-form) input[name="id"][type="hidden"]'
    );
    if (themeFormVariant && themeFormVariant.value) {
      const chosen = pickAllowedVariantId(themeFormVariant.value, allowedVariantIds);
      if (chosen) return chosen;
    }

    // 4) Check any variant selector within product root (excluding widget form)
    const rootVariant = productRoot.querySelector(
      ':not(.option-widget-form) > select[name="id"], ' +
      ':not(.option-widget-form) > input[name="id"]:checked, ' +
      ':not(.option-widget-form) > input[name="id"][type="hidden"]'
    );
    if (rootVariant && rootVariant.value) {
      const chosen = pickAllowedVariantId(rootVariant.value, allowedVariantIds);
      if (chosen) return chosen;
    }

    // 5) Fallback: Explicit variant id on the widget container (static default)
    const explicitVariantId =
      (containerEl && (containerEl.dataset?.variantId || containerEl.getAttribute('data-variant-id'))) ||
      null;
    if (explicitVariantId) {
      const chosen = pickAllowedVariantId(explicitVariantId, allowedVariantIds);
      if (chosen) return chosen;
    }

    // 6) If the widget is inside a form, use that form's variant input as last resort
    const containerForm = containerEl && typeof containerEl.closest === 'function'
      ? containerEl.closest('form')
      : null;
    if (containerForm) {
      const formVariant = containerForm.querySelector(
        'select[name="id"], input[name="id"]:checked, input[name="id"][type="hidden"]'
      );
      if (formVariant && formVariant.value) {
        const chosen = pickAllowedVariantId(formVariant.value, allowedVariantIds);
        if (chosen) return chosen;
      }
    }

    // 7) Legacy: any variant selector in product root (for themes without /cart/add action)
    let variantSelect = productRoot.querySelector('select[name="id"], input[name="id"]:checked, input[name="id"][type="hidden"]');
    if (variantSelect && variantSelect.value) {
      const chosen = pickAllowedVariantId(variantSelect.value, allowedVariantIds);
      if (chosen) return chosen;
    }

    const urlVariantId = getUrlVariantId();
    if (urlVariantId && /\/products\//.test(window.location.pathname || '')) {
      const chosen = pickAllowedVariantId(urlVariantId, allowedVariantIds);
      if (chosen) return chosen;
    }

    // Scoped mode safety: do not leak to document-global fallbacks.
    if (isScopedContainer) {
      console.warn('Custom Option Widget - Unable to resolve scoped variant ID safely for product container.');
      return null;
    }

    // Safe fallback: only use a global selector if there is exactly one candidate
    const globalCandidates = Array.from(
      document.querySelectorAll('select[name="id"], input[name="id"]:checked, input[name="id"][type="hidden"]')
    ).filter(el => el && el.value);
    const allowedGlobalValues = globalCandidates
      .map(el => String(el.value))
      .filter(value => isVariantIdAllowed(value, allowedVariantIds));
    if (allowedGlobalValues.length === 1) {
      return allowedGlobalValues[0];
    }
    if (globalCandidates.length === 1) {
      const chosen = pickAllowedVariantId(globalCandidates[0].value, allowedVariantIds);
      if (chosen) return chosen;
    }

    const variantMeta = document.querySelector('meta[name="variant-id"]');
    if (variantMeta && globalCandidates.length === 0) {
      const chosen = pickAllowedVariantId(variantMeta.getAttribute('content'), allowedVariantIds);
      if (chosen) return chosen;
    }

    if (
      currentVariantId &&
      globalCandidates.some(el => el.value == currentVariantId) &&
      isVariantIdAllowed(currentVariantId, allowedVariantIds)
    ) {
      return String(currentVariantId);
    }

    // Try Shopify's global product JSON if available
    if (typeof meta !== 'undefined' && meta.product && meta.product.variants && meta.product.variants.length > 0) {
      const firstAvailable = meta.product.variants.find(v => v.available);
      if (firstAvailable) {
        const chosen = pickAllowedVariantId(firstAvailable.id, allowedVariantIds);
        if (chosen) return chosen;
      }
      const fallback = pickAllowedVariantId(meta.product.variants[0].id, allowedVariantIds);
      if (fallback) return fallback;
    }

    // Try window.product object (common in many themes)
    if (typeof window.product !== 'undefined' && window.product.variants && window.product.variants.length > 0) {
      const firstAvailable = window.product.variants.find(v => v.available);
      if (firstAvailable) {
        const chosen = pickAllowedVariantId(firstAvailable.id, allowedVariantIds);
        if (chosen) return chosen;
      }
      const fallback = pickAllowedVariantId(window.product.variants[0].id, allowedVariantIds);
      if (fallback) return fallback;
    }

    if (allowedVariantIds.size === 1) {
      return Array.from(allowedVariantIds)[0];
    }

    console.warn('Custom Option Widget - Unable to resolve variant ID safely (multiple candidates found).');
    return null;
  }

  // ✅ FIX 5: VARIANT INTEGRATION
  function initializeVariantWatcher() {
    currentVariantId = getCurrentVariantId();
    
    // Watch for variant changes via select elements
    const variantSelects = document.querySelectorAll('select[name="id"], input[name="id"]');
    
    variantSelects.forEach(element => {
      element.addEventListener('change', function() {
        const newVariantId = this.value;
        handleVariantChange(newVariantId);
      });
    });
    
    // Watch for variant changes via radio buttons
    const variantRadios = document.querySelectorAll('input[name="id"][type="radio"]');
    variantRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        if (this.checked) {
          handleVariantChange(this.value);
        }
      });
    });
    
    // Watch for URL changes (for variant switching via URL)
    if (window.history && window.history.pushState) {
      const originalPushState = window.history.pushState;
      window.history.pushState = function() {
        originalPushState.apply(window.history, arguments);
        setTimeout(checkForVariantChange, 100);
      };
    }

    debugLog('Variant watcher initialized. Current variant:', currentVariantId);
  }

  function handleVariantChange(newVariantId) {
    debugLog('Variant changed from', currentVariantId, 'to', newVariantId);
    currentVariantId = newVariantId;
    clearSoldOutState();
    
    // Sync widget's static values with new variant to keep them fresh
    syncWidgetVariantValues(newVariantId);
    
    // Recalculate pricing with new variant
    const currentSelections = getCurrentSelections();
    syncPriceWithShopify(newVariantId, currentSelections);
    
    // Save new variant selection
    saveSelectionsToSession(currentSelections);
    
    // Update option availability based on new variant
    updateOptionAvailability(newVariantId);
    
    // Trigger analytics
    trackOptionInteraction('variant_changed', 'variant_selector', newVariantId);
  }

  function syncWidgetVariantValues(variantId) {
    // Update all widget containers' data-variant-id attribute
    const containers = document.querySelectorAll(
      '#custom-options-widget-container, #custom-options-widget-container-2, .option-widget-container'
    );
    containers.forEach(container => {
      container.setAttribute('data-variant-id', variantId);
      container.dataset.variantId = variantId;
    });

    // Update all widget form hidden variant inputs
    const widgetVariantInputs = document.querySelectorAll(
      '.option-widget-form input[name="id"][type="hidden"], ' +
      'input[id^="option-widget-variant-id-"]'
    );
    widgetVariantInputs.forEach(input => {
      input.value = variantId;
    });

    debugLog('Widget variant values synced to:', variantId);
  }

  function checkForVariantChange() {
    const newVariantId = getCurrentVariantId();
    if (newVariantId && newVariantId !== currentVariantId) {
      handleVariantChange(newVariantId);
    }
  }

  function getCurrentSelections() {
    const selections = {};
    const widgets = document.querySelectorAll('.option-widget-container');
    
    widgets.forEach(widget => {
      const inputs = widget.querySelectorAll('input, select, textarea');
      inputs.forEach(input => {
        if (input.name && input.value && !input.name.startsWith('properties[')) {
          selections[input.name] = input.type === 'checkbox' ? input.checked : input.value;
        }
      });
    });
    
    return selections;
  }

  function updateOptionAvailability(variantId) {
    // This can be customized based on variant-specific option availability
    debugLog('Updating option availability for variant:', variantId);
    
    // Example: Disable certain options for specific variants
    const optionFields = document.querySelectorAll('.option-widget-field');
    optionFields.forEach(field => {
      const fieldId = field.getAttribute('data-field-id');
      // Add custom logic here to enable/disable options based on variant
    });
  }

  // ✅ FIX 6: MOBILE OPTIMIZATION
  function optimizeForMobile() {
    if ('ontouchstart' in window) {
      document.documentElement.classList.add('touch-device');
      
      // Optimize dropdowns for mobile
      const dropdowns = document.querySelectorAll('.option-widget-dropdown, .custom-dropdown-trigger');
      dropdowns.forEach(dropdown => {
        dropdown.style.minHeight = '44px'; // iOS minimum tap target
        dropdown.style.fontSize = '16px'; // Prevent zoom on iOS
      });
      
      // Optimize input fields for mobile
      const inputs = document.querySelectorAll('.option-widget-input');
      inputs.forEach(input => {
        input.style.fontSize = '16px'; // Prevent zoom on iOS
        input.setAttribute('autocomplete', 'off');
        input.setAttribute('autocorrect', 'off');
        input.setAttribute('autocapitalize', 'off');
      });
      
      // Add mobile-specific CSS
      const mobileStyles = document.createElement('style');
      mobileStyles.innerHTML = `
        .touch-device .option-widget-container {
          -webkit-tap-highlight-color: transparent;
          touch-action: manipulation;
        }
        
        .touch-device .option-widget-field {
          margin-bottom: 20px;
        }
        
        .touch-device .custom-dropdown-trigger,
        .touch-device .option-widget-input {
          padding: 12px 16px;
          border-radius: 8px;
          border: 2px solid #e5e5e5;
          transition: border-color 0.2s ease;
        }
        
        .touch-device .custom-dropdown-trigger:active,
        .touch-device .option-widget-input:focus {
          border-color: #007aff;
          outline: none;
        }
        
        @media (max-width: 768px) {
          .option-widget-container {
            padding: 16px;
            margin: 0;
          }
          
          .custom-dropdown-menu {
            max-height: 200px;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
          }
        }
      `;
      document.head.appendChild(mobileStyles);
      
      debugLog('Mobile optimizations applied');
    }
  }

  function isSoldOutMessage(message) {
    return /sold out|out of stock/i.test(String(message || ''));
  }

  function extractCartErrorMessage(response, errorText) {
    let parsed = null;
    if (errorText) {
      try {
        parsed = JSON.parse(errorText);
      } catch (e) {
        // Ignore parsing errors; fall back to raw text
      }
    }
    const message =
      (parsed && (parsed.message || parsed.description)) ||
      errorText ||
      (response && response.statusText) ||
      'Unable to add to cart.';
    return typeof message === 'string' ? message : JSON.stringify(message);
  }

  /**
   * Get the first available variant ID for the current product from Shopify's product JSON
   * This is the most reliable source - always belongs to the current product
   */
  function getFirstAvailableVariantId() {
    // Try meta.product (common in many themes)
    if (typeof meta !== 'undefined' && meta.product && meta.product.variants && meta.product.variants.length > 0) {
      const available = meta.product.variants.find(v => v.available);
      return String(available ? available.id : meta.product.variants[0].id);
    }
    // Try window.product (also common)
    if (typeof window.product !== 'undefined' && window.product.variants && window.product.variants.length > 0) {
      const available = window.product.variants.find(v => v.available);
      return String(available ? available.id : window.product.variants[0].id);
    }
    // Try ShopifyAnalytics.meta.product
    if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product &&
        ShopifyAnalytics.meta.product.variants && ShopifyAnalytics.meta.product.variants.length > 0) {
      const available = ShopifyAnalytics.meta.product.variants.find(v => v.available);
      return String(available ? available.id : ShopifyAnalytics.meta.product.variants[0].id);
    }
    return null;
  }

  function buildCartError(response, errorText) {
    const status = response && response.status ? response.status : '';
    const statusText = response && response.statusText ? response.statusText : '';
    const error = new Error(`Cart add failed: ${status} ${statusText} - ${errorText || ''}`.trim());
    error.status = response && response.status ? response.status : undefined;
    error.userMessage = extractCartErrorMessage(response, errorText);
    if (response && response.status >= 400 && response.status < 500) {
      error.nonRetryable = true;
    }
    return error;
  }

  function setSoldOutState(container, message) {
    const root = (container && typeof container.closest === 'function') ?
      (container.closest('[data-section-type="product"]') ||
       container.closest('[data-product-id]') ||
       container.closest('.product-single') ||
       container.closest('.product') ||
       document) :
      document;

    const buttons = new Set();
    if (container) {
      container.querySelectorAll('.start-making-button').forEach(btn => buttons.add(btn));
    }
    root.querySelectorAll('.add-to-cart-button, [name="add"], .btn-cart').forEach(btn => buttons.add(btn));

    buttons.forEach(button => {
      if (!button || !button.dataset) return;
      if (!button.dataset.soldOutOriginalText) {
        button.dataset.soldOutOriginalText = button.textContent || '';
        button.dataset.soldOutDisabled = button.disabled ? 'true' : 'false';
      }
      button.textContent = 'Sold Out';
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('sold-out');
    });

    if (container) {
      const wrapper = container.querySelector('.start-making-wrapper') || container;
      if (wrapper && !wrapper.querySelector('.sold-out-message')) {
        const msg = document.createElement('div');
        msg.className = 'sold-out-message';
        msg.style.cssText = 'margin-top: 10px; color: #b91c1c; font-size: 14px; font-weight: 500;';
        msg.textContent = (typeof message === 'string' && message.trim()) ?
          message.trim() :
          'This item is currently sold out.';
        wrapper.appendChild(msg);
      }
    }
  }

  function clearSoldOutState(container) {
    const root = (container && typeof container.closest === 'function') ?
      (container.closest('[data-section-type="product"]') ||
       container.closest('[data-product-id]') ||
       container.closest('.product-single') ||
       container.closest('.product') ||
       document) :
      document;

    const buttons = root.querySelectorAll('[data-sold-out-original-text]');
    buttons.forEach(button => {
      const originalText = button.dataset.soldOutOriginalText;
      const wasDisabled = button.dataset.soldOutDisabled === 'true';
      if (typeof originalText === 'string') {
        button.textContent = originalText;
      }
      button.disabled = wasDisabled;
      if (!wasDisabled) {
        button.removeAttribute('aria-disabled');
      }
      button.classList.remove('sold-out');
      delete button.dataset.soldOutOriginalText;
      delete button.dataset.soldOutDisabled;
    });

    const scope = container || root;
    scope.querySelectorAll('.sold-out-message').forEach(node => node.remove());
  }

  // ✅ FIX 6b: TRIGGER SHOPIFY THEME CART DRAWER/NOTIFICATION
  function triggerShopifyCartUpdate(cartAddResult) {
    try {
      // 1. Standard Shopify Section Rendering API (Dawn and modern themes)
      //    Fetch the cart-drawer / cart-notification section and inject it
      const sectionIds = ['cart-drawer', 'cart-notification', 'cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
      fetch(`${window.Shopify?.routes?.root || '/'}?sections=${sectionIds.join(',')}`)
        .then(r => r.ok ? r.json() : null)
        .then(sections => {
          if (!sections) return;
          Object.entries(sections).forEach(([id, html]) => {
            const existing = document.getElementById(`shopify-section-${id}`);
            if (existing && html) {
              existing.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector(`#shopify-section-${id}`)?.innerHTML || html;
            }
          });
          // Open the cart drawer if it exists (Dawn theme pattern)
          const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('#cart-drawer');
          if (cartDrawer) {
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else if (cartDrawer.classList) {
              cartDrawer.classList.add('active', 'is-open');
              cartDrawer.removeAttribute('hidden');
            }
          }
          // Cart notification (Dawn alternative)
          const cartNotification = document.querySelector('cart-notification') || document.querySelector('#cart-notification');
          if (cartNotification) {
            if (typeof cartNotification.open === 'function') {
              cartNotification.open();
            } else if (cartNotification.classList) {
              cartNotification.classList.add('active', 'is-open');
              cartNotification.removeAttribute('hidden');
            }
          }
        })
        .catch(() => {}); // Non-blocking

      // 2. Dispatch standard events that many themes listen for
      document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: { items: cartAddResult } }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: cartAddResult }));
      
      // 3. jQuery trigger for legacy themes (Debut, Brooklyn, etc.)
      if (window.jQuery) {
        window.jQuery(document).trigger('ajaxCart.afterCartLoad');
        window.jQuery(document.body).trigger('added.ajaxCart');
      }

      // 4. Shopify's own event bus (if available)
      if (window.Shopify && window.Shopify.onCartUpdate) {
        fetch('/cart.js').then(r => r.json()).then(cart => {
          window.Shopify.onCartUpdate(cart);
        }).catch(() => {});
      }

      // 5. Update cart count badge immediately
      fetch('/cart.js').then(r => r.ok ? r.json() : null).then(cart => {
        if (!cart) return;
        const countElements = document.querySelectorAll(
          '.cart-count, .cart-count-bubble, #cart-icon-bubble span, .js-cart-count, [data-cart-count], .header__cart-count'
        );
        countElements.forEach(el => { el.textContent = cart.item_count; });
        // Also look for cart count inside bubble spans
        const bubbles = document.querySelectorAll('cart-icon-bubble span, .cart-icon-bubble span');
        bubbles.forEach(el => { el.textContent = cart.item_count; });
      }).catch(() => {});

      debugLog('ðŸ›’ Shopify cart update events dispatched');
    } catch (error) {
      console.warn('triggerShopifyCartUpdate error (non-blocking):', error);
    }
  }

  // ✅ FIX 7: ENHANCED CART INTEGRATION
  async function addToCartWithValidationLegacy(productId, variantId, quantity, properties, container) {
    const cartAttemptId = PHASE0_WIDGET_TELEMETRY_ENABLED ? generateCartAttemptId() : null;
    const cartTelemetryMetadata = PHASE0_WIDGET_TELEMETRY_ENABLED
      ? {
          widget_session_id: widgetSessionId,
          cart_attempt_id: cartAttemptId,
          widget_runtime_mode: OPTION_WIDGET_RUNTIME_MODE
        }
      : {};

    try {
      // Debug capture: store last payload for quick inspection
      try {
        window.__vici_debug = window.__vici_debug || {};
        window.__vici_debug.last_payload = {
          productId,
          variantId: variantId || null,
          quantity: quantity || 1,
          properties: properties || {},
          ts: new Date().toISOString()
        };
      } catch (e) {
        console.warn('Vici debug payload capture failed:', e);
      }

      // Clear any previous sold-out state when user tries again
      clearSoldOutState(container);

      // Validate before adding to cart
      const activeOptionSetData = resolveActiveOptionSetData(container);
      const validation = validateAllFields(activeOptionSetData, properties);
      if (!validation.isValid) {
        showValidationErrors(validation.errors);
        return { success: false, errors: validation.errors };
      }

      // Show loading state
      showLoadingState();

      // Add to cart with retry logic
      // PRIORITY: keep variant scoped to the current product only.
      const allowedVariantIds = getCurrentProductVariantIdSet(container);
      let resolvedVariantId = null;
      let resolvedVariantSource = 'none';

      const explicitVariantCandidate = pickAllowedVariantId(variantId, allowedVariantIds);
      if (explicitVariantCandidate) {
        resolvedVariantId = explicitVariantCandidate;
        resolvedVariantSource = 'explicit';
      }

      if (!resolvedVariantId) {
        const activeVariantCandidate = pickAllowedVariantId(getCurrentVariantId(container), allowedVariantIds);
        if (activeVariantCandidate) {
          resolvedVariantId = activeVariantCandidate;
          resolvedVariantSource = 'active_selection';
        }
      }

      if (!resolvedVariantId) {
        const fallbackFromProductJson = pickAllowedVariantId(getFirstAvailableVariantId(), allowedVariantIds);
        if (fallbackFromProductJson) {
          resolvedVariantId = fallbackFromProductJson;
          resolvedVariantSource = 'product_json_fallback';
        }
      }

      if (!resolvedVariantId && allowedVariantIds.size > 0) {
        resolvedVariantId = Array.from(allowedVariantIds)[0];
        resolvedVariantSource = 'allowed_set_fallback';
      }

      if (!resolvedVariantId) {
        throw new Error('No variant ID resolved for this product');
      }

      debugLog('ðŸ›’ Resolved variant for cart add:', {
        resolvedVariantId,
        resolvedVariantSource,
        explicitVariantId: variantId || null,
        allowedVariantCount: allowedVariantIds.size
      });

      // Final payload guard: never send zero custom pricing when option-set pricing is available.
      const existingViciPrice = safeNumber(
        properties?._vici_calculated_price,
        0
      );
      if (!(existingViciPrice > 0)) {
        try {
          const guardedPricingData = ensurePricingPayload(activeOptionSetData, {
            source: 'cart_payload_guard',
            productId,
            containerId: container?.id || null
          });
          const recomputedTotal = safeNumber(
            calculatePriceFromVariants(properties || {}, guardedPricingData, activeOptionSetData),
            0
          );
          const designFee = safeNumber(properties?._vici_design_service, 0);
          const recomputedViciPrice = recomputedTotal;

          if (recomputedViciPrice > 0) {
            const recomputedViciPriceString = recomputedViciPrice.toFixed(2);
            properties._vici_calculated_price = recomputedViciPriceString;
          }
          if (!(safeNumber(properties?._total_price, 0) > 0) && recomputedTotal > 0) {
            properties._total_price = recomputedTotal.toFixed(2);
          }
          if (!(safeNumber(properties?._unit_price, 0) > 0) && recomputedTotal > 0) {
            const qtyFromProperties = Math.max(
              1,
              parseInt(properties?.Quantity || properties?.quantity || quantity || 1, 10) || 1
            );
            properties._unit_price = (recomputedTotal / qtyFromProperties).toFixed(2);
          }

          try {
            window.__vici_debug = window.__vici_debug || {};
            window.__vici_debug.last_price_resolution = {
              source: 'cart_payload_guard',
              existingViciPrice,
              recomputedTotal,
              recomputedViciPrice,
              designFee,
              finalViciPrice: properties?._vici_calculated_price || null,
              finalTotalPrice: properties?._total_price || null,
              finalUnitPrice: properties?._unit_price || null,
              ts: new Date().toISOString()
            };
          } catch (e) {
            // Non-blocking debug capture
          }
        } catch (pricingGuardError) {
          console.warn('Pricing guard failed (continuing with existing payload):', pricingGuardError);
        }
      }

      // Hard guard: never submit cart payload with missing/zero custom price.
      let finalViciPrice = safeNumber(
        properties?._vici_calculated_price,
        0
      );
      if (!(finalViciPrice > 0)) {
        console.error('Cart guard blocked zero/invalid custom price.');

        const trustedTotalNode = (container || document).querySelector(
          '.price-row .value, [id^="summary-total-"], .price-display-below .price-text'
        );
        const rescuedTotal = safeNumber(
          parseFloat(String(trustedTotalNode?.textContent || '').replace(/[^0-9.]/g, '')),
          0
        );

        if (rescuedTotal > 0) {
          const rescuedViciPrice = rescuedTotal.toFixed(2);
          properties._vici_calculated_price = rescuedViciPrice;
          if (!(safeNumber(properties?._total_price, 0) > 0)) {
            properties._total_price = rescuedTotal.toFixed(2);
          }
          if (!(safeNumber(properties?._unit_price, 0) > 0)) {
            const qtyFromProperties = Math.max(
              1,
              parseInt(properties?.Quantity || properties?.quantity || quantity || 1, 10) || 1
            );
            properties._unit_price = (rescuedTotal / qtyFromProperties).toFixed(2);
          }
          finalViciPrice = rescuedTotal;
          console.warn('ðŸš‘ Cart guard rescued pricing from trusted UI total:', rescuedTotal);
        } else {
          hideLoadingState();
          showErrorMessage('Pricing error detected. Please refresh and try again.');
          return { success: false, error: 'Pricing calculation failed.' };
        }
      }

      debugLog('Final cart payload prepared', {
        resolvedVariantId,
        quantity: quantity || 1,
        viciPrice: properties?._vici_calculated_price || null,
        totalPrice: properties?._total_price || null,
        unitPrice: properties?._unit_price || null
      });

      try {
        window.__vici_debug = window.__vici_debug || {};
        window.__vici_debug.last_resolved_variant = {
          resolvedVariantId,
          resolvedVariantSource,
          explicitVariantId: variantId || null,
          allowedVariantIds: Array.from(allowedVariantIds),
          urlVariantId: getUrlVariantId(),
          ts: new Date().toISOString()
        };
      } catch (e) {
        // Non-blocking debug capture
      }

      const result = await retryHandler.executeWithRetry(async () => {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{
              id: resolvedVariantId,
              quantity: quantity || 1,
              properties: properties
            }]
          })
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw buildCartError(response, errorText);
        }

        return response.json();
      }, 'Add to Cart');
      
      // Non-blocking cart verify â€” fire and forget for debug capture
      fetch('/cart.js').then(r => r.ok ? r.json() : null).then(cart => {
        if (!cart) return;
        try {
          const addedItem = cart.items.find(item => item.variant_id == resolvedVariantId);
          if (addedItem) {
            window.__vici_debug = window.__vici_debug || {};
            window.__vici_debug.last_cart_line = { item: addedItem, cart_token: cart.token, ts: new Date().toISOString() };
          }
          // ── Persist option data to backend for order metafield pipeline ──
          // Cart Transform lineExpand drops attributes, so we save options now
          // and the orders/create webhook writes them as an order metafield.
          // IMPORTANT: This is NOT fire-and-forget — we log failures so we know
          // when the metafield pipeline will have gaps.
          if (cart.token && properties) {
            var optionsPayload = Object.assign({}, properties);
            delete optionsPayload._unit_price;
            delete optionsPayload._total_price;
            // Strip ?key=... suffix — Shopify webhook only sends the base token
            var cartToken = cart.token.split('?')[0];
            fetch('https://vici-print.vercel.app/api/cart-options-save', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                cartToken: cartToken,
                lines: [{
                  variantId: String(resolvedVariantId),
                  quantity: quantity || 1,
                  options: optionsPayload
                }]
              })
            }).then(function(saveResp) {
              if (!saveResp.ok) {
                console.error('⚠️ ViciPrint: Failed to save options to backend (HTTP ' + saveResp.status + '). Order metafields may be missing for this item.');
                try {
                  window.__vici_debug = window.__vici_debug || {};
                  window.__vici_debug.last_options_save_error = {
                    status: saveResp.status,
                    cartToken: cartToken.substring(0, 8) + '...',
                    variantId: String(resolvedVariantId),
                    ts: new Date().toISOString()
                  };
                } catch (e) { /* ignore */ }
              } else {
                console.log('✅ ViciPrint: Options saved for order metafield pipeline');
              }
            }).catch(function(saveErr) {
              console.error('⚠️ ViciPrint: Network error saving options to backend:', saveErr.message || saveErr);
              try {
                window.__vici_debug = window.__vici_debug || {};
                window.__vici_debug.last_options_save_error = {
                  error: saveErr.message || 'network_error',
                  cartToken: cartToken.substring(0, 8) + '...',
                  variantId: String(resolvedVariantId),
                  ts: new Date().toISOString()
                };
              } catch (e) { /* ignore */ }
            });
          } else if (!cart.token) {
            console.warn('⚠️ ViciPrint: No cart token available — order metafield will be missing for this item');
          }
        } catch (e) { /* ignore */ }
      }).catch(() => {});

      hideLoadingState();

      // Immediately trigger Shopify theme cart drawer/notification
      // This covers Dawn, Debut, and most modern Shopify themes
      triggerShopifyCartUpdate(result);
      
      // Clear session data after successful add
      const productId = getCurrentProductId();
      const sessionKey = `option_selections_${productId}`;
      sessionStorage.removeItem(sessionKey);
      
      // Trigger analytics
      trackOptionInteraction('cart_add_success', 'add_to_cart_button', JSON.stringify(properties), cartTelemetryMetadata);
      
      return { success: true, item: result };

    } catch (error) {
      hideLoadingState();
      console.error('Cart add error:', error);
      const userMessage = error.userMessage || error.message || 'Failed to add item to cart.';
      showErrorMessage(userMessage);
      
      if (isSoldOutMessage(userMessage)) {
        setSoldOutState(container, userMessage);
      }
      
      // Trigger analytics
      trackOptionInteraction('cart_add_failed', 'add_to_cart_button', userMessage, cartTelemetryMetadata);
      
      return { success: false, error: userMessage };
    }
  }

  async function addToCartWithValidationV2(productId, variantId, quantity, properties, container) {
    return addToCartWithValidationLegacy(productId, variantId, quantity, properties, container);
  }

  async function addToCartWithValidation(productId, variantId, quantity, properties, container) {
    return runWidgetModuleFlowAsync(
      PHASE3_WIDGET_MODULES.cartGateway,
      WIDGET_CART_GATEWAY_MODE,
      {
        legacy: () => addToCartWithValidationLegacy(productId, variantId, quantity, properties, container),
        v2: () => addToCartWithValidationV2(productId, variantId, quantity, properties, container),
        sideEffect: true
      },
      { productId }
    );
  }

  // ✅ FIX 8: ANALYTICS & MONITORING
  function trackOptionInteraction(eventType, fieldId, value, metadata = {}) {
    if (widgetAnalyticsDisabled) {
      return;
    }

    const eventData = {
      event: `option_${eventType}`,
      field_id: fieldId,
      field_value: value,
      product_id: getCurrentProductId(),
      variant_id: getCurrentVariantId(),
      session_id: sessionId,
      ...(PHASE0_WIDGET_TELEMETRY_ENABLED ? {
        widget_session_id: widgetSessionId,
        widget_runtime_mode: OPTION_WIDGET_RUNTIME_MODE
      } : {}),
      timestamp: new Date().toISOString(),
      url: window.location.href,
      user_agent: navigator.userAgent,
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight
      },
      is_mobile: 'ontouchstart' in window,
      ...metadata
    };

    // Send to backend analytics
    fetch(WIDGET_ANALYTICS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(eventData)
    }).then((response) => {
      if (!response.ok && (response.status === 404 || response.status === 410)) {
        widgetAnalyticsDisabled = true;
        widgetAnalyticsDisableReason = `http_${response.status}`;
        console.warn(`Option widget analytics disabled after ${response.status} from ${WIDGET_ANALYTICS_ENDPOINT}`);
      }
    }).catch(error => {
      if (widgetAnalyticsDisabled) {
        return;
      }
      const message = error && error.message ? error.message : String(error);
      widgetAnalyticsDisabled = true;
      widgetAnalyticsDisableReason = message || 'request_error';
      if (WIDGET_DEBUG_LOGGING) {
        console.warn('Analytics tracking disabled after request failure:', error);
      }
    });

    // Also log to console in development
    if (WIDGET_DEBUG_LOGGING) {
      debugLog('Option Analytics:', eventData);
    }
  }

  // ✅ ENHANCEMENT FUNCTION: Add enterprise features to existing system
  function enhanceExistingSystem() {
    debugLog('ðŸ”§ Adding enterprise enhancements to existing system...');
    
    try {
      // 1. Add session persistence without interfering
      addNonInterferingSessionPersistence();
      
      // 2. Add validation enhancement to existing functions
      enhanceExistingValidation();
      
      // 3. Add analytics to existing events (non-interfering)
      enhanceExistingAnalytics();
      
      // 4. Add error recovery to existing functions
      enhanceExistingErrorRecovery();
      
      debugLog('✅ System enhanced successfully');
      
    } catch (error) {
      console.error('❌ Enhancement failed:', error);
    }
  }

  function addNonInterferingSessionPersistence() {
    // Save selections when they change, but don't interfere with existing handlers
    // OOM FIX: Debounce observer callback to prevent excessive firing during rapid clicking.
    // Without debounce, each click generates 30-50+ mutations → hundreds of callbacks/second,
    // each performing DOM traversal + JSON serialize + sessionStorage write.
    let sessionSaveTimer = null;
    const observer = new MutationObserver(() => {
      if (sessionSaveTimer) return; // Already scheduled
      sessionSaveTimer = setTimeout(() => {
        sessionSaveTimer = null;
        try {
          const selections = getCurrentSelections();
          if (Object.keys(selections).length > 0) {
            saveSelectionsToSession(selections);
          }
        } catch (error) {
          console.warn('Session save failed:', error);
        }
      }, 300);
    });
    
    // Observe option containers for changes — only childList, not attributes,
    // to avoid firing on every class toggle during option selection
    document.querySelectorAll('.option-widget-container').forEach(container => {
      observer.observe(container, { childList: true, subtree: true, attributes: false });
    });
  }

  function enhanceExistingValidation() {
    // Enhance the existing updateOrderSummary function with validation
    if (window.CustomOptionWidget && window.CustomOptionWidget.updateOrderSummary) {
      const originalUpdateOrderSummary = window.CustomOptionWidget.updateOrderSummary;
      
      window.CustomOptionWidget.updateOrderSummary = function(container, selections) {
        try {
          // Run validation before update
          if (window.optionSetData && selections) {
            const validation = validateAllFields(window.optionSetData, selections);
            if (!validation.isValid) {
              console.warn('Validation errors found:', validation.errors);
              // Still continue with update, just log the issues
            }
          }
          
          // Call original function
          return originalUpdateOrderSummary.call(this, container, selections);
        } catch (error) {
          console.error('Enhanced updateOrderSummary failed:', error);
          // Fallback to original
          return originalUpdateOrderSummary.call(this, container, selections);
        }
      };
    }
  }

  function enhanceExistingAnalytics() {
    // Track interactions with existing elements without interfering
    document.addEventListener('change', function(event) {
      if (event.target.closest('.option-widget-container')) {
        trackOptionInteraction('field_changed', event.target.name || 'unknown', event.target.value);
      }
    }, { passive: true, capture: false });

    // Track button clicks
    document.addEventListener('click', function(event) {
      if (event.target.closest('.start-making-button') || event.target.textContent?.includes('Start Making')) {
        trackOptionInteraction('start_making_clicked', 'start_making_button', event.target.textContent);
      }
    }, { passive: true, capture: false });
  }

  function enhanceExistingErrorRecovery() {
    // Add error recovery to critical functions
    window.addEventListener('error', function(event) {
      if (event.filename && event.filename.includes('option-widget')) {
        trackOptionInteraction('javascript_error', 'widget', event.message, {
          filename: event.filename,
          lineno: event.lineno,
          colno: event.colno
        });
      }
    });
    
    // Add unhandled promise rejection tracking
    window.addEventListener('unhandledrejection', function(event) {
      console.error('Unhandled promise rejection in option widget:', event.reason);
      trackOptionInteraction('promise_rejection', 'widget', event.reason.toString());
    });
  }

  // 14. DESIGN METHOD SYNC INITIALIZATION
  function initializeDesignMethodSync() {
    debugLog('ðŸ”„ Initializing Design Method sync with Start Making button...');
    
    try {
      // Find all widget containers
      const containers = document.querySelectorAll('#custom-options-widget-container, #custom-options-widget-container-2');
      
      containers.forEach(container => {
        // Find the default selected design method and sync button
        const selectedDesignMethod = container.querySelector('.design-method.selected');
        if (selectedDesignMethod) {
          debugLog('ðŸŽ¯ Found default selected design method, syncing button...');
          updateStartMakingButtonForDesignMethod(selectedDesignMethod);
        } else {
          // If no method selected, check for first method and select it
          const firstDesignMethod = container.querySelector('.design-method');
          if (firstDesignMethod) {
            debugLog('ðŸŽ¯ No design method selected, selecting first option and syncing...');
            SafeDOM.addClass(firstDesignMethod, 'selected');
            updateStartMakingButtonForDesignMethod(firstDesignMethod);
          } else {
            // No design method found - ensure button defaults to "Add to Cart"
            const startMakingButton = SafeDOM.query(container, '.start-making-button');
            if (startMakingButton) {
              debugLog('ðŸŽ¯ No design method found, setting default button text to "Add to Cart"');
              SafeDOM.setText(startMakingButton, 'Add to Cart');
              startMakingButton.className = 'start-making-button cart-mode';
            }
          }
        }
      });
      
      debugLog('✅ Design Method sync initialization complete');
    } catch (error) {
      console.error('❌ Design Method sync initialization failed:', error);
    }
  }

  // ✅ ENTERPRISE ENHANCEMENTS - ENHANCEMENT MODE
  function initializeEnterpriseEnhancements() {
    debugLog('ðŸš€ Initializing Enterprise Enhancements (Enhancement Mode)...');
    
    try {
      // ENHANCEMENT MODE: Add enterprise features to existing system
      debugLog('ðŸ”— Enhancing existing option system with enterprise features');
      
      // Add mobile optimizations (safe)
      optimizeForMobile();
      
      // Enhance existing system
      enhanceExistingSystem();
      
      // Initialize design method sync for start making button
      initializeDesignMethodSync();
      
      // Add enterprise features to window object
      window.CustomOptionWidget = window.CustomOptionWidget || {};
      window.CustomOptionWidget.validateAllFields = validateAllFields;
      window.CustomOptionWidget.trackOptionInteraction = trackOptionInteraction;
      window.CustomOptionWidget.syncPriceWithShopify = syncPriceWithShopify;
      
      debugLog('✅ Enterprise enhancements added successfully');
      
    } catch (error) {
      console.error('❌ Failed to initialize enterprise enhancements:', error);
    }
  }

  function restoreSelections(selections) {
    try {
      Object.entries(selections).forEach(([fieldName, value]) => {
        const input = document.querySelector(`[name="${fieldName}"], [data-field-id="${fieldName}"]`);
        if (input) {
          if (input.type === 'checkbox') {
            input.checked = !!value;
          } else {
            input.value = value;
          }
          
          // Trigger change event to update UI
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      
      debugLog('Selections restored from session');
    } catch (error) {
      console.error('Failed to restore selections:', error);
    }
  }

  function interceptAddToCartButtons() {
    // COMPATIBILITY FIX: Only intercept actual "Add to Cart" buttons, not design method buttons
    const addToCartButtons = document.querySelectorAll('button[name="add"], input[name="add"], .btn-cart');
    
    addToCartButtons.forEach(button => {
      // Skip if already intercepted
      if (button.hasAttribute('data-intercepted')) return;
      
      // COMPATIBILITY FIX: Skip design method buttons (Start Making, Upload, etc.)
      const buttonText = button.textContent?.toLowerCase() || '';
      if (buttonText.includes('start') || buttonText.includes('upload') || buttonText.includes('design')) {
        return; // Let existing design method logic handle these
      }
      
      button.addEventListener('click', async function(event) {
        const scopedWidgetContainer =
          this.closest('.option-widget-container') ||
          this.closest('[data-product-id]')?.querySelector('.option-widget-container') ||
          document.querySelector('#custom-options-widget-container, #custom-options-widget-container-2, .option-widget-container');

        // Check if this is on a product page with options
        if (!scopedWidgetContainer) {
          return; // Let normal cart flow proceed
        }

        const scopedOptionSetData = resolveActiveOptionSetData(scopedWidgetContainer);
        if (!scopedOptionSetData) return;
        
        // COMPATIBILITY FIX: Only prevent default for actual cart buttons
        const isActualCartButton = this.textContent?.toLowerCase().includes('cart') || 
                                  this.textContent?.toLowerCase().includes('buy') ||
                                  this.name === 'add';
        
        if (!isActualCartButton) {
          return; // Let other buttons work normally
        }
        
        event.preventDefault();
        event.stopPropagation();
        
        // Use the same flow as the widget's own "Add to Cart" button
        // to ensure properties are correctly formatted and pricing is accurate.
        const data = getCurrentSelectionsFromForm(scopedWidgetContainer);
        const orderSummaryData = extractOrderSummaryData(scopedWidgetContainer, data);

        if (!orderSummaryData || orderSummaryData.totalPrice <= 0) {
          console.warn('No valid order summary data from native button intercept');
          return;
        }

        const designMethodValue = data['properties[Design Method]'];
        const normalizedDesignMethod = normalizeDesignMethodValue(designMethodValue);
        const button = this;

        addToCartDirect(orderSummaryData, data, scopedWidgetContainer, button, 'add_to_cart', normalizedDesignMethod);
      });
      
      button.setAttribute('data-intercepted', 'true');
    });
    
    debugLog(`Intercepted ${addToCartButtons.length} add to cart buttons`);
  }

  // ENHANCEMENT TIMING: Initialize after existing system is stable  
  function safeEnhancementInitialize() {
    // Wait for existing system to fully load
    setTimeout(() => {
      debugLog('ðŸš€ Starting enterprise enhancement initialization...');
      initializeEnterpriseEnhancements();
    }, 2000); // Give existing system time to stabilize
  }

  // Initialize with delayed timing to not interfere
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeEnhancementInitialize);
  } else {
    safeEnhancementInitialize();
  }

  // Export enhanced functions globally
  window.CustomOptionWidget = window.CustomOptionWidget || {};
  window.CustomOptionWidget.validateAllFields = validateAllFields;
  window.CustomOptionWidget.addToCartWithValidation = addToCartWithValidation;
  window.CustomOptionWidget.trackOptionInteraction = trackOptionInteraction;
  window.CustomOptionWidget.syncPriceWithShopify = syncPriceWithShopify;
  window.CustomOptionWidget.getCurrentSelections = getCurrentSelections;

})();
